var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _path841, _path842, _path843, _path844, _path845, _path846, _path847, _path848, _path849, _path850, _path851, _path852, _path853, _path854, _path855, _path856, _path857, _path858, _path859, _path860, _path861, _path862, _path863, _path864, _path865, _path866, _path867, _path868, _path869, _path870, _path871, _path872, _path873, _path874, _path875, _path876, _path877, _path878, _path879, _path880, _path881, _path882, _path883, _path884, _path885, _path886, _path887, _path888, _path889, _path890, _path891, _path892, _path893, _path894, _path895, _path896, _path897, _path898, _path899, _path900, _path901, _path902, _path903, _path904, _path905, _path906, _path907, _path908, _path909, _path910, _path911, _path912, _path913, _path914, _path915, _path916, _path917, _path918, _path919, _path920, _path921, _path922, _path923, _path924, _path925, _path926, _path927, _path928, _path929, _path930, _path931, _path932, _path933, _path934, _path935, _path936, _path937, _path938, _path939, _path940, _path941, _path942, _path943, _path944, _path945, _path946, _path947, _path948, _path949, _path950, _path951, _path952, _path953, _path954, _path955, _path956, _path957, _path958, _path959, _path960, _path961, _path962, _path963, _path964, _path965, _path966, _path967, _path968, _path969, _path970, _path971, _path972, _path973, _path974, _path975, _path976, _path977, _path978, _path979, _path980, _path981, _path982, _path983, _path984, _path985, _path986, _path987, _path988, _path989, _path990, _path991, _path992, _path993, _path994, _path995, _path996, _path997, _path998, _path999, _path1000, _path1001, _path1002, _path1003, _path1004, _path1005, _path1006, _path1007, _path1008, _path1009, _path1010, _path1011, _path1012, _path1013, _path1014, _path1015, _path1016, _path1017, _path1018, _path1019, _path1020, _path1021, _path1022, _path1023, _path1024, _path1025, _path1026, _path1027, _path1028, _path1029, _path1030, _path1031, _path1032, _path1033, _path1034, _path1035, _path1036, _path1037, _path1038, _path1039, _path1040, _path1041, _path1042, _path1043, _path1044, _path1045, _path1046, _path1047, _path1048, _path1049, _path1050, _path1051, _path1052, _path1053, _path1054, _path1055, _path1056, _path1057, _path1058, _path1059, _path1060, _path1061, _path1062, _path1063, _path1064, _path1065, _path1066, _path1067, _path1068, _path1069, _path1070, _path1071, _path1072, _path1073, _path1074, _path1075, _path1076, _path1077, _path1078, _path1079, _path1080, _path1081, _path1082, _path1083, _path1084, _path1085, _path1086, _path1087, _path1088, _path1089, _path1090, _path1091, _path1092, _path1093, _path1094, _path1095, _path1096, _path1097, _path1098, _path1099, _path1100, _path1101, _path1102, _path1103, _path1104, _path1105, _path1106, _path1107, _path1108, _path1109, _path1110, _path1111, _path1112, _path1113, _path1114, _path1115, _path1116, _path1117, _path1118, _path1119, _path1120, _path1121, _path1122, _path1123, _path1124, _path1125, _path1126, _path1127, _path1128, _path1129, _path1130, _path1131, _path1132, _path1133, _path1134, _path1135, _path1136, _path1137, _path1138, _path1139, _path1140, _path1141, _path1142, _path1143, _path1144, _path1145, _path1146, _path1147, _path1148, _path1149, _path1150, _path1151, _path1152, _path1153, _path1154, _path1155, _path1156, _path1157, _path1158, _path1159, _path1160, _path1161, _path1162, _path1163, _path1164, _path1165, _path1166, _path1167, _path1168, _path1169, _path1170, _path1171, _path1172, _path1173, _path1174, _path1175, _path1176, _path1177, _path1178, _path1179, _path1180, _path1181, _path1182, _path1183, _path1184, _path1185, _path1186, _path1187, _path1188, _path1189, _path1190, _path1191, _path1192, _path1193, _path1194, _path1195, _path1196, _path1197, _path1198, _path1199, _path1200, _path1201, _path1202, _path1203, _path1204, _path1205, _path1206, _path1207, _path1208, _path1209, _path1210, _path1211, _path1212, _path1213, _path1214, _path1215, _path1216, _path1217, _path1218, _path1219, _path1220, _path1221, _path1222, _path1223, _path1224, _path1225, _path1226, _path1227, _path1228, _path1229, _path1230, _path1231, _path1232, _path1233, _path1234, _path1235, _path1236, _path1237, _path1238, _path1239, _path1240, _path1241, _path1242, _path1243, _path1244, _path1245, _path1246, _path1247, _path1248, _path1249, _path1250, _path1251, _path1252, _path1253, _path1254, _path1255, _path1256, _path1257, _path1258, _path1259, _path1260, _path1261, _path1262, _path1263, _path1264, _path1265, _path1266, _path1267, _path1268, _path1269, _path1270, _path1271, _path1272, _path1273, _path1274, _path1275, _path1276, _path1277, _path1278, _path1279, _path1280, _path1281, _path1282, _path1283, _path1284, _path1285, _path1286, _path1287, _path1288, _path1289, _path1290, _path1291, _path1292, _path1293, _path1294, _path1295, _path1296, _path1297, _path1298, _path1299, _path1300, _path1301, _path1302, _path1303, _path1304, _path1305, _path1306, _path1307, _path1308, _path1309, _path1310, _path1311, _path1312, _path1313, _path1314, _path1315, _path1316, _path1317, _path1318, _path1319, _path1320, _path1321, _path1322, _path1323, _path1324, _path1325, _path1326, _path1327, _path1328, _path1329, _path1330, _path1331, _path1332, _path1333, _path1334, _path1335, _path1336, _path1337, _path1338, _path1339, _path1340, _path1341, _path1342, _path1343, _path1344, _path1345, _path1346, _path1347, _path1348, _path1349, _path1350, _path1351, _path1352, _path1353, _path1354, _path1355, _path1356, _path1357, _path1358, _path1359, _path1360, _path1361, _path1362, _path1363, _path1364, _path1365, _path1366, _path1367, _path1368, _path1369, _path1370, _path1371, _path1372, _path1373, _path1374, _path1375, _path1376, _path1377, _path1378, _path1379, _path1380, _path1381, _path1382, _path1383, _path1384, _path1385, _path1386, _path1387, _path1388, _path1389, _path1390, _path1391, _path1392, _path1393, _path1394, _path1395, _path1396, _path1397, _path1398, _path1399, _path1400, _path1401, _path1402, _path1403, _path1404, _path1405, _path1406, _path1407, _path1408, _path1409, _path1410, _path1411, _path1412, _path1413, _path1414, _path1415, _path1416, _path1417, _path1418, _path1419, _path1420, _path1421, _path1422, _path1423, _path1424, _path1425, _path1426, _path1427, _path1428, _path1429, _path1430, _path1431, _path1432, _path1433, _path1434, _path1435, _path1436, _path1437, _path1438, _path1439, _path1440, _path1441, _path1442, _path1443, _path1444, _path1445, _path1446, _path1447, _path1448, _path1449, _path1450, _path1451, _path1452, _path1453, _path1454, _path1455, _path1456, _path1457, _path1458, _path1459, _path1460, _path1461, _path1462, _path1463, _path1464, _path1465, _path1466, _path1467, _path1468, _path1469, _path1470, _path1471, _path1472, _path1473, _path1474, _path1475, _path1476, _path1477, _path1478, _path1479, _path1480, _path1481, _path1482, _path1483, _path1484, _path1485, _path1486, _path1487, _path1488, _path1489, _path1490, _path1491, _path1492, _path1493, _path1494, _path1495, _path1496, _path1497, _path1498, _path1499, _path1500, _path1501, _path1502, _path1503, _path1504, _path1505, _path1506, _path1507, _path1508, _path1509, _path1510, _path1511, _path1512, _path1513, _path1514, _path1515, _path1516, _path1517, _path1518, _path1519, _path1520, _path1521, _path1522, _path1523, _path1524, _path1525, _path1526, _path1527, _path1528, _path1529, _path1530, _path1531, _path1532, _path1533, _path1534, _path1535, _path1536, _path1537, _path1538, _path1539, _path1540, _path1541, _path1542, _path1543, _path1544, _path1545, _path1546, _path1547, _path1548, _path1549, _path1550, _path1551, _path1552, _path1553, _path1554, _path1555, _path1556, _path1557, _path1558, _path1559, _path1560, _path1561, _path1562, _path1563, _path1564, _path1565, _path1566, _path1567, _path1568, _path1569, _path1570, _path1571, _path1572, _path1573, _path1574, _path1575, _path1576, _path1577, _path1578, _path1579, _path1580, _path1581, _path1582, _path1583, _path1584, _path1585, _path1586, _path1587, _path1588, _path1589, _path1590, _path1591, _path1592, _path1593, _path1594, _path1595, _path1596, _path1597, _path1598, _path1599, _path1600, _path1601, _path1602, _path1603, _path1604, _path1605, _path1606, _path1607, _path1608, _path1609, _path1610, _path1611, _path1612, _path1613, _path1614, _path1615, _path1616, _path1617, _path1618, _path1619, _path1620, _path1621, _path1622, _path1623, _path1624, _path1625, _path1626, _path1627, _path1628, _path1629, _path1630, _path1631, _path1632, _path1633, _path1634, _path1635, _path1636, _path1637, _path1638, _path1639, _path1640, _path1641, _path1642, _path1643, _path1644, _path1645, _path1646, _path1647, _path1648, _path1649, _path1650, _path1651, _path1652, _path1653, _path1654, _path1655, _path1656, _path1657, _path1658, _path1659, _path1660, _path1661, _path1662, _path1663, _path1664, _path1665, _path1666, _path1667, _path1668, _path1669, _path1670, _path1671, _path1672, _path1673, _path1674, _path1675, _path1676, _path1677, _path1678, _path1679, _path1680, _path1681, _path1682, _path1683, _path1684, _path1685, _path1686, _path1687, _path1688, _path1689, _path1690, _path1691, _path1692, _path1693, _path1694, _path1695, _path1696, _path1697, _path1698, _path1699, _path1700, _path1701, _path1702, _path1703, _path1704, _path1705, _path1706, _path1707, _path1708, _path1709, _path1710, _path1711, _path1712, _path1713, _path1714, _path1715, _path1716, _path1717, _path1718, _path1719, _path1720, _path1721, _path1722, _path1723, _path1724, _path1725, _path1726, _path1727, _path1728, _path1729, _path1730, _path1731, _path1732, _path1733, _path1734, _path1735, _path1736, _path1737, _path1738, _path1739, _path1740, _path1741, _path1742, _path1743, _path1744, _path1745, _path1746, _path1747, _path1748, _path1749, _path1750, _path1751, _path1752, _path1753, _path1754, _path1755, _path1756, _path1757, _path1758, _path1759, _path1760, _path1761, _path1762, _path1763, _path1764, _path1765, _path1766, _path1767, _path1768, _path1769, _path1770, _path1771, _path1772, _path1773, _path1774, _path1775, _path1776, _path1777, _path1778, _path1779, _path1780, _path1781, _path1782, _path1783, _path1784, _path1785, _path1786, _path1787, _path1788, _path1789, _path1790, _path1791, _path1792, _path1793, _path1794, _path1795, _path1796, _path1797, _path1798, _path1799, _path1800, _path1801, _path1802, _path1803, _path1804, _path1805, _path1806, _path1807, _path1808, _path1809, _path1810, _path1811, _path1812, _path1813, _path1814, _path1815, _path1816, _path1817, _path1818, _path1819, _path1820, _path1821, _path1822, _path1823, _path1824, _path1825, _path1826, _path1827, _path1828, _path1829, _path1830, _path1831, _path1832, _path1833, _path1834, _path1835, _path1836, _path1837, _path1838, _path1839, _path1840, _path1841, _path1842, _path1843, _path1844, _path1845, _path1846, _path1847, _path1848, _path1849, _path1850, _path1851, _path1852, _path1853, _path1854, _path1855, _path1856, _mask, _path1857, _path1858, _path1859, _path1860, _path1861, _path1862, _path1863, _path1864, _path1865, _path1866, _path1867, _path1868, _path1869, _path1870, _path1871, _path1872, _path1873, _path1874, _path1875, _path1876, _path1877, _path1878, _path1879, _path1880, _path1881, _path1882, _path1883, _path1884, _mask2, _path1885, _path1886, _path1887, _path1888, _path1889, _path1890, _path1891, _path1892, _path1893, _path1894, _path1895, _path1896, _path1897, _path1898, _path1899, _path1900, _path1901, _path1902, _path1903, _path1904, _path1905, _path1906, _path1907, _path1908, _path1909, _path1910, _path1911, _path1912, _path1913, _path1914, _path1915, _path1916, _path1917, _path1918, _path1919, _path1920, _path1921, _path1922, _path1923, _path1924, _path1925, _path1926, _path1927, _path1928, _path1929, _path1930, _path1931, _path1932, _path1933, _path1934, _path1935, _path1936, _path1937, _path1938, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMetroLostBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6004_56885)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1920.5,
    height: 1080,
    fill: "url(#paint0_linear_6004_56885)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M263.878 642.607H263.839V642.656H263.878V642.607Z",
    fill: "url(#paint1_linear_6004_56885)",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1891.13 494.9L1893.01 388.951L1896.15 495.202C1896.85 495.202 1897.43 495.777 1897.43 496.478V509.213H1898.71C1899.41 509.213 1899.99 509.788 1899.99 510.489V515.624C1900.92 516.471 1901.55 517.65 1901.66 518.985L1901.93 522.298C1902.34 527.15 1902.33 532.031 1901.88 536.884L1901.68 538.969C1901.47 541.307 1899.69 543.158 1897.43 543.528V555.055H1898.71C1899.41 555.055 1899.99 555.63 1899.99 556.331V557.607C1899.99 558.309 1899.41 558.884 1898.71 558.884H1897.43V565.246H1898.71C1899.41 565.246 1899.99 565.821 1899.99 566.522V569.065C1899.99 569.767 1899.41 570.342 1898.71 570.342H1897.43V580.524H1898.71C1899.41 580.524 1899.99 581.098 1899.99 581.8V584.343C1899.99 585.044 1899.41 585.619 1898.71 585.619H1897.43V586.896H1898.71C1899.41 586.896 1899.99 587.47 1899.99 588.172V590.715C1899.99 591.416 1899.41 591.991 1898.71 591.991H1897.43V594.534H1899.98C1900.68 594.534 1901.26 595.109 1901.26 595.811V604.726C1901.26 605.427 1900.68 606.002 1899.98 606.002H1898.7V632.738C1899.4 632.738 1899.98 633.312 1899.98 634.014V636.557C1899.98 637.258 1899.4 637.833 1898.7 637.833V640.376C1899.4 640.376 1899.98 640.951 1899.98 641.653V644.196C1899.98 644.897 1899.4 645.472 1898.7 645.472V674.75H1901.25C1901.96 674.75 1902.53 675.325 1902.53 676.027V689.317H1912.2C1913.6 689.317 1914.75 690.457 1914.75 691.86V693.837H1940.91V685.858C1940.91 685.098 1940.31 684.484 1939.54 684.484C1938.78 684.484 1938.16 683.87 1938.16 683.11V678.268C1938.16 677.157 1937.26 676.251 1936.13 676.251C1934.73 676.251 1933.74 674.838 1934.24 673.523L1946.36 641.682C1946.73 640.688 1947.67 640.035 1948.75 640.035H2099.75C2100.66 640.035 2101.49 640.503 2101.95 641.282L2121.09 673.542C2121.79 674.741 2120.94 676.251 2119.53 676.251C2118.55 676.251 2117.73 677.05 2117.73 678.044V681.931C2117.73 683.334 2116.6 684.474 2115.18 684.474H2114.79C2113.39 684.474 2112.24 685.614 2112.24 687.017V693.818H2129.03V632.387C2129.03 631.753 2129.55 631.237 2130.18 631.237C2130.82 631.237 2131.35 630.721 2131.35 630.087V607.259C2131.35 605.856 2132.48 604.716 2133.9 604.716H2176.04V602.173C2176.04 600.77 2177.18 599.63 2178.59 599.63H2190.12C2191.25 599.63 2192.24 598.899 2192.57 597.828L2198.49 578.516C2198.82 577.445 2199.81 576.714 2200.94 576.714H2345.37C2346.77 576.714 2347.93 577.854 2347.93 579.257V693.828V828.346H1711.46H708.274H86.6572V669.479V662.698C86.6572 661.295 87.8016 660.155 89.21 660.155H90.5892C91.9976 660.155 93.142 659.015 93.142 657.612V645.297C93.142 643.894 94.2863 642.754 95.6948 642.754H142.007C143.416 642.754 144.56 643.894 144.56 645.297V657.612C144.56 659.015 145.705 660.155 147.113 660.155H152.043C153.422 660.155 154.537 661.266 154.537 662.64C154.537 664.013 155.652 665.124 157.031 665.124H170.969C171.917 665.124 172.798 665.65 173.228 666.488L182.706 684.464C182.901 684.825 182.999 685.234 182.999 685.643V694.929H193.973V677.03C193.973 675.51 196.184 675.277 196.507 676.767L197.094 679.495L200.566 679.486L200.928 677.05C201.133 675.627 203.177 675.579 203.441 676.991L203.911 679.427V679.495L210.787 679.486L211.149 677.05C211.354 675.627 213.398 675.579 213.662 676.991L214.132 679.427V679.495L215.892 679.486L216.254 677.05C216.46 675.627 218.504 675.579 218.768 676.991L219.228 679.427C219.238 679.437 219.238 679.466 219.238 679.466V679.495L219.727 679.486L220.089 677.05C220.294 675.627 222.338 675.579 222.602 676.991L223.072 679.427V679.466V679.495H223.795L224.382 676.767C224.705 675.267 226.916 675.501 226.916 677.03V694.929H254.42V624.943H254.625L254.879 622.692C255.055 621.221 257.187 621.172 257.422 622.644L257.765 624.943H258.772L259.026 622.692C259.212 621.221 261.344 621.172 261.56 622.644L261.951 625.206H271.712L271.996 622.692C272.172 621.221 274.304 621.172 274.539 622.644L274.92 625.206H275.869L276.153 622.692C276.339 621.221 278.471 621.172 278.686 622.644L279.077 625.206H279.576V642.5H286.071V604.268H286.472V604.219V604.141L286.961 599.494C287.117 597.944 289.386 597.974 289.504 599.523L289.866 604.17V604.268H295.822V604.141L296.311 599.494C296.468 597.944 298.737 597.974 298.854 599.523L299.216 604.17V604.268H300.625V569.631H301.779L302.101 568.305C302.434 566.971 304.351 567.029 304.605 568.374L304.84 569.621H305.662L310.493 555.659L312.371 528.261H312.303C310.161 528.261 308.42 526.526 308.42 524.383C308.42 522.239 310.141 520.505 312.303 520.505C314.465 520.505 316.206 522.239 316.206 524.383C316.206 526.361 314.709 527.998 312.792 528.232L314.905 555.659L319.238 569.621H319.825L320.773 566.766C321.174 565.558 322.925 565.616 323.228 566.863L323.903 569.631H323.991V570.05C324.001 570.137 324.001 570.225 323.991 570.303V604.268H327.503V604.219V604.141L327.992 599.494C328.148 597.944 330.417 597.974 330.535 599.523L330.896 604.17V604.268L331.141 604.258V604.2C331.141 604.18 331.151 604.141 331.151 604.141L331.62 599.494C331.777 597.944 334.046 597.974 334.163 599.523L334.525 604.17C334.525 604.2 334.535 604.268 334.535 604.268H334.897V642.5H336.97V625.206H337.469L337.86 622.644C338.095 621.182 340.228 621.221 340.394 622.692L340.687 625.206H341.616L342.008 622.644C342.242 621.182 344.375 621.221 344.541 622.692L344.834 625.206H354.586L354.977 622.644C355.212 621.182 357.344 621.221 357.51 622.692L357.774 624.943H358.772L359.134 622.644C359.369 621.182 361.501 621.221 361.667 622.692L361.931 624.943H362.391V694.929H378.901L378.745 675.296C378.725 673.786 380.896 673.513 381.258 674.984L382.295 679.223H383.303L383.674 675.773C383.841 674.283 386.002 674.244 386.217 675.725L386.716 679.213H387.137L387.508 675.764C387.675 674.273 389.836 674.234 390.051 675.715L390.55 679.203H390.971L391.343 675.754C391.509 674.263 393.67 674.224 393.886 675.705L394.384 679.193H396.086L396.458 675.744C396.624 674.254 398.786 674.215 399.001 675.696L399.5 679.184H399.92L400.292 675.734C400.458 674.244 402.62 674.205 402.835 675.686L403.373 679.437H405.006L405.408 675.734C405.574 674.244 407.735 674.205 407.951 675.686L408.489 679.437H409.105L409.965 675.949C410.337 674.487 412.489 674.75 412.479 676.261L412.401 694.88H426.642V652.779C426.642 651.932 426.211 651.133 425.507 650.665L425.175 650.451C424.461 649.973 424.04 649.174 424.04 648.327V646.758C424.04 645.355 425.185 644.215 426.593 644.215H426.808C427.767 644.215 428.657 643.679 429.087 642.832L439.827 621.962C440.267 621.114 441.147 620.578 442.106 620.578H515.893C516.89 620.578 517.8 621.153 518.221 622.049L528.295 643.708C528.451 644.04 528.539 644.41 528.539 644.78V652.867C528.539 653.5 529.058 654.017 529.694 654.017C530.329 654.017 530.858 654.533 530.858 655.166V694.88H605.31L641.871 663.663C642.34 663.273 642.917 663.059 643.534 663.059H656.963C657.579 663.059 658.176 663.283 658.636 663.682L664.23 668.534L673.894 558.669H678.364L696.634 694.88H708.274V647.947C708.274 647.421 708.44 646.904 708.743 646.476L733.635 611.293C733.89 610.932 734.222 610.659 734.584 610.484V609.578H810.005C811.13 609.578 812.127 610.309 812.45 611.38L818.377 630.691C818.7 631.763 819.698 632.494 820.823 632.494H832.354C833.753 632.494 834.907 633.634 834.907 635.037V702.509H857.911V647.879C857.911 647.391 858.058 646.914 858.322 646.505L879.889 613.066C881.072 611.215 883.89 611.634 884.486 613.748L909.662 702.509H937.812V685.624C937.812 684.864 937.205 684.25 936.442 684.25C935.679 684.25 935.063 683.636 935.063 682.876V678.034C935.063 676.923 934.153 676.017 933.029 676.017C931.63 676.017 930.642 674.604 931.141 673.289L943.26 641.448C943.631 640.454 944.57 639.801 945.646 639.801H1012.72C1013.34 639.801 1013.84 639.314 1013.84 638.7C1013.84 638.087 1013.34 637.599 1012.72 637.599H1012.18C1011.27 637.599 1010.52 636.859 1010.52 635.953V635.68C1010.52 634.618 1011.39 633.761 1012.45 633.761H1043.85C1045.21 633.761 1046.32 634.862 1046.32 636.226V637.044C1046.32 637.95 1045.58 638.691 1044.66 638.691H1043.56C1043.26 638.691 1043.02 638.934 1043.02 639.236C1043.02 639.538 1043.26 639.782 1043.56 639.782H1096.63C1097.54 639.782 1098.38 640.25 1098.83 641.029L1117.98 673.289C1118.68 674.487 1117.83 675.998 1116.42 675.998C1115.44 675.998 1114.62 676.796 1114.62 677.79V681.678C1114.62 683.081 1113.49 684.221 1112.07 684.221H1111.67C1110.27 684.221 1109.11 685.361 1109.11 686.764V693.565H1125.91V630.857C1125.91 630.224 1126.43 629.707 1127.06 629.707C1127.7 629.707 1128.23 629.191 1128.23 628.558V605.729C1128.23 604.326 1129.36 603.186 1130.78 603.186H1231.3C1232.7 603.186 1233.85 604.326 1233.85 605.729V628.558C1233.85 629.191 1234.37 629.707 1235 629.707C1235.64 629.707 1236.17 630.224 1236.17 630.857V638.778H1261.24L1266.92 620.256C1267.24 619.185 1268.24 618.454 1269.37 618.454H1342.23C1343.63 618.454 1344.79 619.594 1344.79 620.997V638.778H1432.36L1443 618.084C1443.44 617.236 1444.32 616.7 1445.27 616.7H1519.06C1520.06 616.7 1520.97 617.275 1521.39 618.171L1531.46 639.831C1531.62 640.162 1531.71 640.532 1531.71 640.902V648.989C1531.71 649.623 1532.23 650.139 1532.86 650.139C1533.5 650.139 1534.03 650.655 1534.03 651.289V693.555H1605.51L1645.76 659.181H1661.1L1700.71 693.555H1711.46V644.079C1711.46 643.553 1711.63 643.036 1711.93 642.607L1736.82 607.425C1737.08 607.064 1737.41 606.791 1737.77 606.616V605.71H1813.19C1814.32 605.71 1815.32 606.441 1815.64 607.512L1821.57 626.823C1821.89 627.895 1822.89 628.626 1824.01 628.626H1835.54C1836.94 628.626 1838.1 629.766 1838.1 631.169V693.545H1861.1V691.567C1861.1 690.164 1862.25 689.024 1863.65 689.024H1884.74V675.734C1884.74 675.033 1885.32 674.458 1886.02 674.458H1888.58V645.18C1887.87 645.18 1887.29 644.605 1887.29 643.903V641.36C1887.29 640.659 1887.87 640.084 1888.58 640.084V637.541C1887.87 637.541 1887.29 636.966 1887.29 636.265V633.722C1887.29 633.02 1887.87 632.445 1888.58 632.445V605.71H1887.29C1886.59 605.71 1886.01 605.135 1886.01 604.433V595.518C1886.01 594.817 1886.59 594.242 1887.29 594.242H1889.85V591.699H1888.57C1887.86 591.699 1887.28 591.124 1887.28 590.423V587.88C1887.28 587.178 1887.86 586.603 1888.57 586.603H1889.85V585.327H1888.57C1887.86 585.327 1887.28 584.752 1887.28 584.051V581.508C1887.28 580.806 1887.86 580.231 1888.57 580.231H1889.85V570.05H1888.57C1887.86 570.05 1887.28 569.475 1887.28 568.773V566.23C1887.28 565.529 1887.86 564.954 1888.57 564.954H1889.85V558.591H1888.57C1887.86 558.591 1887.28 558.017 1887.28 557.315V556.039C1887.28 555.337 1887.86 554.762 1888.57 554.762H1889.85V543.295C1887.63 543.168 1885.77 541.492 1885.47 539.261C1884.56 532.635 1884.52 525.932 1885.35 519.307L1885.45 518.449C1885.62 517.105 1886.3 515.945 1887.28 515.146V510.187C1887.28 509.486 1887.86 508.911 1888.57 508.911H1889.85V496.176C1889.85 495.475 1890.42 494.9 1891.13 494.9ZM263.878 642.607H263.839V642.656H263.878V642.607Z",
    fill: "url(#paint2_linear_6004_56885)",
    fillOpacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2171.85 766.43H-82.0938V800.992H2171.85V766.43Z",
    fill: "#CFCDC8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M-79.3477 780.368L2159.31 780.192",
    stroke: "white",
    strokeWidth: 0.97518,
    strokeDasharray: "4.88 4.88"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1891.38 743.252H1928.55C1932.23 743.252 1935.74 741.7 1938.21 738.98L1943.06 733.65C1943.89 732.745 1944.47 731.656 1944.76 730.472L1945.56 727.295C1947.23 720.671 1938.94 716.215 1934.33 721.26V715.778C1934.33 708.618 1925.09 705.735 1921.03 711.627C1923.05 702.062 1911.67 695.475 1904.39 701.994L1903.74 699.626C1901.97 693.145 1894.9 689.714 1888.72 692.345C1883.39 694.607 1880.71 700.584 1882.55 706.066L1884.42 711.632C1875.38 711.632 1869.99 721.718 1875.02 729.226L1880.54 737.459C1882.96 741.079 1887.03 743.252 1891.39 743.252H1891.38Z",
    fill: "#AACAC9",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1893.08 742.562H1926.58C1930.2 742.562 1933.66 741.057 1936.13 738.405L1940.3 733.939C1941.06 733.113 1941.61 732.108 1941.89 731.019L1942.56 728.425C1944.13 722.343 1936.55 718.182 1932.25 722.769V718.008C1932.25 711.416 1923.78 708.722 1919.98 714.099C1921.86 705.418 1911.59 699.352 1904.89 705.192L1904.63 705.429L1904.05 703.35C1902.41 697.458 1895.97 694.333 1890.33 696.679C1885.35 698.742 1882.84 704.318 1884.59 709.411L1886.21 714.104C1877.93 714.104 1873.04 723.385 1877.73 730.209L1882.32 736.89C1884.75 740.441 1888.78 742.562 1893.08 742.562Z",
    fill: "#6F9392"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M464.754 755.695L492.969 753.895C498.525 753.543 503.249 749.702 504.728 744.336L505.386 741.942C505.685 740.853 505.706 739.711 505.454 738.612L504.844 736.007C503.418 729.889 494.774 729.71 493.095 735.765L490.891 731.541C487.84 725.696 479.085 727.232 478.196 733.761C475.849 725.196 463.938 724.57 460.708 732.845L460.576 733.177L459.098 731.604C454.915 727.142 447.771 727.348 443.846 732.041C440.395 736.171 440.747 742.273 444.656 745.977L448.26 749.386C444.43 751.386 446.108 757.199 450.417 756.852L464.748 755.689L464.754 755.695Z",
    fill: "#FAEAC7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M618.732 755.695L646.947 753.895C652.508 753.543 657.222 749.702 658.711 744.336L659.369 741.942C659.664 740.853 659.69 739.711 659.432 738.612L658.827 736.007C657.396 729.889 648.757 729.71 647.074 735.765L644.874 731.541C641.823 725.696 633.063 727.232 632.179 733.761C629.833 725.196 617.922 724.57 614.691 732.845L614.56 733.177L613.081 731.604C608.904 727.142 601.754 727.348 597.829 732.041C594.378 736.171 594.73 742.273 598.639 745.977L602.243 749.386C598.413 751.386 600.092 757.199 604.4 756.852L618.732 755.689V755.695Z",
    fill: "#FAEAC7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M382.272 755.695L410.488 753.895C416.044 753.543 420.768 749.702 422.246 744.336L422.904 741.942C423.204 740.853 423.225 739.711 422.972 738.612L422.362 736.007C420.936 729.889 412.292 729.71 410.614 735.765L408.41 731.541C405.358 725.696 396.604 727.232 395.714 733.761C393.368 725.196 381.457 724.57 378.226 732.845L378.095 733.177L376.616 731.604C372.434 727.142 365.289 727.348 361.364 732.041C357.913 736.171 358.266 742.273 362.175 745.977L365.779 749.386C361.948 751.386 363.627 757.199 367.936 756.852L382.267 755.689L382.272 755.695Z",
    fill: "#FAEAC7"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M541.135 750.418L568.261 742.447C573.601 740.88 577.363 736.092 577.626 730.531L577.742 728.053C577.794 726.927 577.563 725.806 577.073 724.791L575.906 722.381C573.164 716.731 564.694 718.457 564.389 724.733L561.306 721.098C557.044 716.068 548.842 719.493 549.416 726.059C545.238 718.22 533.48 720.235 532.154 729.021L532.101 729.374L530.312 728.163C525.246 724.733 518.322 726.506 515.534 731.951C513.077 736.739 514.766 742.616 519.396 745.367L523.662 747.903C520.369 750.697 523.283 756 527.408 754.711L541.135 750.423V750.418Z",
    fill: "#FAEAC7"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M743.359 744.479L729.596 737.229C725.129 734.877 722.42 730.169 722.625 725.128L722.825 720.414C722.872 719.194 723.225 718.01 723.851 716.958L725.514 714.138C728.991 708.256 738.019 710.918 737.74 717.747L741.597 713.849C746.637 708.756 755.228 713.201 753.982 720.257C759.258 712.028 771.985 715.343 772.585 725.102L774.711 723.871C780.524 720.504 787.969 723.04 790.52 729.253C792.714 734.604 790.415 740.744 785.254 743.343L780.014 745.989H749.446C747.321 745.989 745.232 745.473 743.354 744.484L743.359 744.479Z",
    fill: "#AACAC9",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M733.751 742.003L729.305 738.425C726.117 735.863 724.312 731.954 724.433 727.866L724.591 722.573C724.618 721.447 724.933 720.348 725.507 719.374L726.854 717.065C730.016 711.641 738.328 714.008 738.155 720.285L741.501 716.896C746.136 712.209 754.054 716.244 752.98 722.752C757.742 715.255 769.311 718.159 769.969 727.019L769.995 727.377L774.072 724.646C777.992 722.026 783.127 722.115 786.946 724.872L788.335 725.872C791.834 728.397 793.097 733.027 791.366 736.983C790.508 738.962 788.967 740.566 787.036 741.524L776.998 746.496H752.98L740.201 744.78C737.844 744.465 735.608 743.507 733.751 742.013V742.003Z",
    fill: "#6F9392"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M604.265 718.91H581.2V737.408H604.265V718.91Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M604.38 718.186H581.084V718.643H604.38V718.186Z",
    stroke: "#615E66",
    strokeWidth: 0.347236
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M583.184 715.217L581.474 718H603.997L602.287 715.217C602.097 714.912 601.766 714.728 601.408 714.728H584.062C583.704 714.728 583.373 714.912 583.184 715.217Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M604.265 731.088H581.2V737.407H604.265V731.088Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M585.083 732.92H583.336V735.277H585.083V732.92Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M589.04 732.92H587.293V735.277H589.04V732.92Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M597.566 732.92H595.819V735.277H597.566V732.92Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M601.829 732.92H600.082V735.277H601.829V732.92Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M601.528 725.002H600.387V729.49H601.528V725.002Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M601.528 720.124H600.387V722.176H601.528V720.124Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M597.267 725.002H596.431V729.49H597.267V725.002Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M597.268 720.124H596.432V722.176H597.268V720.124Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M593.002 725.002H592.165V729.49H593.002V725.002Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M593.002 720.124H592.165V722.176H593.002V720.124Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M588.74 725.002H587.903V729.49H588.74V725.002Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M588.74 720.124H587.903V722.176H588.74V720.124Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M584.778 725.002H583.941V729.49H584.778V725.002Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M584.778 720.124H583.941V722.176H584.778V720.124Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M593.605 732.92H591.858V737.408H593.605V732.92Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M874.987 710.599H807.66V737.409H874.987V710.599Z",
    fill: "#D8D0C3",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M874.987 729.409H807.66V737.406H874.987V729.409Z",
    fill: "#D8D0C3",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M812.043 716.027H810.923V719.321H812.043V716.027Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M877.146 712.429H805.51V713.513H877.146V712.429Z",
    fill: "#615E66"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M812.043 723.624H810.923V726.917H812.043V723.624Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M812.408 731.22H809.114V737.407H812.408V731.22Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M821.093 731.22H815.989V737.407H821.093V731.22Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M829.053 731.22H823.95V737.407H829.053V731.22Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M837.011 731.22H831.908V737.407H837.011V731.22Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M839.14 732.326C839.14 731.116 840.124 730.138 841.334 730.138C842.544 730.138 843.517 731.116 843.517 732.326V737.409H839.14V732.326Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M850.761 731.22H845.657V737.407H850.761V731.22Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M858.721 731.22H853.618V737.407H858.721V731.22Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M867.039 731.22H861.936V737.407H867.039V731.22Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M873.187 731.22H870.257V737.407H873.187V731.22Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M818.194 716.027H817.073V719.321H818.194V716.027Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M818.194 723.624H817.073V726.917H818.194V723.624Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M822.175 716.027H821.055V719.321H822.175V716.027Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M822.175 723.624H821.055V726.917H822.175V723.624Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M826.153 716.027H825.032V719.321H826.153V716.027Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M826.153 723.624H825.032V726.917H826.153V723.624Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M829.767 716.027H828.646V719.321H829.767V716.027Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M829.767 723.624H828.646V726.917H829.767V723.624Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M834.114 716.027H832.993V719.321H834.114V716.027Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M834.114 723.624H832.993V726.917H834.114V723.624Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M837.728 716.027H836.607V719.321H837.728V716.027Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M837.728 723.624H836.607V726.917H837.728V723.624Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M842.074 716.027H840.953V719.321H842.074V716.027Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M842.074 723.624H840.953V726.917H842.074V723.624Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M846.416 716.027H845.295V719.321H846.416V716.027Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M846.416 723.624H845.295V726.917H846.416V723.624Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M850.392 716.027H849.271V719.321H850.392V716.027Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M850.392 723.624H849.271V726.917H850.392V723.624Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M854.007 716.027H852.887V719.321H854.007V716.027Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M854.007 723.624H852.887V726.917H854.007V723.624Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M858.353 716.027H857.232V719.321H858.353V716.027Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M858.353 723.624H857.232V726.917H858.353V723.624Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M862.337 716.027H861.217V719.321H862.337V716.027Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M862.337 723.624H861.217V726.917H862.337V723.624Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M865.949 716.027H864.828V719.321H865.949V716.027Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M865.949 723.624H864.828V726.917H865.949V723.624Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M871.737 716.027H870.616V719.321H871.737V716.027Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M871.737 723.624H870.616V726.917H871.737V723.624Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M876.083 710.599H806.583V712.445H876.083V710.599Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M704.516 710.599H637.189V737.409H704.516V710.599Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M704.627 731.22H637.264V737.407H704.627V731.22Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M641.567 716.027H640.446V719.321H641.567V716.027Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M706.674 712.429H635.038V713.513H706.674V712.429Z",
    fill: "#615E66"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M704.627 723.659H637.264V729.157H704.627V723.659Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M642.078 731.22H637.264V737.407H642.078V731.22Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M704.627 731.22H637.264V737.407H704.627V731.22Z",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M650.616 731.22H645.513V737.407H650.616V731.22Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M659.948 731.22H654.45V737.407H659.948V731.22Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M666.536 731.22H661.433V737.407H666.536V731.22Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M668.667 732.326C668.667 731.116 669.651 730.138 670.861 730.138C672.071 730.138 673.044 731.116 673.044 732.326V737.409H668.667V732.326Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M680.284 731.22H675.181V737.407H680.284V731.22Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M688.243 731.22H683.14V737.407H688.243V731.22Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M696.561 731.22H691.458V737.407H696.561V731.22Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M704.63 731.22H699.816V737.407H704.63V731.22Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M706.006 715.41H637.264V721.597H706.006V715.41Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M706.006 715.41H637.264V716.099H706.006V715.41Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M706.006 723.659H637.264V724.348H706.006V723.659Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M706.006 731.22H637.264V731.909H706.006V731.22Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M701.258 723.624H700.138V726.917H701.258V723.624Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M705.608 710.599H636.108V713.129H705.608V710.599Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M706.006 710.599H637.264V711.288H706.006V710.599Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M1468.9 710.599H1401.58V737.409H1468.9V710.599Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M1469.02 731.22H1401.65V737.407H1469.02V731.22Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M1405.96 716.027H1404.83V719.321H1405.96V716.027Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M1471.06 712.429H1399.43V713.513H1471.06V712.429Z",
    fill: "#615E66"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M1469.02 723.659H1401.65V729.157H1469.02V723.659Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M1406.47 731.22H1401.65V737.407H1406.47V731.22Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M1469.02 731.22H1401.65V737.407H1469.02V731.22Z",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M1415 731.22H1409.9V737.407H1415V731.22Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M1424.33 731.22H1418.83V737.407H1424.33V731.22Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M1430.92 731.22H1425.82V737.407H1430.92V731.22Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M1433.05 732.326C1433.05 731.116 1434.03 730.138 1435.24 730.138C1436.45 730.138 1437.43 731.116 1437.43 732.326V737.409H1433.05V732.326Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M1444.67 731.22H1439.57V737.407H1444.67V731.22Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M1452.63 731.22H1447.53V737.407H1452.63V731.22Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M1460.95 731.22H1455.84V737.407H1460.95V731.22Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M1469.02 731.22H1464.21V737.407H1469.02V731.22Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M1470.39 715.41H1401.65V721.597H1470.39V715.41Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M1470.39 715.41H1401.65V716.099H1470.39V715.41Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M1470.39 723.659H1401.65V724.348H1470.39V723.659Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M1470.39 731.22H1401.65V731.909H1470.39V731.22Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M1465.65 723.624H1464.53V726.917H1465.65V723.624Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M1470 710.599H1400.5V713.129H1470V710.599Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M1470.39 710.599H1401.65V711.288H1470.39V710.599Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M1690.94 696.85H1623.62V737.408H1690.94V696.85Z",
    fill: "#CDD9F4",
    stroke: "#FFF9DE",
    strokeWidth: 0.526115
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M1691.05 727.785H1623.68V737.408H1691.05V727.785Z",
    fill: "#CDD9F4",
    stroke: "#FFF9DE",
    strokeWidth: 0.526115
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M1627.99 704.994H1626.87V710.276H1627.99V704.994Z",
    fill: "#FFF9DE",
    stroke: "#FFF9DE",
    strokeWidth: 0.526115
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M1691.73 716.442H1622.99V725.034H1691.73V716.442Z",
    fill: "#CDD9F4",
    stroke: "#FFF9DE",
    strokeWidth: 0.526115
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M1628.5 727.785H1623.68V737.408H1628.5V727.785Z",
    fill: "#CDD9F4",
    stroke: "#FFF9DE",
    strokeWidth: 0.526115
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M1691.05 727.786H1623.68V737.409H1691.05V727.786Z",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M1637.43 727.786H1631.93V737.409H1637.43V727.786Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M1645.67 727.786H1640.17V737.409H1645.67V727.786Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M1653.92 727.786H1648.42V737.409H1653.92V727.786Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M1662.17 727.786H1656.67V737.409H1662.17V727.786Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M1670.42 727.786H1664.92V737.409H1670.42V727.786Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M1678.67 727.786H1673.17V737.409H1678.67V727.786Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M1686.92 727.786H1681.42V737.409H1686.92V727.786Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M1691.73 704.067H1622.99V713.69H1691.73V704.067Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M1691.73 704.067H1622.99V705.441H1691.73V704.067Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M1691.73 716.443H1622.99V717.817H1691.73V716.443Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M1691.73 727.786H1622.99V729.159H1691.73V727.786Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M1691.73 696.851H1622.99V701.317H1691.73V696.851Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M1691.73 696.851H1622.99V698.224H1691.73V696.851Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M1692.08 699.604H1622.65V701.666H1692.08V699.604Z",
    fill: "#615E66"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M1629.18 704.067H1623.68V710.254H1629.18V704.067Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M1635.37 704.067H1629.87V710.254H1635.37V704.067Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M1641.55 704.067H1636.05V710.254H1641.55V704.067Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M1647.74 704.067H1642.24V710.254H1647.74V704.067Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M1653.92 704.067H1648.42V710.254H1653.92V704.067Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M1660.11 704.067H1654.61V710.254H1660.11V704.067Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M1666.3 704.067H1660.8V710.254H1666.3V704.067Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M1672.48 704.067H1666.99V710.254H1672.48V704.067Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M1678.67 704.067H1673.17V710.254H1678.67V704.067Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M1684.86 704.067H1679.36V710.254H1684.86V704.067Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M1691.05 704.067H1685.55V710.254H1691.05V704.067Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M1629.18 716.443H1623.68V721.941H1629.18V716.443Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M1635.37 716.443H1629.87V721.941H1635.37V716.443Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M1641.55 716.443H1636.05V721.941H1641.55V716.443Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M1647.74 716.443H1642.24V721.941H1647.74V716.443Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M1653.92 716.443H1648.42V721.941H1653.92V716.443Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M1660.11 716.443H1654.61V721.941H1660.11V716.443Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M1666.3 716.443H1660.8V721.941H1666.3V716.443Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M1672.48 716.443H1666.99V721.941H1672.48V716.443Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M1678.67 716.443H1673.17V721.941H1678.67V716.443Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M1684.86 716.443H1679.36V721.941H1684.86V716.443Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M1691.05 716.443H1685.55V721.941H1691.05V716.443Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M1360.29 710.599H1292.96V737.409H1360.29V710.599Z",
    fill: "#E4D4B1",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M1360.29 729.409H1292.96V737.406H1360.29V729.409Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M1297.34 716.027H1296.22V719.321H1297.34V716.027Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M1362.45 712.429H1290.81V713.513H1362.45V712.429Z",
    fill: "#615E66"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M1297.34 723.624H1296.22V726.917H1297.34V723.624Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M1297.71 731.22H1294.42V737.407H1297.71V731.22Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M1306.39 731.22H1301.29V737.407H1306.39V731.22Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M1314.35 731.22H1309.25V737.407H1314.35V731.22Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M1322.31 731.22H1317.21V737.407H1322.31V731.22Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M1324.44 732.326C1324.44 731.116 1325.43 730.138 1326.64 730.138C1327.85 730.138 1328.82 731.116 1328.82 732.326V737.409H1324.44V732.326Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M1336.06 731.22H1330.96V737.407H1336.06V731.22Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M1344.02 731.22H1338.92V737.407H1344.02V731.22Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M1352.34 731.22H1347.23V737.407H1352.34V731.22Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M1358.49 731.22H1355.56V737.407H1358.49V731.22Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M1303.5 716.027H1302.38V719.321H1303.5V716.027Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M1303.5 723.624H1302.38V726.917H1303.5V723.624Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M1307.48 716.027H1306.36V719.321H1307.48V716.027Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M1307.48 723.624H1306.36V726.917H1307.48V723.624Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M1311.46 716.027H1310.34V719.321H1311.46V716.027Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M1311.46 723.624H1310.34V726.917H1311.46V723.624Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M1315.07 716.027H1313.95V719.321H1315.07V716.027Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M1315.07 723.624H1313.95V726.917H1315.07V723.624Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M1319.42 716.027H1318.3V719.321H1319.42V716.027Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M1319.42 723.624H1318.3V726.917H1319.42V723.624Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M1323.03 716.027H1321.91V719.321H1323.03V716.027Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M1323.03 723.624H1321.91V726.917H1323.03V723.624Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M1327.38 716.027H1326.26V719.321H1327.38V716.027Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M1327.38 723.624H1326.26V726.917H1327.38V723.624Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M1331.71 716.027H1330.59V719.321H1331.71V716.027Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M1331.71 723.624H1330.59V726.917H1331.71V723.624Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M1335.69 716.027H1334.57V719.321H1335.69V716.027Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M1335.69 723.624H1334.57V726.917H1335.69V723.624Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M1339.31 716.027H1338.19V719.321H1339.31V716.027Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M1339.31 723.624H1338.19V726.917H1339.31V723.624Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M1343.66 716.027H1342.54V719.321H1343.66V716.027Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M1343.66 723.624H1342.54V726.917H1343.66V723.624Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M1347.63 716.027H1346.51V719.321H1347.63V716.027Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M1347.63 723.624H1346.51V726.917H1347.63V723.624Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M1351.25 716.027H1350.13V719.321H1351.25V716.027Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M1351.25 723.624H1350.13V726.917H1351.25V723.624Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M1357.04 716.027H1355.92V719.321H1357.04V716.027Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M1357.04 723.624H1355.92V726.917H1357.04V723.624Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M1361.38 710.599H1291.88V712.445H1361.38V710.599Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M364.416 696.576H351.447V737.408H364.416V696.576Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M370.385 698.774H364.672V737.407H370.385V698.774Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M361.001 696.576H354.861V737.408H361.001V696.576Z",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M383.619 696.576H370.65V737.408H383.619V696.576Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M380.204 696.576H374.064V737.408H380.204V696.576Z",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M380.2 696.576H377.475V737.408H380.2V696.576Z",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M360.996 696.576H358.271V737.408H360.996V696.576Z",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M356.971 689.743H356.755V696.404H356.971V689.743Z",
    stroke: "#615E66",
    strokeWidth: 0.163096
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M359.533 694.141H359.317V696.403H359.533V694.141Z",
    stroke: "#615E66",
    strokeWidth: 0.163096
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M1389.79 698.773H1384.08V737.406H1389.79V698.773Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M1402.33 688.6H1389.28V737.407H1402.33V688.6Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M1398.9 688.6H1392.71V737.407H1398.9V688.6Z",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M1398.9 688.6H1396.15V737.407H1398.9V688.6Z",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M1145.25 678.293H1119.82V737.407H1145.25V678.293Z",
    fill: "#D8D1C3",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M1145.94 676.914H1119.13V677.603H1145.94V676.914Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M1145.08 678.293H1119.99V681.045H1145.08V678.293Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M1145.08 711.975H1119.99V714.726H1145.08V711.975Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M1133.05 678.293H1122.57V707.85H1133.05V678.293Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M1131.51 731.909H1122.57V737.407H1131.51V731.909Z",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M1131.51 731.909H1126.69V737.407H1131.51V731.909Z",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M1142.16 731.909H1133.22V737.407H1142.16V731.909Z",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M1142.5 731.909H1137.69V737.407H1142.5V731.909Z",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M1126.17 716.784H1122.57V718.847H1126.17V716.784Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M1131.33 716.784H1127.72V718.847H1131.33V716.784Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M1142.5 716.784H1133.74V720.909H1142.5V716.784Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M1137.34 716.784H1133.74V718.847H1137.34V716.784Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M1142.5 716.784H1138.89V718.847H1142.5V716.784Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M1133.05 682.418H1122.57V689.294H1133.05V682.418Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M1133.05 692.041H1122.57V698.917H1133.05V692.041Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M1133.05 700.973H1122.57V707.849H1133.05V700.973Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M1132.88 682.418H1130.82V689.294H1132.88V682.418Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M1132.88 692.041H1130.82V698.917H1132.88V692.041Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M1132.88 700.973H1130.82V707.849H1132.88V700.973Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M1145.08 709.225H1119.99V709.914H1145.08V709.225Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M1142.5 682.418H1138.03V689.294H1142.5V682.418Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M1142.5 692.041H1138.03V698.917H1142.5V692.041Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M1142.5 700.973H1138.03V707.849H1142.5V700.973Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M1142.5 682.418H1141.13V689.294H1142.5V682.418Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M1142.5 692.041H1141.13V698.917H1142.5V692.041Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M1142.5 700.973H1141.13V707.849H1142.5V700.973Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M1129.61 682.418H1125.15V689.294H1129.61V682.418Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M1129.61 692.041H1125.15V698.917H1129.61V692.041Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M1129.61 700.973H1125.15V707.849H1129.61V700.973Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M1942.64 678.294H1917.2V737.408H1942.64V678.294Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M1943.32 676.915H1916.51V677.604H1943.32V676.915Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M1942.46 678.294H1917.37V681.046H1942.46V678.294Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M1942.46 711.976H1917.37V714.727H1942.46V711.976Z",
    fill: "#D7C6A2",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M1930.43 678.294H1919.95V707.851H1930.43V678.294Z",
    fill: "#D7C6A2",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M1928.89 728.469H1919.95V737.407H1928.89V728.469Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M1923.56 716.785H1919.95V718.848H1923.56V716.785Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M1930.43 682.419H1919.95V689.295H1930.43V682.419Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M1930.43 692.042H1919.95V698.918H1930.43V692.042Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M1930.43 700.974H1919.95V707.85H1930.43V700.974Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M1942.46 709.226H1917.37V709.915H1942.46V709.226Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M710.082 737.749H735.536C738.84 737.749 742.033 736.491 744.454 734.229L746.779 732.061C747.405 731.472 747.863 730.73 748.105 729.904L748.299 729.257C749.631 724.733 744.143 721.339 740.697 724.554V722.107C740.697 717.13 734.442 714.91 731.306 718.772C732.805 712.742 725.882 708.186 720.941 711.948L719.568 712.99L719.184 711.79C717.858 707.655 713.371 705.445 709.278 706.924C705.221 708.392 703.175 712.927 704.763 716.941L705.484 718.772C699.429 718.772 696.046 725.753 699.786 730.509L702.638 734.129C704.432 736.412 707.184 737.749 710.088 737.749H710.082Z",
    fill: "#E1F1F1",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M710.671 737.746H734.147C737.293 737.746 740.334 736.604 742.707 734.537L744.564 732.916C745.148 732.406 745.579 731.743 745.816 731.001C747.1 726.94 742.249 723.709 739.029 726.508V724.788C739.029 720.274 733.426 718.18 730.464 721.584C731.858 716.36 725.95 712.261 721.541 715.392L719.763 716.659L719.431 715.702C718.195 712.098 714.281 710.172 710.671 711.393C706.857 712.682 704.947 716.938 706.515 720.642L706.915 721.589C701.528 721.589 698.597 727.887 702.075 732.006L704.495 734.879C706.026 736.699 708.288 737.751 710.677 737.751L710.671 737.746Z",
    fill: "#AACAC9"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M655.134 736.08C655.134 733.145 655.739 730.246 656.907 727.557L658.08 724.864C660.353 719.634 667.782 719.634 670.055 724.864L671.228 727.557C672.396 730.246 673.001 733.145 673.001 736.08C673.001 736.812 672.412 737.406 671.675 737.406H656.455C655.718 737.406 655.129 736.812 655.129 736.08H655.134Z",
    fill: "#E1F1F1",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M657.544 735.744C657.544 733.35 658.044 730.983 659.017 728.794L659.575 727.542C661.706 722.744 668.513 722.744 670.644 727.542L671.202 728.794C672.17 730.983 672.675 733.35 672.675 735.744C672.675 736.47 672.086 737.065 671.354 737.065H658.87C658.138 737.065 657.549 736.475 657.549 735.744H657.544Z",
    fill: "#AACAC9"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M664.07 732.25V737.748",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M668.537 730.877L664.07 735.002",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M660.637 732.938L664.072 736.721",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M673.848 737.748H685.917C687.685 737.748 689.379 737.08 690.673 735.875L691.599 735.007C691.909 734.723 692.13 734.365 692.246 733.965L692.335 733.67C692.982 731.487 690.336 729.84 688.663 731.392V730.224C688.663 727.82 685.638 726.741 684.117 728.609C684.843 725.705 681.513 723.501 679.119 725.31L678.441 725.826L678.262 725.252C677.615 723.259 675.452 722.19 673.479 722.901C671.512 723.611 670.523 725.805 671.296 727.746L671.638 728.609C668.718 728.609 667.082 731.982 668.897 734.275L670.265 736.012C671.133 737.106 672.448 737.748 673.848 737.748Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M677.821 737.406L673.696 730.877",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M676.447 734.654L678.852 729.498",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M683.665 737.748L687.101 733.281",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M683.317 732.25L685.722 734.654",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M681.257 737.406L674.381 726.062",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M1367.92 737.751H1393.38C1396.68 737.751 1399.87 736.493 1402.29 734.231L1404.62 732.063C1405.24 731.474 1405.7 730.732 1405.94 729.906L1406.14 729.259C1407.47 724.735 1401.98 721.341 1398.54 724.556V722.109C1398.54 717.132 1392.28 714.912 1389.15 718.774C1390.65 712.744 1383.72 708.188 1378.78 711.95L1377.41 712.992L1377.02 711.792C1375.7 707.657 1371.21 705.447 1367.12 706.926C1363.06 708.393 1361.01 712.929 1362.6 716.943L1363.32 718.774C1357.27 718.774 1353.89 725.755 1357.63 730.511L1360.48 734.131C1362.27 736.414 1365.02 737.751 1367.93 737.751H1367.92Z",
    fill: "#FFD6D0",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M1368.51 737.75H1391.98C1395.13 737.75 1398.17 736.608 1400.54 734.541L1402.4 732.92C1402.99 732.41 1403.42 731.747 1403.65 731.005C1404.94 726.944 1400.09 723.713 1396.87 726.512V724.792C1396.87 720.278 1391.26 718.184 1388.3 721.588C1389.7 716.363 1383.79 712.265 1379.38 715.395L1377.6 716.663L1377.27 715.706C1376.03 712.102 1372.12 710.176 1368.51 711.397C1364.7 712.686 1362.79 716.942 1364.35 720.646L1364.75 721.593C1359.37 721.593 1356.44 727.891 1359.91 732.01L1362.33 734.883C1363.86 736.703 1366.13 737.755 1368.51 737.755L1368.51 737.75Z",
    fill: "#E9A59B"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M1381.72 737.066L1390.65 724.35",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M1385.84 731.562L1398.22 730.188",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M1384.81 721.256L1388.25 727.785",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M1384.47 733.283L1381.03 728.469",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M2171.85 759.062H-82.0938V765.939H2171.85V759.062Z",
    fill: "#FFF9DE"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M464.728 720.227H430.357V737.409H464.728V720.227Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M464.728 730.533H430.357V737.41H464.728V730.533Z",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M437.909 733.38H435.163V737.41H437.909V733.38Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M443.487 733.38H440.74V737.41H443.487V733.38Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M449.919 733.38H447.173V737.41H449.919V733.38Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M455.496 733.38H452.75V737.41H455.496V733.38Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M461.504 733.38H458.758V737.41H461.504V733.38Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M437.909 722.225H435.163V728.401H437.909V722.225Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M443.487 722.225H440.74V728.401H443.487V722.225Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M449.919 722.225H447.173V728.401H449.919V722.225Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M455.496 722.225H452.75V728.401H455.496V722.225Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M461.504 722.225H458.758V728.401H461.504V722.225Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M447.682 711.461L431.378 720.221H463.724L447.682 711.461Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M429.669 721.257L427.948 720.084L447.898 709.572L467.202 720.084L465.755 721.605L447.541 711.635L429.669 721.257Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M1176.87 720.227H1142.5V737.409H1176.87V720.227Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M1176.87 730.532H1142.5V737.409H1176.87V730.532Z",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M1150.05 733.38H1147.31V737.41H1150.05V733.38Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M1155.63 733.38H1152.88V737.41H1155.63V733.38Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M1162.06 733.38H1159.31V737.41H1162.06V733.38Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M1167.64 733.38H1164.89V737.41H1167.64V733.38Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M1173.64 733.38H1170.9V737.41H1173.64V733.38Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M1150.05 722.224H1147.31V728.4H1150.05V722.224Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M1155.63 722.224H1152.88V728.4H1155.63V722.224Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M1162.06 722.224H1159.31V728.4H1162.06V722.224Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M1167.64 722.224H1164.89V728.4H1167.64V722.224Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M1173.64 722.224H1170.9V728.4H1173.64V722.224Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M1159.83 711.461L1143.53 720.221H1175.87L1159.83 711.461Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M1141.81 721.257L1140.09 720.084L1160.04 709.572L1179.35 720.084L1177.9 721.605L1159.69 711.635L1141.81 721.257Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M1699.98 720.228H1665.61V737.41H1699.98V720.228Z",
    fill: "#F8E7C3",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M1699.98 730.533H1665.61V737.41H1699.98V730.533Z",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M1673.16 733.379H1670.42V737.409H1673.16V733.379Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M1678.74 733.379H1676V737.409H1678.74V733.379Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M1685.17 733.379H1682.42V737.409H1685.17V733.379Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M1690.74 733.379H1688V737.409H1690.74V733.379Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M1696.75 733.379H1694.01V737.409H1696.75V733.379Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M1673.16 722.224H1670.42V728.4H1673.16V722.224Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M1678.74 722.224H1676V728.4H1678.74V722.224Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M1685.17 722.224H1682.42V728.4H1685.17V722.224Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M1690.74 722.224H1688V728.4H1690.74V722.224Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M1696.75 722.224H1694.01V728.4H1696.75V722.224Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M1682.94 711.46L1666.64 720.22H1698.98L1682.94 711.46Z",
    fill: "#F8E7C3",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M1664.92 721.257L1663.2 720.084L1683.15 709.572L1702.46 720.084L1701.01 721.605L1682.8 711.635L1664.92 721.257Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M506.662 724.002C542.537 724.002 571.621 694.918 571.621 659.042C571.621 623.167 542.537 594.083 506.662 594.083C470.786 594.083 441.702 623.167 441.702 659.042C441.702 694.918 470.786 724.002 506.662 724.002ZM506.662 718.504C539.502 718.504 566.123 691.883 566.123 659.042C566.123 626.202 539.502 599.581 506.662 599.581C473.822 599.581 447.2 626.202 447.2 659.042C447.2 691.883 473.822 718.504 506.662 718.504Z",
    fill: "#EBC7B6"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M506.662 693.757C525.834 693.757 541.375 678.368 541.375 659.386C541.375 640.404 525.834 625.015 506.662 625.015C487.491 625.015 471.949 640.404 471.949 659.386C471.949 678.368 487.491 693.757 506.662 693.757ZM506.662 688.948C523.177 688.948 536.567 675.716 536.567 659.391C536.567 643.066 523.177 629.834 506.662 629.834C490.148 629.834 476.758 643.066 476.758 659.391C476.758 675.716 490.148 688.948 506.662 688.948Z",
    fill: "#EBC7B6"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M506.662 724.002C542.538 724.002 571.621 694.919 571.621 659.042C571.621 623.166 542.538 594.083 506.662 594.083C470.786 594.083 441.702 623.166 441.702 659.042C441.702 694.919 470.786 724.002 506.662 724.002Z",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M507.348 718.503V724.001",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M495.317 717.475L494.286 722.631",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M506.663 718.505C539.502 718.505 566.124 691.883 566.124 659.044C566.124 626.204 539.502 599.582 506.663 599.582C473.823 599.582 447.201 626.204 447.201 659.044C447.201 691.883 473.823 718.505 506.663 718.505Z",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M506.663 711.633C535.705 711.633 559.249 688.243 559.249 659.39C559.249 630.537 535.705 607.146 506.663 607.146C477.621 607.146 454.078 630.537 454.078 659.39C454.078 688.243 477.621 711.633 506.663 711.633Z",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M506.662 704.757C531.528 704.757 551.687 684.446 551.687 659.39C551.687 634.335 531.528 614.023 506.662 614.023C481.795 614.023 461.637 634.335 461.637 659.39C461.637 684.446 481.795 704.757 506.662 704.757Z",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M506.662 699.261C528.492 699.261 546.189 681.411 546.189 659.392C546.189 637.373 528.492 619.523 506.662 619.523C484.832 619.523 467.135 637.373 467.135 659.392C467.135 681.411 484.832 699.261 506.662 699.261Z",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M506.662 693.764C525.834 693.764 541.375 678.375 541.375 659.393C541.375 640.41 525.834 625.021 506.662 625.021C487.491 625.021 471.949 640.41 471.949 659.393C471.949 678.375 487.491 693.764 506.662 693.764Z",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M506.663 688.948C523.179 688.948 536.568 675.715 536.568 659.391C536.568 643.067 523.179 629.834 506.663 629.834C490.147 629.834 476.759 643.067 476.759 659.391C476.759 675.715 490.147 688.948 506.663 688.948Z",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M506.661 677.952C517.101 677.952 525.564 669.642 525.564 659.39C525.564 649.139 517.101 640.829 506.661 640.829C496.221 640.829 487.758 649.139 487.758 659.39C487.758 669.642 496.221 677.952 506.661 677.952Z",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M546.873 728.468H543.438C542.612 727.095 543.096 725.375 543.438 724.686H546.873C547.699 726.338 547.215 727.895 546.873 728.468Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M531.063 732.595H527.627C526.801 731.222 527.285 729.502 527.627 728.812H531.063C531.889 730.465 531.405 732.022 531.063 732.595Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M516.625 735.346H513.19C512.364 733.973 512.848 732.253 513.19 731.563H516.625C517.451 733.215 516.967 734.773 516.625 735.346Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M501.507 735.346H498.072C497.246 733.973 497.73 732.253 498.072 731.563H501.507C502.333 733.215 501.849 734.773 501.507 735.346Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M487.758 733.284H484.323C483.497 731.911 483.981 730.19 484.323 729.501H487.758C488.584 731.153 488.1 732.71 487.758 733.284Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M559.248 719.537H555.813C554.987 718.164 555.471 716.443 555.813 715.754H559.248C560.074 717.406 559.59 718.963 559.248 719.537Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M570.243 707.162H566.807C565.981 705.789 566.465 704.068 566.807 703.379H570.243C571.069 705.031 570.585 706.588 570.243 707.162Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M577.809 693.415H574.373C573.547 692.041 574.031 690.321 574.373 689.632H577.809C578.635 691.284 578.151 692.841 577.809 693.415Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M583.305 678.294H579.869C579.043 676.921 579.528 675.201 579.869 674.512H583.305C584.131 676.164 583.647 677.721 583.305 678.294Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M584.678 662.483H581.243C580.417 661.11 580.901 659.389 581.243 658.7H584.678C585.504 660.352 585.02 661.909 584.678 662.483Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M582.619 646.669H579.183C578.357 645.296 578.841 643.576 579.183 642.887H582.619C583.445 644.539 582.96 646.096 582.619 646.669Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M577.119 631.548H573.684C572.858 630.175 573.342 628.455 573.684 627.766H577.119C577.945 629.418 577.461 630.975 577.119 631.548Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M569.559 617.113H566.123C565.297 615.74 565.781 614.019 566.123 613.33H569.559C570.385 614.982 569.901 616.539 569.559 617.113Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M558.556 606.117H555.12C554.294 604.744 554.778 603.023 555.12 602.334H558.556C559.382 603.986 558.898 605.543 558.556 606.117Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M545.5 596.494H542.065C541.239 595.121 541.723 593.4 542.065 592.711H545.5C546.326 594.363 545.842 595.92 545.5 596.494Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M531.063 590.99H527.627C526.801 589.617 527.285 587.896 527.627 587.207H531.063C531.889 588.859 531.405 590.416 531.063 590.99Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M515.253 587.554H511.818C510.992 586.181 511.476 584.461 511.818 583.771H515.253C516.079 585.423 515.595 586.981 515.253 587.554Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M499.445 588.244H496.009C495.183 586.871 495.667 585.15 496.009 584.461H499.445C500.271 586.113 499.787 587.67 499.445 588.244Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M483.634 591.68H480.199C479.373 590.307 479.857 588.587 480.199 587.897H483.634C484.46 589.549 483.976 591.107 483.634 591.68Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M469.888 597.866H466.453C465.627 596.493 466.111 594.772 466.453 594.083H469.888C470.714 595.735 470.23 597.292 469.888 597.866Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M456.823 607.49H453.387C452.561 606.117 453.045 604.396 453.387 603.707H456.823C457.649 605.359 457.165 606.916 456.823 607.49Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M446.51 619.174H443.075C442.249 617.801 442.733 616.081 443.075 615.392H446.51C447.336 617.044 446.852 618.601 446.51 619.174Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M438.266 633.611H434.83C434.004 632.238 434.488 630.517 434.83 629.828H438.266C439.092 631.48 438.608 633.037 438.266 633.611Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M434.142 648.047H430.706C429.88 646.674 430.364 644.954 430.706 644.265H434.142C434.968 645.917 434.484 647.474 434.142 648.047Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M432.763 663.859H429.328C428.502 662.486 428.986 660.765 429.328 660.076H432.763C433.589 661.728 433.105 663.285 432.763 663.859Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M434.142 679.668H430.706C429.88 678.294 430.364 676.574 430.706 675.885H434.142C434.968 677.537 434.484 679.094 434.142 679.668Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M438.951 694.787H435.515C434.689 693.413 435.173 691.693 435.515 691.004H438.951C439.777 692.656 439.293 694.213 438.951 694.787Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M447.201 708.535H443.765C442.939 707.162 443.423 705.441 443.765 704.752H447.201C448.027 706.404 447.543 707.961 447.201 708.535Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M458.202 720.225H454.767C453.941 718.852 454.425 717.132 454.767 716.442H458.202C459.028 718.094 458.544 719.652 458.202 720.225Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M471.259 729.16H467.824C466.998 727.787 467.482 726.066 467.824 725.377H471.259C472.085 727.029 471.601 728.586 471.259 729.16Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M446.858 617.461L505.973 659.05",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M457.512 606.115L505.972 659.042",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M469.887 597.524L505.973 658.701",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M483.634 591.68L506.32 658.701",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M498.411 588.244L506.319 658.701",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M513.19 587.554L506.661 657.669",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M527.969 590.989L506.661 658.7",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M542.063 596.492L506.661 659.047",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M554.78 604.738L506.661 659.044",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M565.775 615.396L506.661 659.048",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M573.337 628.455L507.347 659.043",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M579.181 642.892L507.003 659.043",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M582.617 658.7L506.314 659.389",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M581.243 674.511L507.351 659.391",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M576.087 689.289L506.661 659.385",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M568.527 703.383L506.319 659.047",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M557.875 715.753L507.01 659.385",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M545.152 724.692L506.314 659.043",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M529.69 728.469L506.32 659.043",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M438.608 630.175L506.319 659.39",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M434.484 644.953L505.973 659.39",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M433.11 660.42L506.661 659.047",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M434.141 675.884L506.318 659.385",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M437.577 691.008L507.351 659.047",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M445.48 704.758L505.973 659.391",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M456.481 716.441L507.004 658.7",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M469.539 725.375L506.656 658.695",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M485.005 729.501L506.66 658.354",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M499.785 731.562L506.662 658.7",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M515.253 731.22L506.314 658.7",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M470.919 611.613L467.825 607.146",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M461.636 619.863L457.512 616.77",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M454.763 630.175L450.296 627.424",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M449.604 641.521L444.448 640.147",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M447.2 654.233L442.386 653.544",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M447.542 666.603L442.386 667.292",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M450.294 678.635L445.48 680.697",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M455.793 689.632L451.326 692.383",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M463.009 699.603L459.227 703.385",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M472.633 707.85L469.539 712.316",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M481.913 604.739L479.509 600.272",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M493.598 600.96L492.225 595.804",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M505.971 594.083V599.581",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M519.721 595.464L518.689 600.62",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M532.782 599.588L530.378 604.402",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M544.47 606.459L541.376 610.584",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M554.433 615.05L550.309 618.833",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M562.682 626.392L558.215 628.796",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M568.18 638.426L563.366 640.146",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M571.273 651.825L565.775 652.514",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M571.273 665.572L566.117 664.883",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M568.87 678.295L563.714 676.922",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M563.028 690.663L558.562 687.911",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M555.122 701.662L551.339 698.568",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M545.152 710.945L542.059 706.82",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M533.126 717.813L531.063 713.347",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M520.751 717.132L522.124 721.946",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M470.229 594.772L484.318 597.866",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M474.695 602.333L480.54 591.337",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M483.977 588.244L497.382 594.773",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M487.758 596.836L495.665 587.213",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M500.133 585.835L510.445 594.084",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M501.165 594.43L511.477 585.839",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M524.188 596.494L515.938 586.524",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M514.91 594.43L527.284 587.554",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M531.404 590.309L537.249 601.652",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M527.971 597.525L541.376 594.432",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M545.151 596.492L548.245 609.208",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M540.344 603.023L555.122 602.334",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M551.339 611.956L566.117 613.329",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M557.526 618.489V606.115",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M560.279 622.269L575.058 627.424",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M565.087 630.518L566.807 617.112",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M566.465 633.27L580.901 642.892",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M569.9 643.582L574.714 631.555",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M570.244 645.985L582.271 658.702",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M579.181 646.327L571.621 656.981",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M571.621 660.764L581.244 674.169",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M570.59 670.727L580.902 661.446",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M570.244 673.82L576.089 689.288",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M566.808 683.449L579.524 675.541",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M565.775 686.539L568.527 703.038",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M560.62 695.476L574.026 691.009",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M558.557 698.228L558.215 715.41",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M566.807 703.726L551.339 706.13",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M549.277 708.191L545.842 724.69",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M541.031 714.038L555.81 715.758",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M543.437 724.691L527.285 721.256",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M538.281 715.41L531.404 729.158",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M487.758 721.256L471.259 725.381",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M475.04 716.101L484.321 729.159",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M454.418 697.883L439.298 692.038",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M448.231 687.568L445.138 704.409",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M447.542 686.195L434.826 677.604",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M443.766 675.201L437.921 691.011",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M441.701 658.702L434.141 648.048",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M442.734 648.048L431.391 660.075",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M443.074 644.955L438.26 633.27",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M445.828 635.332L434.485 644.271",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M447.543 631.891L445.48 619.175",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M452.696 622.958L438.26 629.834",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M454.42 620.205V607.489",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M460.948 612.646L446.169 615.051",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M471.947 604.054H457.169",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M464.04 609.894L466.444 597.867",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M443.075 672.449L433.105 662.826",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M441.702 661.795L432.421 675.884",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M455.449 699.603V716.101",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M462.669 706.82L447.201 704.758",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M473.662 715.072L458.194 716.445",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M465.074 708.883L469.541 725.382",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M470.572 737.75L505.285 658.354L506.658 662.821L476.412 737.745H470.566L470.572 737.75Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M540.686 739.13L507.693 656.987L506.32 661.454L535.877 739.13H540.691H540.686Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M506.315 665.577C509.732 665.577 512.502 662.807 512.502 659.39C512.502 655.973 509.732 653.203 506.315 653.203C502.898 653.203 500.128 655.973 500.128 659.39C500.128 662.807 502.898 665.577 506.315 665.577Z",
    fill: "#E8E1F3",
    stroke: "#E8E1F3",
    strokeWidth: 0.526115
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M489.132 721.599L498.071 731.221",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M498.753 723.66L488.1 729.847",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M503.226 724.002L512.848 731.562",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M512.85 724.002L501.507 731.909",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M516.285 723.319L527.281 729.164",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M524.876 721.599L516.969 731.568",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M1252.59 749.437L1284.04 752.936C1289.6 753.551 1294.92 750.573 1297.3 745.517L1298.85 742.224C1299.38 741.119 1299.61 739.904 1299.55 738.688L1299.38 735.416C1299.02 728.592 1289.78 726.772 1286.87 732.948L1285.25 727.703C1283.15 720.858 1273.48 720.816 1271.31 727.645C1270.44 717.907 1257.63 714.95 1252.58 723.321L1251.27 721.242C1247.68 715.566 1239.9 714.366 1234.76 718.691C1230.34 722.416 1229.53 728.918 1232.9 733.617L1236.33 738.388C1231.58 739.846 1232.16 746.733 1237.07 747.38L1252.58 749.432L1252.59 749.437Z",
    fill: "#8AD6C4",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M1253.83 749.435L1281.91 752.807C1287.43 753.47 1292.77 750.555 1295.21 745.547L1296.29 743.311C1296.78 742.295 1297.02 741.175 1296.96 740.049L1296.84 737.376C1296.55 731.099 1288.08 729.353 1285.33 734.998L1283.93 730.442C1281.99 724.139 1273.1 724.05 1271.05 730.31C1270.3 721.461 1258.7 718.678 1254.01 726.222L1253.83 726.528L1252.66 724.712C1249.36 719.562 1242.3 718.462 1237.58 722.361C1233.43 725.791 1232.67 731.862 1235.84 736.213L1238.76 740.222C1234.63 741.49 1235.22 747.514 1239.52 747.956L1253.82 749.429L1253.83 749.435Z",
    fill: "#62AE80"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M1205.98 749.978L1192.22 742.728C1187.75 740.376 1185.04 735.668 1185.24 730.627L1185.44 725.913C1185.49 724.693 1185.84 723.509 1186.47 722.457L1188.13 719.637C1191.61 713.755 1200.64 716.417 1200.36 723.246L1204.22 719.348C1209.26 714.255 1217.85 718.7 1216.6 725.756C1221.88 717.527 1234.6 720.842 1235.2 730.601L1237.33 729.37C1243.14 726.003 1250.59 728.539 1253.14 734.752C1255.33 740.103 1253.03 746.243 1247.87 748.842L1242.63 751.488H1212.07C1209.94 751.488 1207.85 750.972 1205.97 749.983L1205.98 749.978Z",
    fill: "#8AD6C4",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M1196.37 747.501L1191.92 743.923C1188.74 741.361 1186.93 737.452 1187.05 733.364L1187.21 728.071C1187.24 726.945 1187.55 725.846 1188.12 724.872L1189.47 722.563C1192.63 717.139 1200.95 719.506 1200.77 725.783L1204.12 722.394C1208.75 717.707 1216.67 721.742 1215.6 728.25C1220.36 720.753 1231.93 723.657 1232.59 732.517L1232.61 732.875L1234.49 731.807C1239.8 728.771 1246.57 731.07 1248.94 736.71C1251.02 741.671 1248.89 747.401 1244.07 749.795L1239.62 751.994H1215.6L1202.82 750.279C1200.47 749.963 1198.23 749.005 1196.37 747.511L1196.37 747.501Z",
    fill: "#7CC69A"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M1143.63 728.106C1145.98 725.633 1146.45 721.919 1144.78 718.941L1135.32 702.006C1134.4 700.359 1132.03 700.359 1131.11 702.006L1121.38 719.441C1119.86 722.156 1120.19 725.533 1122.2 727.906C1123.62 729.574 1125.7 730.532 1127.89 730.532H1137.98C1140.11 730.532 1142.15 729.653 1143.63 728.106Z",
    fill: "#FFD6D0",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M1143.06 728.456C1145.33 726.341 1145.78 722.91 1144.13 720.285L1136.24 707.769C1135.16 706.059 1132.66 706.059 1131.59 707.769L1122.58 722.069C1121.57 723.678 1121.78 725.772 1123.09 727.151C1124.96 729.097 1127.54 730.197 1130.24 730.197H1138.66C1140.3 730.197 1141.87 729.576 1143.07 728.461L1143.06 728.456Z",
    fill: "#E9A59B"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M1133.22 713.008V738.44",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M1128.07 715.071L1132.88 719.885",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M1138.38 720.564L1133.56 725.378",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M1137.69 715.071L1132.88 719.885",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M1159.26 738.052C1162.46 735.175 1162 730.04 1158.36 727.767L1152.3 724C1151.36 723.421 1150.17 723.442 1149.27 724.063L1143.89 727.73C1140.41 730.108 1139.95 735.059 1142.93 738.037C1142.97 738.073 1143.02 738.094 1143.07 738.094H1159.14C1159.19 738.094 1159.23 738.079 1159.26 738.047V738.052Z",
    fill: "#E1F1F1"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M1159.26 738.047C1159.23 738.079 1159.19 738.094 1159.14 738.094H1143.07C1143.02 738.094 1142.97 738.073 1142.93 738.037C1139.95 735.059 1140.41 730.108 1143.89 727.73L1149.27 724.063C1150.17 723.442 1151.36 723.421 1152.3 724L1158.36 727.767C1162 730.04 1162.46 735.175 1159.26 738.052V738.047ZM1159.26 738.047L1159.49 738.305",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M1160.15 737.609C1162.24 735.1 1161.57 731.312 1158.74 729.67L1151.97 725.74C1151.22 725.309 1150.29 725.319 1149.55 725.767L1144.91 728.602C1141.6 730.617 1141.37 735.326 1144.46 737.662C1144.52 737.72 1144.61 737.746 1144.71 737.746H1159.84C1159.97 737.746 1160.07 737.694 1160.15 737.599V737.609Z",
    fill: "#62AE80"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M1151.78 732.253V737.751",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M1147.31 730.88L1151.78 735.005",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M1155.22 732.941L1151.78 736.724",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M1371.4 660.423H1356.28V672.797H1371.4V660.423Z",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M1352.84 663.674V672.792H1356.28V660.807L1352.84 663.669V663.674Z",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M1376.9 676.916H1165.87V681.041H1376.9V676.916Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M1165.04 687.226L1162.68 683.102H1381.39L1378.44 687.226H1165.04Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M1187.87 687.227H1165.19V737.407H1187.87V687.227Z",
    fill: "#FFF8E7",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M1187.87 687.227H1165.19V692.041H1187.87V687.227Z",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M1378.28 687.227H1355.59V692.041H1378.28V687.227Z",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M1183.05 719.538H1170V737.41H1183.05V719.538Z",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M1185.12 715.41H1168.62V716.783H1185.12V715.41Z",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M1169.88 719.537L1168.78 716.785H1184.86L1183.21 719.537H1169.88Z",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M1179.62 722.288H1174.12V737.409H1179.62V722.288Z",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M1181 706.472H1172.75V709.223H1181V706.472Z",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M1178.24 723.661H1175.49V730.537H1178.24V723.661Z",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M1378.28 687.227H1355.59V737.407H1378.28V687.227Z",
    fill: "#FFF8E7",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M1355.59 687.227H1187.87V691.351H1355.59V687.227Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M1355.59 691.352H1187.87V696.849H1355.59V691.352Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M1196.12 696.851H1187.87V737.409H1196.12V696.851Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M1218.8 696.851H1210.55V737.409H1218.8V696.851Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M1243.55 696.851H1235.3V737.409H1243.55V696.851Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M1266.92 696.851H1258.67V737.409H1266.92V696.851Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M1286.86 696.851H1278.61V737.409H1286.86V696.851Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M1310.91 696.851H1301.29V737.409H1310.91V696.851Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M1334.97 696.851H1323.28V737.409H1334.97V696.851Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M1355.59 696.851H1343.91V737.409H1355.59V696.851Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M1192.68 691.352H1187.87V693.414H1192.68V691.352Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M1191.99 693.413H1187.87V737.407H1191.99V693.413Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M1355.6 691.352H1350.78V693.414H1355.6V691.352Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M1355.59 693.413H1351.47V737.407H1355.59V693.413Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M1215.36 691.352H1209.86V693.414H1215.36V691.352Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M1214.68 693.413H1210.55V737.407H1214.68V693.413Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M1240.11 691.352H1234.61V693.414H1240.11V691.352Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M1239.42 693.413H1235.3V737.407H1239.42V693.413Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M1263.48 691.352H1257.98V693.414H1263.48V691.352Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M1262.8 693.413H1258.67V737.407H1262.8V693.413Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M1287.54 691.352H1282.04V693.414H1287.54V691.352Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M1286.85 693.413H1282.73V737.407H1286.85V693.413Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M1311.6 691.352H1306.1V693.414H1311.6V691.352Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M1310.91 693.413H1306.79V737.407H1310.91V693.413Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M1335.66 691.352H1330.16V693.414H1335.66V691.352Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M1334.97 693.413H1330.85V737.407H1334.97V693.413Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M1165.7 674.852L1164.16 672.79H1380L1378.45 674.852H1165.7Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M1165.7 676.917L1164.16 674.854H1380L1378.45 676.917H1165.7Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M1162.32 683.102L1160.73 681.04H1383.42L1381.82 683.102H1162.32Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M1176.87 705.106C1179.53 705.106 1181.68 702.951 1181.68 700.292C1181.68 697.634 1179.53 695.479 1176.87 695.479C1174.21 695.479 1172.06 697.634 1172.06 700.292C1172.06 702.951 1174.21 705.106 1176.87 705.106Z",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M1176.87 703.727C1178.77 703.727 1180.31 702.188 1180.31 700.291C1180.31 698.394 1178.77 696.855 1176.87 696.855C1174.98 696.855 1173.44 698.394 1173.44 700.291C1173.44 702.188 1174.98 703.727 1176.87 703.727Z",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M1265.54 661.796L1269.32 664.547L1274.48 672.797C1273.22 672.797 1270.29 672.729 1268.63 672.455C1265.33 670.529 1265.66 665.926 1266.23 663.864L1265.54 661.801V661.796Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.526115,
    strokeLinejoin: "round"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M1262.8 663.167L1266.58 665.571L1271.73 672.79C1270.48 672.79 1267.54 672.732 1265.89 672.49C1262.59 670.806 1262.91 666.776 1263.49 664.972L1262.8 663.167Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.526115,
    strokeLinejoin: "round"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M1260.04 663.857L1263.83 666.093L1268.98 672.796C1267.72 672.796 1264.79 672.738 1263.14 672.517C1259.84 670.955 1260.16 667.209 1260.73 665.536L1260.04 663.857Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.526115,
    strokeLinejoin: "round"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M1256.61 665.23L1260.39 667.119L1265.55 672.791C1264.29 672.791 1261.35 672.743 1259.7 672.554C1256.4 671.228 1256.72 668.066 1257.3 666.646L1256.61 665.23Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.526115,
    strokeLinejoin: "round"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M1254.55 667.985L1258.33 669.19L1263.48 672.799C1262.23 672.799 1259.29 672.768 1257.64 672.647C1254.34 671.805 1254.66 669.79 1255.24 668.885L1254.55 667.985Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.526115,
    strokeLinejoin: "round"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M1281.35 661.796L1277.57 664.547L1272.41 672.797C1273.67 672.797 1276.61 672.729 1278.26 672.455C1281.56 670.529 1281.24 665.926 1280.66 663.864L1281.35 661.801V661.796Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.526115,
    strokeLinejoin: "round"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M1284.1 663.167L1280.32 665.571L1275.16 672.79C1276.42 672.79 1279.36 672.732 1281.01 672.49C1284.31 670.806 1283.99 666.776 1283.41 664.972L1284.1 663.167Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.526115,
    strokeLinejoin: "round"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M1286.85 663.857L1283.07 666.093L1277.91 672.796C1279.17 672.796 1282.11 672.738 1283.76 672.517C1287.06 670.955 1286.74 667.209 1286.16 665.536L1286.85 663.857Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.526115,
    strokeLinejoin: "round"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M1290.29 665.23L1286.51 667.119L1281.35 672.791C1282.61 672.791 1285.54 672.743 1287.2 672.554C1290.5 671.228 1290.17 668.066 1289.6 666.646L1290.29 665.23Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.526115,
    strokeLinejoin: "round"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M1292.35 667.985L1288.57 669.19L1283.41 672.799C1284.67 672.799 1287.61 672.768 1289.26 672.647C1292.56 671.805 1292.24 669.79 1291.66 668.885L1292.35 667.985Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.526115,
    strokeLinejoin: "round"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M1273.45 671.419C1275.92 671.419 1277.92 669.419 1277.92 666.952C1277.92 664.485 1275.92 662.485 1273.45 662.485C1270.98 662.485 1268.98 664.485 1268.98 666.952C1268.98 669.419 1270.98 671.419 1273.45 671.419Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M1273.45 670.045C1275.16 670.045 1276.54 668.66 1276.54 666.951C1276.54 665.242 1275.16 663.857 1273.45 663.857C1271.74 663.857 1270.35 665.242 1270.35 666.951C1270.35 668.66 1271.74 670.045 1273.45 670.045Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M1170.28 697.314L1169.9 696.009C1169.77 695.572 1170.11 695.13 1170.57 695.13H1172.27C1172.36 695.13 1172.45 695.115 1172.52 695.083L1176.59 693.52C1176.77 693.452 1176.97 693.463 1177.14 693.547L1181.41 695.678C1181.58 695.767 1181.78 695.772 1181.97 695.699L1182.69 695.409C1183.07 695.257 1183.49 695.467 1183.61 695.856L1184.03 697.303C1184.07 697.451 1184.06 697.608 1184 697.745L1183.54 698.908C1183.45 699.118 1183.47 699.355 1183.6 699.544L1183.9 699.997C1184.02 700.176 1184.04 700.397 1183.98 700.597L1183.51 702.022C1183.44 702.222 1183.47 702.443 1183.59 702.622L1183.87 703.043C1184.01 703.248 1184.03 703.511 1183.92 703.732L1183.56 704.443C1183.46 704.637 1183.46 704.864 1183.56 705.058L1183.96 705.847C1184.05 706.021 1184.05 706.226 1183.98 706.41L1183.55 707.505C1183.46 707.715 1183.48 707.952 1183.61 708.141L1183.84 708.488C1183.99 708.72 1183.99 709.02 1183.84 709.251L1183.63 709.567C1183.49 709.772 1183.47 710.035 1183.58 710.256L1183.94 710.966C1184.04 711.161 1184.04 711.387 1183.94 711.582L1183.54 712.387C1183.45 712.55 1183.47 712.745 1183.57 712.892C1183.79 713.229 1183.55 713.681 1183.15 713.681H1170.72C1170.49 713.681 1170.27 713.565 1170.14 713.376L1169.88 712.981C1169.74 712.776 1169.73 712.513 1169.84 712.292L1170.19 711.582C1170.29 711.387 1170.29 711.161 1170.19 710.966L1169.84 710.256C1169.73 710.035 1169.74 709.772 1169.88 709.567L1170.09 709.251C1170.25 709.02 1170.25 708.72 1170.09 708.488L1169.86 708.141C1169.74 707.952 1169.71 707.715 1169.8 707.505L1170.23 706.41C1170.3 706.226 1170.3 706.021 1170.21 705.847L1169.81 705.058C1169.72 704.864 1169.72 704.637 1169.81 704.443L1170.19 703.68C1170.29 703.485 1170.29 703.259 1170.19 703.064L1169.79 702.275C1169.71 702.101 1169.7 701.896 1169.77 701.712L1170.21 700.618C1170.29 700.407 1170.27 700.171 1170.14 699.981L1169.85 699.55C1169.73 699.36 1169.7 699.124 1169.79 698.913L1170.25 697.75C1170.32 697.608 1170.32 697.451 1170.28 697.308V697.314Z",
    stroke: "#615E66",
    strokeWidth: 0.526115,
    strokeLinejoin: "round"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M1373.46 719.538H1360.41V737.41H1373.46V719.538Z",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M1375.53 715.41H1359.03V716.783H1375.53V715.41Z",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M1360.29 719.537L1359.2 716.785H1375.27L1373.62 719.537H1360.29Z",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M1370.03 722.288H1364.53V737.409H1370.03V722.288Z",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M1371.4 706.472H1363.15V709.223H1371.4V706.472Z",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M1368.66 723.661H1365.9V730.537H1368.66V723.661Z",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M1367.28 705.106C1369.94 705.106 1372.09 702.951 1372.09 700.292C1372.09 697.634 1369.94 695.479 1367.28 695.479C1364.62 695.479 1362.46 697.634 1362.46 700.292C1362.46 702.951 1364.62 705.106 1367.28 705.106Z",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M1367.28 703.727C1369.17 703.727 1370.71 702.188 1370.71 700.291C1370.71 698.394 1369.17 696.855 1367.28 696.855C1365.38 696.855 1363.84 698.394 1363.84 700.291C1363.84 702.188 1365.38 703.727 1367.28 703.727Z",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M1360.68 697.314L1360.31 696.009C1360.18 695.572 1360.51 695.13 1360.97 695.13H1362.68C1362.77 695.13 1362.85 695.115 1362.93 695.083L1367 693.52C1367.18 693.452 1367.38 693.463 1367.55 693.547L1371.81 695.678C1371.99 695.767 1372.19 695.772 1372.38 695.699L1373.1 695.409C1373.47 695.257 1373.9 695.467 1374.01 695.856L1374.43 697.303C1374.47 697.451 1374.47 697.608 1374.41 697.745L1373.94 698.908C1373.85 699.118 1373.88 699.355 1374.01 699.544L1374.31 699.997C1374.42 700.176 1374.45 700.397 1374.39 700.597L1373.91 702.022C1373.85 702.222 1373.87 702.443 1374 702.622L1374.28 703.043C1374.42 703.248 1374.43 703.511 1374.32 703.732L1373.96 704.443C1373.87 704.637 1373.87 704.864 1373.96 705.058L1374.36 705.847C1374.45 706.021 1374.46 706.226 1374.39 706.41L1373.95 707.505C1373.86 707.715 1373.89 707.952 1374.02 708.141L1374.25 708.488C1374.4 708.72 1374.4 709.02 1374.25 709.251L1374.04 709.567C1373.9 709.772 1373.89 710.035 1374 710.256L1374.35 710.966C1374.45 711.161 1374.45 711.387 1374.35 711.582L1373.95 712.387C1373.86 712.55 1373.88 712.745 1373.99 712.892C1374.21 713.229 1373.96 713.681 1373.56 713.681H1361.13C1360.9 713.681 1360.68 713.565 1360.55 713.376L1360.29 712.981C1360.15 712.776 1360.14 712.513 1360.25 712.292L1360.61 711.582C1360.7 711.387 1360.7 711.161 1360.61 710.966L1360.25 710.256C1360.14 710.035 1360.15 709.772 1360.29 709.567L1360.5 709.251C1360.65 709.02 1360.65 708.72 1360.5 708.488L1360.27 708.141C1360.14 707.952 1360.12 707.715 1360.21 707.505L1360.64 706.41C1360.71 706.226 1360.71 706.021 1360.62 705.847L1360.22 705.058C1360.12 704.864 1360.12 704.637 1360.22 704.443L1360.6 703.68C1360.7 703.485 1360.7 703.259 1360.6 703.064L1360.2 702.275C1360.11 702.101 1360.11 701.896 1360.18 701.712L1360.61 700.618C1360.7 700.407 1360.67 700.171 1360.55 699.981L1360.26 699.55C1360.13 699.36 1360.11 699.124 1360.2 698.913L1360.66 697.75C1360.72 697.608 1360.73 697.451 1360.68 697.308V697.314Z",
    stroke: "#615E66",
    strokeWidth: 0.526115,
    strokeLinejoin: "round"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M1187.18 660.423H1172.06V672.797H1187.18V660.423Z",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M1190.62 663.674V672.792H1187.18V660.807L1190.62 663.669V663.674Z",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M1168.92 665.398L1170.23 672.238C1170.29 672.564 1170.58 672.795 1170.91 672.795H1244.92C1245.3 672.795 1245.61 672.485 1245.61 672.106V670.286C1245.61 670.128 1245.56 669.976 1245.46 669.855L1244.36 668.481C1244.28 668.376 1244.23 668.25 1244.22 668.118L1243.9 664.977C1243.9 664.914 1243.88 664.856 1243.86 664.799L1242.96 662.463C1242.76 661.915 1241.95 662.005 1241.87 662.589C1241.78 663.199 1240.93 663.257 1240.75 662.663L1240.73 662.552C1240.55 661.968 1239.72 661.984 1239.58 662.573L1239.38 663.367C1239.23 663.978 1238.35 663.957 1238.22 663.341L1238.13 662.847C1238.02 662.347 1237.32 662.331 1237.19 662.826L1237.15 662.999C1237.03 663.452 1236.39 663.436 1236.3 662.978C1236.21 662.547 1235.6 662.499 1235.45 662.915L1235.13 663.799C1234.97 664.241 1234.33 664.215 1234.21 663.762C1234.07 663.252 1233.33 663.304 1233.27 663.825L1233.25 663.909C1233.18 664.462 1232.4 664.499 1232.27 663.957L1231.93 662.542C1231.81 662.036 1231.1 662 1230.94 662.499L1230.81 662.862C1230.66 663.315 1230 663.236 1229.96 662.762C1229.92 662.294 1229.27 662.205 1229.11 662.647L1228.94 663.125C1228.76 663.61 1228.08 663.61 1227.9 663.125L1227.64 662.384C1227.46 661.894 1226.76 661.931 1226.63 662.436L1226.55 662.736C1226.44 663.22 1225.74 663.194 1225.65 662.699C1225.57 662.221 1224.89 662.173 1224.75 662.641L1224.45 663.636C1224.32 664.072 1223.69 664.046 1223.6 663.604L1223.55 663.41C1223.47 663.036 1222.95 662.999 1222.82 663.357C1222.67 663.736 1222.12 663.662 1222.07 663.262V663.199C1222.03 662.778 1221.44 662.705 1221.3 663.104L1221.16 663.462C1220.99 663.936 1220.31 663.867 1220.23 663.367L1220.17 662.978C1220.1 662.51 1219.44 662.489 1219.33 662.947L1219.31 663.004C1219.21 663.457 1218.56 663.425 1218.5 662.968L1218.46 662.705C1218.4 662.273 1217.77 662.263 1217.71 662.699C1217.64 663.11 1217.07 663.136 1216.97 662.736L1216.88 662.352C1216.76 661.884 1216.09 661.894 1215.98 662.368L1215.9 662.747C1215.77 663.325 1214.95 663.325 1214.82 662.747L1214.8 662.657C1214.68 662.079 1213.87 662.052 1213.7 662.62L1213.58 663.047C1213.39 663.694 1212.48 663.699 1212.28 663.052C1212.08 662.394 1211.14 662.41 1210.96 663.073L1210.91 663.283C1210.73 663.973 1209.74 663.962 1209.58 663.262L1209.37 662.378C1209.24 661.842 1208.47 661.852 1208.37 662.394L1208.33 662.573C1208.22 663.099 1207.47 663.083 1207.39 662.552C1207.31 662.063 1206.64 661.994 1206.46 662.452L1206.21 663.11C1206 663.673 1205.18 663.573 1205.09 662.978C1205.01 662.347 1204.11 662.289 1203.95 662.905L1203.86 663.283C1203.69 663.883 1202.85 663.92 1202.65 663.336L1202.55 663.083C1202.37 662.578 1201.65 662.61 1201.5 663.125C1201.35 663.678 1200.56 663.662 1200.43 663.104L1200.27 662.405C1200.15 661.879 1199.44 661.81 1199.22 662.305L1199.02 662.731C1198.86 663.089 1198.33 663.036 1198.25 662.652C1198.16 662.221 1197.54 662.231 1197.45 662.663L1197.31 663.373C1197.22 663.852 1196.52 663.83 1196.46 663.346C1196.4 662.862 1195.7 662.841 1195.61 663.32L1195.55 663.583C1195.45 664.094 1194.72 664.094 1194.62 663.583L1194.56 663.32C1194.46 662.789 1193.7 662.799 1193.6 663.331C1193.51 663.883 1192.7 663.841 1192.63 663.283C1192.57 662.752 1191.82 662.678 1191.68 663.199C1191.55 663.646 1190.93 663.688 1190.76 663.262L1190.73 663.215C1190.56 662.81 1189.98 662.805 1189.8 663.21L1189.41 664.099C1189.19 664.593 1188.51 664.651 1188.2 664.199L1187.3 662.847C1187.1 662.536 1186.63 662.563 1186.46 662.899C1186.25 663.32 1185.63 663.231 1185.54 662.768L1185.53 662.678C1185.42 662.136 1184.66 662.1 1184.51 662.636L1184.48 662.752C1184.35 663.247 1183.67 663.299 1183.46 662.836L1182.91 661.621C1182.72 661.221 1182.14 661.268 1182.02 661.689L1181.84 662.315C1181.74 662.694 1181.19 662.647 1181.15 662.252C1181.11 661.863 1180.57 661.81 1180.45 662.184L1180.36 662.52C1180.23 662.92 1179.67 662.92 1179.55 662.52L1179.46 662.221C1179.31 661.721 1178.59 661.737 1178.47 662.242L1178.41 662.478C1178.29 662.962 1177.6 662.936 1177.51 662.447C1177.42 661.984 1176.79 661.931 1176.62 662.373L1176.46 662.81C1176.27 663.346 1175.49 663.315 1175.34 662.762L1175.25 662.415C1175.11 661.921 1174.42 661.905 1174.26 662.389C1174.1 662.862 1173.43 662.862 1173.28 662.389L1173.25 662.315C1173.09 661.821 1172.38 661.821 1172.22 662.315L1171.98 663.041C1171.86 663.394 1171.39 663.478 1171.17 663.189C1170.88 662.841 1170.33 663.036 1170.33 663.483V664.809C1170.33 665.188 1169.86 665.356 1169.62 665.067C1169.35 664.746 1168.83 664.993 1168.91 665.404L1168.92 665.398Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115,
    strokeLinejoin: "round"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M1375.23 665.398L1373.92 672.238C1373.85 672.564 1373.57 672.795 1373.24 672.795H1299.23C1298.85 672.795 1298.54 672.485 1298.54 672.106V670.286C1298.54 670.128 1298.59 669.976 1298.69 669.855L1299.79 668.481C1299.87 668.376 1299.92 668.25 1299.93 668.118L1300.25 664.977C1300.25 664.914 1300.27 664.856 1300.29 664.799L1301.19 662.463C1301.39 661.915 1302.2 662.005 1302.28 662.589C1302.37 663.199 1303.22 663.257 1303.4 662.663L1303.42 662.552C1303.6 661.968 1304.43 661.984 1304.57 662.573L1304.77 663.367C1304.92 663.978 1305.8 663.957 1305.93 663.341L1306.02 662.847C1306.13 662.347 1306.83 662.331 1306.96 662.826L1307 662.999C1307.12 663.452 1307.76 663.436 1307.85 662.978C1307.94 662.547 1308.55 662.499 1308.7 662.915L1309.02 663.799C1309.18 664.241 1309.82 664.215 1309.94 663.762C1310.08 663.252 1310.82 663.304 1310.88 663.825L1310.9 663.909C1310.97 664.462 1311.75 664.499 1311.88 663.957L1312.22 662.542C1312.34 662.036 1313.05 662 1313.21 662.499L1313.34 662.862C1313.49 663.315 1314.15 663.236 1314.19 662.762C1314.23 662.294 1314.88 662.205 1315.04 662.647L1315.21 663.125C1315.39 663.61 1316.07 663.61 1316.25 663.125L1316.51 662.384C1316.69 661.894 1317.39 661.931 1317.52 662.436L1317.6 662.736C1317.71 663.22 1318.41 663.194 1318.5 662.699C1318.58 662.221 1319.25 662.173 1319.4 662.641L1319.7 663.636C1319.83 664.072 1320.46 664.046 1320.55 663.604L1320.6 663.41C1320.68 663.036 1321.2 662.999 1321.33 663.357C1321.47 663.736 1322.03 663.662 1322.07 663.262V663.199C1322.12 662.778 1322.71 662.705 1322.85 663.104L1322.98 663.462C1323.16 663.936 1323.84 663.867 1323.92 663.367L1323.98 662.978C1324.05 662.51 1324.71 662.489 1324.82 662.947L1324.84 663.004C1324.94 663.457 1325.59 663.425 1325.65 662.968L1325.69 662.705C1325.75 662.273 1326.38 662.263 1326.44 662.699C1326.5 663.11 1327.08 663.136 1327.18 662.736L1327.27 662.352C1327.39 661.884 1328.06 661.894 1328.17 662.368L1328.25 662.747C1328.38 663.325 1329.2 663.325 1329.32 662.747L1329.35 662.657C1329.47 662.079 1330.28 662.052 1330.44 662.62L1330.57 663.047C1330.76 663.694 1331.67 663.699 1331.87 663.052C1332.07 662.394 1333.01 662.41 1333.19 663.073L1333.24 663.283C1333.42 663.973 1334.41 663.962 1334.57 663.262L1334.77 662.378C1334.91 661.842 1335.67 661.852 1335.78 662.394L1335.82 662.573C1335.93 663.099 1336.68 663.083 1336.76 662.552C1336.84 662.063 1337.51 661.994 1337.68 662.452L1337.94 663.11C1338.15 663.673 1338.97 663.573 1339.06 662.978C1339.14 662.347 1340.04 662.289 1340.2 662.905L1340.29 663.283C1340.46 663.883 1341.3 663.92 1341.5 663.336L1341.6 663.083C1341.78 662.578 1342.5 662.61 1342.65 663.125C1342.8 663.678 1343.59 663.662 1343.72 663.104L1343.88 662.405C1344 661.879 1344.71 661.81 1344.93 662.305L1345.13 662.731C1345.29 663.089 1345.82 663.036 1345.9 662.652C1345.99 662.221 1346.61 662.231 1346.7 662.663L1346.84 663.373C1346.93 663.852 1347.63 663.83 1347.69 663.346C1347.75 662.862 1348.45 662.841 1348.54 663.32L1348.6 663.583C1348.7 664.094 1349.43 664.094 1349.53 663.583L1349.59 663.32C1349.69 662.789 1350.45 662.799 1350.55 663.331C1350.64 663.883 1351.45 663.841 1351.52 663.283C1351.58 662.752 1352.33 662.678 1352.47 663.199C1352.6 663.646 1353.22 663.688 1353.39 663.262L1353.42 663.215C1353.59 662.81 1354.17 662.805 1354.35 663.21L1354.74 664.099C1354.96 664.593 1355.64 664.651 1355.95 664.199L1356.85 662.847C1357.05 662.536 1357.52 662.563 1357.69 662.899C1357.9 663.32 1358.52 663.231 1358.61 662.768L1358.62 662.678C1358.73 662.136 1359.49 662.1 1359.64 662.636L1359.67 662.752C1359.8 663.247 1360.48 663.299 1360.69 662.836L1361.24 661.621C1361.43 661.221 1362.01 661.268 1362.13 661.689L1362.31 662.315C1362.41 662.694 1362.96 662.647 1363 662.252C1363.04 661.863 1363.58 661.81 1363.7 662.184L1363.79 662.52C1363.92 662.92 1364.48 662.92 1364.6 662.52L1364.69 662.221C1364.84 661.721 1365.56 661.737 1365.68 662.242L1365.74 662.478C1365.86 662.962 1366.55 662.936 1366.64 662.447C1366.73 661.984 1367.36 661.931 1367.53 662.373L1367.69 662.81C1367.88 663.346 1368.66 663.315 1368.81 662.762L1368.9 662.415C1369.04 661.921 1369.73 661.905 1369.89 662.389C1370.05 662.862 1370.72 662.862 1370.87 662.389L1370.9 662.315C1371.06 661.821 1371.77 661.821 1371.93 662.315L1372.17 663.041C1372.29 663.394 1372.76 663.478 1372.98 663.189C1373.27 662.841 1373.82 663.036 1373.82 663.483V664.809C1373.82 665.188 1374.29 665.356 1374.53 665.067C1374.8 664.746 1375.32 664.993 1375.24 665.404L1375.23 665.398Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115,
    strokeLinejoin: "round"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M1298.88 672.448L1299.01 666.645C1299.03 665.667 1299.82 664.888 1300.8 664.888C1301.77 664.888 1302.56 665.651 1302.6 666.614L1302.82 672.448L1303.01 666.535C1303.05 665.619 1303.8 664.888 1304.72 664.888C1305.63 664.888 1306.39 665.614 1306.42 666.53L1306.64 672.448L1306.87 666.582C1306.91 665.635 1307.68 664.888 1308.63 664.888C1309.57 664.888 1310.35 665.635 1310.38 666.582L1310.6 672.448L1310.88 666.377C1310.92 665.54 1311.61 664.883 1312.45 664.883C1313.3 664.883 1314.01 665.583 1314.01 666.445V672.443",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M1314 672.448L1314.13 666.645C1314.15 665.667 1314.94 664.888 1315.92 664.888C1316.89 664.888 1317.68 665.651 1317.72 666.614L1317.94 672.448L1318.13 666.535C1318.17 665.619 1318.92 664.888 1319.84 664.888C1320.75 664.888 1321.5 665.614 1321.54 666.53L1321.76 672.448L1321.99 666.582C1322.03 665.635 1322.8 664.888 1323.75 664.888C1324.69 664.888 1325.47 665.635 1325.5 666.582L1325.72 672.448L1326 666.377C1326.04 665.54 1326.73 664.883 1327.57 664.883C1328.42 664.883 1329.13 665.583 1329.13 666.445V672.443",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "M1329.13 672.448L1329.25 666.645C1329.28 665.667 1330.08 664.888 1331.05 664.888C1332.01 664.888 1332.81 665.651 1332.84 666.614L1333.06 672.448L1333.26 666.535C1333.29 665.619 1334.05 664.888 1334.96 664.888C1335.88 664.888 1336.63 665.614 1336.67 666.53L1336.89 672.448L1337.11 666.582C1337.15 665.635 1337.92 664.888 1338.87 664.888C1339.82 664.888 1340.6 665.635 1340.63 666.582L1340.85 672.448L1341.12 666.377C1341.17 665.54 1341.85 664.883 1342.69 664.883C1343.55 664.883 1344.25 665.583 1344.25 666.445V672.443",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "M1344.25 672.448L1344.37 666.645C1344.4 665.667 1345.2 664.888 1346.17 664.888C1347.13 664.888 1347.93 665.651 1347.96 666.614L1348.18 672.448L1348.38 666.535C1348.41 665.619 1349.17 664.888 1350.08 664.888C1351 664.888 1351.75 665.614 1351.79 666.53L1352.01 672.448L1352.23 666.582C1352.27 665.635 1353.04 664.888 1353.99 664.888C1354.94 664.888 1355.72 665.635 1355.75 666.582L1355.97 672.448L1356.24 666.377C1356.29 665.54 1356.97 664.883 1357.81 664.883C1358.67 664.883 1359.37 665.583 1359.37 666.445V672.443",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "M1359.37 672.448L1359.5 666.645C1359.52 665.667 1360.32 664.888 1361.29 664.888C1362.26 664.888 1363.05 665.651 1363.09 666.614L1363.31 672.448L1363.5 666.535C1363.54 665.619 1364.29 664.888 1365.21 664.888C1366.12 664.888 1366.88 665.614 1366.91 666.53L1367.13 672.448L1367.36 666.582C1367.4 665.635 1368.17 664.888 1369.12 664.888C1370.06 664.888 1370.84 665.635 1370.87 666.582L1371.1 672.448L1371.37 666.377C1371.41 665.54 1372.1 664.883 1372.94 664.883C1373.79 664.883 1374.5 665.583 1374.5 666.445V672.443",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "M1168.96 672.448L1169.09 666.645C1169.11 665.667 1169.9 664.888 1170.88 664.888C1171.85 664.888 1172.64 665.651 1172.68 666.614L1172.9 672.448L1173.09 666.535C1173.13 665.619 1173.88 664.888 1174.8 664.888C1175.71 664.888 1176.47 665.614 1176.5 666.53L1176.72 672.448L1176.95 666.582C1176.99 665.635 1177.76 664.888 1178.71 664.888C1179.65 664.888 1180.43 665.635 1180.46 666.582L1180.68 672.448L1180.96 666.377C1181 665.54 1181.69 664.883 1182.53 664.883C1183.38 664.883 1184.09 665.583 1184.09 666.445V672.443",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "M1184.09 672.448L1184.22 666.645C1184.24 665.667 1185.03 664.888 1186.01 664.888C1186.97 664.888 1187.77 665.651 1187.8 666.614L1188.02 672.448L1188.22 666.535C1188.26 665.619 1189.01 664.888 1189.92 664.888C1190.84 664.888 1191.59 665.614 1191.63 666.53L1191.85 672.448L1192.08 666.582C1192.11 665.635 1192.89 664.888 1193.83 664.888C1194.78 664.888 1195.56 665.635 1195.59 666.582L1195.81 672.448L1196.08 666.377C1196.13 665.54 1196.82 664.883 1197.65 664.883C1198.51 664.883 1199.21 665.583 1199.21 666.445V672.443",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "M1199.21 672.448L1199.33 666.645C1199.35 665.667 1200.15 664.888 1201.13 664.888C1202.09 664.888 1202.88 665.651 1202.92 666.614L1203.14 672.448L1203.34 666.535C1203.37 665.619 1204.13 664.888 1205.04 664.888C1205.96 664.888 1206.71 665.614 1206.75 666.53L1206.97 672.448L1207.19 666.582C1207.23 665.635 1208 664.888 1208.95 664.888C1209.9 664.888 1210.68 665.635 1210.71 666.582L1210.93 672.448L1211.2 666.377C1211.24 665.54 1211.93 664.883 1212.77 664.883C1213.63 664.883 1214.33 665.583 1214.33 666.445V672.443",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "M1214.33 672.448L1214.46 666.645C1214.48 665.667 1215.27 664.888 1216.25 664.888C1217.21 664.888 1218.01 665.651 1218.04 666.614L1218.27 672.448L1218.46 666.535C1218.5 665.619 1219.25 664.888 1220.16 664.888C1221.08 664.888 1221.83 665.614 1221.87 666.53L1222.09 672.448L1222.32 666.582C1222.35 665.635 1223.13 664.888 1224.07 664.888C1225.02 664.888 1225.8 665.635 1225.83 666.582L1226.05 672.448L1226.33 666.377C1226.37 665.54 1227.06 664.883 1227.89 664.883C1228.75 664.883 1229.46 665.583 1229.46 666.445V672.443",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "M1229.46 672.448L1229.58 666.645C1229.6 665.667 1230.4 664.888 1231.38 664.888C1232.34 664.888 1233.13 665.651 1233.17 666.614L1233.39 672.448L1233.59 666.535C1233.62 665.619 1234.37 664.888 1235.29 664.888C1236.21 664.888 1236.96 665.614 1236.99 666.53L1237.22 672.448L1237.44 666.582C1237.48 665.635 1238.25 664.888 1239.2 664.888C1240.15 664.888 1240.92 665.635 1240.96 666.582L1241.18 672.448L1241.45 666.377C1241.49 665.54 1242.18 664.883 1243.02 664.883C1243.88 664.883 1244.58 665.583 1244.58 666.445V672.443",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "M1183.05 674.854H1170V678.979H1183.05V674.854Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "M1211.24 676.916H1213.3C1214.43 676.916 1215.36 677.837 1215.36 678.978C1215.36 680.115 1214.44 681.041 1213.3 681.041H1211.24C1210.1 681.041 1209.17 680.12 1209.17 678.978C1209.17 677.842 1210.09 676.916 1211.24 676.916Z",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "M1356.28 667.309C1358.59 667.482 1360.41 669.413 1360.41 671.765V672.796H1356.28V667.309Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "M1376.9 667.309C1374.59 667.482 1372.77 669.413 1372.77 671.765V672.796H1376.9V667.309Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "M1310.91 669.355C1310.91 668.219 1309.99 667.293 1308.85 667.293C1307.71 667.293 1306.79 668.214 1306.79 669.355V672.791H1310.91V669.355Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "M1334.97 669.355C1334.97 668.219 1334.05 667.293 1332.91 667.293C1331.77 667.293 1330.84 668.214 1330.84 669.355V672.791H1334.97V669.355Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "M1235.98 676.916H1238.05C1239.18 676.916 1240.11 677.837 1240.11 678.978C1240.11 680.115 1239.19 681.041 1238.05 681.041H1235.98C1234.85 681.041 1233.92 680.12 1233.92 678.978C1233.92 677.842 1234.84 676.916 1235.98 676.916Z",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "M1308.16 676.916H1310.22C1311.36 676.916 1312.29 677.837 1312.29 678.978C1312.29 680.115 1311.37 681.041 1310.22 681.041H1308.16C1307.03 681.041 1306.1 680.12 1306.1 678.978C1306.1 677.842 1307.02 676.916 1308.16 676.916Z",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "M1332.22 676.916H1334.28C1335.42 676.916 1336.35 677.837 1336.35 678.978C1336.35 680.115 1335.42 681.041 1334.28 681.041H1332.22C1331.09 681.041 1330.16 680.12 1330.16 678.978C1330.16 677.842 1331.09 676.916 1332.22 676.916Z",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "M1166.56 667.309C1168.87 667.482 1170.68 669.413 1170.68 671.765V672.796H1166.56V667.309Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "M1187.18 667.309C1184.87 667.482 1183.06 669.413 1183.06 671.765V672.796H1187.18V667.309Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "M1213.99 669.355C1213.99 668.219 1213.07 667.293 1211.92 667.293C1210.78 667.293 1209.86 668.214 1209.86 669.355V672.791H1213.99V669.355Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "M1238.74 669.355C1238.74 668.219 1237.82 667.293 1236.67 667.293C1235.53 667.293 1234.61 668.214 1234.61 669.355V672.791H1238.74V669.355Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "M1373.46 674.854H1360.41V678.979H1373.46V674.854Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "M766.841 674.852L597.054 715.752V719.187L632.456 712.311L774.749 683.438L782.999 686.189L750.006 706.813L733.507 721.25C742.446 716.783 761.896 707.229 768.22 704.751C776.127 701.657 808.089 686.189 812.556 684.127C821.147 680.16 818.401 674.846 812.556 673.815C797.156 670.517 775.664 673.126 766.841 674.846V674.852Z",
    fill: "#FAEAC7"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "M629.362 737.751H618.709L621.129 729.076C621.986 726.008 619.677 722.973 616.494 722.973H597.054V719.19L770.661 684.466C776.354 683.33 782.125 682.63 787.928 682.383C789.97 682.299 790.806 684.966 789.08 686.06L733.365 721.489C730.413 723.362 729.135 727.013 730.266 730.317L732.807 737.746H724.216V727.771C724.216 726.303 722.722 725.303 721.364 725.866L714.251 728.812V722.967L753.089 695.815C754.525 695.031 753.578 692.647 751.995 693.063C723.6 700.481 679.043 710.035 665.101 713.345C652.406 716.359 640.006 719.637 632.745 721.962C629.878 722.878 628.179 725.693 628.468 728.686L629.357 737.746L629.362 737.751Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.526115,
    strokeLinejoin: "round"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "M618.707 714.723V723.661",
    stroke: "#615E66",
    strokeWidth: 0.526115,
    strokeLinejoin: "round"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "M627.3 713.347V721.938",
    stroke: "#615E66",
    strokeWidth: 0.526115,
    strokeLinejoin: "round"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "M649.982 708.882V716.789",
    stroke: "#615E66",
    strokeWidth: 0.526115,
    strokeLinejoin: "round"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "M634.518 711.627V720.908",
    stroke: "#615E66",
    strokeWidth: 0.526115,
    strokeLinejoin: "round"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "M641.737 710.254V718.845",
    stroke: "#615E66",
    strokeWidth: 0.526115,
    strokeLinejoin: "round"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "M619.051 723.658L635.202 720.564",
    stroke: "#615E66",
    strokeWidth: 0.526115,
    strokeLinejoin: "round"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "M726.285 737.749V728.337C726.285 726.248 727.226 724.275 728.868 722.981C732.477 720.135 737.217 716.457 741.679 713.064C744.488 710.807 747.892 708.266 751.991 705.43C752.553 705.035 753.048 704.693 753.485 704.404C761.192 699.159 771.183 692.966 784.026 685.843C768.221 694.608 758.667 700.958 753.49 704.399H753.485C752.974 704.751 752.48 705.088 751.991 705.425C749.449 707.214 745.672 710.023 741.679 713.059C734.013 719.204 730.778 723.202 730.062 725.023V737.739H726.279L726.285 737.749Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115,
    strokeLinejoin: "round"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "M625.285 727.328L623.175 737.409H629.362C629.136 736.493 629.225 733.558 628.673 729.159C628.12 724.761 630.509 722.972 632.108 722.63L659.603 714.723L630.94 721.52C628.089 722.199 625.879 724.461 625.285 727.328Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115,
    strokeLinejoin: "round"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "M714.257 725.374L770.967 692.382L784.372 685.853",
    stroke: "#615E66",
    strokeWidth: 0.526115,
    strokeLinejoin: "round"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "M766.841 674.853L597.054 715.753V713.69L766.841 670.039C776.811 668.092 799.908 665.367 812.556 670.039C817.506 671.691 820 673.248 820.805 673.821C820.805 676.573 821.147 679.666 819.432 681.04C818.059 682.139 761.575 708.308 733.507 721.251C742.446 716.784 761.896 707.23 768.22 704.752C776.127 701.658 808.089 686.19 812.556 684.128C821.147 680.161 818.401 674.847 812.556 673.816C797.156 670.517 775.664 673.127 766.841 674.847V674.853Z",
    fill: "#FBDC99",
    stroke: "#615E66",
    strokeWidth: 0.526115,
    strokeLinejoin: "round"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "M597.054 710.255V713.691L645.514 701.316C683.889 690.662 765.674 669.008 785.745 667.634C805.816 666.261 817.48 671.186 820.8 673.822V667.04C820.8 665.409 820.337 663.773 819.069 662.757C815.796 660.153 809.478 657.601 803.617 657.323C785.471 655.671 764.895 660.3 756.872 662.821L597.054 710.25V710.255Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.526115,
    strokeLinejoin: "round"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "M597.054 715.411V719.194",
    stroke: "#615E66",
    strokeWidth: 0.526115,
    strokeLinejoin: "round"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "M752.064 693.071L784.026 685.853",
    stroke: "#615E66",
    strokeWidth: 0.526115,
    strokeLinejoin: "round"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "M789.181 672.448L784.367 682.418",
    stroke: "#615E66",
    strokeWidth: 0.526115,
    strokeLinejoin: "round"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "M773.712 673.82L780.93 682.759",
    stroke: "#615E66",
    strokeWidth: 0.526115,
    strokeLinejoin: "round"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "M803.617 672.448L787.118 682.418",
    stroke: "#615E66",
    strokeWidth: 0.526115,
    strokeLinejoin: "round"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "M781.964 672.79V682.76",
    stroke: "#615E66",
    strokeWidth: 0.526115,
    strokeLinejoin: "round"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "M1424.34 737.751V698.571H1581.06L1596.87 689.291L1613.37 695.82L1632.96 684.135L1636.75 737.751H1424.34H1424.34Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "M1428.46 701.322V737.756",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    d: "M1432.59 701.322V737.756",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "M1436.71 701.322V737.756",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "M1440.83 701.322V737.756",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "M1444.96 701.322V737.756",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "M1449.08 701.322V737.756",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "M1453.21 701.322V737.756",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    d: "M1457.33 701.322V737.756",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "M1461.46 701.322V737.756",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "M1465.58 701.322V737.756",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "M1469.71 701.322V737.756",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "M1473.83 701.322V737.756",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "M1477.95 701.322V737.756",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "M1482.08 701.322V737.756",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "M1486.21 701.322V737.756",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "M1490.33 701.322V737.756",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "M1494.45 701.322V737.756",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "M1498.57 701.322V737.756",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "M1502.7 701.322V737.756",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "M1506.82 701.322V737.756",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "M1510.95 701.322V737.756",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "M1515.07 701.322V737.756",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "M1519.2 701.322V737.756",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "M1523.32 701.322V737.756",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "M1527.45 701.322V737.756",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "M1531.57 701.322V737.756",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "M1535.69 701.322V737.756",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "M1539.82 701.322V737.756",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "M1543.95 701.322V737.756",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "M1548.07 701.322V737.756",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "M1552.19 701.322V737.756",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "M1556.31 701.322V737.756",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "M1560.44 701.322V737.756",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "M1564.56 701.322V737.756",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "M1568.69 701.322V737.756",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "M1572.81 701.322V737.756",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    d: "M1576.94 701.322V737.756",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    d: "M1581.06 701.322V737.756",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    d: "M1585.19 701.322V737.756",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "M1589.31 701.322V737.756",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    d: "M1593.44 701.322V737.756",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "M1597.56 701.322V737.756",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "M1601.69 701.322V737.756",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "M1605.81 701.322V737.756",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    d: "M1609.94 701.322V737.756",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "M1614.06 701.322V737.756",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "M1618.18 704.067V737.749",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    d: "M1622.3 703.039V737.752",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    d: "M1626.43 701.322V737.756",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    d: "M1630.55 701.322V737.756",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    d: "M1634.68 701.322V737.756",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    d: "M1424.68 686.539C1417.26 686.812 1406 684.134 1401.31 682.756C1418.84 700.628 1421.59 704.064 1424.68 705.784C1439.12 707.157 1435.68 703.722 1454.24 703.722C1472.8 703.722 1483.11 708.535 1492.73 708.877C1502.36 709.219 1504.76 703.722 1516.45 703.722C1528.14 703.722 1534.32 711.629 1542.23 711.629C1550.14 711.629 1549.79 703.38 1560.44 703.038C1571.1 702.696 1575.91 713.691 1581.07 713.691C1591.04 713.691 1585.88 702.348 1595.85 702.006C1605.82 701.664 1605.47 715.065 1612 715.065C1618.53 715.065 1618.19 702.348 1626.44 701.317C1634.68 700.286 1634.34 730.19 1636.75 737.403C1643.28 718.5 1646.37 682.756 1636.75 682.756C1627.12 682.756 1627.81 703.722 1619.56 704.064C1611.31 704.405 1616.47 686.533 1605.47 685.16C1594.48 683.787 1594.48 700.628 1585.88 701.312C1577.29 702.001 1579.01 685.16 1566.98 685.16C1554.95 685.16 1553.57 697.876 1544.29 697.876C1535.01 697.876 1532.27 685.16 1516.45 685.16C1505.8 685.16 1500.3 693.068 1490.67 693.068C1481.04 693.068 1470.15 685.355 1456.99 684.129C1442.21 682.756 1433.96 686.191 1424.68 686.533V686.539Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    d: "M1624.37 701.664C1636.19 678.567 1637.55 715.411 1636.74 736.719C1634.34 709.908 1631.93 707.093 1630.55 704.068C1628.83 700.285 1626.43 701.317 1624.37 701.664Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    d: "M1424.68 717.133H1428.46",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    d: "M1424.68 728.128H1428.46",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    d: "M1436.71 711.628H1440.49",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    d: "M1436.71 722.631H1440.49",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    d: "M1436.71 733.625H1440.49",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    d: "M1444.96 711.628H1448.74",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    d: "M1444.96 722.631H1448.74",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "M1444.96 733.625H1448.74",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    d: "M1453.21 711.628H1456.99",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    d: "M1453.21 722.631H1456.99",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    d: "M1453.21 733.625H1456.99",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    d: "M1461.46 711.628H1465.24",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    d: "M1461.46 722.631H1465.24",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    d: "M1461.46 733.625H1465.24",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    d: "M1469.71 711.628H1473.49",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    d: "M1469.71 722.631H1473.49",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    d: "M1469.71 733.625H1473.49",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    d: "M1477.95 711.628H1481.74",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    d: "M1477.95 722.631H1481.74",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    d: "M1477.95 733.625H1481.74",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    d: "M1486.21 711.628H1489.99",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    d: "M1486.21 722.631H1489.99",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    d: "M1486.21 733.625H1489.99",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    d: "M1494.45 711.628H1498.23",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    d: "M1494.45 722.631H1498.23",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    d: "M1494.45 733.625H1498.23",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    d: "M1502.7 711.628H1506.48",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    d: "M1502.7 722.631H1506.48",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    d: "M1502.7 733.625H1506.48",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    d: "M1510.95 711.628H1514.73",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    d: "M1510.95 722.631H1514.73",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    d: "M1510.95 733.625H1514.73",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    d: "M1519.2 711.628H1522.98",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    d: "M1519.2 722.631H1522.98",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    d: "M1519.2 733.625H1522.98",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    d: "M1527.45 711.628H1531.23",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    d: "M1527.45 722.631H1531.23",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    d: "M1527.45 733.625H1531.23",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    d: "M1535.69 711.628H1539.48",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    d: "M1535.69 722.631H1539.48",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    d: "M1535.69 733.625H1539.48",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    d: "M1543.95 711.628H1547.73",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    d: "M1543.95 722.631H1547.73",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    d: "M1543.95 733.625H1547.73",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    d: "M1552.2 711.628H1555.98",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    d: "M1552.2 722.631H1555.98",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    d: "M1552.19 733.625H1555.98",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    d: "M1560.44 711.628H1564.22",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    d: "M1560.44 722.631H1564.22",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    d: "M1560.44 733.625H1564.22",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    d: "M1568.69 711.628H1572.47",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    d: "M1568.69 722.631H1572.47",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    d: "M1568.69 733.625H1572.47",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    d: "M1593.44 711.628H1597.22",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    d: "M1593.44 722.631H1597.22",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    d: "M1593.44 733.625H1597.22",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    d: "M1601.69 711.628H1605.47",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    d: "M1601.69 722.631H1605.47",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    d: "M1601.69 733.625H1605.47",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    d: "M1618.18 711.628H1621.96",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    d: "M1618.18 722.631H1621.96",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    d: "M1618.18 733.625H1621.96",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    d: "M1576.94 722.631H1580.72",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    d: "M1576.94 733.625H1580.72",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    d: "M1585.19 722.631H1588.97",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    d: "M1585.19 733.625H1588.97",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    d: "M1428.8 711.628H1432.59",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    d: "M1428.8 722.631H1432.59",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    d: "M1428.8 733.625H1432.59",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    d: "M1432.93 717.133H1436.71",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    d: "M1432.93 728.128H1436.71",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    d: "M1441.18 717.133H1444.96",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    d: "M1441.18 728.128H1444.96",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    d: "M1449.43 717.133H1453.21",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    d: "M1449.43 728.128H1453.21",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    d: "M1457.67 717.133H1461.45",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    d: "M1457.67 728.128H1461.45",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    d: "M1465.92 717.133H1469.7",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    d: "M1465.92 728.128H1469.71",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    d: "M1474.17 717.133H1477.95",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    d: "M1474.17 728.128H1477.96",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    d: "M1482.42 717.133H1486.2",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    d: "M1482.42 728.128H1486.2",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    d: "M1490.67 717.133H1494.45",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    d: "M1490.67 728.128H1494.45",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    d: "M1498.92 717.133H1502.7",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    d: "M1498.92 728.128H1502.7",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    d: "M1507.17 717.133H1510.95",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    d: "M1507.17 728.128H1510.95",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    d: "M1515.41 717.133H1519.2",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    d: "M1515.41 728.128H1519.2",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    d: "M1523.66 717.133H1527.44",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    d: "M1523.66 728.128H1527.45",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    d: "M1531.91 717.133H1535.69",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    d: "M1531.91 728.128H1535.69",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    d: "M1540.16 717.133H1543.95",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    d: "M1540.16 728.128H1543.95",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    d: "M1548.41 717.133H1552.19",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    d: "M1548.41 728.128H1552.19",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    d: "M1556.66 717.133H1560.44",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    d: "M1556.66 728.128H1560.44",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    d: "M1564.91 717.133H1568.69",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    d: "M1564.91 728.128H1568.69",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    d: "M1573.16 717.133H1576.94",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    d: "M1573.16 728.128H1576.94",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    d: "M1581.41 717.133H1585.19",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    d: "M1581.41 728.128H1585.19",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    d: "M1589.65 717.133H1593.44",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    d: "M1589.65 728.128H1593.44",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    d: "M1597.9 717.133H1601.69",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    d: "M1597.9 728.128H1601.69",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    d: "M1606.15 717.133H1609.94",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    d: "M1606.15 728.128H1609.94",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    d: "M1614.4 717.133H1618.18",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    d: "M1614.4 728.128H1618.18",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    d: "M1622.65 717.133H1626.44",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    d: "M1622.65 728.128H1626.44",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    d: "M1630.9 717.133H1634",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    d: "M1630.9 728.128H1634.69",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    d: "M1604.09 701.664C1601.53 699.312 1594.47 698.57 1590.34 704.068C1597.22 699.254 1600.62 702.769 1602.72 705.099C1605.81 708.535 1605.81 715.637 1612.69 714.722C1606.5 709.566 1608.22 705.441 1604.1 701.664H1604.09Z",
    fill: "#615E66"
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    d: "M1570.37 701.875C1566.58 699.276 1555.63 699.602 1550.47 707.162C1557 700.975 1564.36 703.369 1567.32 704.41C1573.16 706.473 1574.88 714.265 1581.75 713.349C1576.35 711.976 1575.87 705.657 1570.37 701.875Z",
    fill: "#615E66"
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    d: "M1525.73 701.666C1521.31 700.403 1512.67 700.634 1502.36 706.822C1514.38 702.008 1521.74 703.717 1524.7 704.759C1530.54 706.822 1534.67 710.946 1541.88 711.288C1536.48 709.915 1532.94 703.728 1525.73 701.666Z",
    fill: "#615E66"
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    d: "M1466.95 700.974C1459.74 700.285 1450.1 699.969 1433.96 705.788C1451.49 702.353 1461.2 703.757 1465.92 704.068C1475.2 704.678 1481.44 708.556 1492.73 708.882C1484.29 707.588 1478.37 702.063 1466.95 700.974Z",
    fill: "#615E66"
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    d: "M1072.05 710.255H870.638V737.75H1072.05V710.255Z",
    fill: "#D8D0C3"
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    d: "M1084.76 633.609L1077.88 669.696L1090.94 670.727L1084.75 633.609H1084.76Z",
    fill: "#B7594C",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    d: "M1084.76 633.609L1082.36 670.727H1090.95L1084.76 633.609Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    d: "M1081.32 670.726C1081.32 669.59 1082.24 668.664 1083.39 668.664C1084.53 668.664 1085.45 669.585 1085.45 670.726V682.069H1081.32V670.726Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    d: "M1077.88 670.384C1077.88 669.437 1078.65 668.664 1079.6 668.664C1080.56 668.664 1081.32 669.432 1081.32 670.384V682.069H1077.89V670.384H1077.88Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    d: "M1085.45 671.416C1085.45 669.895 1086.68 668.664 1088.2 668.664C1089.72 668.664 1090.95 669.895 1090.95 671.416V682.069H1085.46V671.416H1085.45Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    d: "M1083.39 680.697C1083.39 678.23 1085.39 676.23 1087.86 676.23C1090.32 676.23 1092.32 678.23 1092.32 680.697V688.257H1083.38V680.697H1083.39Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    d: "M1076.51 680.357C1076.51 678.458 1078.05 676.922 1079.95 676.922C1081.84 676.922 1083.38 678.463 1083.38 680.357V691.7H1076.51V680.357H1076.51Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    d: "M1085.45 681.905C1085.45 680.669 1086.46 679.669 1087.69 679.669H1088.03C1089.26 679.669 1090.27 680.669 1090.27 681.905C1090.27 683.141 1089.26 684.141 1088.03 684.141H1087.69C1086.46 684.141 1085.45 683.141 1085.45 681.905Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    d: "M1078.57 682.417C1078.57 681.66 1079.19 681.044 1079.95 681.044C1080.7 681.044 1081.32 681.66 1081.32 682.417V683.448C1081.32 684.206 1080.7 684.821 1079.95 684.821C1079.19 684.821 1078.57 684.206 1078.57 683.448V682.417Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    d: "M1079.6 698.23L1090.26 684.824L1113.97 698.23H1079.6Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115,
    strokeLinejoin: "round"
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    d: "M1090.26 684.824L1069.64 695.136L1070.32 695.825V702.012L1079.61 698.577L1090.26 684.829V684.824Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    d: "M1113.63 738.438V698.228H1079.95L1070.32 702.01V738.444H1113.63V738.438Z",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    d: "M1070.32 710.599H872.353V738.093H1070.32V710.599Z",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    d: "M872.352 698.914V710.599H1070.32V695.479H869.643L872.273 698.698L872.347 698.793V698.914H872.352Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    d: "M967.558 595.116H966.185C965.615 595.116 965.153 595.578 965.153 596.147V697.193C965.153 697.762 965.615 698.224 966.185 698.224H967.558C968.127 698.224 968.589 697.762 968.589 697.193V596.147C968.589 595.578 968.127 595.116 967.558 595.116Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    d: "M975.807 595.116H974.434C973.864 595.116 973.402 595.578 973.402 596.147V697.193C973.402 697.762 973.864 698.224 974.434 698.224H975.807C976.376 698.224 976.838 697.762 976.838 697.193V596.147C976.838 595.578 976.376 595.116 975.807 595.116Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    d: "M883.352 720.227H873.729V738.099H883.352V720.227Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    d: "M883.352 720.227H873.729V723.662H883.352V720.227Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    d: "M875.792 712.66H873.729V717.474H875.792V712.66Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    d: "M879.918 712.66H877.166V717.474H879.918V712.66Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    d: "M883.351 712.66H881.289V717.474H883.351V712.66Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    d: "M899.162 720.227H889.539V738.099H899.162V720.227Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    d: "M891.602 712.66H889.539V717.474H891.602V712.66Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    d: "M895.728 712.66H892.977V717.474H895.728V712.66Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    d: "M899.163 712.66H897.101V717.474H899.163V712.66Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    d: "M929.409 720.227H919.786V738.099H929.409V720.227Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    d: "M921.849 712.66H919.786V717.474H921.849V712.66Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    d: "M925.975 712.66H923.224V717.474H925.975V712.66Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    d: "M929.409 712.66H927.347V717.474H929.409V712.66Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    d: "M945.218 720.227H935.596V738.099H945.218V720.227Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    d: "M937.658 712.66H935.596V717.474H937.658V712.66Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    d: "M941.784 712.66H939.032V717.474H941.784V712.66Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    d: "M945.22 712.66H943.157V717.474H945.22V712.66Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    d: "M961.028 720.227H951.405V738.099H961.028V720.227Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    d: "M953.468 712.66H951.405V717.474H953.468V712.66Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    d: "M957.592 712.66H954.841V717.474H957.592V712.66Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    d: "M961.028 712.66H958.966V717.474H961.028V712.66Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    d: "M991.959 720.227H982.336V738.099H991.959V720.227Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    d: "M984.398 712.66H982.336V717.474H984.398V712.66Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    d: "M988.528 712.66H985.776V717.474H988.528V712.66Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    d: "M991.959 712.66H989.896V717.474H991.959V712.66Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    d: "M1007.77 720.227H998.146V738.099H1007.77V720.227Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    d: "M1000.21 712.66H998.146V717.474H1000.21V712.66Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    d: "M1004.34 712.66H1001.59V717.474H1004.34V712.66Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    d: "M1007.77 712.66H1005.71V717.474H1007.77V712.66Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    d: "M1068.95 720.227H1059.33V738.099H1068.95V720.227Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    d: "M1061.39 712.66H1059.33V717.474H1061.39V712.66Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    d: "M1065.52 712.66H1062.76V717.474H1065.52V712.66Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    d: "M1088.89 725.724H1084.76V738.098H1088.89V725.724Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    d: "M1078.57 726.407H1076.51V733.967H1078.57V726.407Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    d: "M1074.45 726.407H1072.39V733.967H1074.45V726.407Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    d: "M1076.51 722.972H1078.57V714.817L1076.51 715.333V722.972Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    d: "M1072.39 722.97H1074.45V715.505L1072.39 716.02V722.97Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    d: "M1076.51 704.338V709.525L1078.57 709.268V703.822L1076.51 704.338Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    d: "M1072.39 705.023V710.211L1074.45 709.953V704.508L1072.39 705.023Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    d: "M1109.51 726.407H1105.38V733.967H1109.51V726.407Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    d: "M1068.95 712.66H1066.89V717.474H1068.95V712.66Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    d: "M1053.14 720.227H1043.52V738.099H1053.14V720.227Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    d: "M1045.58 712.66H1043.52V717.474H1045.58V712.66Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    d: "M1049.7 712.66H1046.95V717.474H1049.7V712.66Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    d: "M1053.14 712.66H1051.08V717.474H1053.14V712.66Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    d: "M1023.58 720.227H1013.96V738.099H1023.58V720.227Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    d: "M1016.02 712.66H1013.96V717.474H1016.02V712.66Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    d: "M1020.15 712.66H1017.4V717.474H1020.15V712.66Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    d: "M1023.58 712.66H1021.52V717.474H1023.58V712.66Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    d: "M1057.95 707.85H1054.51V738.096H1057.95V707.85Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path856 || (_path856 = /*#__PURE__*/React.createElement("path", {
    d: "M1012.58 707.85H1009.14V738.096H1012.58V707.85Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path857 || (_path857 = /*#__PURE__*/React.createElement("path", {
    d: "M996.771 707.85H993.336V738.096H996.771V707.85Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path858 || (_path858 = /*#__PURE__*/React.createElement("path", {
    d: "M950.025 707.85H946.59V738.096H950.025V707.85Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path859 || (_path859 = /*#__PURE__*/React.createElement("path", {
    d: "M934.219 707.85H930.783V738.096H934.219V707.85Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path860 || (_path860 = /*#__PURE__*/React.createElement("path", {
    d: "M888.162 707.85H884.727V738.096H888.162V707.85Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path861 || (_path861 = /*#__PURE__*/React.createElement("path", {
    d: "M901.226 710.943C901.226 706.197 905.077 702.352 909.817 702.352C914.557 702.352 918.409 706.197 918.409 710.943V738.096H901.226V710.943Z",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path862 || (_path862 = /*#__PURE__*/React.createElement("path", {
    d: "M1024.96 710.943C1024.96 706.197 1028.81 702.352 1033.55 702.352C1038.29 702.352 1042.14 706.197 1042.14 710.943V738.096H1024.96V710.943Z",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path863 || (_path863 = /*#__PURE__*/React.createElement("path", {
    d: "M1079.95 696.166C1079.95 695.409 1080.57 694.793 1081.32 694.793C1082.07 694.793 1082.69 695.409 1082.69 696.166V738.439H1079.94V696.166H1079.95Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path864 || (_path864 = /*#__PURE__*/React.createElement("path", {
    d: "M1106.07 704.413C1106.07 703.656 1106.69 703.04 1107.44 703.04C1108.2 703.04 1108.82 703.656 1108.82 704.413V708.88H1106.06V704.413H1106.07Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path865 || (_path865 = /*#__PURE__*/React.createElement("path", {
    d: "M1085.45 704.413C1085.45 703.656 1086.07 703.04 1086.82 703.04C1087.58 703.04 1088.2 703.656 1088.2 704.413V708.88H1085.44V704.413H1085.45Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path866 || (_path866 = /*#__PURE__*/React.createElement("path", {
    d: "M1084.76 715.409C1084.76 714.273 1085.68 713.347 1086.82 713.347C1087.96 713.347 1088.89 714.267 1088.89 715.409V721.938H1084.76V715.409Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path867 || (_path867 = /*#__PURE__*/React.createElement("path", {
    d: "M1105.38 715.409C1105.38 714.273 1106.31 713.347 1107.45 713.347C1108.59 713.347 1109.51 714.267 1109.51 715.409V721.938H1105.38V715.409Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path868 || (_path868 = /*#__PURE__*/React.createElement("path", {
    d: "M963.092 707.504C963.092 702.758 966.943 698.912 971.683 698.912C976.424 698.912 980.275 702.758 980.275 707.504V738.092H963.092V707.504Z",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path869 || (_path869 = /*#__PURE__*/React.createElement("path", {
    d: "M872.351 738.099V706.821L864.102 705.101H832.482V738.093H872.351V738.099Z",
    fill: "#D8D0C3",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path870 || (_path870 = /*#__PURE__*/React.createElement("path", {
    d: "M834.203 705.099L856.2 689.631L864.449 705.099H834.203Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path871 || (_path871 = /*#__PURE__*/React.createElement("path", {
    d: "M864.107 704.758L856.547 689.979L869.605 695.825L872.357 698.918V707.168L864.107 704.763V704.758Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path872 || (_path872 = /*#__PURE__*/React.createElement("path", {
    d: "M837.986 732.596H842.111V721.6C842.111 720.464 841.19 719.538 840.049 719.538C838.907 719.538 837.986 720.459 837.986 721.6V732.596Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path873 || (_path873 = /*#__PURE__*/React.createElement("path", {
    d: "M838.67 714.724H841.421V711.288C841.421 710.531 840.801 709.915 840.048 709.915C839.296 709.915 838.675 710.531 838.675 711.288V714.724H838.67Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path874 || (_path874 = /*#__PURE__*/React.createElement("path", {
    d: "M856.541 714.724H859.293V711.288C859.293 710.531 858.672 709.915 857.919 709.915C857.167 709.915 856.546 710.531 856.546 711.288V714.724H856.541Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path875 || (_path875 = /*#__PURE__*/React.createElement("path", {
    d: "M855.858 732.596H859.983V721.6C859.983 720.464 859.062 719.538 857.921 719.538C856.779 719.538 855.858 720.459 855.858 721.6V732.596Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path876 || (_path876 = /*#__PURE__*/React.createElement("path", {
    d: "M844.857 704.757C844.857 702.289 846.856 700.29 849.324 700.29C851.791 700.29 853.79 702.289 853.79 704.757V738.097H844.852V704.757H844.857Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path877 || (_path877 = /*#__PURE__*/React.createElement("path", {
    d: "M832.482 702.007C832.482 701.06 833.251 700.287 834.203 700.287C835.155 700.287 835.923 701.055 835.923 702.007V738.094H832.488V702.007H832.482Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path878 || (_path878 = /*#__PURE__*/React.createElement("path", {
    d: "M862.046 701.663C862.046 700.906 862.667 700.29 863.419 700.29C864.172 700.29 864.793 700.906 864.793 701.663V738.097H862.041V701.663H862.046Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path879 || (_path879 = /*#__PURE__*/React.createElement("path", {
    d: "M847.609 714.724H850.361V711.288C850.361 710.531 849.74 709.915 848.988 709.915C848.235 709.915 847.615 710.531 847.615 711.288V714.724H847.609Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path880 || (_path880 = /*#__PURE__*/React.createElement("path", {
    d: "M846.92 732.596H851.734V721.942C851.734 720.611 850.655 719.538 849.33 719.538C848.004 719.538 846.925 720.617 846.925 721.942V732.596H846.92Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path881 || (_path881 = /*#__PURE__*/React.createElement("path", {
    d: "M902.599 711.628C902.599 707.641 905.829 704.41 909.817 704.41C913.805 704.41 917.035 707.641 917.035 711.628V738.092H902.599V711.628Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path882 || (_path882 = /*#__PURE__*/React.createElement("path", {
    d: "M904.66 738.099H914.282V725.041C914.282 722.384 912.13 720.227 909.468 720.227C906.806 720.227 904.654 722.378 904.654 725.041V738.099H904.66Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path883 || (_path883 = /*#__PURE__*/React.createElement("path", {
    d: "M906.724 712.66H904.661V717.474H906.724V712.66Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path884 || (_path884 = /*#__PURE__*/React.createElement("path", {
    d: "M910.848 712.66H908.097V717.474H910.848V712.66Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path885 || (_path885 = /*#__PURE__*/React.createElement("path", {
    d: "M914.282 712.66H912.22V717.474H914.282V712.66Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path886 || (_path886 = /*#__PURE__*/React.createElement("path", {
    d: "M1026.33 711.628C1026.33 707.641 1029.56 704.41 1033.55 704.41C1037.54 704.41 1040.77 707.641 1040.77 711.628V738.092H1026.33V711.628Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path887 || (_path887 = /*#__PURE__*/React.createElement("path", {
    d: "M964.463 708.191C964.463 704.203 967.693 700.973 971.681 700.973C975.669 700.973 978.899 704.203 978.899 708.191V738.095H964.463V708.191Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path888 || (_path888 = /*#__PURE__*/React.createElement("path", {
    d: "M966.527 738.099H976.149V725.041C976.149 722.384 973.998 720.227 971.335 720.227C968.673 720.227 966.521 722.378 966.521 725.041V738.099H966.527Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path889 || (_path889 = /*#__PURE__*/React.createElement("path", {
    d: "M968.589 712.66H966.526V717.474H968.589V712.66Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path890 || (_path890 = /*#__PURE__*/React.createElement("path", {
    d: "M972.716 712.66H969.965V717.474H972.716V712.66Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path891 || (_path891 = /*#__PURE__*/React.createElement("path", {
    d: "M976.15 712.66H974.088V717.474H976.15V712.66Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path892 || (_path892 = /*#__PURE__*/React.createElement("path", {
    d: "M1028.39 738.099H1038.01V725.041C1038.01 722.384 1035.86 720.227 1033.2 720.227C1030.54 720.227 1028.39 722.378 1028.39 725.041V738.099H1028.39Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path893 || (_path893 = /*#__PURE__*/React.createElement("path", {
    d: "M1028.39 738.097H1038.01V727.786C1038.01 725.129 1035.86 722.972 1033.2 722.972C1030.54 722.972 1028.39 725.123 1028.39 727.786V738.097H1028.39Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path894 || (_path894 = /*#__PURE__*/React.createElement("path", {
    d: "M966.527 738.097H976.149V727.786C976.149 725.129 973.998 722.972 971.335 722.972C968.673 722.972 966.521 725.123 966.521 727.786V738.097H966.527Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path895 || (_path895 = /*#__PURE__*/React.createElement("path", {
    d: "M904.66 738.097H914.282V727.786C914.282 725.129 912.13 722.972 909.468 722.972C906.806 722.972 904.654 725.123 904.654 727.786V738.097H904.66Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path896 || (_path896 = /*#__PURE__*/React.createElement("path", {
    d: "M1030.45 712.66H1028.39V717.474H1030.45V712.66Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path897 || (_path897 = /*#__PURE__*/React.createElement("path", {
    d: "M1034.58 712.66H1031.83V717.474H1034.58V712.66Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path898 || (_path898 = /*#__PURE__*/React.createElement("path", {
    d: "M1038.01 712.66H1035.95V717.474H1038.01V712.66Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path899 || (_path899 = /*#__PURE__*/React.createElement("path", {
    d: "M1090.95 699.26C1090.95 695.65 1093.87 692.73 1097.48 692.73C1101.09 692.73 1104.01 695.656 1104.01 699.26V738.439H1090.95V699.26Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path900 || (_path900 = /*#__PURE__*/React.createElement("path", {
    d: "M1100.57 726.407H1095.07V733.967H1100.57V726.407Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path901 || (_path901 = /*#__PURE__*/React.createElement("path", {
    d: "M1093.69 704.413C1093.69 703.656 1094.32 703.04 1095.07 703.04C1095.82 703.04 1096.44 703.656 1096.44 704.413V708.88H1093.69V704.413H1093.69Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path902 || (_path902 = /*#__PURE__*/React.createElement("path", {
    d: "M1098.51 704.413C1098.51 703.656 1099.13 703.04 1099.88 703.04C1100.63 703.04 1101.25 703.656 1101.25 704.413V708.88H1098.5V704.413H1098.51Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path903 || (_path903 = /*#__PURE__*/React.createElement("path", {
    d: "M1095.07 715.751C1095.07 714.42 1096.15 713.347 1097.48 713.347C1098.8 713.347 1099.88 714.425 1099.88 715.751V721.938H1095.07V715.751H1095.07Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path904 || (_path904 = /*#__PURE__*/React.createElement("path", {
    d: "M899.162 720.227H889.539V723.662H899.162V720.227Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path905 || (_path905 = /*#__PURE__*/React.createElement("path", {
    d: "M929.409 720.227H919.786V723.662H929.409V720.227Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path906 || (_path906 = /*#__PURE__*/React.createElement("path", {
    d: "M945.218 720.227H935.596V723.662H945.218V720.227Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path907 || (_path907 = /*#__PURE__*/React.createElement("path", {
    d: "M961.028 720.227H951.405V723.662H961.028V720.227Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path908 || (_path908 = /*#__PURE__*/React.createElement("path", {
    d: "M991.959 720.227H982.336V723.662H991.959V720.227Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path909 || (_path909 = /*#__PURE__*/React.createElement("path", {
    d: "M1007.77 720.227H998.146V723.662H1007.77V720.227Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path910 || (_path910 = /*#__PURE__*/React.createElement("path", {
    d: "M1023.58 720.227H1013.96V723.662H1023.58V720.227Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path911 || (_path911 = /*#__PURE__*/React.createElement("path", {
    d: "M1053.14 720.227H1043.52V723.662H1053.14V720.227Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path912 || (_path912 = /*#__PURE__*/React.createElement("path", {
    d: "M1068.95 720.227H1059.33V723.662H1068.95V720.227Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path913 || (_path913 = /*#__PURE__*/React.createElement("path", {
    d: "M1111.57 696.166C1111.57 695.409 1112.19 694.793 1112.94 694.793C1113.69 694.793 1114.31 695.409 1114.31 696.166V738.439H1111.56V696.166H1111.57Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path914 || (_path914 = /*#__PURE__*/React.createElement("path", {
    d: "M132.72 698.912H8.29883V738.092H132.72V698.912Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path915 || (_path915 = /*#__PURE__*/React.createElement("path", {
    d: "M324.505 698.912H198.021V738.092H324.505V698.912Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path916 || (_path916 = /*#__PURE__*/React.createElement("path", {
    d: "M8.29757 709.915H-33.6338V738.099H8.29757V709.915Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path917 || (_path917 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7338 707.852C11.7338 705.952 13.2753 704.416 15.1693 704.416C17.0633 704.416 18.6048 705.958 18.6048 707.852V713.349H11.7285V707.852H11.7338Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path918 || (_path918 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9848 707.852C19.9848 705.952 21.5263 704.416 23.4203 704.416C25.3143 704.416 26.8558 705.958 26.8558 707.852V713.349H19.9795V707.852H19.9848Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path919 || (_path919 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2318 707.852C28.2318 705.952 29.7733 704.416 31.6674 704.416C33.5614 704.416 35.1029 705.958 35.1029 707.852V713.349H28.2266V707.852H28.2318Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path920 || (_path920 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4818 707.852C36.4818 705.952 38.0233 704.416 39.9173 704.416C41.8114 704.416 43.3529 705.958 43.3529 707.852V713.349H36.4766V707.852H36.4818Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path921 || (_path921 = /*#__PURE__*/React.createElement("path", {
    d: "M44.726 707.852C44.726 705.952 46.2675 704.416 48.1615 704.416C50.0555 704.416 51.597 705.958 51.597 707.852V713.349H44.7207V707.852H44.726Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path922 || (_path922 = /*#__PURE__*/React.createElement("path", {
    d: "M52.976 707.852C52.976 705.952 54.5175 704.416 56.4115 704.416C58.3055 704.416 59.847 705.958 59.847 707.852V713.349H52.9707V707.852H52.976Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path923 || (_path923 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9154 707.852C61.9154 705.952 63.4569 704.416 65.3509 704.416C67.2449 704.416 68.7865 705.958 68.7865 707.852V713.349H61.9102V707.852H61.9154Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path924 || (_path924 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1644 707.852C70.1644 705.952 71.706 704.416 73.6 704.416C75.494 704.416 77.0355 705.958 77.0355 707.852V713.349H70.1592V707.852H70.1644Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path925 || (_path925 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4125 707.852C78.4125 705.952 79.954 704.416 81.848 704.416C83.742 704.416 85.2836 705.958 85.2836 707.852V713.349H78.4072V707.852H78.4125Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path926 || (_path926 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6576 707.852C86.6576 705.952 88.1991 704.416 90.0932 704.416C91.9872 704.416 93.5287 705.958 93.5287 707.852V713.349H86.6523V707.852H86.6576Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path927 || (_path927 = /*#__PURE__*/React.createElement("path", {
    d: "M94.9056 707.852C94.9056 705.952 96.4472 704.416 98.3412 704.416C100.235 704.416 101.777 705.958 101.777 707.852V713.349H94.9004V707.852H94.9056Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path928 || (_path928 = /*#__PURE__*/React.createElement("path", {
    d: "M103.156 707.852C103.156 705.952 104.697 704.416 106.591 704.416C108.485 704.416 110.027 705.958 110.027 707.852V713.349H103.15V707.852H103.156Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path929 || (_path929 = /*#__PURE__*/React.createElement("path", {
    d: "M111.406 707.852C111.406 705.952 112.947 704.416 114.841 704.416C116.735 704.416 118.277 705.958 118.277 707.852V713.349H111.4V707.852H111.406Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path930 || (_path930 = /*#__PURE__*/React.createElement("path", {
    d: "M119.656 707.852C119.656 705.952 121.197 704.416 123.091 704.416C124.985 704.416 126.527 705.958 126.527 707.852V713.349H119.65V707.852H119.656Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path931 || (_path931 = /*#__PURE__*/React.createElement("path", {
    d: "M127.906 707.852C127.906 705.952 129.447 704.416 131.341 704.416C133.235 704.416 134.777 705.958 134.777 707.852V713.349H127.9V707.852H127.906Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path932 || (_path932 = /*#__PURE__*/React.createElement("path", {
    d: "M198.704 707.852C198.704 705.952 200.246 704.416 202.14 704.416C204.034 704.416 205.576 705.958 205.576 707.852V713.349H198.699V707.852H198.704Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path933 || (_path933 = /*#__PURE__*/React.createElement("path", {
    d: "M206.954 707.852C206.954 705.952 208.496 704.416 210.39 704.416C212.284 704.416 213.826 705.958 213.826 707.852V713.349H206.949V707.852H206.954Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path934 || (_path934 = /*#__PURE__*/React.createElement("path", {
    d: "M215.204 707.852C215.204 705.952 216.745 704.416 218.639 704.416C220.533 704.416 222.075 705.958 222.075 707.852V713.349H215.198V707.852H215.204Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path935 || (_path935 = /*#__PURE__*/React.createElement("path", {
    d: "M189.081 681.038H144.398V698.91H189.081V681.038Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path936 || (_path936 = /*#__PURE__*/React.createElement("path", {
    d: "M223.453 707.852C223.453 705.952 224.994 704.416 226.888 704.416C228.782 704.416 230.324 705.958 230.324 707.852V713.349H223.447V707.852H223.453Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path937 || (_path937 = /*#__PURE__*/React.createElement("path", {
    d: "M231.703 707.852C231.703 705.952 233.244 704.416 235.138 704.416C237.032 704.416 238.574 705.958 238.574 707.852V713.349H231.697V707.852H231.703Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path938 || (_path938 = /*#__PURE__*/React.createElement("path", {
    d: "M239.95 707.852C239.95 705.952 241.491 704.416 243.385 704.416C245.279 704.416 246.821 705.958 246.821 707.852V713.349H239.944V707.852H239.95Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path939 || (_path939 = /*#__PURE__*/React.createElement("path", {
    d: "M248.885 707.852C248.885 705.952 250.427 704.416 252.321 704.416C254.215 704.416 255.756 705.958 255.756 707.852V713.349H248.88V707.852H248.885Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path940 || (_path940 = /*#__PURE__*/React.createElement("path", {
    d: "M257.134 707.852C257.134 705.952 258.676 704.416 260.57 704.416C262.464 704.416 264.005 705.958 264.005 707.852V713.349H257.129V707.852H257.134Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path941 || (_path941 = /*#__PURE__*/React.createElement("path", {
    d: "M265.384 707.852C265.384 705.952 266.926 704.416 268.82 704.416C270.714 704.416 272.255 705.958 272.255 707.852V713.349H265.379V707.852H265.384Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path942 || (_path942 = /*#__PURE__*/React.createElement("path", {
    d: "M273.633 707.852C273.633 705.952 275.175 704.416 277.069 704.416C278.963 704.416 280.504 705.958 280.504 707.852V713.349H273.628V707.852H273.633Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path943 || (_path943 = /*#__PURE__*/React.createElement("path", {
    d: "M281.878 707.852C281.878 705.952 283.42 704.416 285.314 704.416C287.208 704.416 288.749 705.958 288.749 707.852V713.349H281.873V707.852H281.878Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path944 || (_path944 = /*#__PURE__*/React.createElement("path", {
    d: "M290.126 707.852C290.126 705.952 291.668 704.416 293.562 704.416C295.456 704.416 296.997 705.958 296.997 707.852V713.349H290.121V707.852H290.126Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path945 || (_path945 = /*#__PURE__*/React.createElement("path", {
    d: "M298.376 707.852C298.376 705.952 299.918 704.416 301.812 704.416C303.706 704.416 305.247 705.958 305.247 707.852V713.349H298.371V707.852H298.376Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path946 || (_path946 = /*#__PURE__*/React.createElement("path", {
    d: "M306.626 707.852C306.626 705.952 308.168 704.416 310.062 704.416C311.956 704.416 313.497 705.958 313.497 707.852V713.349H306.621V707.852H306.626Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path947 || (_path947 = /*#__PURE__*/React.createElement("path", {
    d: "M314.874 707.852C314.874 705.952 316.416 704.416 318.31 704.416C320.204 704.416 321.745 705.958 321.745 707.852V713.349H314.869V707.852H314.874Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path948 || (_path948 = /*#__PURE__*/React.createElement("path", {
    d: "M145.777 691.008C145.777 688.92 147.471 687.226 149.56 687.226C151.649 687.226 153.343 688.92 153.343 691.008V696.853H145.783V691.008H145.777Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path949 || (_path949 = /*#__PURE__*/React.createElement("path", {
    d: "M154.711 691.008C154.711 688.92 156.405 687.226 158.494 687.226C160.582 687.226 162.276 688.92 162.276 691.008V696.853H154.716V691.008H154.711Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path950 || (_path950 = /*#__PURE__*/React.createElement("path", {
    d: "M162.27 691.008C162.27 688.92 163.964 687.226 166.052 687.226C168.141 687.226 169.835 688.92 169.835 691.008V696.853H162.275V691.008H162.27Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path951 || (_path951 = /*#__PURE__*/React.createElement("path", {
    d: "M171.209 691.008C171.209 688.92 172.903 687.226 174.992 687.226C177.08 687.226 178.775 688.92 178.775 691.008V696.853H171.214V691.008H171.209Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path952 || (_path952 = /*#__PURE__*/React.createElement("path", {
    d: "M178.771 691.008C178.771 688.92 180.465 687.226 182.553 687.226C184.642 687.226 186.336 688.92 186.336 691.008V696.853H178.776V691.008H178.771Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path953 || (_path953 = /*#__PURE__*/React.createElement("path", {
    d: "M176.018 659.043H156.772V681.04H176.018V659.043Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path954 || (_path954 = /*#__PURE__*/React.createElement("path", {
    d: "M162.965 661.104H158.151V678.286H162.965V661.104Z",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path955 || (_path955 = /*#__PURE__*/React.createElement("path", {
    d: "M169.148 661.104H164.334V678.286H169.148V661.104Z",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path956 || (_path956 = /*#__PURE__*/React.createElement("path", {
    d: "M174.646 661.104H170.521V678.286H174.646V661.104Z",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path957 || (_path957 = /*#__PURE__*/React.createElement("path", {
    d: "M162.965 661.104H158.151V662.477H162.965V661.104Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path958 || (_path958 = /*#__PURE__*/React.createElement("path", {
    d: "M169.148 661.104H164.334V662.477H169.148V661.104Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path959 || (_path959 = /*#__PURE__*/React.createElement("path", {
    d: "M166.053 652.173C166.621 652.173 167.084 652.636 167.084 653.204V655.956C167.084 656.524 166.621 656.987 166.053 656.987C165.484 656.987 165.021 656.524 165.021 655.956V653.204C165.021 652.636 165.484 652.173 166.053 652.173Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path960 || (_path960 = /*#__PURE__*/React.createElement("path", {
    d: "M156.772 653.204C156.772 652.636 157.235 652.173 157.804 652.173C158.372 652.173 158.835 652.636 158.835 653.204V654.577C158.835 655.787 157.94 656.792 156.772 656.96V653.204Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path961 || (_path961 = /*#__PURE__*/React.createElement("path", {
    d: "M173.962 653.204C173.962 652.636 174.425 652.173 174.993 652.173C175.561 652.173 176.024 652.636 176.024 653.204V656.96C174.856 656.792 173.962 655.793 173.962 654.577V653.204Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path962 || (_path962 = /*#__PURE__*/React.createElement("path", {
    d: "M174.646 661.104H170.521V662.477H174.646V661.104Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path963 || (_path963 = /*#__PURE__*/React.createElement("path", {
    d: "M180.143 678.293H152.648V681.045H180.143V678.293Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path964 || (_path964 = /*#__PURE__*/React.createElement("path", {
    d: "M160.207 693.412H156.771V696.848H160.207V693.412Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path965 || (_path965 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1079 695.479H30.2939V698.914H35.1079V695.479Z",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path966 || (_path966 = /*#__PURE__*/React.createElement("path", {
    d: "M79.103 695.479H74.2891V698.914H79.103V695.479Z",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path967 || (_path967 = /*#__PURE__*/React.createElement("path", {
    d: "M123.095 695.479H118.281V698.914H123.095V695.479Z",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path968 || (_path968 = /*#__PURE__*/React.createElement("path", {
    d: "M214.521 695.479H209.707V698.914H214.521V695.479Z",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path969 || (_path969 = /*#__PURE__*/React.createElement("path", {
    d: "M258.514 695.479H253.7V698.914H258.514V695.479Z",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path970 || (_path970 = /*#__PURE__*/React.createElement("path", {
    d: "M302.506 695.479H297.692V698.914H302.506V695.479Z",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path971 || (_path971 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0104 692.042H33.3836C34.3306 692.042 35.104 692.81 35.104 693.762C35.104 694.709 34.3359 695.483 33.3836 695.483H32.0104C31.0634 695.483 30.29 694.715 30.29 693.762C30.29 692.815 31.0582 692.042 32.0104 692.042Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path972 || (_path972 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0026 692.042H77.3758C78.3228 692.042 79.0962 692.81 79.0962 693.762C79.0962 694.709 78.328 695.483 77.3758 695.483H76.0026C75.0556 695.483 74.2822 694.715 74.2822 693.762C74.2822 692.815 75.0503 692.042 76.0026 692.042Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path973 || (_path973 = /*#__PURE__*/React.createElement("path", {
    d: "M119.997 692.042H121.37C122.317 692.042 123.09 692.81 123.09 693.762C123.09 694.709 122.322 695.483 121.37 695.483H119.997C119.05 695.483 118.276 694.715 118.276 693.762C118.276 692.815 119.044 692.042 119.997 692.042Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path974 || (_path974 = /*#__PURE__*/React.createElement("path", {
    d: "M211.422 692.042H212.795C213.742 692.042 214.515 692.81 214.515 693.762C214.515 694.709 213.747 695.483 212.795 695.483H211.422C210.475 695.483 209.701 694.715 209.701 693.762C209.701 692.815 210.469 692.042 211.422 692.042Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path975 || (_path975 = /*#__PURE__*/React.createElement("path", {
    d: "M255.415 692.042H256.788C257.735 692.042 258.508 692.81 258.508 693.762C258.508 694.709 257.74 695.483 256.788 695.483H255.415C254.468 695.483 253.694 694.715 253.694 693.762C253.694 692.815 254.462 692.042 255.415 692.042Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path976 || (_path976 = /*#__PURE__*/React.createElement("path", {
    d: "M299.409 692.042H300.782C301.729 692.042 302.502 692.81 302.502 693.762C302.502 694.709 301.734 695.483 300.782 695.483H299.409C298.462 695.483 297.688 694.715 297.688 693.762C297.688 692.815 298.457 692.042 299.409 692.042Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path977 || (_path977 = /*#__PURE__*/React.createElement("path", {
    d: "M167.77 693.412H164.334V696.848H167.77V693.412Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path978 || (_path978 = /*#__PURE__*/React.createElement("path", {
    d: "M176.707 693.412H173.271V696.848H176.707V693.412Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path979 || (_path979 = /*#__PURE__*/React.createElement("path", {
    d: "M176.017 657.672H156.771V659.045H176.017V657.672Z",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path980 || (_path980 = /*#__PURE__*/React.createElement("path", {
    d: "M171.899 631.548H160.214V659.043H171.899V631.548Z",
    fill: "#FEF6E0",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path981 || (_path981 = /*#__PURE__*/React.createElement("path", {
    d: "M171.209 616.428H160.897V631.548H171.209V616.428Z",
    fill: "#FEF6E0",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path982 || (_path982 = /*#__PURE__*/React.createElement("path", {
    d: "M171.188 616.426C171.014 614.88 169.704 613.675 168.115 613.675H163.99C162.396 613.675 161.086 614.88 160.918 616.426H171.193H171.188Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path983 || (_path983 = /*#__PURE__*/React.createElement("path", {
    d: "M164.337 613.677L165.016 553.873H166.399L167.078 613.677H164.337Z",
    fill: "#B7594C",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path984 || (_path984 = /*#__PURE__*/React.createElement("path", {
    d: "M165.71 545.624V553.874",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path985 || (_path985 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6709 718.163H16.5472V727.102H9.6709V718.163Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path986 || (_path986 = /*#__PURE__*/React.createElement("path", {
    d: "M11.043 732.595H15.1677V738.093H11.043V732.595Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path987 || (_path987 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6104 732.595H24.1083V738.093H18.6104V732.595Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path988 || (_path988 = /*#__PURE__*/React.createElement("path", {
    d: "M27.543 732.595H33.0409V738.093H27.543V732.595Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path989 || (_path989 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4824 732.595H41.9803V738.093H36.4824V732.595Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path990 || (_path990 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4141 732.595H50.912V738.093H45.4141V732.595Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path991 || (_path991 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6641 732.595H59.162V738.093H53.6641V732.595Z",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path992 || (_path992 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6641 732.595H59.162V738.093H53.6641V732.595Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path993 || (_path993 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9746 731.22H66.7262V738.096H63.9746V731.22Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path994 || (_path994 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5371 731.22H75.6618V738.096H71.5371V731.22Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path995 || (_path995 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4697 731.22H83.9053V738.096H80.4697V731.22Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path996 || (_path996 = /*#__PURE__*/React.createElement("path", {
    d: "M88.7197 731.22H92.1552V738.096H88.7197V731.22Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path997 || (_path997 = /*#__PURE__*/React.createElement("path", {
    d: "M97.6592 731.22H101.095V738.096H97.6592V731.22Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path998 || (_path998 = /*#__PURE__*/React.createElement("path", {
    d: "M105.908 731.22H110.033V738.096H105.908V731.22Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path999 || (_path999 = /*#__PURE__*/React.createElement("path", {
    d: "M114.157 731.22H118.282V738.096H114.157V731.22Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1000 || (_path1000 = /*#__PURE__*/React.createElement("path", {
    d: "M122.401 731.22H126.526V738.096H122.401V731.22Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1001 || (_path1001 = /*#__PURE__*/React.createElement("path", {
    d: "M129.968 731.22H132.719V738.096H129.968V731.22Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1002 || (_path1002 = /*#__PURE__*/React.createElement("path", {
    d: "M199.395 731.22H202.146V738.096H199.395V731.22Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1003 || (_path1003 = /*#__PURE__*/React.createElement("path", {
    d: "M206.955 731.22H211.08V738.096H206.955V731.22Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1004 || (_path1004 = /*#__PURE__*/React.createElement("path", {
    d: "M215.893 731.22H219.328V738.096H215.893V731.22Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1005 || (_path1005 = /*#__PURE__*/React.createElement("path", {
    d: "M224.139 731.22H227.574V738.096H224.139V731.22Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1006 || (_path1006 = /*#__PURE__*/React.createElement("path", {
    d: "M233.074 731.22H236.51V738.096H233.074V731.22Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1007 || (_path1007 = /*#__PURE__*/React.createElement("path", {
    d: "M240.635 731.22H244.759V738.096H240.635V731.22Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1008 || (_path1008 = /*#__PURE__*/React.createElement("path", {
    d: "M248.885 731.22H253.009V738.096H248.885V731.22Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1009 || (_path1009 = /*#__PURE__*/React.createElement("path", {
    d: "M257.824 731.22H261.949V738.096H257.824V731.22Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1010 || (_path1010 = /*#__PURE__*/React.createElement("path", {
    d: "M266.758 731.22H269.509V738.096H266.758V731.22Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1011 || (_path1011 = /*#__PURE__*/React.createElement("path", {
    d: "M8.29757 709.915H-33.6338V727.098H8.29757V709.915Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1012 || (_path1012 = /*#__PURE__*/React.createElement("path", {
    d: "M273.634 731.22H278.448V738.096H273.634V731.22Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1013 || (_path1013 = /*#__PURE__*/React.createElement("path", {
    d: "M283.255 731.22H287.38V738.096H283.255V731.22Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1014 || (_path1014 = /*#__PURE__*/React.createElement("path", {
    d: "M291.505 731.22H296.319V738.096H291.505V731.22Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1015 || (_path1015 = /*#__PURE__*/React.createElement("path", {
    d: "M300.438 731.22H305.252V738.096H300.438V731.22Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1016 || (_path1016 = /*#__PURE__*/React.createElement("path", {
    d: "M309.377 731.22H314.191V738.096H309.377V731.22Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1017 || (_path1017 = /*#__PURE__*/React.createElement("path", {
    d: "M317.627 731.22H322.441V738.096H317.627V731.22Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1018 || (_path1018 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9219 718.163H24.7982V727.102H17.9219V718.163Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1019 || (_path1019 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1689 718.163H33.0453V727.102H26.1689V718.163Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1020 || (_path1020 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0498047 718.163H6.92613V727.102H0.0498047V718.163Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1021 || (_path1021 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6055 708.534H33.7302V713.348H29.6055V708.534Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1022 || (_path1022 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8555 708.534H41.9802V713.348H37.8555V708.534Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1023 || (_path1023 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7891 708.534H50.2246V713.348H46.7891V708.534Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1024 || (_path1024 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0371 708.534H58.4726V713.348H55.0371V708.534Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1025 || (_path1025 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9746 708.534H67.4101V713.348H63.9746V708.534Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1026 || (_path1026 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2266 708.534H75.6621V713.348H72.2266V708.534Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1027 || (_path1027 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4697 708.534H83.9053V713.348H80.4697V708.534Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1028 || (_path1028 = /*#__PURE__*/React.createElement("path", {
    d: "M88.7197 708.534H92.1552V713.348H88.7197V708.534Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1029 || (_path1029 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9697 708.534H100.405V713.348H96.9697V708.534Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1030 || (_path1030 = /*#__PURE__*/React.createElement("path", {
    d: "M105.221 708.534H108.656V713.348H105.221V708.534Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1031 || (_path1031 = /*#__PURE__*/React.createElement("path", {
    d: "M113.468 708.534H116.903V713.348H113.468V708.534Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1032 || (_path1032 = /*#__PURE__*/React.createElement("path", {
    d: "M121.72 708.534H125.155V713.348H121.72V708.534Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1033 || (_path1033 = /*#__PURE__*/React.createElement("path", {
    d: "M129.278 708.534H132.714V713.348H129.278V708.534Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1034 || (_path1034 = /*#__PURE__*/React.createElement("path", {
    d: "M200.081 708.534H204.206V713.348H200.081V708.534Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1035 || (_path1035 = /*#__PURE__*/React.createElement("path", {
    d: "M208.326 708.534H212.451V713.348H208.326V708.534Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1036 || (_path1036 = /*#__PURE__*/React.createElement("path", {
    d: "M217.266 708.534H220.701V713.348H217.266V708.534Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1037 || (_path1037 = /*#__PURE__*/React.createElement("path", {
    d: "M225.514 708.534H228.949V713.348H225.514V708.534Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1038 || (_path1038 = /*#__PURE__*/React.createElement("path", {
    d: "M233.765 708.534H237.2V713.348H233.765V708.534Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1039 || (_path1039 = /*#__PURE__*/React.createElement("path", {
    d: "M242.01 708.534H245.445V713.348H242.01V708.534Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1040 || (_path1040 = /*#__PURE__*/React.createElement("path", {
    d: "M250.947 708.534H254.383V713.348H250.947V708.534Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1041 || (_path1041 = /*#__PURE__*/React.createElement("path", {
    d: "M259.197 708.534H262.633V713.348H259.197V708.534Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1042 || (_path1042 = /*#__PURE__*/React.createElement("path", {
    d: "M267.447 708.534H270.883V713.348H267.447V708.534Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1043 || (_path1043 = /*#__PURE__*/React.createElement("path", {
    d: "M275.696 708.534H279.132V713.348H275.696V708.534Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1044 || (_path1044 = /*#__PURE__*/React.createElement("path", {
    d: "M283.94 708.534H287.376V713.348H283.94V708.534Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1045 || (_path1045 = /*#__PURE__*/React.createElement("path", {
    d: "M292.188 708.534H295.624V713.348H292.188V708.534Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1046 || (_path1046 = /*#__PURE__*/React.createElement("path", {
    d: "M299.755 708.534H303.19V713.348H299.755V708.534Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1047 || (_path1047 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4824 718.163H43.3587V727.102H36.4824V718.163Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1048 || (_path1048 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7275 718.163H51.6039V727.102H44.7275V718.163Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1049 || (_path1049 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9746 718.163H59.8509V727.102H52.9746V718.163Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1050 || (_path1050 = /*#__PURE__*/React.createElement("path", {
    d: "M61.916 718.163H68.7923V727.102H61.916V718.163Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1051 || (_path1051 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1641 718.163H77.0404V727.102H70.1641V718.163Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1052 || (_path1052 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4121 718.163H85.2884V727.102H78.4121V718.163Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1053 || (_path1053 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6572 718.163H93.5336V727.102H86.6572V718.163Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1054 || (_path1054 = /*#__PURE__*/React.createElement("path", {
    d: "M94.9072 718.163H101.784V727.102H94.9072V718.163Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1055 || (_path1055 = /*#__PURE__*/React.createElement("path", {
    d: "M103.155 718.163H110.032V727.102H103.155V718.163Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1056 || (_path1056 = /*#__PURE__*/React.createElement("path", {
    d: "M111.405 718.163H118.282V727.102H111.405V718.163Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1057 || (_path1057 = /*#__PURE__*/React.createElement("path", {
    d: "M119.655 718.163H126.532V727.102H119.655V718.163Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1058 || (_path1058 = /*#__PURE__*/React.createElement("path", {
    d: "M127.905 718.163H132.719V727.102H127.905V718.163Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1059 || (_path1059 = /*#__PURE__*/React.createElement("path", {
    d: "M198.021 718.163H204.898V727.102H198.021V718.163Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1060 || (_path1060 = /*#__PURE__*/React.createElement("path", {
    d: "M206.264 718.163H213.14V727.102H206.264V718.163Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1061 || (_path1061 = /*#__PURE__*/React.createElement("path", {
    d: "M214.514 718.163H221.39V727.102H214.514V718.163Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1062 || (_path1062 = /*#__PURE__*/React.createElement("path", {
    d: "M224.826 718.163H231.702V727.102H224.826V718.163Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1063 || (_path1063 = /*#__PURE__*/React.createElement("path", {
    d: "M233.074 718.163H239.951V727.102H233.074V718.163Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1064 || (_path1064 = /*#__PURE__*/React.createElement("path", {
    d: "M241.326 718.163H248.202V727.102H241.326V718.163Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1065 || (_path1065 = /*#__PURE__*/React.createElement("path", {
    d: "M250.259 718.163H257.135V727.102H250.259V718.163Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1066 || (_path1066 = /*#__PURE__*/React.createElement("path", {
    d: "M258.508 718.163H265.384V727.102H258.508V718.163Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1067 || (_path1067 = /*#__PURE__*/React.createElement("path", {
    d: "M266.758 718.163H273.634V727.102H266.758V718.163Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1068 || (_path1068 = /*#__PURE__*/React.createElement("path", {
    d: "M366.429 709.915H324.498V737.41H366.429V709.915Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1069 || (_path1069 = /*#__PURE__*/React.createElement("path", {
    d: "M275.006 718.163H281.882V727.102H275.006V718.163Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1070 || (_path1070 = /*#__PURE__*/React.createElement("path", {
    d: "M283.255 718.163H290.131V727.102H283.255V718.163Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1071 || (_path1071 = /*#__PURE__*/React.createElement("path", {
    d: "M291.505 718.163H298.381V727.102H291.505V718.163Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1072 || (_path1072 = /*#__PURE__*/React.createElement("path", {
    d: "M299.755 718.163H306.631V727.102H299.755V718.163Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1073 || (_path1073 = /*#__PURE__*/React.createElement("path", {
    d: "M307.999 718.163H314.875V727.102H307.999V718.163Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1074 || (_path1074 = /*#__PURE__*/React.createElement("path", {
    d: "M316.251 718.163H323.127V727.102H316.251V718.163Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1075 || (_path1075 = /*#__PURE__*/React.createElement("path", {
    d: "M325.87 718.163H332.746V727.102H325.87V718.163Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1076 || (_path1076 = /*#__PURE__*/React.createElement("path", {
    d: "M334.119 718.163H340.995V727.102H334.119V718.163Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1077 || (_path1077 = /*#__PURE__*/React.createElement("path", {
    d: "M342.369 718.163H349.245V727.102H342.369V718.163Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1078 || (_path1078 = /*#__PURE__*/React.createElement("path", {
    d: "M350.62 718.163H357.496V727.102H350.62V718.163Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1079 || (_path1079 = /*#__PURE__*/React.createElement("path", {
    d: "M358.87 718.163H365.746V727.102H358.87V718.163Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1080 || (_path1080 = /*#__PURE__*/React.createElement("path", {
    d: "M366.429 709.915H324.498V737.41H366.429V709.915Z",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1081 || (_path1081 = /*#__PURE__*/React.createElement("path", {
    d: "M366.429 709.915H324.498V713.351H366.429V709.915Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1082 || (_path1082 = /*#__PURE__*/React.createElement("path", {
    d: "M8.29757 709.915H-33.6338V714.04H8.29757V709.915Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1083 || (_path1083 = /*#__PURE__*/React.createElement("path", {
    d: "M166.052 646.674C168.141 646.674 169.835 644.98 169.835 642.891C169.835 640.802 168.141 639.108 166.052 639.108C163.963 639.108 162.27 640.802 162.27 642.891C162.27 644.98 163.963 646.674 166.052 646.674Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1084 || (_path1084 = /*#__PURE__*/React.createElement("path", {
    d: "M166.055 644.264C166.813 644.264 167.428 643.649 167.428 642.891C167.428 642.132 166.813 641.518 166.055 641.518C165.296 641.518 164.682 642.132 164.682 642.891C164.682 643.649 165.296 644.264 166.055 644.264Z",
    fill: "white"
  })), _path1085 || (_path1085 = /*#__PURE__*/React.createElement("path", {
    d: "M158.494 692.034C159.822 692.034 160.899 690.958 160.899 689.63C160.899 688.302 159.822 687.226 158.494 687.226C157.166 687.226 156.09 688.302 156.09 689.63C156.09 690.958 157.166 692.034 158.494 692.034Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1086 || (_path1086 = /*#__PURE__*/React.createElement("path", {
    d: "M166.054 692.034C167.382 692.034 168.458 690.958 168.458 689.63C168.458 688.302 167.382 687.226 166.054 687.226C164.726 687.226 163.649 688.302 163.649 689.63C163.649 690.958 164.726 692.034 166.054 692.034Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1087 || (_path1087 = /*#__PURE__*/React.createElement("path", {
    d: "M174.993 692.034C176.321 692.034 177.398 690.958 177.398 689.63C177.398 688.302 176.321 687.226 174.993 687.226C173.665 687.226 172.589 688.302 172.589 689.63C172.589 690.958 173.665 692.034 174.993 692.034Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1088 || (_path1088 = /*#__PURE__*/React.createElement("path", {
    d: "M165.711 538.83L166.695 541.86L166.774 542.097H170.21L167.632 543.97L167.432 544.118L167.511 544.354L168.495 547.385L165.917 545.512L165.717 545.364L165.517 545.512L162.939 547.385L163.923 544.354L164.002 544.118L163.802 543.97L161.224 542.097H164.659L164.738 541.86L165.722 538.83H165.711Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1089 || (_path1089 = /*#__PURE__*/React.createElement("path", {
    d: "M169.148 618.488H167.774V622.613H169.148V618.488Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1090 || (_path1090 = /*#__PURE__*/React.createElement("path", {
    d: "M163.643 618.488H162.27V622.613H163.643V618.488Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1091 || (_path1091 = /*#__PURE__*/React.createElement("path", {
    d: "M28.918 722.287H33.0427V727.101H28.918V722.287Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1092 || (_path1092 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8555 722.287H41.9802V727.101H37.8555V722.287Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1093 || (_path1093 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7891 722.287H50.2246V727.101H46.7891V722.287Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1094 || (_path1094 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0371 722.287H58.4726V727.101H55.0371V722.287Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1095 || (_path1095 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9746 722.287H67.4101V727.101H63.9746V722.287Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1096 || (_path1096 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2266 722.287H75.6621V727.101H72.2266V722.287Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1097 || (_path1097 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4697 722.287H83.9053V727.101H80.4697V722.287Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1098 || (_path1098 = /*#__PURE__*/React.createElement("path", {
    d: "M88.7197 722.287H92.1552V727.101H88.7197V722.287Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1099 || (_path1099 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9707 722.287H100.406V727.101H96.9707V722.287Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1100 || (_path1100 = /*#__PURE__*/React.createElement("path", {
    d: "M105.221 722.287H108.656V727.101H105.221V722.287Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1101 || (_path1101 = /*#__PURE__*/React.createElement("path", {
    d: "M113.468 722.287H116.903V727.101H113.468V722.287Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1102 || (_path1102 = /*#__PURE__*/React.createElement("path", {
    d: "M121.72 722.287H125.155V727.101H121.72V722.287Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1103 || (_path1103 = /*#__PURE__*/React.createElement("path", {
    d: "M129.278 722.287H132.714V727.101H129.278V722.287Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1104 || (_path1104 = /*#__PURE__*/React.createElement("path", {
    d: "M200.081 722.287H204.206V727.101H200.081V722.287Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1105 || (_path1105 = /*#__PURE__*/React.createElement("path", {
    d: "M208.326 722.287H212.451V727.101H208.326V722.287Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1106 || (_path1106 = /*#__PURE__*/React.createElement("path", {
    d: "M217.266 722.287H220.701V727.101H217.266V722.287Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1107 || (_path1107 = /*#__PURE__*/React.createElement("path", {
    d: "M225.514 722.287H228.949V727.101H225.514V722.287Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1108 || (_path1108 = /*#__PURE__*/React.createElement("path", {
    d: "M233.765 722.287H237.2V727.101H233.765V722.287Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1109 || (_path1109 = /*#__PURE__*/React.createElement("path", {
    d: "M242.01 722.287H245.445V727.101H242.01V722.287Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1110 || (_path1110 = /*#__PURE__*/React.createElement("path", {
    d: "M250.947 722.287H254.383V727.101H250.947V722.287Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1111 || (_path1111 = /*#__PURE__*/React.createElement("path", {
    d: "M259.197 722.287H262.633V727.101H259.197V722.287Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1112 || (_path1112 = /*#__PURE__*/React.createElement("path", {
    d: "M267.447 722.287H270.883V727.101H267.447V722.287Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1113 || (_path1113 = /*#__PURE__*/React.createElement("path", {
    d: "M275.696 722.287H279.132V727.101H275.696V722.287Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1114 || (_path1114 = /*#__PURE__*/React.createElement("path", {
    d: "M283.94 722.287H287.376V727.101H283.94V722.287Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1115 || (_path1115 = /*#__PURE__*/React.createElement("path", {
    d: "M292.188 722.287H295.624V727.101H292.188V722.287Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1116 || (_path1116 = /*#__PURE__*/React.createElement("path", {
    d: "M299.755 722.287H303.19V727.101H299.755V722.287Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1117 || (_path1117 = /*#__PURE__*/React.createElement("path", {
    d: "M198.015 698.912H132.714V738.092H198.015V698.912Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1118 || (_path1118 = /*#__PURE__*/React.createElement("path", {
    d: "M145.088 711.974C145.088 709.317 147.24 707.16 149.902 707.16C152.564 707.16 154.716 709.312 154.716 711.974V727.095H145.093V711.974H145.088Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1119 || (_path1119 = /*#__PURE__*/React.createElement("path", {
    d: "M161.587 711.974C161.587 709.317 163.739 707.16 166.401 707.16C169.063 707.16 171.215 709.312 171.215 711.974V727.095H161.592V711.974H161.587Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1120 || (_path1120 = /*#__PURE__*/React.createElement("path", {
    d: "M178.771 711.974C178.771 709.317 180.922 707.16 183.584 707.16C186.247 707.16 188.398 709.312 188.398 711.974V727.095H178.776V711.974H178.771Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1121 || (_path1121 = /*#__PURE__*/React.createElement("path", {
    d: "M198.015 727.098H132.714V738.093H198.015V727.098Z",
    fill: "#F2D8D1",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1122 || (_path1122 = /*#__PURE__*/React.createElement("path", {
    d: "M198.015 727.098H132.714V728.471H198.015V727.098Z",
    fill: "#F2D8D1",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1123 || (_path1123 = /*#__PURE__*/React.createElement("path", {
    d: "M198.015 729.848H132.714V731.221H198.015V729.848Z",
    fill: "#F2D8D1",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1124 || (_path1124 = /*#__PURE__*/React.createElement("path", {
    d: "M198.015 732.595H132.714V733.968H198.015V732.595Z",
    fill: "#F2D8D1",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1125 || (_path1125 = /*#__PURE__*/React.createElement("path", {
    d: "M198.015 735.346H132.714V736.719H198.015V735.346Z",
    fill: "#F2D8D1",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1126 || (_path1126 = /*#__PURE__*/React.createElement("path", {
    d: "M324.499 698.912H8.29883V701.664H324.499V698.912Z",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1127 || (_path1127 = /*#__PURE__*/React.createElement("path", {
    d: "M324.5 698.912H202.831V701.664H324.5V698.912Z",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1128 || (_path1128 = /*#__PURE__*/React.createElement("path", {
    d: "M133.404 698.912H8.29883V701.664H133.404V698.912Z",
    fill: "#F2D8D1",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1129 || (_path1129 = /*#__PURE__*/React.createElement("path", {
    d: "M145.092 706.472H138.216V727.095H145.092V706.472Z",
    fill: "#F2D8D1",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1130 || (_path1130 = /*#__PURE__*/React.createElement("path", {
    d: "M161.587 706.472H154.711V727.095H161.587V706.472Z",
    fill: "#F2D8D1",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1131 || (_path1131 = /*#__PURE__*/React.createElement("path", {
    d: "M178.769 706.472H171.209V727.095H178.769V706.472Z",
    fill: "#F2D8D1",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1132 || (_path1132 = /*#__PURE__*/React.createElement("path", {
    d: "M195.953 706.472H188.393V727.095H195.953V706.472Z",
    fill: "#F2D8D1",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1133 || (_path1133 = /*#__PURE__*/React.createElement("path", {
    d: "M184.957 716.784H181.521V727.096H184.957V716.784Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1134 || (_path1134 = /*#__PURE__*/React.createElement("path", {
    d: "M168.457 716.784H165.021V727.096H168.457V716.784Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1135 || (_path1135 = /*#__PURE__*/React.createElement("path", {
    d: "M151.274 716.784H147.839V727.096H151.274V716.784Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1136 || (_path1136 = /*#__PURE__*/React.createElement("path", {
    d: "M141.306 711.975C142.256 711.975 143.027 711.205 143.027 710.255C143.027 709.304 142.256 708.534 141.306 708.534C140.356 708.534 139.586 709.304 139.586 710.255C139.586 711.205 140.356 711.975 141.306 711.975Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1137 || (_path1137 = /*#__PURE__*/React.createElement("path", {
    d: "M141.306 717.472C142.256 717.472 143.027 716.702 143.027 715.752C143.027 714.801 142.256 714.031 141.306 714.031C140.356 714.031 139.586 714.801 139.586 715.752C139.586 716.702 140.356 717.472 141.306 717.472Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1138 || (_path1138 = /*#__PURE__*/React.createElement("path", {
    d: "M141.306 722.978C142.256 722.978 143.027 722.208 143.027 721.258C143.027 720.307 142.256 719.537 141.306 719.537C140.356 719.537 139.586 720.307 139.586 721.258C139.586 722.208 140.356 722.978 141.306 722.978Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1139 || (_path1139 = /*#__PURE__*/React.createElement("path", {
    d: "M157.802 711.975C158.753 711.975 159.523 711.205 159.523 710.255C159.523 709.304 158.753 708.534 157.802 708.534C156.852 708.534 156.082 709.304 156.082 710.255C156.082 711.205 156.852 711.975 157.802 711.975Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1140 || (_path1140 = /*#__PURE__*/React.createElement("path", {
    d: "M157.802 717.472C158.753 717.472 159.523 716.702 159.523 715.752C159.523 714.801 158.753 714.031 157.802 714.031C156.852 714.031 156.082 714.801 156.082 715.752C156.082 716.702 156.852 717.472 157.802 717.472Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1141 || (_path1141 = /*#__PURE__*/React.createElement("path", {
    d: "M157.802 722.978C158.753 722.978 159.523 722.208 159.523 721.258C159.523 720.307 158.753 719.537 157.802 719.537C156.852 719.537 156.082 720.307 156.082 721.258C156.082 722.208 156.852 722.978 157.802 722.978Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1142 || (_path1142 = /*#__PURE__*/React.createElement("path", {
    d: "M174.993 711.975C175.943 711.975 176.713 711.205 176.713 710.255C176.713 709.304 175.943 708.534 174.993 708.534C174.043 708.534 173.272 709.304 173.272 710.255C173.272 711.205 174.043 711.975 174.993 711.975Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1143 || (_path1143 = /*#__PURE__*/React.createElement("path", {
    d: "M174.993 717.472C175.943 717.472 176.713 716.702 176.713 715.752C176.713 714.801 175.943 714.031 174.993 714.031C174.043 714.031 173.272 714.801 173.272 715.752C173.272 716.702 174.043 717.472 174.993 717.472Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1144 || (_path1144 = /*#__PURE__*/React.createElement("path", {
    d: "M174.992 722.978C175.942 722.978 176.712 722.208 176.712 721.258C176.712 720.307 175.942 719.537 174.992 719.537C174.042 719.537 173.271 720.307 173.271 721.258C173.271 722.208 174.042 722.978 174.992 722.978Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1145 || (_path1145 = /*#__PURE__*/React.createElement("path", {
    d: "M192.175 711.975C193.126 711.975 193.896 711.205 193.896 710.255C193.896 709.304 193.126 708.534 192.175 708.534C191.225 708.534 190.455 709.304 190.455 710.255C190.455 711.205 191.225 711.975 192.175 711.975Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1146 || (_path1146 = /*#__PURE__*/React.createElement("path", {
    d: "M192.175 717.472C193.126 717.472 193.896 716.702 193.896 715.752C193.896 714.801 193.126 714.031 192.175 714.031C191.225 714.031 190.455 714.801 190.455 715.752C190.455 716.702 191.225 717.472 192.175 717.472Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1147 || (_path1147 = /*#__PURE__*/React.createElement("path", {
    d: "M192.175 722.978C193.126 722.978 193.896 722.208 193.896 721.258C193.896 720.307 193.126 719.537 192.175 719.537C191.225 719.537 190.455 720.307 190.455 721.258C190.455 722.208 191.225 722.978 192.175 722.978Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1148 || (_path1148 = /*#__PURE__*/React.createElement("path", {
    d: "M154.709 709.565C154.709 710.133 154.273 710.732 153.383 711.206C152.51 711.674 151.279 711.969 149.9 711.969C148.522 711.969 147.291 711.669 146.418 711.206C145.528 710.732 145.092 710.138 145.092 709.565C145.092 708.991 145.528 708.397 146.418 707.923C147.291 707.455 148.522 707.16 149.9 707.16C151.279 707.16 152.51 707.46 153.383 707.923C154.273 708.397 154.709 708.991 154.709 709.565Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1149 || (_path1149 = /*#__PURE__*/React.createElement("path", {
    d: "M171.209 709.565C171.209 710.133 170.773 710.732 169.883 711.206C169.01 711.674 167.779 711.969 166.4 711.969C165.022 711.969 163.791 711.669 162.918 711.206C162.028 710.732 161.592 710.138 161.592 709.565C161.592 708.991 162.028 708.397 162.918 707.923C163.791 707.455 165.022 707.16 166.4 707.16C167.779 707.16 169.01 707.46 169.883 707.923C170.773 708.397 171.209 708.991 171.209 709.565Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1150 || (_path1150 = /*#__PURE__*/React.createElement("path", {
    d: "M188.394 709.565C188.394 710.133 187.957 710.732 187.068 711.206C186.195 711.674 184.963 711.969 183.585 711.969C182.207 711.969 180.976 711.669 180.102 711.206C179.213 710.732 178.776 710.138 178.776 709.565C178.776 708.991 179.213 708.397 180.102 707.923C180.976 707.455 182.207 707.16 183.585 707.16C184.963 707.16 186.195 707.46 187.068 707.923C187.957 708.397 188.394 708.991 188.394 709.565Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1151 || (_path1151 = /*#__PURE__*/React.createElement("path", {
    d: "M156.793 657.67C156.967 656.123 158.277 654.918 159.866 654.918H172.924C174.518 654.918 175.828 656.123 175.997 657.67H156.788H156.793Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1152 || (_path1152 = /*#__PURE__*/React.createElement("path", {
    d: "M160.083 631.548L156.3 623.987H175.808L172.025 631.548H160.077H160.083Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1153 || (_path1153 = /*#__PURE__*/React.createElement("path", {
    d: "M163.643 626.052H162.27V630.177H163.643V626.052Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1154 || (_path1154 = /*#__PURE__*/React.createElement("path", {
    d: "M166.395 626.052H165.021V630.177H166.395V626.052Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1155 || (_path1155 = /*#__PURE__*/React.createElement("path", {
    d: "M169.148 626.052H167.774V630.177H169.148V626.052Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1156 || (_path1156 = /*#__PURE__*/React.createElement("path", {
    d: "M152.648 676.572C152.648 676.004 153.111 675.541 153.68 675.541C154.248 675.541 154.711 676.004 154.711 676.572V677.945C154.711 679.155 153.816 680.16 152.648 680.329V676.572Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1157 || (_path1157 = /*#__PURE__*/React.createElement("path", {
    d: "M178.085 676.572C178.085 676.004 178.548 675.541 179.116 675.541C179.684 675.541 180.147 676.004 180.147 676.572V680.329C178.979 680.16 178.085 679.161 178.085 677.945V676.572Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1158 || (_path1158 = /*#__PURE__*/React.createElement("path", {
    d: "M1812.03 685.854H1683.49V737.407H1812.03V685.854Z",
    fill: "#F4D7C9",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1159 || (_path1159 = /*#__PURE__*/React.createElement("path", {
    d: "M1812.03 721.6H1683.49V737.409H1812.03V721.6Z",
    fill: "#D7C7A3",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1160 || (_path1160 = /*#__PURE__*/React.createElement("path", {
    d: "M1692.42 696.165H1689.67V703.041H1692.42V696.165Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1161 || (_path1161 = /*#__PURE__*/React.createElement("path", {
    d: "M1815.81 689.632H1679.7V691.694H1815.81V689.632Z",
    fill: "#615E66"
  })), _path1162 || (_path1162 = /*#__PURE__*/React.createElement("path", {
    d: "M1692.42 710.6H1689.67V717.476H1692.42V710.6Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1163 || (_path1163 = /*#__PURE__*/React.createElement("path", {
    d: "M1693.11 725.035H1686.23V737.409H1693.11V725.035Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1164 || (_path1164 = /*#__PURE__*/React.createElement("path", {
    d: "M1709.61 725.035H1699.29V737.409H1709.61V725.035Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1165 || (_path1165 = /*#__PURE__*/React.createElement("path", {
    d: "M1724.73 725.035H1714.42V737.409H1724.73V725.035Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1166 || (_path1166 = /*#__PURE__*/React.createElement("path", {
    d: "M1739.85 725.035H1729.54V737.409H1739.85V725.035Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1167 || (_path1167 = /*#__PURE__*/React.createElement("path", {
    d: "M1743.29 727.438C1743.29 724.971 1745.29 722.972 1747.76 722.972C1750.22 722.972 1752.22 724.971 1752.22 727.438V737.408H1743.29V727.438H1743.29Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1168 || (_path1168 = /*#__PURE__*/React.createElement("path", {
    d: "M1765.98 725.035H1755.66V737.409H1765.98V725.035Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1169 || (_path1169 = /*#__PURE__*/React.createElement("path", {
    d: "M1781.1 725.035H1770.79V737.409H1781.1V725.035Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1170 || (_path1170 = /*#__PURE__*/React.createElement("path", {
    d: "M1796.91 725.035H1786.59V737.409H1796.91V725.035Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1171 || (_path1171 = /*#__PURE__*/React.createElement("path", {
    d: "M1808.59 725.035H1802.41V737.409H1808.59V725.035Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1172 || (_path1172 = /*#__PURE__*/React.createElement("path", {
    d: "M1693.11 727.098H1686.23V737.41H1693.11V727.098Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1173 || (_path1173 = /*#__PURE__*/React.createElement("path", {
    d: "M1709.61 727.098H1699.29V737.41H1709.61V727.098Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1174 || (_path1174 = /*#__PURE__*/React.createElement("path", {
    d: "M1724.73 727.098H1714.42V737.41H1724.73V727.098Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1175 || (_path1175 = /*#__PURE__*/React.createElement("path", {
    d: "M1739.85 727.098H1729.54V737.41H1739.85V727.098Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1176 || (_path1176 = /*#__PURE__*/React.createElement("path", {
    d: "M1743.29 729.502C1743.29 727.034 1745.29 725.035 1747.76 725.035C1750.22 725.035 1752.22 727.034 1752.22 729.502V737.409H1743.29V729.502H1743.29Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1177 || (_path1177 = /*#__PURE__*/React.createElement("path", {
    d: "M1765.98 727.098H1755.66V737.41H1765.98V727.098Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1178 || (_path1178 = /*#__PURE__*/React.createElement("path", {
    d: "M1781.1 727.098H1770.79V737.41H1781.1V727.098Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1179 || (_path1179 = /*#__PURE__*/React.createElement("path", {
    d: "M1796.91 727.098H1786.59V737.41H1796.91V727.098Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1180 || (_path1180 = /*#__PURE__*/React.createElement("path", {
    d: "M1808.59 727.098H1802.41V737.41H1808.59V727.098Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1181 || (_path1181 = /*#__PURE__*/React.createElement("path", {
    d: "M1704.11 696.165H1701.36V703.041H1704.11V696.165Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1182 || (_path1182 = /*#__PURE__*/React.createElement("path", {
    d: "M1704.11 710.6H1701.36V717.476H1704.11V710.6Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1183 || (_path1183 = /*#__PURE__*/React.createElement("path", {
    d: "M1711.67 696.165H1708.92V703.041H1711.67V696.165Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1184 || (_path1184 = /*#__PURE__*/React.createElement("path", {
    d: "M1711.67 710.6H1708.92V717.476H1711.67V710.6Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1185 || (_path1185 = /*#__PURE__*/React.createElement("path", {
    d: "M1719.23 696.165H1716.48V703.041H1719.23V696.165Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1186 || (_path1186 = /*#__PURE__*/React.createElement("path", {
    d: "M1719.23 710.6H1716.48V717.476H1719.23V710.6Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1187 || (_path1187 = /*#__PURE__*/React.createElement("path", {
    d: "M1726.11 696.165H1723.35V703.041H1726.11V696.165Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1188 || (_path1188 = /*#__PURE__*/React.createElement("path", {
    d: "M1726.11 710.6H1723.35V717.476H1726.11V710.6Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1189 || (_path1189 = /*#__PURE__*/React.createElement("path", {
    d: "M1734.36 696.165H1731.6V703.041H1734.36V696.165Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1190 || (_path1190 = /*#__PURE__*/React.createElement("path", {
    d: "M1734.36 710.6H1731.6V717.476H1734.36V710.6Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1191 || (_path1191 = /*#__PURE__*/React.createElement("path", {
    d: "M1741.23 696.165H1738.47V703.041H1741.23V696.165Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1192 || (_path1192 = /*#__PURE__*/React.createElement("path", {
    d: "M1741.23 710.6H1738.47V717.476H1741.23V710.6Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1193 || (_path1193 = /*#__PURE__*/React.createElement("path", {
    d: "M1749.48 696.165H1746.73V703.041H1749.48V696.165Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1194 || (_path1194 = /*#__PURE__*/React.createElement("path", {
    d: "M1749.48 710.6H1746.73V717.476H1749.48V710.6Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1195 || (_path1195 = /*#__PURE__*/React.createElement("path", {
    d: "M1757.73 696.165H1754.97V703.041H1757.73V696.165Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1196 || (_path1196 = /*#__PURE__*/React.createElement("path", {
    d: "M1757.73 710.6H1754.97V717.476H1757.73V710.6Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1197 || (_path1197 = /*#__PURE__*/React.createElement("path", {
    d: "M1765.29 696.165H1762.54V703.041H1765.29V696.165Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1198 || (_path1198 = /*#__PURE__*/React.createElement("path", {
    d: "M1765.29 710.6H1762.54V717.476H1765.29V710.6Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1199 || (_path1199 = /*#__PURE__*/React.createElement("path", {
    d: "M1772.16 696.165H1769.41V703.041H1772.16V696.165Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1200 || (_path1200 = /*#__PURE__*/React.createElement("path", {
    d: "M1772.16 710.6H1769.41V717.476H1772.16V710.6Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1201 || (_path1201 = /*#__PURE__*/React.createElement("path", {
    d: "M1780.41 696.165H1777.66V703.041H1780.41V696.165Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1202 || (_path1202 = /*#__PURE__*/React.createElement("path", {
    d: "M1780.41 710.6H1777.66V717.476H1780.41V710.6Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1203 || (_path1203 = /*#__PURE__*/React.createElement("path", {
    d: "M1787.97 696.165H1785.22V703.041H1787.97V696.165Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1204 || (_path1204 = /*#__PURE__*/React.createElement("path", {
    d: "M1787.97 710.6H1785.22V717.476H1787.97V710.6Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1205 || (_path1205 = /*#__PURE__*/React.createElement("path", {
    d: "M1794.84 696.165H1792.09V703.041H1794.84V696.165Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1206 || (_path1206 = /*#__PURE__*/React.createElement("path", {
    d: "M1794.84 710.6H1792.09V717.476H1794.84V710.6Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1207 || (_path1207 = /*#__PURE__*/React.createElement("path", {
    d: "M1805.84 696.165H1803.09V703.041H1805.84V696.165Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1208 || (_path1208 = /*#__PURE__*/React.createElement("path", {
    d: "M1805.84 710.6H1803.09V717.476H1805.84V710.6Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1209 || (_path1209 = /*#__PURE__*/React.createElement("path", {
    d: "M1814.09 685.854H1681.42V689.978H1814.09V685.854Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1210 || (_path1210 = /*#__PURE__*/React.createElement("path", {
    d: "M1695.17 687.227H1683.49V688.6H1695.17V687.227Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1211 || (_path1211 = /*#__PURE__*/React.createElement("path", {
    d: "M1711.67 687.227H1699.98V688.6H1711.67V687.227Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1212 || (_path1212 = /*#__PURE__*/React.createElement("path", {
    d: "M1728.16 687.227H1716.48V688.6H1728.16V687.227Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1213 || (_path1213 = /*#__PURE__*/React.createElement("path", {
    d: "M1744.66 687.227H1732.98V688.6H1744.66V687.227Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1214 || (_path1214 = /*#__PURE__*/React.createElement("path", {
    d: "M1761.16 687.227H1749.48V688.6H1761.16V687.227Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1215 || (_path1215 = /*#__PURE__*/React.createElement("path", {
    d: "M1777.66 687.227H1765.97V688.6H1777.66V687.227Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1216 || (_path1216 = /*#__PURE__*/React.createElement("path", {
    d: "M1794.16 687.227H1782.47V688.6H1794.16V687.227Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1217 || (_path1217 = /*#__PURE__*/React.createElement("path", {
    d: "M1810.65 687.227H1798.97V688.6H1810.65V687.227Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1218 || (_path1218 = /*#__PURE__*/React.createElement("path", {
    d: "M1752.5 682.763L1751.82 682.899L1751.93 683.452H1752.5V682.763ZM1755.32 682.763H1756.01V682.073H1755.32V682.763ZM1755.32 686.198V686.887H1756.01V686.198H1755.32ZM1741.57 686.198H1740.88V686.887H1741.57V686.198ZM1741.57 682.763V682.073H1740.88V682.763H1741.57ZM1744.39 682.763V683.452H1744.95L1745.06 682.899L1744.39 682.763ZM1752.5 683.452H1755.32V682.079H1752.5V683.452ZM1754.63 682.763V686.198H1756.01V682.763H1754.63ZM1755.32 685.509H1741.57V686.882H1755.32V685.509ZM1742.26 686.198V682.763H1740.89V686.198H1742.26ZM1741.57 683.452H1744.39V682.079H1741.57V683.452ZM1745.06 682.899C1745.32 681.647 1746.43 680.7 1747.76 680.7V679.327C1745.76 679.327 1744.1 680.742 1743.72 682.626L1745.06 682.899ZM1747.76 680.7H1749.13V679.327H1747.76V680.7ZM1749.13 680.7C1750.46 680.7 1751.57 681.647 1751.82 682.899L1753.17 682.626C1752.79 680.742 1751.12 679.327 1749.13 679.327V680.7Z",
    fill: "#615E66"
  })), _path1219 || (_path1219 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1752.5 682.761H1755.32V686.197H1741.57V682.761H1744.39C1744.71 681.194 1746.09 680.01 1747.76 680.01H1749.13C1750.79 680.01 1752.18 681.188 1752.5 682.761Z",
    fill: "white"
  })), _path1220 || (_path1220 = /*#__PURE__*/React.createElement("path", {
    d: "M1867.7 705.789H1812.02V737.409H1867.7V705.789Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1221 || (_path1221 = /*#__PURE__*/React.createElement("path", {
    d: "M1867.7 726.407H1812.02V737.403H1867.7V726.407Z",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1222 || (_path1222 = /*#__PURE__*/React.createElement("path", {
    d: "M1824.4 730.532H1819.58V737.409H1824.4V730.532Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1223 || (_path1223 = /*#__PURE__*/React.createElement("path", {
    d: "M1833.34 730.532H1828.52V737.409H1833.34V730.532Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1224 || (_path1224 = /*#__PURE__*/React.createElement("path", {
    d: "M1843.65 730.532H1838.84V737.409H1843.65V730.532Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1225 || (_path1225 = /*#__PURE__*/React.createElement("path", {
    d: "M1852.58 730.532H1847.77V737.409H1852.58V730.532Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1226 || (_path1226 = /*#__PURE__*/React.createElement("path", {
    d: "M1862.21 730.532H1857.39V737.409H1862.21V730.532Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1227 || (_path1227 = /*#__PURE__*/React.createElement("path", {
    d: "M1824.4 712.66H1819.58V722.972H1824.4V712.66Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1228 || (_path1228 = /*#__PURE__*/React.createElement("path", {
    d: "M1833.34 712.66H1828.52V722.972H1833.34V712.66Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1229 || (_path1229 = /*#__PURE__*/React.createElement("path", {
    d: "M1843.65 712.66H1838.84V722.972H1843.65V712.66Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1230 || (_path1230 = /*#__PURE__*/React.createElement("path", {
    d: "M1852.58 712.66H1847.77V722.972H1852.58V712.66Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1231 || (_path1231 = /*#__PURE__*/React.createElement("path", {
    d: "M1855.34 722.288H1823.03V726.413H1855.34V722.288Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1232 || (_path1232 = /*#__PURE__*/React.createElement("path", {
    d: "M1862.21 712.66H1857.39V722.972H1862.21V712.66Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1233 || (_path1233 = /*#__PURE__*/React.createElement("path", {
    d: "M1839.87 692.084L1813.11 705.789H1866.63L1839.87 692.084H1839.87Z",
    fill: "#D7C6A2",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1234 || (_path1234 = /*#__PURE__*/React.createElement("path", {
    d: "M1809.96 707.851L1808.24 706.131L1840.2 689.29L1871.13 706.131L1869.76 707.851L1840.2 692.042L1809.96 707.851H1809.96Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1235 || (_path1235 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1824.04 729.274H1825.43V731.563H1818.55V729.274H1819.94C1820.05 728.243 1820.93 727.443 1821.99 727.443C1823.05 727.443 1823.93 728.243 1824.04 729.274H1824.04Z",
    fill: "#E8CD9C"
  })), _path1236 || (_path1236 = /*#__PURE__*/React.createElement("path", {
    d: "M1824.04 729.275L1823.36 729.349L1823.43 729.959H1824.04V729.27V729.275ZM1825.43 729.275H1826.12V728.586H1825.43V729.275ZM1825.43 731.564V732.253H1826.12V731.564H1825.43ZM1818.55 731.564H1817.87V732.253H1818.55V731.564ZM1818.55 729.275V728.586H1817.87V729.275H1818.55ZM1819.94 729.275V729.965H1820.55L1820.62 729.354L1819.94 729.281V729.275ZM1824.04 729.965H1825.43V728.591H1824.04V729.965ZM1824.74 729.275V731.564H1826.11V729.275H1824.74ZM1825.43 730.88H1818.55V732.253H1825.43V730.88ZM1819.24 731.564V729.275H1817.87V731.564H1819.24ZM1818.55 729.965H1819.94V728.591H1818.55V729.965ZM1820.63 729.349C1820.7 728.66 1821.29 728.128 1822 728.128V726.755C1820.58 726.755 1819.42 727.823 1819.26 729.202L1820.63 729.354V729.349ZM1822 728.128C1822.71 728.128 1823.29 728.665 1823.36 729.349L1824.73 729.196C1824.57 727.823 1823.41 726.75 1822 726.75V728.123V728.128Z",
    fill: "#615E66"
  })), _path1237 || (_path1237 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1832.98 729.274H1834.37V731.563H1827.49V729.274H1828.88C1828.99 728.243 1829.87 727.443 1830.93 727.443C1831.98 727.443 1832.86 728.243 1832.97 729.274H1832.98Z",
    fill: "#E8CD9C"
  })), _path1238 || (_path1238 = /*#__PURE__*/React.createElement("path", {
    d: "M1832.98 729.275L1832.3 729.349L1832.37 729.959H1832.98V729.27V729.275ZM1834.37 729.275H1835.06V728.586H1834.37V729.275ZM1834.37 731.564V732.253H1835.06V731.564H1834.37ZM1827.49 731.564H1826.8V732.253H1827.49V731.564ZM1827.49 729.275V728.586H1826.8V729.275H1827.49ZM1828.88 729.275V729.965H1829.49L1829.56 729.354L1828.88 729.281V729.275ZM1832.98 729.965H1834.37V728.591H1832.98V729.965ZM1833.68 729.275V731.564H1835.05V729.275H1833.68ZM1834.37 730.88H1827.49V732.253H1834.37V730.88ZM1828.18 731.564V729.275H1826.81V731.564H1828.18ZM1827.49 729.965H1828.88V728.591H1827.49V729.965ZM1829.56 729.349C1829.63 728.66 1830.22 728.128 1830.93 728.128V726.755C1829.51 726.755 1828.35 727.823 1828.19 729.202L1829.56 729.354V729.349ZM1830.93 728.128C1831.64 728.128 1832.22 728.665 1832.3 729.349L1833.66 729.196C1833.51 727.823 1832.34 726.75 1830.93 726.75V728.123V728.128Z",
    fill: "#615E66"
  })), _path1239 || (_path1239 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1843.29 729.274H1844.68V731.563H1837.8V729.274H1839.19C1839.3 728.243 1840.18 727.443 1841.24 727.443C1842.29 727.443 1843.17 728.243 1843.28 729.274H1843.29Z",
    fill: "#E8CD9C"
  })), _path1240 || (_path1240 = /*#__PURE__*/React.createElement("path", {
    d: "M1843.29 729.275L1842.61 729.349L1842.68 729.959H1843.29V729.27V729.275ZM1844.68 729.275H1845.37V728.586H1844.68V729.275ZM1844.68 731.564V732.253H1845.37V731.564H1844.68ZM1837.81 731.564H1837.12V732.253H1837.81V731.564ZM1837.81 729.275V728.586H1837.12V729.275H1837.81ZM1839.19 729.275V729.965H1839.8L1839.87 729.354L1839.19 729.281V729.275ZM1843.29 729.965H1844.68V728.591H1843.29V729.965ZM1843.99 729.275V731.564H1845.37V729.275H1843.99ZM1844.68 730.88H1837.8V732.253H1844.68V730.88ZM1838.49 731.564V729.275H1837.12V731.564H1838.49ZM1837.81 729.965H1839.19V728.591H1837.81V729.965ZM1839.87 729.349C1839.95 728.66 1840.53 728.128 1841.24 728.128V726.755C1839.83 726.755 1838.66 727.823 1838.51 729.202L1839.87 729.354V729.349ZM1841.24 728.128C1841.95 728.128 1842.54 728.665 1842.61 729.349L1843.98 729.196C1843.82 727.823 1842.66 726.75 1841.24 726.75V728.123V728.128Z",
    fill: "#615E66"
  })), _path1241 || (_path1241 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1852.23 729.274H1853.62V731.563H1846.74V729.274H1848.13C1848.24 728.243 1849.12 727.443 1850.17 727.443C1851.23 727.443 1852.11 728.243 1852.22 729.274H1852.23Z",
    fill: "#E8CD9C"
  })), _path1242 || (_path1242 = /*#__PURE__*/React.createElement("path", {
    d: "M1852.23 729.275L1851.55 729.349L1851.62 729.959H1852.23V729.27V729.275ZM1853.62 729.275H1854.31V728.586H1853.62V729.275ZM1853.62 731.564V732.253H1854.31V731.564H1853.62ZM1846.74 731.564H1846.05V732.253H1846.74V731.564ZM1846.74 729.275V728.586H1846.05V729.275H1846.74ZM1848.13 729.275V729.965H1848.74L1848.81 729.354L1848.13 729.281V729.275ZM1852.23 729.965H1853.62V728.591H1852.23V729.965ZM1852.93 729.275V731.564H1854.3V729.275H1852.93ZM1853.62 730.88H1846.74V732.253H1853.62V730.88ZM1847.43 731.564V729.275H1846.06V731.564H1847.43ZM1846.74 729.965H1848.13V728.591H1846.74V729.965ZM1848.81 729.349C1848.89 728.66 1849.47 728.128 1850.18 728.128V726.755C1848.77 726.755 1847.6 727.823 1847.44 729.202L1848.81 729.354V729.349ZM1850.18 728.128C1850.89 728.128 1851.47 728.665 1851.55 729.349L1852.92 729.196C1852.76 727.823 1851.6 726.75 1850.18 726.75V728.123V728.128Z",
    fill: "#615E66"
  })), _path1243 || (_path1243 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1861.85 729.274H1863.24V731.563H1856.36V729.274H1857.75C1857.86 728.243 1858.74 727.443 1859.8 727.443C1860.85 727.443 1861.73 728.243 1861.84 729.274H1861.85Z",
    fill: "#E8CD9C"
  })), _path1244 || (_path1244 = /*#__PURE__*/React.createElement("path", {
    d: "M1861.85 729.275L1861.17 729.349L1861.24 729.959H1861.85V729.27V729.275ZM1863.24 729.275H1863.93V728.586H1863.24V729.275ZM1863.24 731.564V732.253H1863.93V731.564H1863.24ZM1856.37 731.564H1855.68V732.253H1856.37V731.564ZM1856.37 729.275V728.586H1855.68V729.275H1856.37ZM1857.75 729.275V729.965H1858.36L1858.43 729.354L1857.75 729.281V729.275ZM1861.85 729.965H1863.24V728.591H1861.85V729.965ZM1862.55 729.275V731.564H1863.92V729.275H1862.55ZM1863.24 730.88H1856.36V732.253H1863.24V730.88ZM1857.05 731.564V729.275H1855.68V731.564H1857.05ZM1856.37 729.965H1857.75V728.591H1856.37V729.965ZM1858.43 729.349C1858.51 728.66 1859.09 728.128 1859.8 728.128V726.755C1858.39 726.755 1857.22 727.823 1857.06 729.202L1858.43 729.354V729.349ZM1859.8 728.128C1860.51 728.128 1861.09 728.665 1861.17 729.349L1862.54 729.196C1862.38 727.823 1861.22 726.75 1859.8 726.75V728.123V728.128Z",
    fill: "#615E66"
  })), _path1245 || (_path1245 = /*#__PURE__*/React.createElement("path", {
    d: "M1825.09 709.565C1825.09 709.629 1825.05 709.728 1824.92 709.849C1824.79 709.976 1824.59 710.102 1824.3 710.218C1823.73 710.449 1822.91 710.597 1821.99 710.597C1821.08 710.597 1820.26 710.449 1819.69 710.218C1819.4 710.102 1819.2 709.976 1819.06 709.849C1818.93 709.723 1818.9 709.629 1818.9 709.565C1818.9 709.502 1818.94 709.402 1819.06 709.281C1819.2 709.155 1819.4 709.029 1819.69 708.913C1820.26 708.681 1821.08 708.534 1821.99 708.534C1822.91 708.534 1823.72 708.681 1824.3 708.913C1824.59 709.029 1824.79 709.155 1824.92 709.281C1825.06 709.408 1825.09 709.502 1825.09 709.565Z",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1246 || (_path1246 = /*#__PURE__*/React.createElement("path", {
    d: "M1834.02 709.565C1834.02 709.629 1833.99 709.728 1833.86 709.849C1833.73 709.976 1833.52 710.102 1833.23 710.218C1832.67 710.449 1831.84 710.597 1830.93 710.597C1830.01 710.597 1829.2 710.449 1828.63 710.218C1828.34 710.102 1828.13 709.976 1828 709.849C1827.87 709.723 1827.84 709.629 1827.84 709.565C1827.84 709.502 1827.87 709.402 1828 709.281C1828.13 709.155 1828.34 709.029 1828.63 708.913C1829.19 708.681 1830.01 708.534 1830.93 708.534C1831.84 708.534 1832.66 708.681 1833.23 708.913C1833.52 709.029 1833.73 709.155 1833.86 709.281C1833.99 709.408 1834.02 709.502 1834.02 709.565Z",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1247 || (_path1247 = /*#__PURE__*/React.createElement("path", {
    d: "M1844.33 709.565C1844.33 709.629 1844.3 709.728 1844.17 709.849C1844.04 709.976 1843.83 710.102 1843.54 710.218C1842.98 710.449 1842.16 710.597 1841.24 710.597C1840.32 710.597 1839.51 710.449 1838.94 710.218C1838.65 710.102 1838.44 709.976 1838.31 709.849C1838.18 709.723 1838.15 709.629 1838.15 709.565C1838.15 709.502 1838.18 709.402 1838.31 709.281C1838.44 709.155 1838.65 709.029 1838.94 708.913C1839.5 708.681 1840.32 708.534 1841.24 708.534C1842.16 708.534 1842.97 708.681 1843.54 708.913C1843.83 709.029 1844.04 709.155 1844.17 709.281C1844.3 709.408 1844.33 709.502 1844.33 709.565Z",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1248 || (_path1248 = /*#__PURE__*/React.createElement("path", {
    d: "M1853.27 709.565C1853.27 709.629 1853.23 709.728 1853.11 709.849C1852.98 709.976 1852.77 710.102 1852.48 710.218C1851.91 710.449 1851.09 710.597 1850.18 710.597C1849.26 710.597 1848.45 710.449 1847.87 710.218C1847.58 710.102 1847.38 709.976 1847.25 709.849C1847.12 709.723 1847.08 709.629 1847.08 709.565C1847.08 709.502 1847.12 709.402 1847.25 709.281C1847.38 709.155 1847.58 709.029 1847.87 708.913C1848.44 708.681 1849.26 708.534 1850.18 708.534C1851.09 708.534 1851.91 708.681 1852.48 708.913C1852.77 709.029 1852.98 709.155 1853.11 709.281C1853.24 709.408 1853.27 709.502 1853.27 709.565Z",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1249 || (_path1249 = /*#__PURE__*/React.createElement("path", {
    d: "M1862.9 709.565C1862.9 709.629 1862.86 709.728 1862.73 709.849C1862.6 709.976 1862.4 710.102 1862.11 710.218C1861.54 710.449 1860.72 710.597 1859.8 710.597C1858.89 710.597 1858.07 710.449 1857.5 710.218C1857.21 710.102 1857 709.976 1856.87 709.849C1856.74 709.723 1856.71 709.629 1856.71 709.565C1856.71 709.502 1856.75 709.402 1856.87 709.281C1857 709.155 1857.21 709.029 1857.5 708.913C1858.07 708.681 1858.89 708.534 1859.8 708.534C1860.72 708.534 1861.53 708.681 1862.11 708.913C1862.4 709.029 1862.6 709.155 1862.73 709.281C1862.86 709.408 1862.9 709.502 1862.9 709.565Z",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1250 || (_path1250 = /*#__PURE__*/React.createElement("path", {
    d: "M1840.21 696.508L1830.93 700.975H1848.8L1840.21 696.508Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1251 || (_path1251 = /*#__PURE__*/React.createElement("path", {
    d: "M381.556 703.728C386.112 703.728 389.806 707.421 389.806 711.977V722.289C389.806 726.845 386.112 730.538 381.556 730.538C377 730.538 373.307 726.845 373.307 722.289V711.977C373.307 707.421 377 703.728 381.556 703.728Z",
    fill: "#FFD6D0",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1252 || (_path1252 = /*#__PURE__*/React.createElement("path", {
    d: "M382.586 706.132C386.385 706.132 389.463 709.21 389.463 713.008V722.631C389.463 726.429 386.385 729.507 382.586 729.507C378.788 729.507 375.71 726.429 375.71 722.631V713.008C375.71 709.21 378.788 706.132 382.586 706.132Z",
    fill: "#E9A59B"
  })), _path1253 || (_path1253 = /*#__PURE__*/React.createElement("path", {
    d: "M381.21 713.008V738.44",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1254 || (_path1254 = /*#__PURE__*/React.createElement("path", {
    d: "M386.367 715.071L381.553 719.885",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1255 || (_path1255 = /*#__PURE__*/React.createElement("path", {
    d: "M376.742 720.568L381.556 725.382",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1256 || (_path1256 = /*#__PURE__*/React.createElement("path", {
    d: "M376.744 715.071L381.558 719.885",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1257 || (_path1257 = /*#__PURE__*/React.createElement("path", {
    d: "M420.047 703.728C424.604 703.728 428.297 707.421 428.297 711.977C428.297 716.533 424.604 720.226 420.047 720.226C415.491 720.226 411.798 716.533 411.798 711.977C411.798 707.421 415.491 703.728 420.047 703.728Z",
    fill: "#E1F1F1",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1258 || (_path1258 = /*#__PURE__*/React.createElement("path", {
    d: "M420.046 706.823H420.735C424.344 706.823 427.264 709.748 427.264 713.352C427.264 716.961 424.339 719.881 420.735 719.881H420.046C416.437 719.881 413.517 716.956 413.517 713.352C413.517 709.743 416.442 706.823 420.046 706.823Z",
    fill: "#62AE80"
  })), _path1259 || (_path1259 = /*#__PURE__*/React.createElement("path", {
    d: "M419.704 713.008V738.44",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1260 || (_path1260 = /*#__PURE__*/React.createElement("path", {
    d: "M424.513 713.692L419.699 718.506",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1261 || (_path1261 = /*#__PURE__*/React.createElement("path", {
    d: "M415.238 713.692L420.052 718.506",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1262 || (_path1262 = /*#__PURE__*/React.createElement("path", {
    d: "M392.553 725.088C392.553 722.152 393.158 719.254 394.326 716.565L395.499 713.871C397.777 708.642 405.196 708.642 407.474 713.871L408.647 716.565C409.82 719.254 410.42 722.152 410.42 725.088C410.42 725.819 409.825 726.414 409.094 726.414H393.874C393.142 726.414 392.548 725.819 392.548 725.088H392.553Z",
    fill: "#E1F1F1",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1263 || (_path1263 = /*#__PURE__*/React.createElement("path", {
    d: "M394.956 724.751C394.956 722.357 395.456 719.99 396.429 717.801L396.987 716.549C399.118 711.751 405.926 711.751 408.056 716.549L408.614 717.801C409.582 719.99 410.087 722.357 410.087 724.751C410.087 725.477 409.498 726.072 408.767 726.072H396.282C395.556 726.072 394.961 725.482 394.961 724.751H394.956Z",
    fill: "#62AE80"
  })), _path1264 || (_path1264 = /*#__PURE__*/React.createElement("path", {
    d: "M401.491 721.259V738.1",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1265 || (_path1265 = /*#__PURE__*/React.createElement("path", {
    d: "M405.958 719.88L401.491 724.005",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1266 || (_path1266 = /*#__PURE__*/React.createElement("path", {
    d: "M398.05 721.943L401.485 725.726",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1267 || (_path1267 = /*#__PURE__*/React.createElement("path", {
    d: "M355.171 738.051C351.978 735.174 352.43 730.039 356.081 727.766L362.137 723.999C363.073 723.42 364.263 723.441 365.167 724.062L370.539 727.729C374.017 730.107 374.48 735.058 371.502 738.036C371.465 738.072 371.412 738.094 371.36 738.094H355.287C355.245 738.094 355.198 738.078 355.166 738.046L355.171 738.051Z",
    fill: "#E1F1F1"
  })), _path1268 || (_path1268 = /*#__PURE__*/React.createElement("path", {
    d: "M355.166 738.046C355.198 738.078 355.245 738.094 355.287 738.094H371.36C371.412 738.094 371.465 738.072 371.502 738.036C374.48 735.058 374.017 730.107 370.539 727.729L365.167 724.062C364.263 723.441 363.073 723.42 362.137 723.999L356.081 727.766C352.43 730.039 351.978 735.174 355.171 738.051L355.166 738.046ZM355.166 738.046L354.935 738.304",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1269 || (_path1269 = /*#__PURE__*/React.createElement("path", {
    d: "M355.656 737.609C353.562 735.1 354.235 731.312 357.06 729.67L363.842 725.74C364.589 725.309 365.515 725.319 366.257 725.767L370.902 728.602C374.206 730.617 374.438 735.326 371.355 737.662C371.281 737.72 371.192 737.746 371.097 737.746H355.961C355.84 737.746 355.724 737.694 355.65 737.599L355.656 737.609Z",
    fill: "#62AE80"
  })), _path1270 || (_path1270 = /*#__PURE__*/React.createElement("path", {
    d: "M362.647 732.255V737.753",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1271 || (_path1271 = /*#__PURE__*/React.createElement("path", {
    d: "M367.121 730.882L362.654 735.007",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1272 || (_path1272 = /*#__PURE__*/React.createElement("path", {
    d: "M359.212 732.943L362.647 736.726",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1273 || (_path1273 = /*#__PURE__*/React.createElement("path", {
    d: "M419.515 738.44H431.584C433.352 738.44 435.051 737.772 436.34 736.567L437.272 735.699C437.577 735.415 437.798 735.057 437.919 734.657L438.003 734.363C438.65 732.179 436.004 730.533 434.331 732.085V730.917C434.331 728.512 431.311 727.434 429.79 729.301C430.516 726.397 427.181 724.193 424.797 726.003L424.119 726.518L423.935 725.945C423.293 723.951 421.125 722.883 419.158 723.593C417.19 724.303 416.201 726.497 416.969 728.439L417.311 729.301C414.386 729.301 412.755 732.674 414.57 734.968L415.943 736.704C416.811 737.798 418.132 738.44 419.526 738.44H419.515Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1274 || (_path1274 = /*#__PURE__*/React.createElement("path", {
    d: "M423.483 738.098L419.358 731.569",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1275 || (_path1275 = /*#__PURE__*/React.createElement("path", {
    d: "M422.109 735.346L424.514 730.19",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1276 || (_path1276 = /*#__PURE__*/React.createElement("path", {
    d: "M429.328 738.441L432.764 733.975",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1277 || (_path1277 = /*#__PURE__*/React.createElement("path", {
    d: "M428.986 732.943L431.391 735.348",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1278 || (_path1278 = /*#__PURE__*/React.createElement("path", {
    d: "M426.922 738.098L420.046 726.755",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1279 || (_path1279 = /*#__PURE__*/React.createElement("path", {
    d: "M579.275 728.108C581.627 725.635 582.095 721.921 580.427 718.943L570.968 702.008C570.047 700.361 567.685 700.361 566.764 702.008L557.026 719.443C555.51 722.158 555.837 725.535 557.857 727.908C559.272 729.576 561.35 730.533 563.539 730.533H573.625C575.761 730.533 577.802 729.655 579.275 728.108Z",
    fill: "#E1F1F1",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1280 || (_path1280 = /*#__PURE__*/React.createElement("path", {
    d: "M578.708 728.456C580.975 726.341 581.423 722.91 579.765 720.285L571.879 707.769C570.8 706.059 568.301 706.059 567.223 707.769L558.216 722.069C557.2 723.678 557.416 725.772 558.731 727.151C560.599 729.097 563.177 730.197 565.871 730.197H574.289C575.925 730.197 577.503 729.576 578.697 728.461L578.708 728.456Z",
    fill: "#62AE80"
  })), _path1281 || (_path1281 = /*#__PURE__*/React.createElement("path", {
    d: "M568.868 713.008V738.44",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1282 || (_path1282 = /*#__PURE__*/React.createElement("path", {
    d: "M563.712 715.07L568.526 719.884",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1283 || (_path1283 = /*#__PURE__*/React.createElement("path", {
    d: "M574.024 720.568L569.21 725.382",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1284 || (_path1284 = /*#__PURE__*/React.createElement("path", {
    d: "M573.335 715.07L568.521 719.884",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1285 || (_path1285 = /*#__PURE__*/React.createElement("path", {
    d: "M594.912 738.053C598.105 735.176 597.653 730.041 594.002 727.768L587.946 724.001C587.01 723.422 585.821 723.443 584.916 724.064L579.544 727.731C576.066 730.109 575.603 735.06 578.581 738.038C578.618 738.074 578.671 738.095 578.723 738.095H594.796C594.838 738.095 594.885 738.08 594.917 738.048L594.912 738.053Z",
    fill: "#FFD6D0"
  })), _path1286 || (_path1286 = /*#__PURE__*/React.createElement("path", {
    d: "M594.917 738.048C594.885 738.08 594.838 738.095 594.796 738.095H578.723C578.671 738.095 578.618 738.074 578.581 738.038C575.603 735.06 576.066 730.109 579.544 727.731L584.916 724.064C585.821 723.443 587.01 723.422 587.946 724.001L594.002 727.768C597.653 730.041 598.105 735.176 594.912 738.053L594.917 738.048ZM594.917 738.048L595.149 738.306",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1287 || (_path1287 = /*#__PURE__*/React.createElement("path", {
    d: "M595.802 737.609C597.896 735.1 597.222 731.312 594.397 729.67L587.615 725.74C586.868 725.309 585.942 725.319 585.201 725.767L580.555 728.602C577.251 730.617 577.019 735.326 580.103 737.662C580.176 737.72 580.266 737.746 580.36 737.746H595.497C595.618 737.746 595.733 737.694 595.807 737.599L595.802 737.609Z",
    fill: "#E9A59B"
  })), _path1288 || (_path1288 = /*#__PURE__*/React.createElement("path", {
    d: "M587.43 732.255V737.753",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1289 || (_path1289 = /*#__PURE__*/React.createElement("path", {
    d: "M582.962 730.88L587.429 735.005",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1290 || (_path1290 = /*#__PURE__*/React.createElement("path", {
    d: "M590.865 732.941L587.43 736.724",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1291 || (_path1291 = /*#__PURE__*/React.createElement("path", {
    d: "M2171.85 737.409H-81.752V758.717H2171.85V737.409Z",
    fill: "#E1F1F1",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1292 || (_path1292 = /*#__PURE__*/React.createElement("path", {
    d: "M2171.85 737.507H-82.0938V758.374H2171.85V737.507Z",
    fill: "#A9D395"
  })), _path1293 || (_path1293 = /*#__PURE__*/React.createElement("path", {
    d: "M1198.52 748.75C1198.33 750.702 1196.69 752.186 1194.73 752.186H1194.23C1192.21 752.186 1190.48 750.739 1190.13 748.75C1189.82 750.728 1188.09 752.186 1186.08 752.186C1184.06 752.186 1182.31 750.733 1181.96 748.75C1181.6 750.739 1179.87 752.186 1177.85 752.186H1177.58C1175.56 752.186 1173.83 750.739 1173.48 748.75L1173.35 749.334C1173 751.002 1171.52 752.191 1169.82 752.191H1169.65C1167.75 752.191 1166.21 750.649 1166.21 748.755",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1294 || (_path1294 = /*#__PURE__*/React.createElement("path", {
    d: "M1924.42 742.564C1924.22 743.753 1923.18 744.627 1921.98 744.627H1918.78C1917.5 744.627 1916.38 743.785 1916.02 742.564C1915.7 743.78 1914.6 744.627 1913.35 744.627H1910.6C1909.33 744.627 1908.21 743.785 1907.85 742.564C1907.49 743.79 1906.35 744.627 1905.08 744.627H1902.12C1900.85 744.627 1899.72 743.785 1899.37 742.564C1898.93 743.801 1897.75 744.627 1896.45 744.627H1894.16C1893.02 744.627 1892.1 743.706 1892.1 742.564",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1295 || (_path1295 = /*#__PURE__*/React.createElement("path", {
    d: "M1869.43 748.75C1869.23 750.702 1867.59 752.186 1865.63 752.186H1865.13C1863.11 752.186 1861.39 750.739 1861.03 748.75C1860.72 750.728 1858.99 752.186 1856.98 752.186C1854.96 752.186 1853.21 750.733 1852.86 748.75C1852.5 750.739 1850.77 752.186 1848.75 752.186H1848.48C1846.46 752.186 1844.74 750.739 1844.38 748.75L1844.26 749.334C1843.9 751.002 1842.43 752.191 1840.72 752.191H1840.55C1838.65 752.191 1837.11 750.649 1837.11 748.755",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1296 || (_path1296 = /*#__PURE__*/React.createElement("path", {
    d: "M1923.38 708.535C1918.83 708.535 1915.13 712.228 1915.13 716.785V727.096C1915.13 731.653 1918.83 735.346 1923.38 735.346C1927.94 735.346 1931.63 731.653 1931.63 727.096V716.785C1931.63 712.228 1927.94 708.535 1923.38 708.535Z",
    fill: "#E1F1F1",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1297 || (_path1297 = /*#__PURE__*/React.createElement("path", {
    d: "M1922.35 710.944C1918.55 710.944 1915.48 714.022 1915.48 717.821V727.443C1915.48 731.242 1918.55 734.32 1922.35 734.32C1926.15 734.32 1929.23 731.242 1929.23 727.443V717.821C1929.23 714.022 1926.15 710.944 1922.35 710.944Z",
    fill: "#AACAC9"
  })), _path1298 || (_path1298 = /*#__PURE__*/React.createElement("path", {
    d: "M1918.57 719.879L1923.39 724.693",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1299 || (_path1299 = /*#__PURE__*/React.createElement("path", {
    d: "M1884.89 703.038C1880.34 703.038 1876.64 706.731 1876.64 711.288C1876.64 715.844 1880.34 719.537 1884.89 719.537C1889.45 719.537 1893.14 715.844 1893.14 711.288C1893.14 706.731 1889.45 703.038 1884.89 703.038Z",
    fill: "#E1F1F1",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1300 || (_path1300 = /*#__PURE__*/React.createElement("path", {
    d: "M1884.89 706.131H1884.2C1880.59 706.131 1877.67 709.056 1877.67 712.66C1877.67 716.269 1880.6 719.189 1884.2 719.189H1884.89C1888.5 719.189 1891.42 716.264 1891.42 712.66C1891.42 709.051 1888.5 706.131 1884.89 706.131Z",
    fill: "#AACAC9"
  })), _path1301 || (_path1301 = /*#__PURE__*/React.createElement("path", {
    d: "M1885.23 712.317V737.75",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1302 || (_path1302 = /*#__PURE__*/React.createElement("path", {
    d: "M1880.42 713.007L1885.24 717.821",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1303 || (_path1303 = /*#__PURE__*/React.createElement("path", {
    d: "M1889.7 713.007L1884.89 717.821",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1304 || (_path1304 = /*#__PURE__*/React.createElement("path", {
    d: "M1912.39 724.396C1912.39 721.46 1911.78 718.561 1910.61 715.873L1909.44 713.179C1907.17 707.949 1899.74 707.949 1897.47 713.179L1896.29 715.873C1895.12 718.561 1894.52 721.46 1894.52 724.396C1894.52 725.127 1895.11 725.722 1895.85 725.722H1911.07C1911.8 725.722 1912.39 725.127 1912.39 724.396H1912.39Z",
    fill: "#FFD6D0",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1305 || (_path1305 = /*#__PURE__*/React.createElement("path", {
    d: "M1909.98 724.06C1909.98 721.666 1909.48 719.298 1908.51 717.11L1907.95 715.857C1905.82 711.059 1899.02 711.059 1896.88 715.857L1896.33 717.11C1895.36 719.298 1894.85 721.666 1894.85 724.06C1894.85 724.786 1895.44 725.38 1896.17 725.38H1908.66C1909.38 725.38 1909.98 724.791 1909.98 724.06H1909.98Z",
    fill: "#E9A59B"
  })), _path1306 || (_path1306 = /*#__PURE__*/React.createElement("path", {
    d: "M1903.45 720.564V737.405",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1307 || (_path1307 = /*#__PURE__*/React.createElement("path", {
    d: "M1898.98 719.194L1903.45 723.319",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1308 || (_path1308 = /*#__PURE__*/React.createElement("path", {
    d: "M1906.89 721.256L1903.46 725.039",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1309 || (_path1309 = /*#__PURE__*/React.createElement("path", {
    d: "M1885.43 737.75H1873.36C1871.59 737.75 1869.89 737.082 1868.61 735.877L1867.68 735.009C1867.37 734.725 1867.15 734.367 1867.03 733.967L1866.94 733.672C1866.3 731.489 1868.94 729.842 1870.61 731.394V730.226C1870.61 727.822 1873.64 726.743 1875.16 728.611C1874.43 725.707 1877.76 723.502 1880.16 725.312L1880.84 725.828L1881.02 725.254C1881.66 723.26 1883.83 722.192 1885.8 722.903C1887.77 723.613 1888.76 725.807 1887.98 727.748L1887.64 728.611C1890.56 728.611 1892.2 731.983 1890.38 734.277L1889.01 736.013C1888.15 737.108 1886.83 737.75 1885.43 737.75Z",
    fill: "#AACAC9",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1310 || (_path1310 = /*#__PURE__*/React.createElement("path", {
    d: "M1881.45 737.408L1885.58 730.879",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1311 || (_path1311 = /*#__PURE__*/React.createElement("path", {
    d: "M1882.83 734.657L1880.43 729.501",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1312 || (_path1312 = /*#__PURE__*/React.createElement("path", {
    d: "M1875.61 737.751L1872.18 733.284",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1313 || (_path1313 = /*#__PURE__*/React.createElement("path", {
    d: "M1875.95 732.253L1873.55 734.657",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1314 || (_path1314 = /*#__PURE__*/React.createElement("path", {
    d: "M1878.02 737.407L1884.89 726.064",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1315 || (_path1315 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "M868.71 764.445C864.217 762.946 860.797 765.071 859.655 766.318C859.234 766.523 858.34 766.755 858.093 766.008C860.587 763.198 865.585 762.262 868.704 764.445H868.71Z",
    fill: "url(#paint3_linear_6004_56885)"
  })), _path1316 || (_path1316 = /*#__PURE__*/React.createElement("path", {
    d: "M306.069 749.013V751.239L328.971 750.981C328.34 749.718 327.051 748.924 325.641 748.924H306.159C306.111 748.924 306.069 748.966 306.069 749.013Z",
    fill: "#FFF9DE"
  })), _path1317 || (_path1317 = /*#__PURE__*/React.createElement("path", {
    d: "M280.852 775.431H284.976C284.976 776.567 284.056 777.493 282.914 777.493H280.852V775.431Z",
    fill: "#B7594C"
  })), _path1318 || (_path1318 = /*#__PURE__*/React.createElement("path", {
    d: "M1643.62 724.35H1666.57L1712.56 746.346H1643.62V724.35Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1319 || (_path1319 = /*#__PURE__*/React.createElement("path", {
    d: "M1660.8 724.35H1643.62V746.346H1660.8V724.35Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1320 || (_path1320 = /*#__PURE__*/React.createElement("path", {
    d: "M1655.3 729.848H1649.11V746.347H1655.3V729.848Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1321 || (_path1321 = /*#__PURE__*/React.createElement("path", {
    d: "M1656.51 722.855L1654.48 717.158H1654.41L1652.93 720.298L1651.4 717.126L1649.31 722.85H1648.77V723.308H1651.73V722.85H1651.15L1651.73 721.061L1652.93 723.313L1654.08 721.061L1654.66 722.85H1654.08V723.308H1657.02V722.85H1656.51L1656.51 722.855Z",
    fill: "#B7594C"
  })), _path1322 || (_path1322 = /*#__PURE__*/React.createElement("path", {
    d: "M1022.21 747.767C1022.21 744.831 1022.81 741.932 1023.98 739.244L1025.15 736.55C1027.42 731.321 1034.85 731.321 1037.13 736.55L1038.3 739.244C1039.47 741.932 1040.07 744.831 1040.07 747.767C1040.07 748.498 1039.48 749.093 1038.75 749.093H1023.53C1022.79 749.093 1022.2 748.498 1022.2 747.767H1022.21Z",
    fill: "#E1F1F1",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1323 || (_path1323 = /*#__PURE__*/React.createElement("path", {
    d: "M1024.62 747.431C1024.62 745.037 1025.12 742.669 1026.09 740.481L1026.65 739.229C1028.78 734.43 1035.59 734.43 1037.72 739.229L1038.27 740.481C1039.24 742.669 1039.75 745.037 1039.75 747.431C1039.75 748.157 1039.16 748.751 1038.43 748.751H1025.94C1025.21 748.751 1024.62 748.162 1024.62 747.431H1024.62Z",
    fill: "#AACAC9"
  })), _path1324 || (_path1324 = /*#__PURE__*/React.createElement("path", {
    d: "M1031.15 743.938V749.435",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1325 || (_path1325 = /*#__PURE__*/React.createElement("path", {
    d: "M1035.61 742.564L1031.15 746.689",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1326 || (_path1326 = /*#__PURE__*/React.createElement("path", {
    d: "M1027.71 744.627L1031.15 748.41",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1327 || (_path1327 = /*#__PURE__*/React.createElement("path", {
    d: "M976.577 749.046C973.378 746.168 973.836 741.033 977.482 738.76L983.538 734.993C984.474 734.414 985.663 734.435 986.568 735.056L991.945 738.723C995.423 741.101 995.886 746.052 992.908 749.03C992.866 749.067 992.818 749.088 992.766 749.088H976.693C976.651 749.088 976.609 749.072 976.577 749.04V749.046Z",
    fill: "#FFD6D0"
  })), _path1328 || (_path1328 = /*#__PURE__*/React.createElement("path", {
    d: "M976.577 749.04C976.609 749.072 976.651 749.088 976.693 749.088H992.766C992.818 749.088 992.866 749.067 992.908 749.03C995.886 746.052 995.423 741.101 991.945 738.723L986.568 735.056C985.663 734.435 984.474 734.414 983.538 734.993L977.482 738.76C973.836 741.033 973.378 746.168 976.577 749.046V749.04ZM976.577 749.04L976.346 749.298",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1329 || (_path1329 = /*#__PURE__*/React.createElement("path", {
    d: "M977.061 748.606C974.972 746.096 975.645 742.308 978.471 740.666L985.247 736.736C985.994 736.305 986.925 736.315 987.662 736.763L992.307 739.598C995.611 741.613 995.848 746.322 992.76 748.658C992.692 748.716 992.602 748.742 992.507 748.742H977.376C977.25 748.742 977.145 748.69 977.061 748.595V748.606Z",
    fill: "#E9A59B"
  })), _path1330 || (_path1330 = /*#__PURE__*/React.createElement("path", {
    d: "M984.057 743.255V748.753",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1331 || (_path1331 = /*#__PURE__*/React.createElement("path", {
    d: "M988.523 741.874L984.057 745.999",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1332 || (_path1332 = /*#__PURE__*/React.createElement("path", {
    d: "M980.621 743.938L984.057 747.72",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1333 || (_path1333 = /*#__PURE__*/React.createElement("path", {
    d: "M1040.92 749.436H1052.99C1054.76 749.436 1056.45 748.768 1057.75 747.563L1058.67 746.695C1058.98 746.411 1059.2 746.053 1059.32 745.653L1059.41 745.359C1060.06 743.175 1057.41 741.529 1055.74 743.081V741.913C1055.74 739.508 1052.71 738.43 1051.19 740.298C1051.92 737.393 1048.59 735.189 1046.19 736.999L1045.51 737.514L1045.34 736.941C1044.69 734.947 1042.53 733.879 1040.55 734.589C1038.58 735.299 1037.6 737.493 1038.37 739.435L1038.71 740.298C1035.79 740.298 1034.16 743.67 1035.97 745.964L1037.34 747.7C1038.21 748.794 1039.52 749.436 1040.92 749.436Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1334 || (_path1334 = /*#__PURE__*/React.createElement("path", {
    d: "M1044.89 749.094L1040.77 742.564",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1335 || (_path1335 = /*#__PURE__*/React.createElement("path", {
    d: "M1043.52 746.341L1045.92 741.186",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1336 || (_path1336 = /*#__PURE__*/React.createElement("path", {
    d: "M1050.73 749.434L1054.17 744.967",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1337 || (_path1337 = /*#__PURE__*/React.createElement("path", {
    d: "M1050.39 743.938L1052.8 746.342",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1338 || (_path1338 = /*#__PURE__*/React.createElement("path", {
    d: "M1048.33 749.094L1041.45 737.751",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1339 || (_path1339 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6029 747.767C51.6029 744.831 52.208 741.932 53.3759 739.244L54.5492 736.55C56.8272 731.321 64.2455 731.321 66.5235 736.55L67.6968 739.244C68.87 741.932 69.4698 744.831 69.4698 747.767C69.4698 748.498 68.8753 749.093 68.144 749.093H52.9235C52.1922 749.093 51.5977 748.498 51.5977 747.767H51.6029Z",
    fill: "#E1F1F1",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1340 || (_path1340 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0059 747.431C54.0059 745.037 54.5057 742.669 55.479 740.481L56.0367 739.229C58.1674 734.43 64.9754 734.43 67.1061 739.229L67.6638 740.481C68.6319 742.669 69.1369 745.037 69.1369 747.431C69.1369 748.157 68.5477 748.751 67.8164 748.751H55.3317C54.6056 748.751 54.0111 748.162 54.0111 747.431H54.0059Z",
    fill: "#62AE80"
  })), _path1341 || (_path1341 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5352 743.938V749.435",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1342 || (_path1342 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0097 742.564L60.543 746.689",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1343 || (_path1343 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1006 744.628L60.5361 748.411",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1344 || (_path1344 = /*#__PURE__*/React.createElement("path", {
    d: "M5.97301 749.046C2.77949 746.168 3.23195 741.033 6.88319 738.76L12.9388 734.993C13.8752 734.414 15.0643 734.435 15.9692 735.056L21.3408 738.723C24.8184 741.101 25.2814 746.052 22.3036 749.03C22.2668 749.067 22.2142 749.088 22.1616 749.088H6.08875C6.04666 749.088 5.99931 749.072 5.96774 749.04L5.97301 749.046Z",
    fill: "#FFD6D0"
  })), _path1345 || (_path1345 = /*#__PURE__*/React.createElement("path", {
    d: "M5.96774 749.04C5.99931 749.072 6.04666 749.088 6.08875 749.088H22.1616C22.2142 749.088 22.2668 749.067 22.3036 749.03C25.2814 746.052 24.8184 741.101 21.3408 738.723L15.9692 735.056C15.0643 734.435 13.8752 734.414 12.9388 734.993L6.88319 738.76C3.23195 741.033 2.77949 746.168 5.97301 749.046L5.96774 749.04ZM5.96774 749.04L5.73625 749.298",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1346 || (_path1346 = /*#__PURE__*/React.createElement("path", {
    d: "M6.45732 748.605C4.36339 746.095 5.0368 742.307 7.86204 740.665L14.6437 736.735C15.3907 736.304 16.3167 736.315 17.0585 736.762L21.7041 739.597C25.0081 741.613 25.2396 746.321 22.1566 748.657C22.0829 748.715 21.9935 748.741 21.8988 748.741H6.76246C6.64146 748.741 6.52571 748.689 6.45206 748.594L6.45732 748.605Z",
    fill: "#E9A59B"
  })), _path1347 || (_path1347 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4541 743.252V748.75",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1348 || (_path1348 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9208 741.875L13.4541 746",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1349 || (_path1349 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0137 743.938L13.4492 747.72",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1350 || (_path1350 = /*#__PURE__*/React.createElement("path", {
    d: "M70.317 749.436H82.3861C84.1539 749.436 85.8532 748.768 87.1422 747.563L88.0734 746.695C88.3786 746.411 88.5995 746.053 88.7206 745.653L88.8047 745.359C89.4518 743.175 86.8055 741.529 85.1324 743.081V741.913C85.1324 739.508 82.1125 738.43 80.5921 740.298C81.3181 737.393 77.9825 735.189 75.5992 736.999L74.9205 737.514L74.7364 736.941C74.0945 734.947 71.9269 733.879 69.9593 734.589C67.9916 735.299 67.0025 737.493 67.7706 739.435L68.1126 740.298C65.1874 740.298 63.5565 743.67 65.3716 745.964L66.7447 747.7C67.6128 748.794 68.9334 749.436 70.3276 749.436H70.317Z",
    fill: "#62AE80",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1351 || (_path1351 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2888 749.094L70.1641 742.564",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1352 || (_path1352 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9102 746.34L75.3145 741.184",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1353 || (_path1353 = /*#__PURE__*/React.createElement("path", {
    d: "M80.1289 749.434L83.5644 744.967",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1354 || (_path1354 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7861 743.938L82.1905 746.342",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1355 || (_path1355 = /*#__PURE__*/React.createElement("path", {
    d: "M77.724 749.093L70.8477 737.75",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1356 || (_path1356 = /*#__PURE__*/React.createElement("path", {
    d: "M1721.98 745.02C1721.98 742.084 1721.37 739.185 1720.2 736.497L1719.03 733.803C1716.76 728.573 1709.33 728.573 1707.06 733.803L1705.88 736.497C1704.71 739.185 1704.11 742.084 1704.11 745.02C1704.11 745.751 1704.7 746.346 1705.44 746.346H1720.66C1721.39 746.346 1721.98 745.751 1721.98 745.02H1721.98Z",
    fill: "#FFD6D0",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1357 || (_path1357 = /*#__PURE__*/React.createElement("path", {
    d: "M1719.57 744.683C1719.57 742.289 1719.07 739.921 1718.1 737.733L1717.54 736.48C1715.41 731.682 1708.6 731.682 1706.47 736.48L1705.91 737.733C1704.95 739.921 1704.44 742.289 1704.44 744.683C1704.44 745.409 1705.03 746.003 1705.76 746.003H1718.25C1718.97 746.003 1719.57 745.414 1719.57 744.683H1719.57Z",
    fill: "#E9A59B"
  })), _path1358 || (_path1358 = /*#__PURE__*/React.createElement("path", {
    d: "M1713.04 741.19V746.688",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1359 || (_path1359 = /*#__PURE__*/React.createElement("path", {
    d: "M1708.58 739.812L1713.04 743.937",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1360 || (_path1360 = /*#__PURE__*/React.createElement("path", {
    d: "M1716.48 741.875L1713.04 745.658",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1361 || (_path1361 = /*#__PURE__*/React.createElement("path", {
    d: "M1767.61 746.298C1770.8 743.421 1770.35 738.286 1766.7 736.013L1760.65 732.246C1759.71 731.667 1758.52 731.688 1757.62 732.309L1752.24 735.976C1748.76 738.354 1748.3 743.305 1751.28 746.283C1751.32 746.32 1751.36 746.341 1751.42 746.341H1767.49C1767.53 746.341 1767.57 746.325 1767.61 746.293V746.298Z",
    fill: "#E1F1F1"
  })), _path1362 || (_path1362 = /*#__PURE__*/React.createElement("path", {
    d: "M1767.61 746.293C1767.57 746.325 1767.53 746.341 1767.49 746.341H1751.42C1751.36 746.341 1751.32 746.32 1751.28 746.283C1748.3 743.305 1748.76 738.354 1752.24 735.976L1757.62 732.309C1758.52 731.688 1759.71 731.667 1760.65 732.246L1766.7 736.013C1770.35 738.286 1770.8 743.421 1767.61 746.298V746.293ZM1767.61 746.293L1767.84 746.551",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1363 || (_path1363 = /*#__PURE__*/React.createElement("path", {
    d: "M1767.13 745.853C1769.22 743.343 1768.54 739.555 1765.72 737.914L1758.94 733.983C1758.19 733.552 1757.26 733.563 1756.53 734.01L1751.88 736.846C1748.58 738.861 1748.34 743.569 1751.43 745.905C1751.5 745.963 1751.59 745.989 1751.68 745.989H1766.81C1766.94 745.989 1767.04 745.937 1767.13 745.842V745.853Z",
    fill: "#AACAC9"
  })), _path1364 || (_path1364 = /*#__PURE__*/React.createElement("path", {
    d: "M1760.13 740.502V746",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1365 || (_path1365 = /*#__PURE__*/React.createElement("path", {
    d: "M1755.66 739.129L1760.13 743.254",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1366 || (_path1366 = /*#__PURE__*/React.createElement("path", {
    d: "M1763.57 741.19L1760.13 744.973",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1367 || (_path1367 = /*#__PURE__*/React.createElement("path", {
    d: "M1703.27 746.688H1691.2C1689.43 746.688 1687.73 746.02 1686.44 744.815L1685.52 743.947C1685.21 743.663 1684.98 743.305 1684.87 742.905L1684.78 742.611C1684.13 740.427 1686.78 738.781 1688.45 740.333V739.165C1688.45 736.76 1691.48 735.682 1693 737.55C1692.27 734.645 1695.6 732.441 1698 734.251L1698.67 734.766L1698.85 734.193C1699.5 732.199 1701.66 731.131 1703.64 731.841C1705.6 732.551 1706.59 734.745 1705.82 736.687L1705.48 737.55C1708.4 737.55 1710.03 740.922 1708.22 743.216L1706.85 744.952C1705.98 746.046 1704.67 746.688 1703.27 746.688Z",
    fill: "#AACAC9",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1368 || (_path1368 = /*#__PURE__*/React.createElement("path", {
    d: "M1699.3 746.342L1703.42 739.812",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1369 || (_path1369 = /*#__PURE__*/React.createElement("path", {
    d: "M1700.67 743.594L1698.26 738.438",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1370 || (_path1370 = /*#__PURE__*/React.createElement("path", {
    d: "M1693.45 746.69L1690.01 742.224",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1371 || (_path1371 = /*#__PURE__*/React.createElement("path", {
    d: "M1693.8 741.19L1691.39 743.595",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1372 || (_path1372 = /*#__PURE__*/React.createElement("path", {
    d: "M1695.85 746.343L1702.73 735",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1373 || (_path1373 = /*#__PURE__*/React.createElement("path", {
    d: "M1.17804 735.461H-28.1318V741.206H1.17804V735.461Z",
    fill: "#FFF9DE"
  })), _path1374 || (_path1374 = /*#__PURE__*/React.createElement("path", {
    d: "M1.17804 739.485H-28.1318V740.059H1.17804V739.485Z",
    fill: "#615E66"
  })), _path1375 || (_path1375 = /*#__PURE__*/React.createElement("path", {
    d: "M1.17804 737.188H-28.1318V737.761H1.17804V737.188Z",
    fill: "#615E66"
  })), _path1376 || (_path1376 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.546875 735.177C-0.546875 734.699 -0.162803 734.314 0.315961 734.314C0.794726 734.314 1.1788 734.699 1.1788 735.177V748.972C1.1788 749.446 0.794726 749.835 0.315961 749.835C-0.162803 749.835 -0.546875 749.451 -0.546875 748.972V735.177Z",
    fill: "#615E66"
  })), _path1377 || (_path1377 = /*#__PURE__*/React.createElement("path", {
    d: "M5.20515 744.946C5.20515 744.469 4.81884 744.083 4.34231 744.083C3.86579 744.083 3.47949 744.469 3.47949 744.946V750.118C3.47949 750.594 3.86579 750.98 4.34231 750.98C4.81884 750.98 5.20515 750.594 5.20515 750.118V744.946Z",
    fill: "#615E66"
  })), _path1378 || (_path1378 = /*#__PURE__*/React.createElement("path", {
    d: "M-28.1288 744.084L-29.8545 742.647H1.18103L5.20581 744.084V745.809H-25.2562L-28.1288 744.084Z",
    fill: "#FFF9DE"
  })), _path1379 || (_path1379 = /*#__PURE__*/React.createElement("path", {
    d: "M5.20619 744.083H-25.2559V745.809H5.20619V744.083Z",
    fill: "#615E66"
  })), _path1380 || (_path1380 = /*#__PURE__*/React.createElement("path", {
    d: "M938.864 734.314C939.337 734.314 939.727 734.699 939.727 735.177V748.972C939.727 749.446 939.343 749.835 938.864 749.835C938.39 749.835 938.001 749.451 938.001 748.972V735.177C938.001 734.704 938.385 734.314 938.864 734.314Z",
    fill: "#615E66"
  })), _path1381 || (_path1381 = /*#__PURE__*/React.createElement("path", {
    d: "M969.037 735.461H939.728V741.206H969.037V735.461Z",
    fill: "#FFF9DE"
  })), _path1382 || (_path1382 = /*#__PURE__*/React.createElement("path", {
    d: "M969.037 739.485H939.728V740.059H969.037V739.485Z",
    fill: "#615E66"
  })), _path1383 || (_path1383 = /*#__PURE__*/React.createElement("path", {
    d: "M969.037 737.188H939.728V737.761H969.037V737.188Z",
    fill: "#615E66"
  })), _path1384 || (_path1384 = /*#__PURE__*/React.createElement("path", {
    d: "M967.311 735.177C967.311 734.699 967.695 734.314 968.168 734.314C968.642 734.314 969.036 734.699 969.036 735.177V748.972C969.036 749.446 968.652 749.835 968.168 749.835C967.684 749.835 967.311 749.451 967.311 748.972V735.177Z",
    fill: "#615E66"
  })), _path1385 || (_path1385 = /*#__PURE__*/React.createElement("path", {
    d: "M943.46 744.083C943.934 744.083 944.323 744.467 944.323 744.946V750.118C944.323 750.591 943.939 750.98 943.46 750.98C942.987 750.98 942.598 750.596 942.598 750.118V744.946C942.598 744.472 942.982 744.083 943.46 744.083Z",
    fill: "#615E66"
  })), _path1386 || (_path1386 = /*#__PURE__*/React.createElement("path", {
    d: "M972.193 744.083C972.666 744.083 973.056 744.467 973.056 744.946V750.118C973.056 750.591 972.672 750.98 972.193 750.98C971.719 750.98 971.33 750.596 971.33 750.118V744.946C971.33 744.472 971.714 744.083 972.193 744.083Z",
    fill: "#615E66"
  })), _path1387 || (_path1387 = /*#__PURE__*/React.createElement("path", {
    d: "M939.727 744.084L938.001 742.647H969.036L973.056 744.084V745.809H942.599L939.727 744.084Z",
    fill: "#FFF9DE"
  })), _path1388 || (_path1388 = /*#__PURE__*/React.createElement("path", {
    d: "M973.06 744.083H942.598V745.809H973.06V744.083Z",
    fill: "#615E66"
  })), _path1389 || (_path1389 = /*#__PURE__*/React.createElement("path", {
    d: "M938.001 742.647L942.599 744.084V746.383L938.001 744.373V742.647Z",
    fill: "#615E66"
  })), _path1390 || (_path1390 = /*#__PURE__*/React.createElement("path", {
    d: "M1610.12 739.534C1610.45 739.534 1610.73 739.804 1610.73 740.14V749.818C1610.73 750.15 1610.46 750.423 1610.12 750.423C1609.79 750.423 1609.52 750.153 1609.52 749.818V740.14C1609.52 739.807 1609.79 739.534 1610.12 739.534Z",
    fill: "#615E66"
  })), _path1391 || (_path1391 = /*#__PURE__*/React.createElement("path", {
    d: "M1631.29 740.338H1610.73V744.369H1631.29V740.338Z",
    fill: "#FFF9DE"
  })), _path1392 || (_path1392 = /*#__PURE__*/React.createElement("path", {
    d: "M1631.29 743.161H1610.73V743.563H1631.29V743.161Z",
    fill: "#615E66"
  })), _path1393 || (_path1393 = /*#__PURE__*/React.createElement("path", {
    d: "M1631.29 741.55H1610.73V741.952H1631.29V741.55Z",
    fill: "#615E66"
  })), _path1394 || (_path1394 = /*#__PURE__*/React.createElement("path", {
    d: "M1630.08 740.14C1630.08 739.804 1630.35 739.534 1630.68 739.534C1631.01 739.534 1631.29 739.804 1631.29 740.14V749.818C1631.29 750.15 1631.02 750.423 1630.68 750.423C1630.34 750.423 1630.08 750.153 1630.08 749.818V740.14Z",
    fill: "#615E66"
  })), _path1395 || (_path1395 = /*#__PURE__*/React.createElement("path", {
    d: "M1613.35 746.388C1613.68 746.388 1613.95 746.657 1613.95 746.993V750.621C1613.95 750.954 1613.68 751.227 1613.35 751.227C1613.02 751.227 1612.74 750.957 1612.74 750.621V746.993C1612.74 746.661 1613.01 746.388 1613.35 746.388Z",
    fill: "#615E66"
  })), _path1396 || (_path1396 = /*#__PURE__*/React.createElement("path", {
    d: "M1633.51 746.388C1633.84 746.388 1634.11 746.657 1634.11 746.993V750.621C1634.11 750.954 1633.84 751.227 1633.51 751.227C1633.17 751.227 1632.9 750.957 1632.9 750.621V746.993C1632.9 746.661 1633.17 746.388 1633.51 746.388Z",
    fill: "#615E66"
  })), _path1397 || (_path1397 = /*#__PURE__*/React.createElement("path", {
    d: "M1610.73 746.389L1609.52 745.381H1631.29L1634.11 746.389V747.599H1612.74L1610.73 746.389Z",
    fill: "#FFF9DE"
  })), _path1398 || (_path1398 = /*#__PURE__*/React.createElement("path", {
    d: "M1634.11 746.388H1612.74V747.598H1634.11V746.388Z",
    fill: "#615E66"
  })), _path1399 || (_path1399 = /*#__PURE__*/React.createElement("path", {
    d: "M1609.52 745.381L1612.74 746.389V748.002L1609.52 746.592V745.381Z",
    fill: "#615E66"
  })), _path1400 || (_path1400 = /*#__PURE__*/React.createElement("path", {
    d: "M1086.72 736.574C1086.39 736.574 1086.12 736.844 1086.12 737.18V746.858C1086.12 747.19 1086.39 747.463 1086.72 747.463C1087.06 747.463 1087.33 747.193 1087.33 746.858V737.18C1087.33 736.847 1087.06 736.574 1086.72 736.574Z",
    fill: "#615E66"
  })), _path1401 || (_path1401 = /*#__PURE__*/React.createElement("path", {
    d: "M1065.56 737.378H1086.12V741.409H1065.56V737.378Z",
    fill: "#FFF9DE"
  })), _path1402 || (_path1402 = /*#__PURE__*/React.createElement("path", {
    d: "M1065.56 740.201H1086.12V740.603H1065.56V740.201Z",
    fill: "#615E66"
  })), _path1403 || (_path1403 = /*#__PURE__*/React.createElement("path", {
    d: "M1065.56 738.59H1086.12V738.992H1065.56V738.59Z",
    fill: "#615E66"
  })), _path1404 || (_path1404 = /*#__PURE__*/React.createElement("path", {
    d: "M1066.77 737.18C1066.77 736.844 1066.5 736.574 1066.16 736.574C1065.83 736.574 1065.56 736.844 1065.56 737.18V746.858C1065.56 747.19 1065.83 747.463 1066.16 747.463C1066.5 747.463 1066.77 747.193 1066.77 746.858V737.18Z",
    fill: "#615E66"
  })), _path1405 || (_path1405 = /*#__PURE__*/React.createElement("path", {
    d: "M1083.5 743.428C1083.17 743.428 1082.89 743.697 1082.89 744.033V747.661C1082.89 747.994 1083.16 748.267 1083.5 748.267C1083.83 748.267 1084.1 747.997 1084.1 747.661V744.033C1084.1 743.701 1083.83 743.428 1083.5 743.428Z",
    fill: "#615E66"
  })), _path1406 || (_path1406 = /*#__PURE__*/React.createElement("path", {
    d: "M1063.34 743.428C1063.01 743.428 1062.74 743.697 1062.74 744.033V747.661C1062.74 747.994 1063.01 748.267 1063.34 748.267C1063.67 748.267 1063.95 747.997 1063.95 747.661V744.033C1063.95 743.701 1063.68 743.428 1063.34 743.428Z",
    fill: "#615E66"
  })), _path1407 || (_path1407 = /*#__PURE__*/React.createElement("path", {
    d: "M1086.12 743.429L1087.33 742.421H1065.55L1062.73 743.429V744.639H1084.1L1086.12 743.429Z",
    fill: "#FFF9DE"
  })), _path1408 || (_path1408 = /*#__PURE__*/React.createElement("path", {
    d: "M1062.73 743.428H1084.1V744.638H1062.73V743.428Z",
    fill: "#615E66"
  })), _path1409 || (_path1409 = /*#__PURE__*/React.createElement("path", {
    d: "M1087.33 742.421L1084.1 743.429V745.042L1087.33 743.632V742.421Z",
    fill: "#615E66"
  })), _path1410 || (_path1410 = /*#__PURE__*/React.createElement("path", {
    d: "M324.492 731.657C324.775 731.657 325.007 731.886 325.007 732.172V740.405C325.007 740.688 324.778 740.92 324.492 740.92C324.21 740.92 323.978 740.691 323.978 740.405V732.172C323.978 731.89 324.207 731.657 324.492 731.657Z",
    fill: "#615E66"
  })), _path1411 || (_path1411 = /*#__PURE__*/React.createElement("path", {
    d: "M342.501 732.341H325.008V735.77H342.501V732.341Z",
    fill: "#FFF9DE"
  })), _path1412 || (_path1412 = /*#__PURE__*/React.createElement("path", {
    d: "M342.501 734.743H325.008V735.085H342.501V734.743Z",
    fill: "#615E66"
  })), _path1413 || (_path1413 = /*#__PURE__*/React.createElement("path", {
    d: "M342.501 733.372H325.008V733.714H342.501V733.372Z",
    fill: "#615E66"
  })), _path1414 || (_path1414 = /*#__PURE__*/React.createElement("path", {
    d: "M341.471 732.172C341.471 731.886 341.7 731.657 341.983 731.657C342.265 731.657 342.501 731.886 342.501 732.172V740.405C342.501 740.688 342.271 740.92 341.983 740.92C341.694 740.92 341.471 740.691 341.471 740.405V732.172Z",
    fill: "#615E66"
  })), _path1415 || (_path1415 = /*#__PURE__*/React.createElement("path", {
    d: "M327.237 737.487C327.519 737.487 327.752 737.717 327.752 738.002V741.089C327.752 741.372 327.522 741.604 327.237 741.604C326.954 741.604 326.722 741.375 326.722 741.089V738.002C326.722 737.72 326.951 737.487 327.237 737.487Z",
    fill: "#615E66"
  })), _path1416 || (_path1416 = /*#__PURE__*/React.createElement("path", {
    d: "M344.385 737.487C344.668 737.487 344.9 737.717 344.9 738.002V741.089C344.9 741.372 344.671 741.604 344.385 741.604C344.102 741.604 343.87 741.375 343.87 741.089V738.002C343.87 737.72 344.099 737.487 344.385 737.487Z",
    fill: "#615E66"
  })), _path1417 || (_path1417 = /*#__PURE__*/React.createElement("path", {
    d: "M325.008 737.489L323.979 736.632H342.502L344.9 737.489V738.519H326.723L325.008 737.489Z",
    fill: "#FFF9DE"
  })), _path1418 || (_path1418 = /*#__PURE__*/React.createElement("path", {
    d: "M344.902 737.487H326.722V738.517H344.902V737.487Z",
    fill: "#615E66"
  })), _path1419 || (_path1419 = /*#__PURE__*/React.createElement("path", {
    d: "M323.979 736.632L326.723 737.489V738.861L323.979 737.662V736.632Z",
    fill: "#615E66"
  })), _path1420 || (_path1420 = /*#__PURE__*/React.createElement("path", {
    d: "M542.911 530.235H537.164L543.621 527.547C545.768 526.651 548.206 526.732 550.288 527.773C551.386 526.675 554.719 524.819 559.312 526.134C553.404 527.45 550.837 531.058 550.288 532.696C548.157 531.098 545.566 530.235 542.903 530.235H542.911Z",
    fill: "#615E66"
  })), _path1421 || (_path1421 = /*#__PURE__*/React.createElement("path", {
    d: "M383.07 479.65H377.323L383.78 476.963C385.935 476.067 388.365 476.147 390.447 477.189C391.545 476.099 394.879 474.235 399.471 475.55C393.563 476.866 390.996 480.474 390.447 482.112C388.316 480.514 385.726 479.65 383.062 479.65H383.07Z",
    fill: "#615E66"
  })), _path1422 || (_path1422 = /*#__PURE__*/React.createElement("path", {
    d: "M1723.37 540.361H1729.12L1722.66 537.674C1720.51 536.778 1718.08 536.858 1715.99 537.9C1714.9 536.81 1711.56 534.945 1706.97 536.261C1712.88 537.577 1715.45 541.185 1715.99 542.823C1718.12 541.225 1720.72 540.361 1723.38 540.361H1723.37Z",
    fill: "#615E66"
  })), _path1423 || (_path1423 = /*#__PURE__*/React.createElement("path", {
    d: "M2171.85 799.616H-82.0938V807.797H2171.85V799.616Z",
    fill: "#C3E1B5"
  })), _path1424 || (_path1424 = /*#__PURE__*/React.createElement("path", {
    d: "M2171.85 807.065H-82.0938V812.673H2171.85V807.065Z",
    fill: "#FFF9DE"
  })), _path1425 || (_path1425 = /*#__PURE__*/React.createElement("path", {
    d: "M643.111 742.564C642.911 743.753 641.88 744.627 640.675 744.627H637.471C636.192 744.627 635.072 743.785 634.714 742.564C634.393 743.78 633.299 744.627 632.041 744.627H629.3C628.022 744.627 626.901 743.785 626.544 742.564C626.181 743.79 625.049 744.627 623.771 744.627H620.819C619.541 744.627 618.42 743.785 618.063 742.564C617.621 743.801 616.447 744.627 615.143 744.627H612.859C611.718 744.627 610.797 743.706 610.797 742.564",
    stroke: "#615E66",
    strokeWidth: 0.526115,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1426 || (_path1426 = /*#__PURE__*/React.createElement("path", {
    d: "M588.115 748.752C587.92 750.704 586.279 752.187 584.316 752.187H583.817C581.796 752.187 580.071 750.741 579.723 748.752C579.413 750.73 577.672 752.187 575.667 752.187C573.652 752.187 571.895 750.735 571.548 748.752C571.19 750.741 569.459 752.187 567.439 752.187H567.17C565.15 752.187 563.424 750.741 563.077 748.752L562.951 749.336C562.593 751.004 561.125 752.193 559.421 752.193H559.247C557.348 752.193 555.812 750.651 555.812 748.757",
    stroke: "#615E66",
    strokeWidth: 0.526115,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1427 || (_path1427 = /*#__PURE__*/React.createElement("path", {
    d: "M252.67 742.564C252.47 743.753 251.444 744.627 250.234 744.627H247.03C245.757 744.627 244.636 743.785 244.273 742.564C243.952 743.78 242.853 744.627 241.6 744.627H238.854C237.581 744.627 236.46 743.785 236.097 742.564C235.729 743.79 234.603 744.627 233.325 744.627H230.373C229.1 744.627 227.979 743.785 227.616 742.564C227.174 743.801 226.006 744.627 224.691 744.627H222.413C221.277 744.627 220.351 743.706 220.351 742.564",
    stroke: "#615E66",
    strokeWidth: 0.526115,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1428 || (_path1428 = /*#__PURE__*/React.createElement("path", {
    d: "M197.675 748.752C197.48 750.704 195.838 752.187 193.876 752.187H193.376C191.356 752.187 189.63 750.741 189.283 748.752C188.973 750.73 187.231 752.187 185.227 752.187C183.212 752.187 181.454 750.735 181.107 748.752C180.749 750.741 179.019 752.187 176.998 752.187H176.73C174.71 752.187 172.984 750.741 172.637 748.752L172.51 749.336C172.153 751.004 170.685 752.193 168.98 752.193H168.807C166.907 752.193 165.371 750.651 165.371 748.757",
    stroke: "#615E66",
    strokeWidth: 0.526115,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1429 || (_path1429 = /*#__PURE__*/React.createElement("path", {
    d: "M841.082 742.564C840.882 743.753 839.85 744.627 838.646 744.627H835.442C834.163 744.627 833.042 743.785 832.685 742.564C832.364 743.78 831.27 744.627 830.012 744.627H827.271C825.993 744.627 824.872 743.785 824.514 742.564C824.151 743.79 823.02 744.627 821.742 744.627H818.79C817.512 744.627 816.391 743.785 816.033 742.564C815.591 743.801 814.418 744.627 813.113 744.627H810.83C809.688 744.627 808.768 743.706 808.768 742.564",
    stroke: "#615E66",
    strokeWidth: 0.526115,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1430 || (_path1430 = /*#__PURE__*/React.createElement("path", {
    d: "M786.085 748.752C785.891 750.704 784.249 752.187 782.292 752.187H781.792C779.772 752.187 778.046 750.741 777.694 748.752C777.378 750.73 775.647 752.187 773.638 752.187C771.623 752.187 769.871 750.735 769.518 748.752C769.16 750.741 767.429 752.187 765.409 752.187H765.141C763.121 752.187 761.395 750.741 761.042 748.752L760.916 749.336C760.558 751.004 759.085 752.193 757.381 752.193H757.207C755.308 752.193 753.771 750.651 753.771 748.757",
    stroke: "#615E66",
    strokeWidth: 0.526115,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1431 || (_path1431 = /*#__PURE__*/React.createElement("path", {
    d: "M1253.52 742.564C1253.32 743.753 1252.29 744.627 1251.08 744.627H1247.88C1246.6 744.627 1245.48 743.785 1245.12 742.564C1244.8 743.78 1243.71 744.627 1242.45 744.627H1239.71C1238.43 744.627 1237.31 743.785 1236.95 742.564C1236.59 743.79 1235.46 744.627 1234.18 744.627H1231.23C1229.95 744.627 1228.83 743.785 1228.47 742.564C1228.03 743.801 1226.86 744.627 1225.55 744.627H1223.27C1222.13 744.627 1221.21 743.706 1221.21 742.564",
    stroke: "#615E66",
    strokeWidth: 0.526115,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1432 || (_path1432 = /*#__PURE__*/React.createElement("path", {
    d: "M1544.93 745.397C1544.73 746.586 1543.7 747.46 1542.49 747.46H1539.29C1538.01 747.46 1536.89 746.618 1536.53 745.397C1536.21 746.613 1535.12 747.46 1533.86 747.46H1531.12C1529.84 747.46 1528.72 746.618 1528.36 745.397C1528 746.623 1526.87 747.46 1525.59 747.46H1522.64C1521.36 747.46 1520.24 746.618 1519.88 745.397C1519.44 746.634 1518.27 747.46 1516.96 747.46H1514.68C1513.54 747.46 1512.62 746.539 1512.62 745.397",
    stroke: "#615E66",
    strokeWidth: 0.526115,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1433 || (_path1433 = /*#__PURE__*/React.createElement("path", {
    d: "M1407.5 748.752C1407.3 750.704 1405.66 752.187 1403.7 752.187H1403.2C1401.18 752.187 1399.46 750.741 1399.11 748.752C1398.79 750.73 1397.06 752.187 1395.05 752.187C1393.03 752.187 1391.28 750.735 1390.93 748.752C1390.57 750.741 1388.84 752.187 1386.82 752.187H1386.55C1384.53 752.187 1382.81 750.741 1382.45 748.752L1382.33 749.336C1381.97 751.004 1380.5 752.193 1378.79 752.193H1378.62C1376.72 752.193 1375.18 750.651 1375.18 748.757",
    stroke: "#615E66",
    strokeWidth: 0.526115
  })), _path1434 || (_path1434 = /*#__PURE__*/React.createElement("path", {
    d: "M778.183 698.229C782.739 698.229 786.433 701.923 786.433 706.479V716.791C786.433 721.347 782.739 725.04 778.183 725.04C773.627 725.04 769.934 721.347 769.934 716.791V706.479C769.934 701.923 773.627 698.229 778.183 698.229Z",
    fill: "#E1F1F1",
    stroke: "#615E66",
    strokeWidth: 0.526115,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1435 || (_path1435 = /*#__PURE__*/React.createElement("path", {
    d: "M779.213 700.634C783.012 700.634 786.09 703.712 786.09 707.51V717.133C786.09 720.931 783.012 724.009 779.213 724.009C775.415 724.009 772.337 720.931 772.337 717.133V707.51C772.337 703.712 775.415 700.634 779.213 700.634Z",
    fill: "#AACAC9"
  })), _path1436 || (_path1436 = /*#__PURE__*/React.createElement("path", {
    d: "M777.836 707.505V737.751",
    stroke: "#615E66",
    strokeWidth: 0.526115,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1437 || (_path1437 = /*#__PURE__*/React.createElement("path", {
    d: "M782.99 709.567L777.834 715.302",
    stroke: "#615E66",
    strokeWidth: 0.526115,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1438 || (_path1438 = /*#__PURE__*/React.createElement("path", {
    d: "M773.369 715.071L777.836 719.538",
    stroke: "#615E66",
    strokeWidth: 0.526115,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1439 || (_path1439 = /*#__PURE__*/React.createElement("path", {
    d: "M773.369 709.567L777.836 714.034",
    stroke: "#615E66",
    strokeWidth: 0.526115,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1440 || (_path1440 = /*#__PURE__*/React.createElement("path", {
    d: "M802.926 710.6C807.482 710.6 811.176 714.293 811.176 718.849C811.176 723.405 807.482 727.099 802.926 727.099C798.37 727.099 794.677 723.405 794.677 718.849C794.677 714.293 798.37 710.6 802.926 710.6Z",
    fill: "#E1F1F1",
    stroke: "#615E66",
    strokeWidth: 0.526115,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1441 || (_path1441 = /*#__PURE__*/React.createElement("path", {
    d: "M802.926 713.693H803.615C807.224 713.693 810.144 716.619 810.144 720.222C810.144 723.832 807.219 726.752 803.615 726.752H802.926C799.316 726.752 796.396 723.826 796.396 720.222C796.396 716.613 799.322 713.693 802.926 713.693Z",
    fill: "#AACAC9"
  })), _path1442 || (_path1442 = /*#__PURE__*/React.createElement("path", {
    d: "M802.584 719.881V737.411",
    stroke: "#615E66",
    strokeWidth: 0.526115,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1443 || (_path1443 = /*#__PURE__*/React.createElement("path", {
    d: "M807.392 720.568L802.578 725.382",
    stroke: "#615E66",
    strokeWidth: 0.526115,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1444 || (_path1444 = /*#__PURE__*/React.createElement("path", {
    d: "M798.117 720.568L802.931 725.382",
    stroke: "#615E66",
    strokeWidth: 0.526115,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1445 || (_path1445 = /*#__PURE__*/React.createElement("path", {
    d: "M755.986 737.412C755.986 737.412 755.865 737.264 755.807 737.191C753.523 734.239 754.207 729.83 757.517 727.768L763.572 724.001C764.509 723.422 765.698 723.443 766.603 724.064L771.979 727.731C775.12 729.878 775.799 734.123 773.71 737.122C773.642 737.217 773.5 737.412 773.5 737.412H755.991H755.986Z",
    fill: "#E1F1F1",
    stroke: "#615E66",
    strokeWidth: 0.526115,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1446 || (_path1446 = /*#__PURE__*/React.createElement("path", {
    d: "M757.074 737.004C755.012 734.526 755.675 730.791 758.463 729.17L765.15 725.293C765.892 724.867 766.808 724.877 767.528 725.319L772.111 728.118C775.373 730.107 775.604 734.753 772.558 737.057C772.49 737.11 772.4 737.141 772.305 737.141H757.38C757.258 737.141 757.148 737.088 757.069 736.999L757.074 737.004Z",
    fill: "#AACAC9"
  })), _path1447 || (_path1447 = /*#__PURE__*/React.createElement("path", {
    d: "M764.089 732.254V737.41",
    stroke: "#615E66",
    strokeWidth: 0.526115,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1448 || (_path1448 = /*#__PURE__*/React.createElement("path", {
    d: "M768.556 730.88L764.089 735.005",
    stroke: "#615E66",
    strokeWidth: 0.526115,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1449 || (_path1449 = /*#__PURE__*/React.createElement("path", {
    d: "M760.652 732.943L764.088 736.726",
    stroke: "#615E66",
    strokeWidth: 0.526115,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1450 || (_path1450 = /*#__PURE__*/React.createElement("path", {
    d: "M801.617 737.41C801.617 737.41 802.38 736.889 802.722 736.568L803.648 735.7C803.958 735.416 804.179 735.058 804.295 734.658L804.384 734.364C805.031 732.18 802.385 730.534 800.712 732.086V730.918C800.712 728.513 797.687 727.435 796.166 729.302C796.892 726.398 793.562 724.194 791.168 726.004L790.49 726.519L790.311 725.946C789.664 723.952 787.501 722.884 785.528 723.594C783.561 724.304 782.571 726.498 783.345 728.44L783.687 729.302C780.767 729.302 779.131 732.675 780.946 734.969L782.314 736.705C782.519 736.968 783.008 737.41 783.008 737.41H801.617Z",
    fill: "#AACAC9",
    stroke: "#615E66",
    strokeWidth: 0.526115,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1451 || (_path1451 = /*#__PURE__*/React.createElement("path", {
    d: "M789.43 737.41L785.742 731.564",
    stroke: "#615E66",
    strokeWidth: 0.526115,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1452 || (_path1452 = /*#__PURE__*/React.createElement("path", {
    d: "M787.979 735.111L790.899 730.191",
    stroke: "#615E66",
    strokeWidth: 0.526115,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1453 || (_path1453 = /*#__PURE__*/React.createElement("path", {
    d: "M796.502 737.41L799.148 733.975",
    stroke: "#615E66",
    strokeWidth: 0.526115,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1454 || (_path1454 = /*#__PURE__*/React.createElement("path", {
    d: "M795.364 732.943L797.995 735.469",
    stroke: "#615E66",
    strokeWidth: 0.526115,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1455 || (_path1455 = /*#__PURE__*/React.createElement("path", {
    d: "M792.887 737.413L786.432 726.759",
    stroke: "#615E66",
    strokeWidth: 0.526115,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1456 || (_path1456 = /*#__PURE__*/React.createElement("path", {
    d: "M0 761.138H1919V791.675H0V761.138Z",
    fill: "#CFCDC8"
  })), _path1457 || (_path1457 = /*#__PURE__*/React.createElement("path", {
    d: "M1916.66 770.855L10.6811 770.678",
    stroke: "white",
    strokeWidth: 0.984558,
    strokeDasharray: "4.92 4.92"
  })), _path1458 || (_path1458 = /*#__PURE__*/React.createElement("path", {
    d: "M0 791.162H1919V799.039H0V791.162Z",
    fill: "#FFF9DE"
  })), _path1459 || (_path1459 = /*#__PURE__*/React.createElement("path", {
    d: "M0 753.256H1919V761.132H0V753.256Z",
    fill: "#FFF9DE"
  })), _path1460 || (_path1460 = /*#__PURE__*/React.createElement("path", {
    d: "M0.00012207 745.921H1919V758.088H0.00012207V745.921Z",
    fill: "#A9D395"
  })), _path1461 || (_path1461 = /*#__PURE__*/React.createElement("path", {
    d: "M1918 758.089H1521.2L1653.47 754.539H1810.9L1918 758.089Z",
    fill: "#62AE80"
  })), _path1462 || (_path1462 = /*#__PURE__*/React.createElement("path", {
    d: "M1645.69 758.089H1181.59L1294.54 754.539H1451.97L1645.68 758.089H1645.69Z",
    fill: "#62AE80"
  })), _path1463 || (_path1463 = /*#__PURE__*/React.createElement("path", {
    d: "M1241.29 758.089H529.625L718.661 754.539H1086.78L1241.29 758.089Z",
    fill: "#62AE80"
  })), _path1464 || (_path1464 = /*#__PURE__*/React.createElement("path", {
    d: "M1370.4 744.914C1375.34 746.052 1382.6 750.041 1386.62 752.043L1386.72 757.952C1387 758.299 1387.59 759.29 1387.66 760.472C1387.72 761.443 1386.98 763.03 1386.4 764.061C1386.2 764.427 1385.8 764.642 1385.38 764.642H1326C1325.32 764.642 1324.77 764.095 1324.77 763.416V760.731C1324.77 758.299 1327.41 756.297 1329.2 755.603C1330.64 755.047 1335.51 753.054 1339.29 752.126C1339.29 752.126 1345.04 747.17 1353.43 744.997C1358.99 743.557 1365.5 743.781 1370.41 744.909L1370.4 744.914Z",
    fill: "#CDD9F4",
    stroke: "#76736C",
    strokeWidth: 0.444365
  })), _path1465 || (_path1465 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "M1376.94 756.449C1372.77 755.057 1369.6 757.03 1368.54 758.187C1368.15 758.378 1367.32 758.593 1367.09 757.899C1369.4 755.292 1374.04 754.422 1376.94 756.449H1376.94Z",
    fill: "url(#paint4_linear_6004_56885)"
  })), _path1466 || (_path1466 = /*#__PURE__*/React.createElement("path", {
    d: "M1369.12 759.636C1363.56 761.257 1346.33 761.472 1338.41 761.375V763.694H1386.5C1386.89 762.923 1387.66 761.204 1387.66 760.505C1387.66 759.807 1386.89 758.479 1386.5 757.898C1383.02 757.8 1374.68 758.015 1369.12 759.636Z",
    fill: "#FFF9DE"
  })), _path1467 || (_path1467 = /*#__PURE__*/React.createElement("path", {
    d: "M1381.95 752.996L1386.62 751.951L1386.67 755.95L1381.87 754.173C1381.3 753.958 1381.35 753.132 1381.95 753.001L1381.95 752.996Z",
    fill: "#B7594C"
  })), _path1468 || (_path1468 = /*#__PURE__*/React.createElement("path", {
    d: "M1335.42 767.685C1338.36 767.685 1340.75 765.407 1340.75 762.597C1340.75 759.786 1338.36 757.508 1335.42 757.508C1332.48 757.508 1330.09 759.786 1330.09 762.597C1330.09 765.407 1332.48 767.685 1335.42 767.685Z",
    fill: "#76736C"
  })), _path1469 || (_path1469 = /*#__PURE__*/React.createElement("path", {
    d: "M1335.42 764.907C1336.76 764.907 1337.84 763.872 1337.84 762.596C1337.84 761.319 1336.76 760.285 1335.42 760.285C1334.09 760.285 1333 761.319 1333 762.596C1333 763.872 1334.09 764.907 1335.42 764.907Z",
    fill: "white"
  })), _path1470 || (_path1470 = /*#__PURE__*/React.createElement("path", {
    d: "M1374.13 767.685C1377.07 767.685 1379.46 765.407 1379.46 762.597C1379.46 759.786 1377.07 757.508 1374.13 757.508C1371.18 757.508 1368.79 759.786 1368.79 762.597C1368.79 765.407 1371.18 767.685 1374.13 767.685Z",
    fill: "#76736C"
  })), _path1471 || (_path1471 = /*#__PURE__*/React.createElement("path", {
    d: "M1374.12 764.907C1375.46 764.907 1376.54 763.872 1376.54 762.596C1376.54 761.319 1375.46 760.285 1374.12 760.285C1372.79 760.285 1371.71 761.319 1371.71 762.596C1371.71 763.872 1372.79 764.907 1374.12 764.907Z",
    fill: "white"
  })), _path1472 || (_path1472 = /*#__PURE__*/React.createElement("path", {
    d: "M1360.4 752.302C1354.68 752.941 1343.34 752.302 1343.34 752.302C1349.47 747.521 1355.22 746.076 1359.37 745.958C1371.44 745.612 1374.45 749.176 1374.45 749.176C1374.45 749.176 1367.38 751.525 1360.4 752.306V752.302Z",
    fill: "url(#paint5_linear_6004_56885)"
  })), _path1473 || (_path1473 = /*#__PURE__*/React.createElement("path", {
    d: "M1355.79 752.501L1362.4 745.673V748.991L1359.39 752.501H1355.79Z",
    fill: "white",
    fillOpacity: 0.6
  })), _path1474 || (_path1474 = /*#__PURE__*/React.createElement("path", {
    d: "M1353.41 752.585L1359.26 745.858H1360.73L1354.5 752.585H1353.41Z",
    fill: "white",
    fillOpacity: 0.6
  })), _path1475 || (_path1475 = /*#__PURE__*/React.createElement("path", {
    d: "M1217.71 763.184C1212.62 761.866 1199.1 761.973 1193.67 762.046C1192.28 762.066 1190.95 762.647 1189.99 763.653L1184.8 769.093C1184.8 769.093 1170.84 770.929 1170.84 772.281V777.443C1170.54 777.824 1169.89 778.918 1169.81 780.216C1169.74 781.286 1170.56 783.029 1171.2 784.167C1171.42 784.572 1171.86 784.807 1172.32 784.807H1237.71C1238.46 784.807 1239.06 784.206 1239.06 783.459V775.153C1239.06 773.82 1236.16 773.238 1234.18 772.945C1232.2 772.653 1227.23 772.052 1223.07 771.031C1223.07 771.031 1220.21 763.834 1217.71 763.184Z",
    fill: "#D7D0B3",
    stroke: "#382456",
    strokeWidth: 0.488313
  })), _path1476 || (_path1476 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.52,
    d: "M1181.61 775.793C1186.2 774.259 1189.69 776.432 1190.86 777.707C1191.29 777.922 1192.2 778.151 1192.46 777.389C1189.9 774.518 1184.8 773.561 1181.61 775.793H1181.61Z",
    fill: "url(#paint6_linear_6004_56885)"
  })), _path1477 || (_path1477 = /*#__PURE__*/React.createElement("path", {
    d: "M1199.8 778.343C1209.37 778.343 1233.6 778.343 1238.07 779.3V783.768H1171.08C1170.65 782.918 1169.81 781.023 1169.81 780.257C1169.81 779.49 1170.66 778.025 1171.08 777.386C1174.91 777.278 1193.41 778.343 1199.79 778.343H1199.79H1199.8Z",
    fill: "#FFF9DE"
  })), _path1478 || (_path1478 = /*#__PURE__*/React.createElement("path", {
    d: "M1175.56 772.756L1170.96 772.116L1170.91 775.241L1175.64 774.079C1176.36 773.903 1176.3 772.858 1175.57 772.756H1175.56Z",
    fill: "#C86A3F"
  })), _path1479 || (_path1479 = /*#__PURE__*/React.createElement("path", {
    d: "M1229.87 788.157C1233.28 788.157 1236.04 785.335 1236.04 781.853C1236.04 778.371 1233.28 775.548 1229.87 775.548C1226.46 775.548 1223.69 778.371 1223.69 781.853C1223.69 785.335 1226.46 788.157 1229.87 788.157Z",
    fill: "#76736C"
  })), _path1480 || (_path1480 = /*#__PURE__*/React.createElement("path", {
    d: "M1229.87 784.712C1231.42 784.712 1232.67 783.432 1232.67 781.852C1232.67 780.272 1231.42 778.992 1229.87 778.992C1228.32 778.992 1227.06 780.272 1227.06 781.852C1227.06 783.432 1228.32 784.712 1229.87 784.712Z",
    fill: "white"
  })), _path1481 || (_path1481 = /*#__PURE__*/React.createElement("path", {
    d: "M1185.02 788.157C1188.43 788.157 1191.2 785.335 1191.2 781.853C1191.2 778.371 1188.43 775.548 1185.02 775.548C1181.61 775.548 1178.84 778.371 1178.84 781.853C1178.84 785.335 1181.61 788.157 1185.02 788.157Z",
    fill: "#76736C"
  })), _path1482 || (_path1482 = /*#__PURE__*/React.createElement("path", {
    d: "M1185.02 784.712C1186.57 784.712 1187.82 783.432 1187.82 781.852C1187.82 780.272 1186.57 778.992 1185.02 778.992C1183.47 778.992 1182.22 780.272 1182.22 781.852C1182.22 783.432 1183.47 784.712 1185.02 784.712Z",
    fill: "white"
  })), _path1483 || (_path1483 = /*#__PURE__*/React.createElement("path", {
    d: "M1203.14 771.319H1221.93L1217.66 764.307L1203.94 763.35H1192.46L1186.4 769.732C1186.4 769.732 1195.33 771.319 1203.15 771.319H1203.14Z",
    fill: "url(#paint7_linear_6004_56885)"
  })), _path1484 || (_path1484 = /*#__PURE__*/React.createElement("path", {
    d: "M1203.14 771.319H1221.93L1217.66 764.307L1203.94 763.35H1192.46L1186.4 769.732C1186.4 769.732 1195.33 771.319 1203.15 771.319H1203.14Z",
    fill: "url(#paint8_linear_6004_56885)"
  })), _path1485 || (_path1485 = /*#__PURE__*/React.createElement("path", {
    d: "M1205.24 763.59H1204.79V771.662H1205.24V763.59Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.341819
  })), _path1486 || (_path1486 = /*#__PURE__*/React.createElement("path", {
    d: "M1208.44 771.225L1216.89 764.371V767.755L1211.27 771.225H1208.44Z",
    fill: "white",
    fillOpacity: 0.6
  })), _path1487 || (_path1487 = /*#__PURE__*/React.createElement("path", {
    d: "M1205.22 771.318L1213.21 763.952L1215.09 764.203L1206.69 771.318H1205.22Z",
    fill: "white",
    fillOpacity: 0.6
  })), _path1488 || (_path1488 = /*#__PURE__*/React.createElement("path", {
    d: "M1262.18 759.576C1266.91 759.576 1270.75 763.41 1270.75 768.139C1270.75 772.869 1266.91 776.702 1262.18 776.702C1257.45 776.702 1253.62 772.869 1253.62 768.139C1253.62 763.41 1257.45 759.576 1262.18 759.576Z",
    fill: "#AACAC9",
    stroke: "#382456",
    strokeWidth: 0.54612
  })), _path1489 || (_path1489 = /*#__PURE__*/React.createElement("path", {
    d: "M1262.18 762.788H1262.9C1266.65 762.788 1269.68 765.825 1269.68 769.565C1269.68 773.312 1266.64 776.343 1262.9 776.343H1262.18C1258.44 776.343 1255.41 773.306 1255.41 769.565C1255.41 765.819 1258.44 762.788 1262.18 762.788Z",
    fill: "#62AE80"
  })), _path1490 || (_path1490 = /*#__PURE__*/React.createElement("path", {
    d: "M1261.83 769.207V795.606",
    stroke: "#382456",
    strokeWidth: 0.54612
  })), _path1491 || (_path1491 = /*#__PURE__*/React.createElement("path", {
    d: "M1266.82 769.927L1261.83 774.924",
    stroke: "#382456",
    strokeWidth: 0.54612
  })), _path1492 || (_path1492 = /*#__PURE__*/React.createElement("path", {
    d: "M1257.19 769.927L1262.19 774.924",
    stroke: "#382456",
    strokeWidth: 0.54612
  })), _path1493 || (_path1493 = /*#__PURE__*/React.createElement("path", {
    d: "M1273.6 759.576C1278.33 759.576 1282.16 763.41 1282.16 768.139C1282.16 772.869 1278.33 776.702 1273.6 776.702C1268.87 776.702 1265.04 772.869 1265.04 768.139C1265.04 763.41 1268.87 759.576 1273.6 759.576Z",
    fill: "#AACAC9",
    stroke: "#382456",
    strokeWidth: 0.54612
  })), _path1494 || (_path1494 = /*#__PURE__*/React.createElement("path", {
    d: "M1273.6 762.788H1274.32C1278.06 762.788 1281.09 765.825 1281.09 769.565C1281.09 773.312 1278.06 776.343 1274.32 776.343H1273.6C1269.85 776.343 1266.82 773.306 1266.82 769.565C1266.82 765.819 1269.86 762.788 1273.6 762.788Z",
    fill: "#62AE80"
  })), _path1495 || (_path1495 = /*#__PURE__*/React.createElement("path", {
    d: "M1273.25 769.207V795.606",
    stroke: "#382456",
    strokeWidth: 0.54612
  })), _path1496 || (_path1496 = /*#__PURE__*/React.createElement("path", {
    d: "M1278.24 769.927L1273.24 774.924",
    stroke: "#382456",
    strokeWidth: 0.54612
  })), _path1497 || (_path1497 = /*#__PURE__*/React.createElement("path", {
    d: "M1268.61 769.927L1273.6 774.924",
    stroke: "#382456",
    strokeWidth: 0.54612
  })), _path1498 || (_path1498 = /*#__PURE__*/React.createElement("path", {
    d: "M1285.02 759.576C1289.75 759.576 1293.58 763.41 1293.58 768.139C1293.58 772.869 1289.75 776.702 1285.02 776.702C1280.29 776.702 1276.46 772.869 1276.46 768.139C1276.46 763.41 1280.29 759.576 1285.02 759.576Z",
    fill: "#AACAC9",
    stroke: "#382456",
    strokeWidth: 0.54612
  })), _path1499 || (_path1499 = /*#__PURE__*/React.createElement("path", {
    d: "M1285.02 762.788H1285.73C1289.48 762.788 1292.51 765.825 1292.51 769.565C1292.51 773.312 1289.47 776.343 1285.73 776.343H1285.02C1281.27 776.343 1278.24 773.306 1278.24 769.565C1278.24 765.819 1281.28 762.788 1285.02 762.788Z",
    fill: "#62AE80"
  })), _path1500 || (_path1500 = /*#__PURE__*/React.createElement("path", {
    d: "M1284.66 769.207V795.606",
    stroke: "#382456",
    strokeWidth: 0.54612
  })), _path1501 || (_path1501 = /*#__PURE__*/React.createElement("path", {
    d: "M1289.66 769.927L1284.66 774.924",
    stroke: "#382456",
    strokeWidth: 0.54612
  })), _path1502 || (_path1502 = /*#__PURE__*/React.createElement("path", {
    d: "M1280.03 769.927L1285.02 774.924",
    stroke: "#382456",
    strokeWidth: 0.54612
  })), _path1503 || (_path1503 = /*#__PURE__*/React.createElement("path", {
    d: "M520.518 761.275C525.024 761.275 528.677 764.928 528.677 769.435C528.677 773.941 525.024 777.594 520.518 777.594C516.011 777.594 512.358 773.941 512.358 769.435C512.358 764.928 516.011 761.275 520.518 761.275Z",
    fill: "#AACAC9",
    stroke: "#382456",
    strokeWidth: 0.520356
  })), _path1504 || (_path1504 = /*#__PURE__*/React.createElement("path", {
    d: "M520.517 764.336H521.199C524.768 764.336 527.657 767.229 527.657 770.794C527.657 774.363 524.763 777.251 521.199 777.251H520.517C516.947 777.251 514.06 774.358 514.06 770.794C514.06 767.224 516.953 764.336 520.517 764.336Z",
    fill: "#62AE80"
  })), _path1505 || (_path1505 = /*#__PURE__*/React.createElement("path", {
    d: "M520.173 770.452V795.606",
    stroke: "#382456",
    strokeWidth: 0.520356
  })), _path1506 || (_path1506 = /*#__PURE__*/React.createElement("path", {
    d: "M524.934 771.137L520.173 775.898",
    stroke: "#382456",
    strokeWidth: 0.520356
  })), _path1507 || (_path1507 = /*#__PURE__*/React.createElement("path", {
    d: "M515.754 771.137L520.515 775.898",
    stroke: "#382456",
    strokeWidth: 0.520356
  })), _path1508 || (_path1508 = /*#__PURE__*/React.createElement("path", {
    d: "M531.391 761.275C535.897 761.275 539.55 764.928 539.55 769.435C539.55 773.941 535.897 777.594 531.391 777.594C526.884 777.594 523.231 773.941 523.231 769.435C523.231 764.928 526.884 761.275 531.391 761.275Z",
    fill: "#AACAC9",
    stroke: "#382456",
    strokeWidth: 0.520356
  })), _path1509 || (_path1509 = /*#__PURE__*/React.createElement("path", {
    d: "M531.393 764.336H532.075C535.645 764.336 538.533 767.229 538.533 770.794C538.533 774.363 535.639 777.251 532.075 777.251H531.393C527.824 777.251 524.936 774.358 524.936 770.794C524.936 767.224 527.829 764.336 531.393 764.336Z",
    fill: "#62AE80"
  })), _path1510 || (_path1510 = /*#__PURE__*/React.createElement("path", {
    d: "M531.055 770.452V795.606",
    stroke: "#382456",
    strokeWidth: 0.520356
  })), _path1511 || (_path1511 = /*#__PURE__*/React.createElement("path", {
    d: "M535.816 771.137L531.055 775.898",
    stroke: "#382456",
    strokeWidth: 0.520356
  })), _path1512 || (_path1512 = /*#__PURE__*/React.createElement("path", {
    d: "M526.635 771.137L531.396 775.898",
    stroke: "#382456",
    strokeWidth: 0.520356
  })), _path1513 || (_path1513 = /*#__PURE__*/React.createElement("path", {
    d: "M542.272 761.275C546.779 761.275 550.432 764.928 550.432 769.435C550.432 773.941 546.779 777.594 542.272 777.594C537.766 777.594 534.113 773.941 534.113 769.435C534.113 764.928 537.766 761.275 542.272 761.275Z",
    fill: "#AACAC9",
    stroke: "#382456",
    strokeWidth: 0.520356
  })), _path1514 || (_path1514 = /*#__PURE__*/React.createElement("path", {
    d: "M542.272 764.336H542.954C546.523 764.336 549.411 767.229 549.411 770.794C549.411 774.363 546.518 777.251 542.954 777.251H542.272C538.702 777.251 535.814 774.358 535.814 770.794C535.814 767.224 538.708 764.336 542.272 764.336Z",
    fill: "#62AE80"
  })), _path1515 || (_path1515 = /*#__PURE__*/React.createElement("path", {
    d: "M546.689 771.137L541.928 775.898",
    stroke: "#382456",
    strokeWidth: 0.520356
  })), _path1516 || (_path1516 = /*#__PURE__*/React.createElement("path", {
    d: "M537.511 771.137L542.272 775.898",
    stroke: "#382456",
    strokeWidth: 0.520356
  })), _path1517 || (_path1517 = /*#__PURE__*/React.createElement("path", {
    d: "M541.928 770.452V795.606",
    stroke: "#382456",
    strokeWidth: 0.520356
  })), _path1518 || (_path1518 = /*#__PURE__*/React.createElement("path", {
    d: "M413.436 744.941V746.138L449.981 745.899L433.74 743.989H414.393C413.865 743.989 413.436 744.419 413.436 744.946V744.941Z",
    fill: "#CDD9F4"
  })), _path1519 || (_path1519 = /*#__PURE__*/React.createElement("path", {
    d: "M351.815 749.004C351.815 747.158 353.315 745.659 355.16 745.659H478.982C481.907 745.659 484.641 747.109 486.282 749.536C488.504 752.828 490.257 756.412 491.483 760.191L491.556 760.421C492.337 762.828 492.738 765.338 492.738 767.868V779.099C492.738 780.945 491.239 782.444 489.393 782.444H355.16C353.315 782.444 351.815 780.945 351.815 779.099V749.004Z",
    fill: "#CDD9F4",
    stroke: "#76736C",
    strokeWidth: 0.488313
  })), _path1520 || (_path1520 = /*#__PURE__*/React.createElement("path", {
    d: "M494.12 751.52L494.408 752.829L492.738 753.547C492.738 751.364 490.687 749.762 488.568 750.29L487.005 750.68L485.335 748.532H490.389C492.181 748.532 493.729 749.777 494.12 751.525V751.52Z",
    fill: "#FFF9DE",
    stroke: "#76736C",
    strokeWidth: 0.488313
  })), _path1521 || (_path1521 = /*#__PURE__*/React.createElement("path", {
    d: "M352.768 768.83H475.266",
    stroke: "#76736C",
    strokeWidth: 0.488313
  })), _path1522 || (_path1522 = /*#__PURE__*/React.createElement("path", {
    d: "M396.237 769.064V782.439",
    stroke: "#76736C",
    strokeWidth: 0.488313
  })), _path1523 || (_path1523 = /*#__PURE__*/React.createElement("path", {
    d: "M363.756 770.501H376.174",
    stroke: "#76736C",
    strokeWidth: 0.488313
  })), _path1524 || (_path1524 = /*#__PURE__*/React.createElement("path", {
    d: "M363.756 771.936H376.174",
    stroke: "#76736C",
    strokeWidth: 0.488313
  })), _path1525 || (_path1525 = /*#__PURE__*/React.createElement("path", {
    d: "M363.756 773.367H376.174",
    stroke: "#76736C",
    strokeWidth: 0.488313
  })), _path1526 || (_path1526 = /*#__PURE__*/React.createElement("path", {
    d: "M363.756 774.798H376.174",
    stroke: "#76736C",
    strokeWidth: 0.488313
  })), _path1527 || (_path1527 = /*#__PURE__*/React.createElement("path", {
    d: "M363.756 776.233H376.174",
    stroke: "#76736C",
    strokeWidth: 0.488313
  })), _path1528 || (_path1528 = /*#__PURE__*/React.createElement("path", {
    d: "M363.756 777.664H376.174",
    stroke: "#76736C",
    strokeWidth: 0.488313
  })), _path1529 || (_path1529 = /*#__PURE__*/React.createElement("path", {
    d: "M363.756 779.098H376.174",
    stroke: "#76736C",
    strokeWidth: 0.488313
  })), _path1530 || (_path1530 = /*#__PURE__*/React.createElement("path", {
    d: "M363.756 780.53H376.174",
    stroke: "#76736C",
    strokeWidth: 0.488313
  })), _path1531 || (_path1531 = /*#__PURE__*/React.createElement("path", {
    d: "M414.872 769.064V782.439",
    stroke: "#76736C",
    strokeWidth: 0.488313
  })), _path1532 || (_path1532 = /*#__PURE__*/React.createElement("path", {
    d: "M433.501 769.064V782.439",
    stroke: "#76736C",
    strokeWidth: 0.488313
  })), _path1533 || (_path1533 = /*#__PURE__*/React.createElement("path", {
    d: "M451.651 769.064V782.439",
    stroke: "#76736C",
    strokeWidth: 0.488313
  })), _path1534 || (_path1534 = /*#__PURE__*/React.createElement("path", {
    d: "M478.405 769.064V782.439",
    stroke: "#76736C",
    strokeWidth: 0.488313
  })), _path1535 || (_path1535 = /*#__PURE__*/React.createElement("path", {
    d: "M489.394 770.019V782.437",
    stroke: "#76736C",
    strokeWidth: 0.488313
  })), _path1536 || (_path1536 = /*#__PURE__*/React.createElement("path", {
    d: "M355.155 765.007V762.14H457.384C462.35 762.14 464.869 762.936 465.504 763.337L478.161 768.591L486.282 770.022H492.733C492.894 770.656 493.113 772.17 492.733 773.127C488.909 773.366 479.836 772.888 478.161 771.931C470.71 766.579 463.907 765.085 461.441 765.002H355.15L355.155 765.007Z",
    fill: "#FFF9DE"
  })), _path1537 || (_path1537 = /*#__PURE__*/React.createElement("path", {
    d: "M387.165 788.657C390.859 788.657 393.854 785.554 393.854 781.728C393.854 777.901 390.859 774.798 387.165 774.798C383.47 774.798 380.475 777.901 380.475 781.728C380.475 785.554 383.47 788.657 387.165 788.657Z",
    fill: "#76736C"
  })), _path1538 || (_path1538 = /*#__PURE__*/React.createElement("path", {
    d: "M386.926 784.831C388.641 784.831 390.032 783.441 390.032 781.725C390.032 780.01 388.641 778.62 386.926 778.62C385.211 778.62 383.82 780.01 383.82 781.725C383.82 783.441 385.211 784.831 386.926 784.831Z",
    fill: "white"
  })), _path1539 || (_path1539 = /*#__PURE__*/React.createElement("path", {
    d: "M460.729 788.657C464.424 788.657 467.419 785.554 467.419 781.728C467.419 777.901 464.424 774.798 460.729 774.798C457.034 774.798 454.039 777.901 454.039 781.728C454.039 785.554 457.034 788.657 460.729 788.657Z",
    fill: "#76736C"
  })), _path1540 || (_path1540 = /*#__PURE__*/React.createElement("path", {
    d: "M460.489 784.831C462.205 784.831 463.595 783.441 463.595 781.725C463.595 780.01 462.205 778.62 460.489 778.62C458.774 778.62 457.384 780.01 457.384 781.725C457.384 783.441 458.774 784.831 460.489 784.831Z",
    fill: "white"
  })), _path1541 || (_path1541 = /*#__PURE__*/React.createElement("path", {
    d: "M407.23 780.057H403.406V781.966H407.23V780.057Z",
    fill: "#FFF9DE"
  })), _path1542 || (_path1542 = /*#__PURE__*/React.createElement("path", {
    d: "M425.859 780.057H422.035V781.966H425.859V780.057Z",
    fill: "#FFF9DE"
  })), _path1543 || (_path1543 = /*#__PURE__*/React.createElement("path", {
    d: "M444.016 780.057H440.192V781.966H444.016V780.057Z",
    fill: "#FFF9DE"
  })), _path1544 || (_path1544 = /*#__PURE__*/React.createElement("path", {
    d: "M476.496 772.887H473.63V774.797H476.496V772.887Z",
    fill: "#FFF9DE"
  })), _path1545 || (_path1545 = /*#__PURE__*/React.createElement("path", {
    d: "M476.496 777.19H473.63V779.1H476.496V777.19Z",
    fill: "#FFF9DE"
  })), _path1546 || (_path1546 = /*#__PURE__*/React.createElement("path", {
    d: "M355.155 750.436C355.155 749.381 356.01 748.526 357.065 748.526H478.635C480.696 748.526 482.747 748.844 484.71 749.469L484.856 749.518C486.233 749.957 487.386 750.904 488.084 752.174L489.881 755.446C492.361 759.968 493.441 765.129 492.972 770.266H486.282L478.161 768.835L467.414 764.304C464.415 763.039 461.197 762.39 457.945 762.39H355.15V750.445L355.155 750.436Z",
    fill: "url(#paint9_linear_6004_56885)"
  })), _path1547 || (_path1547 = /*#__PURE__*/React.createElement("path", {
    d: "M485.793 749.25L487.302 752.663C489.783 758.284 491.062 764.358 491.062 770.501",
    stroke: "white",
    strokeWidth: 0.488313
  })), _path1548 || (_path1548 = /*#__PURE__*/React.createElement("path", {
    d: "M454.044 762.395L468.376 746.764H473.357L454.044 765.959V762.395Z",
    fill: "white",
    fillOpacity: 0.7
  })), _path1549 || (_path1549 = /*#__PURE__*/React.createElement("path", {
    d: "M450.938 763.338L465.988 746.857L466.604 747.712L450.943 764.193V763.338H450.938Z",
    fill: "white",
    fillOpacity: 0.7
  })), _path1550 || (_path1550 = /*#__PURE__*/React.createElement("path", {
    d: "M419.007 762.395L433.339 746.764V751.154L419.007 765.964V762.399V762.395Z",
    fill: "white",
    fillOpacity: 0.7
  })), _path1551 || (_path1551 = /*#__PURE__*/React.createElement("path", {
    d: "M415.901 763.338L430.951 746.857L431.566 747.712L415.906 764.193V763.338H415.901Z",
    fill: "white",
    fillOpacity: 0.7
  })), _path1552 || (_path1552 = /*#__PURE__*/React.createElement("path", {
    d: "M382.066 762.395L396.398 746.764V751.154L382.066 765.964V762.399V762.395Z",
    fill: "white",
    fillOpacity: 0.7
  })), _path1553 || (_path1553 = /*#__PURE__*/React.createElement("path", {
    d: "M396.237 748.526V762.971",
    stroke: "white",
    strokeWidth: 0.488313
  })), _path1554 || (_path1554 = /*#__PURE__*/React.createElement("path", {
    d: "M377.13 748.526V763.605",
    stroke: "white",
    strokeWidth: 0.488313
  })), _path1555 || (_path1555 = /*#__PURE__*/React.createElement("path", {
    d: "M414.871 748.526V762.971",
    stroke: "white",
    strokeWidth: 0.488313
  })), _path1556 || (_path1556 = /*#__PURE__*/React.createElement("path", {
    d: "M433.5 748.526V763.605",
    stroke: "white",
    strokeWidth: 0.488313
  })), _path1557 || (_path1557 = /*#__PURE__*/React.createElement("path", {
    d: "M451.651 748.526V763.288",
    stroke: "white",
    strokeWidth: 0.488313
  })), _path1558 || (_path1558 = /*#__PURE__*/React.createElement("path", {
    d: "M478.405 748.526V769.07",
    stroke: "white",
    strokeWidth: 0.488313
  })), _path1559 || (_path1559 = /*#__PURE__*/React.createElement("path", {
    d: "M495.048 758.398V753.466C495.048 753.115 494.76 752.827 494.408 752.827H493.691C492.899 752.827 492.26 753.466 492.26 754.257V757.602C492.26 758.393 492.899 759.038 493.691 759.038H494.408C494.76 759.038 495.048 758.75 495.048 758.398Z",
    fill: "#76736C"
  })), _path1560 || (_path1560 = /*#__PURE__*/React.createElement("path", {
    d: "M1904.15 967.085V797.242L-25.0323 797.242V967.085L1904.15 967.085Z",
    fill: "#C4E1B5"
  })), _path1561 || (_path1561 = /*#__PURE__*/React.createElement("path", {
    d: "M1923 1087.31H-25.5498V948.225H1923V1087.31Z",
    fill: "#C3E1B5"
  })), _path1562 || (_path1562 = /*#__PURE__*/React.createElement("path", {
    d: "M1227 830.018L308.45 834.441L593.45 948.336H1262.45L1227 830.018Z",
    fill: "#FFF5F5"
  })), _path1563 || (_path1563 = /*#__PURE__*/React.createElement("path", {
    d: "M308.45 834.441H-36.5498L-37.5498 859.874H236.717C237.864 859.874 239.002 860.071 240.082 860.457L306.13 884.058L444.45 948.336H593.45L308.45 834.441Z",
    fill: "#FFF5F5"
  })), _path1564 || (_path1564 = /*#__PURE__*/React.createElement("path", {
    d: "M444.45 948.336L306.13 884.058H-26.1948L-25.5498 948.336H444.45Z",
    fill: "#FFF5F5"
  })), _path1565 || (_path1565 = /*#__PURE__*/React.createElement("path", {
    d: "M1417.45 948.336L1546.45 947.783L1918.45 948.336L1923 869.274L1459.92 867.818C1417.66 867.685 1376.13 856.845 1339.2 836.309L1326.16 829.057C1321.63 826.538 1323.45 819.641 1328.64 819.687L1933 825.042V806.244L1235.12 804.168C1221.2 804.127 1215.55 822.085 1227 830.018V830.018L1262.45 948.336H1417.45Z",
    fill: "#FFF5F5"
  })), _path1566 || (_path1566 = /*#__PURE__*/React.createElement("path", {
    d: "M1551.71 866.374C1551.71 866.374 1556.05 862.975 1556.18 859.436C1556.3 855.896 1550.36 859.436 1550.36 859.436C1550.36 859.436 1551.35 857.915 1549.99 857.522C1548.64 857.135 1545.66 859.647 1545.66 859.647C1545.66 859.647 1545.58 852.991 1540.05 852.377C1534.53 851.763 1532.96 855.398 1532.96 855.398C1532.96 855.398 1531.89 852.709 1529.83 852.659C1527.77 852.613 1528.09 854.642 1528.09 854.642C1528.09 854.642 1525.45 851.34 1519.02 851.999C1512.59 852.659 1511.52 857.804 1511.52 857.804C1511.52 857.804 1509.48 856.143 1507.56 856.495C1505.65 856.848 1506.88 860.422 1506.88 860.422C1506.88 860.422 1503.42 855.821 1501.07 855.785C1498.72 855.75 1500.33 859.713 1500.33 859.713C1500.33 859.713 1497.8 854.794 1490 853.872C1482.21 852.951 1484.99 859.139 1484.99 859.139C1484.99 859.139 1481.84 857.271 1479.99 857.799C1478.14 858.328 1481.66 862.013 1481.66 862.013C1481.66 862.013 1477.14 860.135 1474.3 860.916C1471.45 861.696 1477.47 866.368 1477.47 866.368H1551.7L1551.71 866.374Z",
    fill: "#62AE80",
    stroke: "#4C736A",
    strokeWidth: 0.5
  })), _path1567 || (_path1567 = /*#__PURE__*/React.createElement("path", {
    d: "M1339.12 948.528C1339.12 948.528 1343.47 945.129 1343.59 941.59C1343.72 938.05 1337.78 941.59 1337.78 941.59C1337.78 941.59 1338.77 940.069 1337.41 939.677C1336.05 939.289 1333.08 941.801 1333.08 941.801C1333.08 941.801 1333 935.145 1327.47 934.531C1321.94 933.917 1320.38 937.552 1320.38 937.552C1320.38 937.552 1319.3 934.863 1317.24 934.813C1315.18 934.768 1315.51 936.797 1315.51 936.797C1315.51 936.797 1312.87 933.494 1306.44 934.154C1300.01 934.813 1298.93 939.959 1298.93 939.959C1298.93 939.959 1296.89 938.297 1294.98 938.65C1293.06 939.002 1294.3 942.577 1294.3 942.577C1294.3 942.577 1290.83 937.975 1288.48 937.94C1286.13 937.904 1287.74 941.867 1287.74 941.867C1287.74 941.867 1285.21 936.948 1277.42 936.026C1269.62 935.105 1272.41 941.293 1272.41 941.293C1272.41 941.293 1269.25 939.425 1267.4 939.954C1265.55 940.482 1269.07 944.168 1269.07 944.168C1269.07 944.168 1264.56 942.29 1261.71 943.07C1258.87 943.85 1264.88 948.523 1264.88 948.523H1339.11L1339.12 948.528Z",
    fill: "#62AE80",
    stroke: "#4C736A",
    strokeWidth: 0.5
  })), _path1568 || (_path1568 = /*#__PURE__*/React.createElement("path", {
    d: "M233.057 860.596C233.057 860.596 236.14 858.186 236.227 855.676C236.315 853.165 232.105 855.676 232.105 855.676C232.105 855.676 232.805 854.597 231.842 854.319C230.88 854.044 228.77 855.826 228.77 855.826C228.77 855.826 228.713 851.105 224.791 850.669C220.874 850.234 219.763 852.812 219.763 852.812C219.763 852.812 219.001 850.905 217.539 850.869C216.078 850.837 216.309 852.276 216.309 852.276C216.309 852.276 214.436 849.934 209.876 850.402C205.316 850.869 204.554 854.519 204.554 854.519C204.554 854.519 203.108 853.34 201.749 853.59C200.39 853.84 201.265 856.375 201.265 856.375C201.265 856.375 198.81 853.112 197.143 853.087C195.475 853.062 196.618 855.872 196.618 855.872C196.618 855.872 194.822 852.383 189.294 851.73C183.766 851.076 185.743 855.465 185.743 855.465C185.743 855.465 183.504 854.14 182.192 854.515C180.879 854.89 183.375 857.504 183.375 857.504C183.375 857.504 180.174 856.172 178.157 856.725C176.139 857.279 180.406 860.593 180.406 860.593H233.052L233.057 860.596Z",
    fill: "#62AE80",
    stroke: "#4C736A",
    strokeWidth: 0.354609
  })), _path1569 || (_path1569 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M418.747 938.029C418.747 938.029 410.156 940.688 413.346 949.066H472.951C473.623 947.939 474.108 946.639 474.252 945.157C471.416 939.211 466.4 939.816 466.4 939.816C466.4 939.816 468.841 937.26 467.557 936.894C466.274 936.527 464.084 937.822 464.084 937.822C464.084 937.822 466.017 933.531 460.612 934.17C455.206 934.809 453.45 938.221 453.45 938.221C453.45 938.221 454.567 935.472 452.936 935.497C451.305 935.521 448.905 938.713 448.905 938.713C448.905 938.713 449.76 936.234 448.432 935.989C447.103 935.745 445.689 936.897 445.689 936.897C445.689 936.897 444.944 933.328 440.484 932.871C436.025 932.414 434.193 934.704 434.193 934.704C434.193 934.704 434.42 933.297 432.99 933.328C431.561 933.363 430.816 935.228 430.816 935.228C430.816 935.228 429.729 932.707 425.899 933.133C422.063 933.559 422.008 938.175 422.008 938.175C422.008 938.175 419.944 936.433 419.003 936.702C418.062 936.974 418.747 938.029 418.747 938.029Z",
    fill: "#62AE80",
    stroke: "#4C736A",
    strokeWidth: 0.5
  })), _path1570 || (_path1570 = /*#__PURE__*/React.createElement("path", {
    d: "M221.89 544.471H-156.339V811.057H221.89V544.471Z",
    fill: "#F9E3E1",
    stroke: "#6B6770",
    strokeWidth: 1.54802
  })), _path1571 || (_path1571 = /*#__PURE__*/React.createElement("path", {
    d: "M221.89 749.499H-156.339V811.059H221.89V749.499Z",
    fill: "#D7C7A3",
    stroke: "#6B6770",
    strokeWidth: 1.54802
  })), _path1572 || (_path1572 = /*#__PURE__*/React.createElement("path", {
    d: "M2.9592 761.509H-27.3818V811.06H2.9592V761.509Z",
    fill: "#6B6770",
    stroke: "#6B6770",
    strokeWidth: 1.54802
  })), _path1573 || (_path1573 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4504 761.509H17.1094V811.06H47.4504V761.509Z",
    fill: "#6B6770",
    stroke: "#6B6770",
    strokeWidth: 1.54802
  })), _path1574 || (_path1574 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7971 761.509H55.4561V811.06H85.7971V761.509Z",
    fill: "#6B6770",
    stroke: "#6B6770",
    strokeWidth: 1.54802
  })), _path1575 || (_path1575 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0435 771.132C94.0435 761.252 103.517 753.246 115.209 753.246C126.901 753.246 136.374 761.252 136.374 771.132V811.055H94.0186V771.132H94.0435Z",
    fill: "#6B6770",
    stroke: "#6B6770",
    strokeWidth: 1.54802
  })), _path1576 || (_path1576 = /*#__PURE__*/React.createElement("path", {
    d: "M173.898 761.509H143.557V811.06H173.898V761.509Z",
    fill: "#6B6770",
    stroke: "#6B6770",
    strokeWidth: 1.54802
  })), _path1577 || (_path1577 = /*#__PURE__*/React.createElement("path", {
    d: "M213.306 761.509H182.965V811.06H213.306V761.509Z",
    fill: "#6B6770",
    stroke: "#6B6770",
    strokeWidth: 1.54802
  })), _path1578 || (_path1578 = /*#__PURE__*/React.createElement("path", {
    d: "M2.96017 769.77H-27.3809V811.062H2.96017V769.77Z",
    fill: "#FAEAC7",
    stroke: "#6B6770",
    strokeWidth: 1.54802
  })), _path1579 || (_path1579 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4504 769.77H17.1094V811.062H47.4504V769.77Z",
    fill: "#FAEAC7",
    stroke: "#6B6770",
    strokeWidth: 1.54802
  })), _path1580 || (_path1580 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7971 769.77H55.4561V811.062H85.7971V769.77Z",
    fill: "#FAEAC7",
    stroke: "#6B6770",
    strokeWidth: 1.54802
  })), _path1581 || (_path1581 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0435 779.395C94.0435 769.514 103.517 761.509 115.209 761.509C126.901 761.509 136.374 769.514 136.374 779.395V811.06H94.0186V779.395H94.0435Z",
    fill: "#FAEAC7",
    stroke: "#6B6770",
    strokeWidth: 1.54802
  })), _path1582 || (_path1582 = /*#__PURE__*/React.createElement("path", {
    d: "M173.898 769.77H143.557V811.062H173.898V769.77Z",
    fill: "#FAEAC7",
    stroke: "#6B6770",
    strokeWidth: 1.54802
  })), _path1583 || (_path1583 = /*#__PURE__*/React.createElement("path", {
    d: "M213.306 769.77H182.965V811.062H213.306V769.77Z",
    fill: "#FAEAC7",
    stroke: "#6B6770",
    strokeWidth: 1.54802
  })), _path1584 || (_path1584 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7844 666.589H0.936523V691.371H13.7844V666.589Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 1.54802
  })), _path1585 || (_path1585 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7834 716.154H0.935547V740.937H13.7834V716.154Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 1.54802
  })), _path1586 || (_path1586 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4094 666.589H25.5615V691.371H38.4094V666.589Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 1.54802
  })), _path1587 || (_path1587 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4094 716.154H25.5615V740.937H38.4094V716.154Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 1.54802
  })), _path1588 || (_path1588 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0344 666.589H50.1865V691.371H63.0344V666.589Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 1.54802
  })), _path1589 || (_path1589 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0344 716.154H50.1865V740.937H63.0344V716.154Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 1.54802
  })), _path1590 || (_path1590 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6594 666.589H74.8115V691.371H87.6594V666.589Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 1.54802
  })), _path1591 || (_path1591 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6594 716.154H74.8115V740.937H87.6594V716.154Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 1.54802
  })), _path1592 || (_path1592 = /*#__PURE__*/React.createElement("path", {
    d: "M112.284 666.589H99.4365V691.371H112.284V666.589Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 1.54802
  })), _path1593 || (_path1593 = /*#__PURE__*/React.createElement("path", {
    d: "M112.284 716.154H99.4365V740.937H112.284V716.154Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 1.54802
  })), _path1594 || (_path1594 = /*#__PURE__*/React.createElement("path", {
    d: "M136.909 666.589H124.062V691.371H136.909V666.589Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 1.54802
  })), _path1595 || (_path1595 = /*#__PURE__*/React.createElement("path", {
    d: "M136.909 716.154H124.062V740.937H136.909V716.154Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 1.54802
  })), _path1596 || (_path1596 = /*#__PURE__*/React.createElement("path", {
    d: "M161.534 666.589H148.687V691.371H161.534V666.589Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 1.54802
  })), _path1597 || (_path1597 = /*#__PURE__*/React.createElement("path", {
    d: "M161.534 716.154H148.687V740.937H161.534V716.154Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 1.54802
  })), _path1598 || (_path1598 = /*#__PURE__*/React.createElement("path", {
    d: "M186.159 666.589H173.312V691.371H186.159V666.589Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 1.54802
  })), _path1599 || (_path1599 = /*#__PURE__*/React.createElement("path", {
    d: "M186.159 716.154H173.312V740.937H186.159V716.154Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 1.54802
  })), _path1600 || (_path1600 = /*#__PURE__*/React.createElement("path", {
    d: "M210.784 666.589H197.937V691.371H210.784V666.589Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 1.54802
  })), _path1601 || (_path1601 = /*#__PURE__*/React.createElement("path", {
    d: "M210.784 716.154H197.937V740.937H210.784V716.154Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 1.54802
  })), _path1602 || (_path1602 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7844 563.74H0.936523V588.522H13.7844V563.74Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 1.54802
  })), _path1603 || (_path1603 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7834 613.305H0.935547V638.087H13.7834V613.305Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 1.54802
  })), _path1604 || (_path1604 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4094 563.74H25.5615V588.522H38.4094V563.74Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 1.54802
  })), _path1605 || (_path1605 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4094 613.305H25.5615V638.087H38.4094V613.305Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 1.54802
  })), _path1606 || (_path1606 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0344 563.74H50.1865V588.522H63.0344V563.74Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 1.54802
  })), _path1607 || (_path1607 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0344 613.305H50.1865V638.087H63.0344V613.305Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 1.54802
  })), _path1608 || (_path1608 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6594 563.74H74.8115V588.522H87.6594V563.74Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 1.54802
  })), _path1609 || (_path1609 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6594 613.305H74.8115V638.087H87.6594V613.305Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 1.54802
  })), _path1610 || (_path1610 = /*#__PURE__*/React.createElement("path", {
    d: "M112.284 563.74H99.4365V588.522H112.284V563.74Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 1.54802
  })), _path1611 || (_path1611 = /*#__PURE__*/React.createElement("path", {
    d: "M112.284 613.305H99.4365V638.087H112.284V613.305Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 1.54802
  })), _path1612 || (_path1612 = /*#__PURE__*/React.createElement("path", {
    d: "M136.909 563.74H124.062V588.522H136.909V563.74Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 1.54802
  })), _path1613 || (_path1613 = /*#__PURE__*/React.createElement("path", {
    d: "M136.909 613.305H124.062V638.087H136.909V613.305Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 1.54802
  })), _path1614 || (_path1614 = /*#__PURE__*/React.createElement("path", {
    d: "M161.534 563.74H148.687V588.522H161.534V563.74Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 1.54802
  })), _path1615 || (_path1615 = /*#__PURE__*/React.createElement("path", {
    d: "M161.534 613.305H148.687V638.087H161.534V613.305Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 1.54802
  })), _path1616 || (_path1616 = /*#__PURE__*/React.createElement("path", {
    d: "M186.159 563.74H173.312V588.522H186.159V563.74Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 1.54802
  })), _path1617 || (_path1617 = /*#__PURE__*/React.createElement("path", {
    d: "M186.159 613.305H173.312V638.087H186.159V613.305Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 1.54802
  })), _path1618 || (_path1618 = /*#__PURE__*/React.createElement("path", {
    d: "M210.784 563.74H197.937V588.522H210.784V563.74Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 1.54802
  })), _path1619 || (_path1619 = /*#__PURE__*/React.createElement("path", {
    d: "M210.784 613.305H197.937V638.087H210.784V613.305Z",
    fill: "#FFF9DE",
    stroke: "#6B6770",
    strokeWidth: 1.54802
  })), _path1620 || (_path1620 = /*#__PURE__*/React.createElement("path", {
    d: "M233.001 543.609H-167.473V549.678H233.001V543.609Z",
    fill: "#6B6770"
  })), _path1621 || (_path1621 = /*#__PURE__*/React.createElement("path", {
    d: "M227.942 530.888H-162.407V543.024H227.942V530.888Z",
    fill: "#FAEAC7",
    stroke: "#6B6770",
    strokeWidth: 1.54802
  })), _path1622 || (_path1622 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6667 534.659H-10.7148V538.7H23.6667V534.659Z",
    fill: "#CDD9F4",
    stroke: "#6B6770",
    strokeWidth: 1.54802
  })), _path1623 || (_path1623 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2097 534.393H37.8281V538.433H72.2097V534.393Z",
    fill: "#CDD9F4",
    stroke: "#6B6770",
    strokeWidth: 1.54802
  })), _path1624 || (_path1624 = /*#__PURE__*/React.createElement("path", {
    d: "M120.739 534.393H86.3574V538.433H120.739V534.393Z",
    fill: "#CDD9F4",
    stroke: "#6B6770",
    strokeWidth: 1.54802
  })), _path1625 || (_path1625 = /*#__PURE__*/React.createElement("path", {
    d: "M169.286 534.393H134.904V538.433H169.286V534.393Z",
    fill: "#CDD9F4",
    stroke: "#6B6770",
    strokeWidth: 1.54802
  })), _path1626 || (_path1626 = /*#__PURE__*/React.createElement("path", {
    d: "M217.834 534.393H183.452V538.433H217.834V534.393Z",
    fill: "#CDD9F4",
    stroke: "#6B6770",
    strokeWidth: 1.54802
  })), _path1627 || (_path1627 = /*#__PURE__*/React.createElement("path", {
    d: "M167.055 760.906L165.7 761.181L165.923 762.292H167.055V760.906ZM172.728 760.906H174.115V759.519H172.728V760.906ZM172.728 767.817V769.204H174.115V767.817H172.728ZM145.072 767.817H143.686V769.204H145.072V767.817ZM145.072 760.906V759.519H143.686V760.906H145.072ZM150.745 760.906V762.292H151.878L152.1 761.181L150.745 760.906ZM167.055 762.292H171.352H172.728V759.53H167.055V762.292ZM171.352 760.906V762.292V766.431V767.817H174.115V760.906H171.352ZM172.728 766.431H171.352H146.458H145.072V769.193H172.728V766.431ZM146.458 767.817V766.431V762.292V760.906H143.696V767.817H146.458ZM145.072 762.292H146.458H150.745V759.53H145.072V762.292ZM152.1 761.181C152.608 758.662 154.852 756.757 157.519 756.757V753.994C153.507 753.994 150.163 756.841 149.39 760.63L152.1 761.181ZM157.519 756.757H160.281V753.994H157.519V756.757ZM160.281 756.757C162.949 756.757 165.192 758.662 165.7 761.181L168.41 760.63C167.637 756.841 164.293 753.994 160.281 753.994V756.757Z",
    fill: "#6B6770"
  })), _path1628 || (_path1628 = /*#__PURE__*/React.createElement("path", {
    d: "M165.923 762.292L165.7 761.181C165.192 758.662 162.949 756.757 160.281 756.757H157.519C154.852 756.757 152.608 758.662 152.1 761.181L151.878 762.292H150.745H146.458V766.431H171.352V762.292H167.055H165.923Z",
    fill: "#FFF9DE"
  })), _path1629 || (_path1629 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7183 760.906L39.3635 761.181L39.586 762.292H40.7183V760.906ZM46.3915 760.906H47.7781V759.519H46.3915V760.906ZM46.3915 767.817V769.204H47.7781V767.817H46.3915ZM18.735 767.817H17.3486V769.204H18.735V767.817ZM18.735 760.906V759.519H17.3486V760.906H18.735ZM24.4082 760.906V762.292H25.5408L25.763 761.181L24.4082 760.906ZM40.7183 762.292H45.0155H46.3915V759.53H40.7183V762.292ZM45.0155 760.906V762.292V766.431V767.817H47.7781V760.906H45.0155ZM46.3915 766.431H45.0155H20.1215H18.735V769.193H46.3915V766.431ZM20.1215 767.817V766.431V762.292V760.906H17.3592V767.817H20.1215ZM18.735 762.292H20.1215H24.4082V759.53H18.735V762.292ZM25.763 761.181C26.271 758.662 28.5147 756.757 31.1819 756.757V753.994C27.1705 753.994 23.826 756.841 23.0534 760.63L25.763 761.181ZM31.1819 756.757H33.9445V753.994H31.1819V756.757ZM33.9445 756.757C36.6117 756.757 38.8554 758.662 39.3635 761.181L42.0731 760.63C41.3004 756.841 37.9559 753.994 33.9445 753.994V756.757Z",
    fill: "#6B6770"
  })), _path1630 || (_path1630 = /*#__PURE__*/React.createElement("path", {
    d: "M39.586 762.292L39.3635 761.181C38.8554 758.662 36.6117 756.757 33.9445 756.757H31.1819C28.5147 756.757 26.271 758.662 25.763 761.181L25.5408 762.292H24.4082H20.1215V766.431H45.0155V762.292H40.7183H39.586Z",
    fill: "#FFF9DE"
  })), _path1631 || (_path1631 = /*#__PURE__*/React.createElement("path", {
    d: "M206.668 760.906L205.314 761.181L205.536 762.292H206.668V760.906ZM212.342 760.906H213.728V759.519H212.342V760.906ZM212.342 767.817V769.204H213.728V767.817H212.342ZM184.685 767.817H183.299V769.204H184.685V767.817ZM184.685 760.906V759.519H183.299V760.906H184.685ZM190.358 760.906V762.292H191.491L191.713 761.181L190.358 760.906ZM206.668 762.292H210.966H212.342V759.53H206.668V762.292ZM210.966 760.906V762.292V766.431V767.817H213.728V760.906H210.966ZM212.342 766.431H210.966H186.072H184.685V769.193H212.342V766.431ZM186.072 767.817V766.431V762.292V760.906H183.309V767.817H186.072ZM184.685 762.292H186.072H190.358V759.53H184.685V762.292ZM191.713 761.181C192.221 758.662 194.465 756.757 197.132 756.757V753.994C193.121 753.994 189.776 756.841 189.004 760.63L191.713 761.181ZM197.132 756.757H199.895V753.994H197.132V756.757ZM199.895 756.757C202.562 756.757 204.806 758.662 205.314 761.181L208.023 760.63C207.251 756.841 203.906 753.994 199.895 753.994V756.757Z",
    fill: "#6B6770"
  })), _path1632 || (_path1632 = /*#__PURE__*/React.createElement("path", {
    d: "M205.536 762.292L205.314 761.181C204.806 758.662 202.562 756.757 199.895 756.757H197.132C194.465 756.757 192.221 758.662 191.713 761.181L191.491 762.292H190.358H186.072V766.431H210.966V762.292H206.668H205.536Z",
    fill: "#FFF9DE"
  })), _path1633 || (_path1633 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3316 760.906L78.9768 761.181L79.1992 762.292H80.3316V760.906ZM86.0048 760.906H87.3914V759.519H86.0048V760.906ZM86.0048 767.817V769.204H87.3914V767.817H86.0048ZM58.3482 767.817H56.9619V769.204H58.3482V767.817ZM58.3482 760.906V759.519H56.9619V760.906H58.3482ZM64.0215 760.906V762.292H65.154L65.3763 761.181L64.0215 760.906ZM80.3316 762.292H84.6288H86.0048V759.53H80.3316V762.292ZM84.6288 760.906V762.292V766.431V767.817H87.3914V760.906H84.6288ZM86.0048 766.431H84.6288H59.7348H58.3482V769.193H86.0048V766.431ZM59.7348 767.817V766.431V762.292V760.906H56.9725V767.817H59.7348ZM58.3482 762.292H59.7348H64.0215V759.53H58.3482V762.292ZM65.3763 761.181C65.8843 758.662 68.128 756.757 70.7952 756.757V753.994C66.7838 753.994 63.4393 756.841 62.6667 760.63L65.3763 761.181ZM70.7952 756.757H73.5578V753.994H70.7952V756.757ZM73.5578 756.757C76.225 756.757 78.4687 758.662 78.9768 761.181L81.6864 760.63C80.9137 756.841 77.5692 753.994 73.5578 753.994V756.757Z",
    fill: "#6B6770"
  })), _path1634 || (_path1634 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1992 762.292L78.9768 761.181C78.4687 758.662 76.225 756.757 73.5578 756.757H70.7952C68.128 756.757 65.8843 758.662 65.3763 761.181L65.154 762.292H64.0215H59.7348V766.431H84.6288V762.292H80.3316H79.1992Z",
    fill: "#FFF9DE"
  })), _path1635 || (_path1635 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2507 604.252H114.156V950.634H42.2507V604.252Z",
    fill: "#FCDACB"
  })), _path1636 || (_path1636 = /*#__PURE__*/React.createElement("path", {
    d: "M114.73 950.634V604.251C114.73 603.94 114.467 603.677 114.156 603.677H42.2502C41.915 603.677 41.6755 603.94 41.6755 604.251V950.634C41.6755 950.969 41.9389 951.232 42.2502 951.232H114.156C114.467 951.232 114.73 950.969 114.73 950.634ZM42.8249 604.826H113.557V950.059H42.8249V604.826Z",
    fill: "#6B6770"
  })), _path1637 || (_path1637 = /*#__PURE__*/React.createElement("path", {
    d: "M-31.2849 632.557H72.8262V950.636H-31.2849V632.557Z",
    fill: "#DFDCCC"
  })), _path1638 || (_path1638 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4014 950.636V632.556C73.4014 632.221 73.138 631.981 72.8267 631.981H-31.2843C-31.5956 631.981 -31.859 632.221 -31.859 632.556V950.636C-31.859 950.971 -31.5956 951.235 -31.2843 951.235H72.8267C73.1619 951.235 73.4014 950.971 73.4014 950.636ZM-30.7336 633.155H72.2281V950.061H-30.7336V633.155Z",
    fill: "#6B6770"
  })), _path1639 || (_path1639 = /*#__PURE__*/React.createElement("path", {
    d: "M-22.6173 643.279H61.5V655.18H-22.6173V643.279Z",
    fill: "#6B6770"
  })), _path1640 || (_path1640 = /*#__PURE__*/React.createElement("path", {
    d: "M-20.6552 645.29H59.5352V654.437H-20.6552V645.29Z",
    fill: "#2B465B"
  })), _path1641 || (_path1641 = /*#__PURE__*/React.createElement("path", {
    d: "M-20.6552 645.29H59.5352V654.437H-20.6552V645.29Z",
    fill: "#FFFDF4"
  })), _path1642 || (_path1642 = /*#__PURE__*/React.createElement("path", {
    d: "M-22.6183 665.261H61.499V677.185H-22.6183V665.261Z",
    fill: "#6B6770"
  })), _path1643 || (_path1643 = /*#__PURE__*/React.createElement("path", {
    d: "M-20.6552 667.296H59.5352V676.419H-20.6552V667.296Z",
    fill: "#2B465B"
  })), _path1644 || (_path1644 = /*#__PURE__*/React.createElement("path", {
    d: "M-20.6552 667.296H59.5352V676.419H-20.6552V667.296Z",
    fill: "#FFFDF4"
  })), _path1645 || (_path1645 = /*#__PURE__*/React.createElement("path", {
    d: "M-22.6173 687.267H61.5V699.167H-22.6173V687.267Z",
    fill: "#6B6770"
  })), _path1646 || (_path1646 = /*#__PURE__*/React.createElement("path", {
    d: "M-20.6552 689.302H59.5352V698.425H-20.6552V689.302Z",
    fill: "#2B465B"
  })), _path1647 || (_path1647 = /*#__PURE__*/React.createElement("path", {
    d: "M-20.6552 689.302H59.5352V698.425H-20.6552V689.302Z",
    fill: "#FFFDF4"
  })), _path1648 || (_path1648 = /*#__PURE__*/React.createElement("path", {
    d: "M-22.6173 709.248H61.5V721.172H-22.6173V709.248Z",
    fill: "#6B6770"
  })), _path1649 || (_path1649 = /*#__PURE__*/React.createElement("path", {
    d: "M-20.6552 711.31H59.5352V720.432H-20.6552V711.31Z",
    fill: "#2B465B"
  })), _path1650 || (_path1650 = /*#__PURE__*/React.createElement("path", {
    d: "M-20.6552 711.31H59.5352V720.432H-20.6552V711.31Z",
    fill: "#FFFDF4"
  })), _path1651 || (_path1651 = /*#__PURE__*/React.createElement("path", {
    d: "M-22.6173 731.253H61.5V743.177H-22.6173V731.253Z",
    fill: "#6B6770"
  })), _path1652 || (_path1652 = /*#__PURE__*/React.createElement("path", {
    d: "M-20.6543 733.288H59.5361V742.411H-20.6543V733.288Z",
    fill: "#2B465B"
  })), _path1653 || (_path1653 = /*#__PURE__*/React.createElement("path", {
    d: "M-20.6543 733.288H59.5361V742.411H-20.6543V733.288Z",
    fill: "#FFFDF4"
  })), _path1654 || (_path1654 = /*#__PURE__*/React.createElement("path", {
    d: "M-22.6173 753.235H61.5V765.136H-22.6173V753.235Z",
    fill: "#6B6770"
  })), _path1655 || (_path1655 = /*#__PURE__*/React.createElement("path", {
    d: "M-20.6552 755.295H59.5352V764.418H-20.6552V755.295Z",
    fill: "#2B465B"
  })), _path1656 || (_path1656 = /*#__PURE__*/React.createElement("path", {
    d: "M-20.6552 755.295H59.5352V764.418H-20.6552V755.295Z",
    fill: "#FFFDF4"
  })), _path1657 || (_path1657 = /*#__PURE__*/React.createElement("path", {
    d: "M-22.6183 775.242H61.499V787.167H-22.6183V775.242Z",
    fill: "#6B6770"
  })), _path1658 || (_path1658 = /*#__PURE__*/React.createElement("path", {
    d: "M-20.6562 777.302H59.5342V786.425H-20.6562V777.302Z",
    fill: "#2B465B"
  })), _path1659 || (_path1659 = /*#__PURE__*/React.createElement("path", {
    d: "M-20.6562 777.302H59.5342V786.425H-20.6562V777.302Z",
    fill: "#FFFDF4"
  })), _path1660 || (_path1660 = /*#__PURE__*/React.createElement("path", {
    d: "M-22.6183 797.242H61.499V809.167H-22.6183V797.242Z",
    fill: "#6B6770"
  })), _path1661 || (_path1661 = /*#__PURE__*/React.createElement("path", {
    d: "M-20.6552 799.277H59.5352V808.4H-20.6552V799.277Z",
    fill: "#2B465B"
  })), _path1662 || (_path1662 = /*#__PURE__*/React.createElement("path", {
    d: "M-20.6552 799.277H59.5352V808.4H-20.6552V799.277Z",
    fill: "#FFFDF4"
  })), _path1663 || (_path1663 = /*#__PURE__*/React.createElement("path", {
    d: "M-22.6173 819.226H61.5V831.15H-22.6173V819.226Z",
    fill: "#6B6770"
  })), _path1664 || (_path1664 = /*#__PURE__*/React.createElement("path", {
    d: "M-20.6552 821.285H59.5352V830.408H-20.6552V821.285Z",
    fill: "#2B465B"
  })), _path1665 || (_path1665 = /*#__PURE__*/React.createElement("path", {
    d: "M-20.6552 821.285H59.5352V830.408H-20.6552V821.285Z",
    fill: "#FFFDF4"
  })), _path1666 || (_path1666 = /*#__PURE__*/React.createElement("path", {
    d: "M-22.6173 841.23H61.5V853.155H-22.6173V841.23Z",
    fill: "#6B6770"
  })), _path1667 || (_path1667 = /*#__PURE__*/React.createElement("path", {
    d: "M-20.6543 843.266H59.5361V852.389H-20.6543V843.266Z",
    fill: "#2B465B"
  })), _path1668 || (_path1668 = /*#__PURE__*/React.createElement("path", {
    d: "M-20.6543 843.266H59.5361V852.389H-20.6543V843.266Z",
    fill: "#FFFDF4"
  })), _path1669 || (_path1669 = /*#__PURE__*/React.createElement("path", {
    d: "M-22.6173 863.208H61.5V875.156H-22.6173V863.208Z",
    fill: "#6B6770"
  })), _path1670 || (_path1670 = /*#__PURE__*/React.createElement("path", {
    d: "M-20.6552 865.268H59.5352V874.39H-20.6552V865.268Z",
    fill: "#2B465B"
  })), _path1671 || (_path1671 = /*#__PURE__*/React.createElement("path", {
    d: "M-20.6552 865.268H59.5352V874.39H-20.6552V865.268Z",
    fill: "#FFFDF4"
  })), _path1672 || (_path1672 = /*#__PURE__*/React.createElement("path", {
    d: "M-22.6183 885.217H61.499V897.141H-22.6183V885.217Z",
    fill: "#6B6770"
  })), _path1673 || (_path1673 = /*#__PURE__*/React.createElement("path", {
    d: "M-20.6562 887.276H59.5342V896.399H-20.6562V887.276Z",
    fill: "#2B465B"
  })), _path1674 || (_path1674 = /*#__PURE__*/React.createElement("path", {
    d: "M-20.6562 887.276H59.5342V896.399H-20.6562V887.276Z",
    fill: "#FFFDF4"
  })), _path1675 || (_path1675 = /*#__PURE__*/React.createElement("path", {
    d: "M-22.6173 907.195H61.5V919.12H-22.6173V907.195Z",
    fill: "#6B6770"
  })), _path1676 || (_path1676 = /*#__PURE__*/React.createElement("path", {
    d: "M-20.6543 909.255H59.5361V918.378H-20.6543V909.255Z",
    fill: "#2B465B"
  })), _path1677 || (_path1677 = /*#__PURE__*/React.createElement("path", {
    d: "M-20.6543 909.255H59.5361V918.378H-20.6543V909.255Z",
    fill: "#FFFDF4"
  })), _path1678 || (_path1678 = /*#__PURE__*/React.createElement("path", {
    d: "M-22.6173 929.201H61.5V941.126H-22.6173V929.201Z",
    fill: "#6B6770"
  })), _path1679 || (_path1679 = /*#__PURE__*/React.createElement("path", {
    d: "M-20.6552 931.261H59.5352V940.384H-20.6552V931.261Z",
    fill: "#2B465B"
  })), _path1680 || (_path1680 = /*#__PURE__*/React.createElement("path", {
    d: "M-20.6552 931.261H59.5352V940.384H-20.6552V931.261Z",
    fill: "#FFFDF4"
  })), _path1681 || (_path1681 = /*#__PURE__*/React.createElement("path", {
    d: "M82.9142 636.395H105.982V697.211H82.9142V636.395Z",
    fill: "#FFF9DE"
  })), _path1682 || (_path1682 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9203 698.101H106.935V635.455H81.9203V698.101ZM104.988 696.271H83.9138V637.329H104.988V696.271Z",
    fill: "#6B6770"
  })), _path1683 || (_path1683 = /*#__PURE__*/React.createElement("path", {
    d: "M82.9142 636.395H105.982V665.754H82.9142V636.395Z",
    fill: "white"
  })), _path1684 || (_path1684 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9203 666.689H106.935V635.455H81.9203V666.689ZM104.988 664.815H83.9138V637.284H104.988V664.815Z",
    fill: "#6B6770"
  })), _path1685 || (_path1685 = /*#__PURE__*/React.createElement("path", {
    d: "M82.9142 715.944H105.982V776.761H82.9142V715.944Z",
    fill: "#FFF9DE"
  })), _path1686 || (_path1686 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9203 777.696H106.935V715.05H81.9203V777.696ZM104.988 775.822H83.9138V716.879H104.988V775.822Z",
    fill: "#6B6770"
  })), _path1687 || (_path1687 = /*#__PURE__*/React.createElement("path", {
    d: "M82.9142 715.944H105.982V745.349H82.9142V715.944Z",
    fill: "white"
  })), _path1688 || (_path1688 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9203 746.283H106.935V715.05H81.9203V746.283ZM104.988 744.409H83.9138V716.924H104.988V744.409Z",
    fill: "#6B6770"
  })), _path1689 || (_path1689 = /*#__PURE__*/React.createElement("path", {
    d: "M82.9142 795.594H105.982V856.365H82.9142V795.594Z",
    fill: "#FFF9DE"
  })), _path1690 || (_path1690 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9203 857.301H106.935V794.655H81.9203V857.301ZM104.988 855.427H83.9138V796.485H104.988V855.427Z",
    fill: "#6B6770"
  })), _path1691 || (_path1691 = /*#__PURE__*/React.createElement("path", {
    d: "M82.9142 795.584H105.982V824.944H82.9142V795.584Z",
    fill: "white"
  })), _path1692 || (_path1692 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9203 825.838H106.935V794.604H81.9203V825.838ZM104.988 824.009H83.9138V796.523H104.988V824.009Z",
    fill: "#6B6770"
  })), _path1693 || (_path1693 = /*#__PURE__*/React.createElement("path", {
    d: "M82.9142 875.146H105.982V935.917H82.9142V875.146Z",
    fill: "#FFF9DE"
  })), _path1694 || (_path1694 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9203 936.897H106.935V874.207H81.9203V936.897ZM104.988 935.023H83.9138V876.081H104.988V935.023Z",
    fill: "#6B6770"
  })), _path1695 || (_path1695 = /*#__PURE__*/React.createElement("path", {
    d: "M82.9142 875.146H105.982V904.505H82.9142V875.146Z",
    fill: "#FFF9DE"
  })), _path1696 || (_path1696 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9203 905.441H106.935V874.207H81.9203V905.441ZM104.988 903.567H83.9138V876.081H104.988V903.567Z",
    fill: "#6B6770"
  })), _path1697 || (_path1697 = /*#__PURE__*/React.createElement("path", {
    d: "M176.636 809.771C176.653 809.756 176.673 809.738 176.695 809.717C176.785 809.633 176.915 809.508 177.072 809.349C177.385 809.03 177.804 808.574 178.225 808.025C179.074 806.915 179.901 805.468 179.947 804.02C179.958 803.667 179.899 803.433 179.814 803.28C179.733 803.134 179.616 803.044 179.465 802.992C179.137 802.88 178.644 802.948 178.079 803.137C177.529 803.321 176.971 803.6 176.545 803.837C176.333 803.954 176.157 804.06 176.033 804.136C175.971 804.174 175.923 804.205 175.891 804.226L175.854 804.25L175.845 804.256L175.843 804.257L175.842 804.257L175.842 804.257L175.842 804.257L175.842 804.257L175.453 803.891C175.453 803.89 175.453 803.89 175.453 803.89L175.453 803.89L175.453 803.889L175.458 803.881C175.462 803.873 175.469 803.861 175.477 803.845C175.493 803.813 175.517 803.766 175.541 803.708C175.592 803.591 175.646 803.438 175.671 803.282C175.697 803.124 175.688 802.987 175.642 802.883C175.601 802.791 175.517 802.694 175.318 802.629C175.153 802.577 174.889 802.615 174.536 802.767C174.195 802.913 173.824 803.142 173.475 803.388C173.128 803.633 172.812 803.89 172.582 804.086C172.467 804.183 172.374 804.266 172.31 804.323C172.278 804.352 172.254 804.374 172.237 804.39L172.218 804.407L172.214 804.411L172.213 804.412L172.213 804.412L172.213 804.412L172.213 804.412L171.756 804.841L171.75 804.215L171.75 804.215L171.75 804.215L171.75 804.212L171.749 804.202C171.749 804.192 171.749 804.177 171.748 804.157C171.747 804.117 171.744 804.057 171.739 803.98C171.729 803.827 171.711 803.605 171.675 803.337C171.604 802.8 171.465 802.082 171.197 801.351C170.659 799.885 169.626 798.422 167.618 798.174L167.618 798.174C165.544 797.917 164.239 798.548 163.453 799.221C163.056 799.561 162.786 799.916 162.616 800.186C162.531 800.32 162.471 800.433 162.433 800.51C162.414 800.549 162.4 800.579 162.392 800.598L162.383 800.619L162.381 800.623L162.381 800.623L162.381 800.623L162.381 800.623L162.381 800.623L162.115 801.31L176.636 809.771ZM176.636 809.771H118.972C118.941 809.744 118.902 809.709 118.855 809.667C118.733 809.556 118.561 809.397 118.361 809.204C117.96 808.817 117.451 808.298 117.013 807.76C116.568 807.214 116.224 806.682 116.112 806.267C116.057 806.064 116.069 805.924 116.113 805.83C116.155 805.743 116.249 805.645 116.476 805.576C117.504 805.262 118.872 805.479 120.022 805.8C120.589 805.959 121.089 806.138 121.448 806.278C121.627 806.348 121.77 806.408 121.868 806.45C121.917 806.471 121.954 806.487 121.98 806.499L122.008 806.511L122.015 806.515L122.016 806.515L122.016 806.515L122.016 806.515L122.017 806.515L122.34 806.087L122.341 806.087L122.341 806.087L122.34 806.087L122.339 806.085L122.334 806.079L122.312 806.053C122.293 806.031 122.265 805.997 122.23 805.954C122.159 805.867 122.059 805.743 121.944 805.592C121.713 805.29 121.422 804.885 121.177 804.47C120.928 804.047 120.744 803.642 120.697 803.333C120.675 803.18 120.69 803.079 120.72 803.016C120.746 802.962 120.795 802.908 120.914 802.87C121.212 802.775 121.584 802.783 121.995 802.866C122.403 802.948 122.826 803.1 123.213 803.269C123.6 803.438 123.943 803.622 124.191 803.763C124.314 803.834 124.413 803.893 124.481 803.935C124.515 803.956 124.541 803.973 124.558 803.984L124.577 803.996L124.582 803.999L124.583 804L124.583 804L176.636 809.771ZM159.674 798.421C160.34 798.439 160.882 798.937 161.28 799.508C161.474 799.787 161.622 800.065 161.721 800.276C161.77 800.38 161.807 800.467 161.832 800.527C161.844 800.557 161.853 800.58 161.859 800.595L161.865 800.612L161.866 800.616L161.867 800.616L161.867 800.616L161.867 800.617L159.674 798.421ZM159.674 798.421C159.326 798.412 159.106 798.501 158.963 798.614C158.816 798.73 158.723 798.893 158.665 799.075C158.608 799.258 158.591 799.447 158.59 799.596C158.589 799.669 158.592 799.729 158.596 799.771C158.597 799.791 158.599 799.807 158.6 799.817L158.601 799.828L158.602 799.829L158.602 799.829C158.602 799.829 158.602 799.829 158.601 799.829L158.107 800.028C158.106 800.029 158.107 800.029 158.107 800.029L158.106 800.028L158.106 800.028L158.104 800.025C158.101 800.021 158.096 800.014 158.089 800.005C158.075 799.987 158.053 799.96 158.022 799.925C157.962 799.854 157.868 799.751 157.739 799.627C157.482 799.381 157.086 799.055 156.538 798.745C155.445 798.128 153.736 797.567 151.29 797.847C148.874 798.123 147.478 799.331 146.679 800.466C146.278 801.036 146.027 801.59 145.877 802C145.801 802.205 145.752 802.374 145.721 802.49C145.706 802.548 145.695 802.593 145.688 802.622C145.685 802.637 145.683 802.648 145.681 802.655L145.68 802.662L145.68 802.663L145.68 802.663L145.68 802.663L145.68 802.663L145.589 803.146L159.674 798.421ZM145.225 802.816L145.225 802.816L145.225 802.816L145.225 802.816L145.222 802.814L145.21 802.803C145.2 802.794 145.183 802.78 145.162 802.762C145.119 802.726 145.054 802.673 144.972 802.611C144.807 802.486 144.573 802.324 144.295 802.17C143.73 801.858 143.031 801.612 142.382 801.745C142.126 801.798 141.969 801.962 141.872 802.231C141.771 802.512 141.749 802.885 141.775 803.277C141.8 803.665 141.871 804.047 141.936 804.335C141.968 804.478 141.999 804.596 142.021 804.679C142.033 804.72 142.042 804.752 142.048 804.773L142.055 804.797L142.057 804.802L142.057 804.804L142.057 804.804L142.057 804.804L145.225 802.816ZM142.057 804.804L141.567 805.039L141.567 805.039L141.567 805.039L141.567 805.038L141.566 805.037L141.56 805.029L141.538 804.996C141.518 804.968 141.489 804.926 141.451 804.872C141.375 804.765 141.264 804.611 141.125 804.425C140.846 804.055 140.457 803.561 140.012 803.068C139.567 802.573 139.071 802.086 138.581 801.723C138.083 801.353 137.629 801.141 137.259 801.135C137.074 801.132 136.949 801.172 136.862 801.229C136.775 801.285 136.705 801.37 136.652 801.49C136.541 801.742 136.52 802.111 136.561 802.526C136.602 802.932 136.697 803.344 136.784 803.659C136.827 803.815 136.868 803.945 136.898 804.036C136.912 804.081 136.924 804.116 136.933 804.14L136.942 804.167L136.944 804.173L136.945 804.174L136.945 804.175L136.945 804.175L142.057 804.804ZM136.943 804.175L136.441 804.383C136.437 804.384 136.437 804.384 136.437 804.384L136.437 804.384L136.437 804.383L136.434 804.376C136.43 804.37 136.425 804.359 136.418 804.345C136.404 804.316 136.381 804.273 136.35 804.217C136.288 804.106 136.191 803.943 136.056 803.743C135.786 803.345 135.362 802.803 134.753 802.235C133.537 801.102 131.576 799.863 128.601 799.472C127.114 799.276 126.182 799.465 125.606 799.812C125.04 800.152 124.776 800.668 124.678 801.232C124.579 801.804 124.653 802.41 124.758 802.884C124.81 803.12 124.868 803.317 124.914 803.456C124.936 803.525 124.956 803.579 124.969 803.615C124.972 803.622 124.974 803.629 124.976 803.634C124.979 803.643 124.982 803.651 124.984 803.656L124.988 803.666L124.989 803.668L124.989 803.668L124.989 803.668L124.989 803.668L125.32 804.486L124.583 804L136.943 804.175ZM175.452 803.891C175.452 803.891 175.452 803.891 175.452 803.89L175.452 803.891Z",
    fill: "#62AE80",
    stroke: "#4C736A",
    strokeWidth: 0.549618
  })), _path1698 || (_path1698 = /*#__PURE__*/React.createElement("path", {
    d: "M228.982 809.771C228.994 809.759 229.006 809.745 229.02 809.731C229.099 809.646 229.211 809.522 229.347 809.363C229.619 809.045 229.983 808.589 230.349 808.039C231.086 806.933 231.809 805.48 231.849 804.021C231.859 803.663 231.807 803.423 231.731 803.266C231.659 803.117 231.56 803.034 231.443 802.988C231.182 802.885 230.775 802.944 230.285 803.133C229.812 803.315 229.329 803.592 228.96 803.828C228.777 803.945 228.624 804.051 228.517 804.127C228.463 804.164 228.422 804.195 228.394 804.216L228.362 804.239L228.354 804.245L228.352 804.247L228.352 804.247L228.352 804.247L228.352 804.247L228.352 804.247L227.94 803.905C227.94 803.904 227.94 803.904 227.94 803.904L227.94 803.904L227.94 803.903L227.945 803.895C227.948 803.887 227.954 803.875 227.961 803.859C227.976 803.826 227.996 803.779 228.018 803.721C228.062 803.602 228.11 803.447 228.132 803.288C228.155 803.125 228.148 802.981 228.105 802.87C228.067 802.772 227.995 802.684 227.839 802.626C227.723 802.583 227.516 802.609 227.209 802.76C226.918 802.904 226.598 803.131 226.295 803.377C225.994 803.621 225.72 803.877 225.52 804.073C225.421 804.17 225.34 804.252 225.285 804.31C225.257 804.339 225.236 804.361 225.221 804.376L225.205 804.393L225.202 804.397L225.201 804.398L225.201 804.399L225.2 804.399L225.2 804.399L224.73 804.907L224.724 804.215L224.724 804.215L224.724 804.215L224.724 804.214L224.724 804.212L224.724 804.201C224.723 804.191 224.723 804.176 224.723 804.155C224.721 804.115 224.719 804.055 224.715 803.978C224.706 803.824 224.69 803.601 224.659 803.333C224.596 802.794 224.475 802.074 224.242 801.34C223.768 799.857 222.869 798.417 221.159 798.173L221.159 798.173C219.381 797.92 218.264 798.54 217.585 799.208C217.242 799.546 217.007 799.901 216.859 800.171C216.785 800.306 216.733 800.419 216.699 800.497C216.683 800.536 216.671 800.566 216.664 800.585L216.656 800.607L216.654 800.611L216.654 800.611L216.654 800.611L216.654 800.612L216.654 800.612L216.384 801.415L216.131 800.606L216.131 800.605L216.131 800.605L216.131 800.605L216.131 800.605L216.13 800.601L216.124 800.584C216.119 800.568 216.111 800.545 216.101 800.515C216.079 800.455 216.047 800.368 216.004 800.263C215.917 800.052 215.789 799.772 215.62 799.494C215.268 798.912 214.805 798.438 214.261 798.421C213.975 798.413 213.799 798.495 213.681 798.602C213.558 798.715 213.475 798.877 213.423 799.065C213.372 799.252 213.357 799.445 213.356 799.595C213.356 799.67 213.359 799.731 213.362 799.773C213.363 799.795 213.365 799.811 213.366 799.821L213.367 799.832L213.367 799.834L213.367 799.834C213.367 799.834 213.367 799.834 213.366 799.834L212.862 800.013C212.861 800.014 212.861 800.014 212.861 800.014L212.861 800.014L212.861 800.014L212.859 800.01L212.846 799.99C212.834 799.973 212.815 799.945 212.788 799.91C212.736 799.839 212.654 799.736 212.543 799.614C212.32 799.368 211.978 799.044 211.505 798.737C210.563 798.124 209.092 797.569 206.984 797.846C204.909 798.119 203.702 799.313 203.006 800.451C202.657 801.022 202.438 801.577 202.307 801.989C202.241 802.195 202.198 802.364 202.171 802.481C202.157 802.54 202.148 802.585 202.142 802.615C202.141 802.62 202.141 802.624 202.14 802.628C202.138 802.637 202.137 802.643 202.136 802.648L202.135 802.655L202.135 802.657L202.135 802.657L202.135 802.657L202.135 802.657L202.046 803.2L201.665 802.803L201.665 802.803L201.665 802.803L201.665 802.803L201.665 802.802L201.663 802.8L201.653 802.79C201.644 802.781 201.63 802.767 201.611 802.749C201.573 802.713 201.518 802.661 201.447 802.599C201.304 802.475 201.102 802.313 200.863 802.162C200.372 801.85 199.784 801.617 199.247 801.744C199.052 801.79 198.914 801.937 198.826 802.22C198.736 802.507 198.717 802.885 198.74 803.28C198.762 803.67 198.824 804.054 198.881 804.342C198.909 804.486 198.936 804.605 198.955 804.688C198.965 804.729 198.973 804.761 198.979 804.782L198.985 804.806L198.986 804.812L198.987 804.813L198.987 804.814L198.987 804.814L228.982 809.771ZM228.982 809.771H178.907C178.883 809.746 178.853 809.716 178.819 809.68C178.713 809.57 178.563 809.411 178.389 809.218C178.041 808.831 177.599 808.312 177.219 807.775C176.833 807.23 176.532 806.696 176.433 806.276C176.385 806.068 176.393 805.919 176.436 805.817C176.474 805.726 176.553 805.636 176.734 805.573C177.606 805.266 178.776 805.477 179.775 805.797C180.266 805.955 180.698 806.133 181.009 806.273C181.164 806.342 181.287 806.402 181.372 806.444C181.414 806.465 181.447 806.481 181.469 806.492L181.493 806.505L181.499 806.508L181.5 806.508L181.5 806.509L181.5 806.509L181.5 806.508L181.849 806.102L181.85 806.102L181.849 806.102L181.849 806.101L181.848 806.1L181.844 806.094L181.825 806.068C181.808 806.045 181.784 806.012 181.753 805.969C181.692 805.882 181.605 805.758 181.505 805.607C181.304 805.304 181.051 804.9 180.838 804.484C180.622 804.062 180.459 803.653 180.418 803.338C180.398 803.181 180.411 803.073 180.44 803.003C180.465 802.944 180.506 802.898 180.593 802.866C180.836 802.777 181.144 802.782 181.495 802.864C181.843 802.945 182.206 803.094 182.541 803.263C182.875 803.431 183.172 803.613 183.386 803.754C183.493 803.824 183.579 803.884 183.637 803.926C183.666 803.946 183.689 803.963 183.704 803.974L183.72 803.986L183.724 803.989L183.725 803.99L183.725 803.99L228.982 809.771ZM198.986 804.814L198.484 805.024L198.484 805.024L198.484 805.024L198.484 805.024L198.483 805.022L198.478 805.014L198.459 804.982C198.442 804.953 198.416 804.911 198.383 804.857C198.317 804.75 198.221 804.596 198.1 804.411C197.858 804.04 197.519 803.547 197.133 803.054C196.745 802.559 196.316 802.073 195.892 801.711C195.457 801.34 195.075 801.141 194.777 801.135C194.63 801.132 194.535 801.169 194.468 801.218C194.398 801.27 194.337 801.353 194.289 801.478C194.19 801.736 194.172 802.112 194.208 802.529C194.243 802.938 194.327 803.353 194.403 803.668C194.44 803.824 194.476 803.955 194.502 804.046C194.515 804.091 194.525 804.127 194.532 804.151L194.54 804.178L194.543 804.184L194.543 804.185L194.543 804.186L194.543 804.186L198.986 804.814ZM194.541 804.186L194.03 804.37C194.026 804.371 194.026 804.371 194.026 804.372L194.026 804.371L194.026 804.37L194.023 804.363C194.02 804.356 194.015 804.346 194.009 804.331C193.996 804.303 193.977 804.26 193.95 804.203C193.895 804.091 193.811 803.928 193.694 803.729C193.459 803.33 193.091 802.788 192.562 802.221C191.506 801.09 189.811 799.86 187.243 799.471C185.96 799.277 185.169 799.466 184.682 799.802C184.199 800.136 183.966 800.651 183.879 801.226C183.791 801.804 183.857 802.416 183.948 802.892C183.994 803.128 184.045 803.327 184.085 803.466C184.104 803.536 184.121 803.59 184.133 803.627C184.139 803.645 184.143 803.659 184.146 803.668L184.15 803.677L184.15 803.679L184.15 803.679L184.15 803.68L184.15 803.68L184.453 804.542L183.725 803.99L194.541 804.186Z",
    fill: "#62AE80",
    stroke: "#4C736A",
    strokeWidth: 0.549618
  })), _path1699 || (_path1699 = /*#__PURE__*/React.createElement("path", {
    d: "M231.623 807.579H116.531V812.476H231.623V807.579Z",
    fill: "white",
    stroke: "#382456",
    strokeWidth: 0.549618
  })), _path1700 || (_path1700 = /*#__PURE__*/React.createElement("path", {
    d: "M125.181 874.855C136.302 874.855 145.317 883.871 145.317 894.992C145.317 906.113 136.302 915.128 125.181 915.128C114.06 915.128 105.045 906.113 105.045 894.992C105.045 883.871 114.06 874.855 125.181 874.855Z",
    fill: "#AACAC9",
    stroke: "#382456",
    strokeWidth: 1.2842
  })), _path1701 || (_path1701 = /*#__PURE__*/React.createElement("path", {
    d: "M125.181 882.408H126.863C135.673 882.408 142.8 889.548 142.8 898.345C142.8 907.155 135.66 914.282 126.863 914.282H125.181C116.371 914.282 109.244 907.142 109.244 898.345C109.244 889.535 116.384 882.408 125.181 882.408Z",
    fill: "#62AE80"
  })), _path1702 || (_path1702 = /*#__PURE__*/React.createElement("path", {
    d: "M124.333 897.502V959.58",
    stroke: "#382456",
    strokeWidth: 1.2842
  })), _path1703 || (_path1703 = /*#__PURE__*/React.createElement("path", {
    d: "M136.083 899.193L124.333 910.944",
    stroke: "#382456",
    strokeWidth: 1.2842
  })), _path1704 || (_path1704 = /*#__PURE__*/React.createElement("path", {
    d: "M113.431 899.193L125.181 910.944",
    stroke: "#382456",
    strokeWidth: 1.2842
  })), _path1705 || (_path1705 = /*#__PURE__*/React.createElement("path", {
    d: "M152.021 874.855C163.142 874.855 172.157 883.871 172.157 894.992C172.157 906.113 163.142 915.128 152.021 915.128C140.9 915.128 131.885 906.113 131.885 894.992C131.885 883.871 140.9 874.855 152.021 874.855Z",
    fill: "#AACAC9",
    stroke: "#382456",
    strokeWidth: 1.2842
  })), _path1706 || (_path1706 = /*#__PURE__*/React.createElement("path", {
    d: "M152.02 882.408H153.702C162.512 882.408 169.639 889.548 169.639 898.345C169.639 907.155 162.499 914.282 153.702 914.282H152.02C143.21 914.282 136.083 907.142 136.083 898.345C136.083 889.535 143.223 882.408 152.02 882.408Z",
    fill: "#62AE80"
  })), _path1707 || (_path1707 = /*#__PURE__*/React.createElement("path", {
    d: "M151.186 897.502V959.58",
    stroke: "#382456",
    strokeWidth: 1.2842
  })), _path1708 || (_path1708 = /*#__PURE__*/React.createElement("path", {
    d: "M162.936 899.193L151.186 910.944",
    stroke: "#382456",
    strokeWidth: 1.2842
  })), _path1709 || (_path1709 = /*#__PURE__*/React.createElement("path", {
    d: "M140.283 899.193L152.034 910.944",
    stroke: "#382456",
    strokeWidth: 1.2842
  })), _path1710 || (_path1710 = /*#__PURE__*/React.createElement("path", {
    d: "M178.872 874.855C189.994 874.855 199.009 883.871 199.009 894.992C199.009 906.113 189.994 915.128 178.872 915.128C167.751 915.128 158.736 906.113 158.736 894.992C158.736 883.871 167.751 874.855 178.872 874.855Z",
    fill: "#AACAC9",
    stroke: "#382456",
    strokeWidth: 1.2842
  })), _path1711 || (_path1711 = /*#__PURE__*/React.createElement("path", {
    d: "M178.871 882.408H180.554C189.363 882.408 196.49 889.548 196.49 898.345C196.49 907.155 189.35 914.282 180.554 914.282H178.871C170.062 914.282 162.935 907.142 162.935 898.345C162.935 889.535 170.075 882.408 178.871 882.408Z",
    fill: "#62AE80"
  })), _path1712 || (_path1712 = /*#__PURE__*/React.createElement("path", {
    d: "M189.775 899.193L178.024 910.944",
    stroke: "#382456",
    strokeWidth: 1.2842
  })), _path1713 || (_path1713 = /*#__PURE__*/React.createElement("path", {
    d: "M167.122 899.193L178.872 910.944",
    stroke: "#382456",
    strokeWidth: 1.2842
  })), _path1714 || (_path1714 = /*#__PURE__*/React.createElement("path", {
    d: "M178.025 897.502V959.58",
    stroke: "#382456",
    strokeWidth: 1.2842
  })), _path1715 || (_path1715 = /*#__PURE__*/React.createElement("path", {
    d: "M238.564 771.109C239.616 771.109 240.481 771.963 240.481 773.027V803.678C240.481 804.73 239.627 805.595 238.564 805.595C237.511 805.595 236.646 804.742 236.646 803.678V773.027C236.646 771.974 237.5 771.109 238.564 771.109Z",
    fill: "#615E66"
  })), _path1716 || (_path1716 = /*#__PURE__*/React.createElement("path", {
    d: "M305.607 773.654H240.481V786.42H305.607V773.654Z",
    fill: "#FFF9DE"
  })), _path1717 || (_path1717 = /*#__PURE__*/React.createElement("path", {
    d: "M305.607 782.596H240.481V783.87H305.607V782.596Z",
    fill: "#615E66"
  })), _path1718 || (_path1718 = /*#__PURE__*/React.createElement("path", {
    d: "M305.607 777.496H240.481V778.77H305.607V777.496Z",
    fill: "#615E66"
  })), _path1719 || (_path1719 = /*#__PURE__*/React.createElement("path", {
    d: "M301.771 773.027C301.771 771.963 302.624 771.109 303.676 771.109C304.728 771.109 305.605 771.963 305.605 773.027V803.678C305.605 804.73 304.752 805.595 303.676 805.595C302.601 805.595 301.771 804.742 301.771 803.678V773.027Z",
    fill: "#615E66"
  })), _path1720 || (_path1720 = /*#__PURE__*/React.createElement("path", {
    d: "M248.782 792.812C249.834 792.812 250.7 793.665 250.7 794.729V806.22C250.7 807.272 249.846 808.137 248.782 808.137C247.73 808.137 246.865 807.284 246.865 806.22V794.729C246.865 793.677 247.718 792.812 248.782 792.812Z",
    fill: "#615E66"
  })), _path1721 || (_path1721 = /*#__PURE__*/React.createElement("path", {
    d: "M312.622 792.812C313.674 792.812 314.539 793.665 314.539 794.729V806.22C314.539 807.272 313.686 808.137 312.622 808.137C311.57 808.137 310.705 807.284 310.705 806.22V794.729C310.705 793.677 311.558 792.812 312.622 792.812Z",
    fill: "#615E66"
  })), _path1722 || (_path1722 = /*#__PURE__*/React.createElement("path", {
    d: "M240.482 792.819L236.647 789.628H305.608L314.539 792.819V796.654H246.865L240.482 792.819Z",
    fill: "#FFF9DE"
  })), _path1723 || (_path1723 = /*#__PURE__*/React.createElement("path", {
    d: "M314.551 792.812H246.865V796.646H314.551V792.812Z",
    fill: "#615E66"
  })), _path1724 || (_path1724 = /*#__PURE__*/React.createElement("path", {
    d: "M236.647 789.628L246.865 792.819V797.928L236.647 793.462V789.628Z",
    fill: "#615E66"
  })), _path1725 || (_path1725 = /*#__PURE__*/React.createElement("path", {
    d: "M111.494 948.514C111.537 948.482 111.592 948.442 111.657 948.392C111.834 948.258 112.087 948.061 112.393 947.808C113.005 947.303 113.821 946.58 114.642 945.71C116.304 943.949 117.905 941.664 117.992 939.393C118.014 938.845 117.903 938.483 117.737 938.241C117.574 938.003 117.326 937.84 116.986 937.745C116.279 937.549 115.262 937.673 114.16 937.973C113.075 938.269 111.978 938.715 111.146 939.089C110.732 939.276 110.386 939.445 110.144 939.566C110.023 939.626 109.929 939.675 109.865 939.709C109.833 939.725 109.808 939.738 109.792 939.747L109.774 939.756L109.769 939.759L109.769 939.759L109.768 939.759L109.768 939.759L109.768 939.759L109.256 939.177C109.255 939.176 109.255 939.176 109.255 939.176L109.255 939.176L109.257 939.174L109.266 939.161C109.274 939.149 109.287 939.129 109.303 939.104C109.335 939.053 109.38 938.979 109.429 938.888C109.527 938.702 109.631 938.463 109.679 938.221C109.727 937.978 109.712 937.773 109.624 937.615C109.542 937.465 109.358 937.287 108.918 937.171C108.522 937.069 107.949 937.151 107.255 937.393C106.576 937.63 105.843 937.997 105.161 938.388C104.482 938.778 103.863 939.186 103.414 939.496C103.19 939.651 103.009 939.782 102.884 939.873C102.822 939.919 102.773 939.955 102.741 939.979L102.704 940.006L102.695 940.013L102.693 940.015L102.693 940.015L102.693 940.015L102.693 940.015L102.063 940.496L102.052 939.704V939.704L102.052 939.704L102.052 939.703L102.052 939.7L102.052 939.683C102.051 939.668 102.051 939.644 102.049 939.613C102.047 939.55 102.041 939.456 102.032 939.336C102.013 939.094 101.977 938.746 101.908 938.324C101.769 937.479 101.5 936.348 100.979 935.195C99.9433 932.901 97.9212 930.532 93.9076 930.128L93.9076 930.128C89.811 929.716 87.22 930.731 85.6619 931.814C84.8792 932.358 84.349 932.925 84.0164 933.352C83.8501 933.566 83.7334 933.744 83.6595 933.867C83.6225 933.928 83.5963 933.975 83.5799 934.005C83.5718 934.021 83.566 934.032 83.5627 934.038L83.5597 934.045L83.5594 934.045L83.5593 934.045L83.5591 934.046L83.1861 934.828L111.494 948.514ZM111.494 948.514H-0.793854C-0.858315 948.468 -0.951622 948.4 -1.06857 948.314C-1.30685 948.139 -1.64294 947.887 -2.03299 947.581C-2.8148 946.969 -3.80616 946.146 -4.66064 945.294C-5.53081 944.427 -6.20232 943.584 -6.41824 942.932C-6.52248 942.617 -6.49994 942.41 -6.41656 942.268C-6.32989 942.121 -6.11996 941.945 -5.63256 941.824C-3.57304 941.313 -0.863014 941.67 1.37773 942.177C2.48907 942.429 3.46806 942.714 4.16914 942.937C4.51947 943.048 4.7999 943.143 4.99216 943.21C5.08828 943.244 5.16232 943.27 5.21201 943.288L5.26798 943.309L5.28172 943.314L5.28494 943.315L5.28562 943.315L5.28568 943.315L5.28581 943.315L5.69995 942.653L5.70008 942.653L5.70003 942.653L5.69949 942.652L5.697 942.65L5.68642 942.64L5.64408 942.599C5.60683 942.563 5.55212 942.51 5.48324 942.441C5.34541 942.304 5.15112 942.107 4.92649 941.868C4.47579 941.389 3.90918 940.749 3.43152 940.091C2.94377 939.42 2.58813 938.783 2.49982 938.302C2.45715 938.069 2.48561 937.92 2.54239 937.824C2.59596 937.734 2.71376 937.624 2.99559 937.551C3.62138 937.389 4.38451 937.406 5.20086 937.54C6.01271 937.673 6.84964 937.917 7.60958 938.187C8.36832 938.457 9.0423 938.749 9.52684 938.974C9.76885 939.086 9.96296 939.182 10.096 939.249C10.1625 939.282 10.2137 939.308 10.248 939.326L10.2864 939.346L10.2957 939.351L10.2979 939.352L10.2982 939.353L10.2983 939.353L11.4001 939.942L10.8432 938.824L10.8432 938.824L10.843 938.824L10.843 938.823L10.8415 938.82L10.8343 938.805C10.8277 938.792 10.8176 938.77 10.8046 938.742C10.7787 938.684 10.7414 938.599 10.6975 938.49C10.6096 938.272 10.4962 937.961 10.3954 937.591C10.1917 936.844 10.0494 935.894 10.2407 935.001C10.4275 934.13 10.9343 933.295 12.0812 932.735C13.2507 932.164 15.1156 931.866 18.0343 932.178C23.8675 932.802 27.7129 934.775 30.0935 936.576C31.2852 937.478 32.1128 938.339 32.6401 938.97C32.9037 939.286 33.0922 939.544 33.2136 939.721C33.2743 939.81 33.3182 939.878 33.3463 939.923C33.3603 939.945 33.3704 939.962 33.3767 939.973L33.3832 939.984L33.3841 939.985L33.3843 939.986C33.3842 939.986 33.3842 939.985 33.389 939.983L34.0919 939.626C34.094 939.625 34.094 939.625 34.094 939.625L34.0939 939.625L34.0938 939.624L34.0929 939.622L34.0885 939.612L34.0703 939.57C34.0543 939.533 34.0309 939.477 34.0021 939.406C33.9445 939.263 33.8657 939.058 33.7818 938.812C33.613 938.316 33.4284 937.668 33.3505 937.03C33.2711 936.379 33.3116 935.807 33.524 935.415C33.7122 935.068 34.0738 934.792 34.8471 934.803C35.633 934.814 36.5559 935.174 37.5273 935.759C38.4904 936.34 39.4594 937.115 40.328 937.897C41.1951 938.678 41.9536 939.459 42.4957 940.045C42.7666 940.338 42.9828 940.582 43.1311 940.752C43.2051 940.837 43.2622 940.903 43.3005 940.949L43.3437 941L43.3544 941.012L43.3569 941.015L43.3574 941.016L43.3575 941.016L43.3577 941.016L44.0356 940.619C44.0363 940.619 44.0364 940.619 44.0364 940.619L44.0363 940.619L44.0363 940.619L44.0356 940.617L44.0323 940.608L44.0185 940.571C44.0064 940.537 43.9887 940.487 43.9669 940.422C43.9234 940.293 43.8638 940.107 43.8011 939.881C43.6749 939.428 43.5386 938.827 43.4891 938.218C43.4391 937.602 43.4819 937.022 43.6758 936.584C43.8575 936.173 44.1767 935.868 44.7634 935.771C46.1012 935.548 47.5133 935.961 48.6217 936.457C49.1704 936.703 49.6321 936.964 49.9562 937.163C50.1181 937.263 50.245 937.347 50.3307 937.405C50.3735 937.434 50.406 937.457 50.4273 937.472L50.4507 937.489L50.456 937.492L50.4569 937.493M111.494 948.514L50.4569 937.493M50.4569 937.493L50.457 937.493L50.4569 937.493ZM82.8355 934.034L82.8354 934.034L82.8353 934.034L82.835 934.033L82.8324 934.028L82.8201 934.001C82.8088 933.977 82.7913 933.94 82.7676 933.893C82.7202 933.799 82.6483 933.662 82.5521 933.496C82.3594 933.165 82.0718 932.723 81.6928 932.281C80.9277 931.389 79.8371 930.548 78.4394 930.517C77.7173 930.502 77.2453 930.653 76.9341 930.852C76.6247 931.051 76.4418 931.319 76.3331 931.599C76.2227 931.884 76.1907 932.178 76.1886 932.408C76.1875 932.521 76.1938 932.615 76.2 932.679C76.2032 932.711 76.2063 932.736 76.2084 932.751L76.2108 932.767L76.2109 932.768L76.211 932.768L76.2111 932.769L76.2111 932.769L76.2112 932.769L76.4594 934.164L75.5206 933.102L75.5205 933.102L75.5203 933.102L75.52 933.102L75.5198 933.102L75.5137 933.095C75.5078 933.088 75.4979 933.078 75.484 933.063C75.4563 933.035 75.4128 932.991 75.353 932.934C75.2334 932.82 75.0488 932.656 74.7959 932.459C74.2902 932.066 73.5112 931.545 72.4318 931.049C70.2761 930.059 66.9085 929.165 62.1047 929.611C57.3355 930.053 54.586 931.993 53.0269 933.793C52.2438 934.697 51.7553 935.573 51.4632 936.22C51.3173 936.543 51.2207 936.809 51.1612 936.991C51.1314 937.082 51.1109 937.152 51.0982 937.199C51.0957 937.208 51.0936 937.216 51.0917 937.223C51.0887 937.234 51.0863 937.243 51.0847 937.249L51.0819 937.261L51.0816 937.262L51.0816 937.262L51.0815 937.262L82.8355 934.034Z",
    fill: "#62AE80",
    stroke: "#4C736A",
    strokeWidth: 0.79712
  })), _path1726 || (_path1726 = /*#__PURE__*/React.createElement("path", {
    d: "M114.365 945.892H-6.30489V952.994H114.365V945.892Z",
    fill: "white",
    stroke: "#382456",
    strokeWidth: 0.79712
  })), _path1727 || (_path1727 = /*#__PURE__*/React.createElement("path", {
    d: "M1895.63 580.153H1941.68V625.112H1895.63V580.153Z",
    fill: "#FDFDE7"
  })), _path1728 || (_path1728 = /*#__PURE__*/React.createElement("path", {
    d: "M1942.17 625.131V580.173C1942.17 579.885 1941.94 579.679 1941.68 579.679H1895.63C1895.34 579.679 1895.11 579.905 1895.11 580.173V625.131C1895.11 625.399 1895.34 625.625 1895.63 625.625H1941.68C1941.94 625.625 1942.17 625.399 1942.17 625.131ZM1896.12 580.646H1941.16V624.637H1896.12V580.646Z",
    fill: "#706D74"
  })), _path1729 || (_path1729 = /*#__PURE__*/React.createElement("path", {
    d: "M1829.57 580.153H1875.62V625.112H1829.57V580.153Z",
    fill: "#FDFDE7"
  })), _path1730 || (_path1730 = /*#__PURE__*/React.createElement("path", {
    d: "M1876.11 625.131V580.173C1876.11 579.885 1875.88 579.679 1875.62 579.679H1829.57C1829.28 579.679 1829.07 579.905 1829.07 580.173V625.131C1829.07 625.399 1829.3 625.625 1829.57 625.625H1875.62C1875.88 625.625 1876.11 625.399 1876.11 625.131ZM1830.06 580.646H1875.1V624.637H1830.06V580.646Z",
    fill: "#706D74"
  })), _path1731 || (_path1731 = /*#__PURE__*/React.createElement("path", {
    d: "M1859.6 588.137H1905.63V633.116H1859.6V588.137Z",
    fill: "#E8CD9C"
  })), _path1732 || (_path1732 = /*#__PURE__*/React.createElement("path", {
    d: "M1906.15 633.116V588.137C1906.15 587.869 1905.92 587.643 1905.63 587.643H1859.6C1859.31 587.643 1859.11 587.869 1859.11 588.137V633.116C1859.11 633.404 1859.33 633.63 1859.6 633.63H1905.63C1905.92 633.63 1906.15 633.404 1906.15 633.116ZM1860.1 588.651H1905.14V632.622H1860.1V588.651Z",
    fill: "#706D74"
  })), _path1733 || (_path1733 = /*#__PURE__*/React.createElement("path", {
    d: "M1810.59 602.468H1980.66V939.903H1810.59V602.468Z",
    fill: "#FAF3CE",
    stroke: "#706D74",
    strokeWidth: 0.846536
  })), _path1734 || (_path1734 = /*#__PURE__*/React.createElement("path", {
    d: "M1981.16 939.903V602.468C1981.16 602.2 1980.93 601.974 1980.66 601.974H1810.59C1810.32 601.974 1810.09 602.2 1810.09 602.468V939.903C1810.09 940.191 1810.32 940.418 1810.59 940.418H1980.66C1980.95 940.418 1981.16 940.191 1981.16 939.903ZM1811.08 602.962H1980.15V939.409H1811.08V602.962Z",
    fill: "#C7CACB",
    stroke: "#706D74",
    strokeWidth: 0.846536
  })), _path1735 || (_path1735 = /*#__PURE__*/React.createElement("path", {
    d: "M1871.3 869.521H1887.52V885.371H1871.3V869.521Z",
    fill: "#FDFDE7"
  })), _path1736 || (_path1736 = /*#__PURE__*/React.createElement("path", {
    d: "M1888.01 869.026H1870.8V885.865H1888.01V869.026ZM1871.79 870.014H1887.02V884.877H1871.79V870.014Z",
    fill: "#706D74"
  })), _path1737 || (_path1737 = /*#__PURE__*/React.createElement("path", {
    d: "M1855.05 869.521H1871.28V885.371H1855.05V869.521Z",
    fill: "#FDFDE7"
  })), _path1738 || (_path1738 = /*#__PURE__*/React.createElement("path", {
    d: "M1871.79 869.026H1854.56V885.865H1871.79V869.026ZM1855.55 870.014H1870.78V884.877H1855.55V870.014Z",
    fill: "#706D74"
  })), _path1739 || (_path1739 = /*#__PURE__*/React.createElement("path", {
    d: "M1855.05 853.667H1871.28V869.497H1855.05V853.667Z",
    fill: "#FDFDE7"
  })), _path1740 || (_path1740 = /*#__PURE__*/React.createElement("path", {
    d: "M1871.79 853.173H1854.56V870.012H1871.79V853.173ZM1855.55 854.161H1870.78V869.024H1855.55V854.161Z",
    fill: "#706D74"
  })), _path1741 || (_path1741 = /*#__PURE__*/React.createElement("path", {
    d: "M1855.05 821.971H1871.28V837.821H1855.05V821.971Z",
    fill: "#FDFDE7"
  })), _path1742 || (_path1742 = /*#__PURE__*/React.createElement("path", {
    d: "M1871.79 821.475H1854.56V838.313H1871.79V821.475ZM1855.55 822.463H1870.78V837.305H1855.55V822.463Z",
    fill: "#706D74"
  })), _path1743 || (_path1743 = /*#__PURE__*/React.createElement("path", {
    d: "M1855.05 758.588H1871.28V774.439H1855.05V758.588Z",
    fill: "#FDFDE7"
  })), _path1744 || (_path1744 = /*#__PURE__*/React.createElement("path", {
    d: "M1871.79 758.073H1854.56V774.933H1871.79V758.073ZM1855.55 759.082H1870.78V773.945H1855.55V759.082Z",
    fill: "#706D74"
  })), _path1745 || (_path1745 = /*#__PURE__*/React.createElement("path", {
    d: "M1855.05 726.884H1871.28V742.735H1855.05V726.884Z",
    fill: "#FDFDE7"
  })), _path1746 || (_path1746 = /*#__PURE__*/React.createElement("path", {
    d: "M1871.79 726.37H1854.56V743.209H1871.79V726.37ZM1855.55 727.379H1870.78V742.221H1855.55V727.379Z",
    fill: "#706D74"
  })), _path1747 || (_path1747 = /*#__PURE__*/React.createElement("path", {
    d: "M1855.05 711.029H1871.28V726.88H1855.05V711.029Z",
    fill: "#FDFDE7"
  })), _path1748 || (_path1748 = /*#__PURE__*/React.createElement("path", {
    d: "M1871.79 710.516H1854.56V727.354H1871.79V710.516ZM1855.55 711.524H1870.78V726.366H1855.55V711.524Z",
    fill: "#706D74"
  })), _path1749 || (_path1749 = /*#__PURE__*/React.createElement("path", {
    d: "M1855.05 679.332H1871.28V695.162H1855.05V679.332Z",
    fill: "#FDFDE7"
  })), _path1750 || (_path1750 = /*#__PURE__*/React.createElement("path", {
    d: "M1871.79 678.838H1854.56V695.677H1871.79V678.838ZM1855.55 679.826H1870.78V694.689H1855.55V679.826Z",
    fill: "#706D74"
  })), _path1751 || (_path1751 = /*#__PURE__*/React.createElement("path", {
    d: "M1855.05 663.48H1871.28V679.331H1855.05V663.48Z",
    fill: "#FDFDE7"
  })), _path1752 || (_path1752 = /*#__PURE__*/React.createElement("path", {
    d: "M1871.79 662.984H1854.56V679.823H1871.79V662.984ZM1855.55 663.993H1870.78V678.835H1855.55V663.993Z",
    fill: "#706D74"
  })), _path1753 || (_path1753 = /*#__PURE__*/React.createElement("path", {
    d: "M1855.05 774.432H1871.28V790.282H1855.05V774.432Z",
    fill: "#FDFDE7"
  })), _path1754 || (_path1754 = /*#__PURE__*/React.createElement("path", {
    d: "M1871.79 773.918H1854.56V790.757H1871.79V773.918ZM1855.55 774.927H1870.78V789.769H1855.55V774.927Z",
    fill: "#706D74"
  })), _path1755 || (_path1755 = /*#__PURE__*/React.createElement("path", {
    d: "M1855.05 806.118H1871.28V821.969H1855.05V806.118Z",
    fill: "#FDFDE7"
  })), _path1756 || (_path1756 = /*#__PURE__*/React.createElement("path", {
    d: "M1871.79 805.624H1854.56V822.463H1871.79V805.624ZM1855.55 806.612H1870.78V821.475H1855.55V806.612Z",
    fill: "#706D74"
  })), _path1757 || (_path1757 = /*#__PURE__*/React.createElement("path", {
    d: "M1871.3 631.776H1887.52V647.627H1871.3V631.776Z",
    fill: "#FDFDE7"
  })), _path1758 || (_path1758 = /*#__PURE__*/React.createElement("path", {
    d: "M1888.01 631.282H1870.8V648.142H1888.01V631.282ZM1871.79 632.291H1887.02V647.133H1871.79V632.291Z",
    fill: "#706D74"
  })), _path1759 || (_path1759 = /*#__PURE__*/React.createElement("path", {
    d: "M1838.83 679.332H1855.05V695.162H1838.83V679.332Z",
    fill: "#FDFDE7"
  })), _path1760 || (_path1760 = /*#__PURE__*/React.createElement("path", {
    d: "M1855.55 678.838H1838.32V695.677H1855.55V678.838ZM1839.33 679.826H1854.56V694.689H1839.33V679.826Z",
    fill: "#706D74"
  })), _path1761 || (_path1761 = /*#__PURE__*/React.createElement("path", {
    d: "M1838.83 631.776H1855.05V647.627H1838.83V631.776Z",
    fill: "#FDFDE7"
  })), _path1762 || (_path1762 = /*#__PURE__*/React.createElement("path", {
    d: "M1855.55 631.282H1838.32V648.142H1855.55V631.282ZM1839.33 632.291H1854.56V647.133H1839.33V632.291Z",
    fill: "#706D74"
  })), _path1763 || (_path1763 = /*#__PURE__*/React.createElement("path", {
    d: "M1838.83 663.48H1855.05V679.331H1838.83V663.48Z",
    fill: "#FDFDE7"
  })), _path1764 || (_path1764 = /*#__PURE__*/React.createElement("path", {
    d: "M1855.55 662.984H1838.32V679.823H1855.55V662.984ZM1839.33 663.993H1854.56V678.835H1839.33V663.993Z",
    fill: "#706D74"
  })), _path1765 || (_path1765 = /*#__PURE__*/React.createElement("path", {
    d: "M1855.05 631.776H1871.28V647.627H1855.05V631.776Z",
    fill: "#FDFDE7"
  })), _path1766 || (_path1766 = /*#__PURE__*/React.createElement("path", {
    d: "M1871.79 631.282H1854.56V648.142H1871.79V631.282ZM1855.55 632.291H1870.78V647.133H1855.55V632.291Z",
    fill: "#706D74"
  })), _path1767 || (_path1767 = /*#__PURE__*/React.createElement("path", {
    d: "M1871.3 679.332H1887.52V695.162H1871.3V679.332Z",
    fill: "#FDFDE7"
  })), _path1768 || (_path1768 = /*#__PURE__*/React.createElement("path", {
    d: "M1888.01 678.838H1870.8V695.677H1888.01V678.838ZM1871.79 679.826H1887.02V694.689H1871.79V679.826Z",
    fill: "#706D74"
  })), _path1769 || (_path1769 = /*#__PURE__*/React.createElement("path", {
    d: "M1871.3 711.03H1887.52V726.881H1871.3V711.03Z",
    fill: "#FDFDE7"
  })), _path1770 || (_path1770 = /*#__PURE__*/React.createElement("path", {
    d: "M1888.01 710.517H1870.8V727.355H1888.01V710.517ZM1871.79 711.525H1887.02V726.367H1871.79V711.525Z",
    fill: "#706D74"
  })), _path1771 || (_path1771 = /*#__PURE__*/React.createElement("path", {
    d: "M1871.3 663.479H1887.52V679.33H1871.3V663.479Z",
    fill: "#FDFDE7"
  })), _path1772 || (_path1772 = /*#__PURE__*/React.createElement("path", {
    d: "M1888.01 662.985H1870.8V679.824H1888.01V662.985ZM1871.79 663.994H1887.02V678.836H1871.79V663.994Z",
    fill: "#706D74"
  })), _path1773 || (_path1773 = /*#__PURE__*/React.createElement("path", {
    d: "M1871.3 774.432H1887.52V790.282H1871.3V774.432Z",
    fill: "#FDFDE7"
  })), _path1774 || (_path1774 = /*#__PURE__*/React.createElement("path", {
    d: "M1888.01 773.918H1870.8V790.757H1888.01V773.918ZM1871.79 774.927H1887.02V789.769H1871.79V774.927Z",
    fill: "#706D74"
  })), _path1775 || (_path1775 = /*#__PURE__*/React.createElement("path", {
    d: "M1871.3 726.883H1887.52V742.734H1871.3V726.883Z",
    fill: "#FDFDE7"
  })), _path1776 || (_path1776 = /*#__PURE__*/React.createElement("path", {
    d: "M1888.01 726.368H1870.8V743.207H1888.01V726.368ZM1871.79 727.377H1887.02V742.219H1871.79V727.377Z",
    fill: "#706D74"
  })), _path1777 || (_path1777 = /*#__PURE__*/React.createElement("path", {
    d: "M1871.3 758.588H1887.52V774.439H1871.3V758.588Z",
    fill: "#FDFDE7"
  })), _path1778 || (_path1778 = /*#__PURE__*/React.createElement("path", {
    d: "M1888.01 758.073H1870.8V774.933H1888.01V758.073ZM1871.79 759.082H1887.02V773.945H1871.79V759.082Z",
    fill: "#706D74"
  })), _path1779 || (_path1779 = /*#__PURE__*/React.createElement("path", {
    d: "M1871.3 806.116H1887.52V821.967H1871.3V806.116Z",
    fill: "#FDFDE7"
  })), _path1780 || (_path1780 = /*#__PURE__*/React.createElement("path", {
    d: "M1888.01 805.621H1870.8V822.46H1888.01V805.621ZM1871.79 806.609H1887.02V821.472H1871.79V806.609Z",
    fill: "#706D74"
  })), _path1781 || (_path1781 = /*#__PURE__*/React.createElement("path", {
    d: "M1871.3 853.667H1887.52V869.497H1871.3V853.667Z",
    fill: "#FDFDE7"
  })), _path1782 || (_path1782 = /*#__PURE__*/React.createElement("path", {
    d: "M1888.01 853.173H1870.8V870.012H1888.01V853.173ZM1871.79 854.161H1887.02V869.024H1871.79V854.161Z",
    fill: "#706D74"
  })), _path1783 || (_path1783 = /*#__PURE__*/React.createElement("path", {
    d: "M1871.3 821.971H1887.52V837.821H1871.3V821.971Z",
    fill: "#FDFDE7"
  })), _path1784 || (_path1784 = /*#__PURE__*/React.createElement("path", {
    d: "M1888.01 821.475H1870.8V838.313H1888.01V821.475ZM1871.79 822.463H1887.02V837.305H1871.79V822.463Z",
    fill: "#706D74"
  })), _path1785 || (_path1785 = /*#__PURE__*/React.createElement("path", {
    d: "M1855.05 901.219H1871.28V915.834H1855.05V901.219Z",
    fill: "#FDFDE7"
  })), _path1786 || (_path1786 = /*#__PURE__*/React.createElement("path", {
    d: "M1871.79 900.725H1854.56V916.349H1871.79V900.725ZM1855.55 901.713H1870.78V915.34H1855.55V901.713Z",
    fill: "#706D74"
  })), _path1787 || (_path1787 = /*#__PURE__*/React.createElement("path", {
    d: "M1822.53 853.667H1838.83V869.497H1822.53V853.667Z",
    fill: "#FDFDE7"
  })), _path1788 || (_path1788 = /*#__PURE__*/React.createElement("path", {
    d: "M1839.33 853.173H1822.01V870.012H1839.33V853.173ZM1823.02 854.161H1838.32V869.024H1823.02V854.161Z",
    fill: "#706D74"
  })), _path1789 || (_path1789 = /*#__PURE__*/React.createElement("path", {
    d: "M1822.53 821.971H1838.83V837.821H1822.53V821.971Z",
    fill: "#FDFDE7"
  })), _path1790 || (_path1790 = /*#__PURE__*/React.createElement("path", {
    d: "M1839.33 821.475H1822.01V838.313H1839.33V821.475ZM1823.02 822.463H1838.32V837.305H1823.02V822.463Z",
    fill: "#706D74"
  })), _path1791 || (_path1791 = /*#__PURE__*/React.createElement("path", {
    d: "M1822.53 869.521H1838.83V885.371H1822.53V869.521Z",
    fill: "#FDFDE7"
  })), _path1792 || (_path1792 = /*#__PURE__*/React.createElement("path", {
    d: "M1839.33 869.026H1822.01V885.865H1839.33V869.026ZM1823.02 870.014H1838.32V884.877H1823.02V870.014Z",
    fill: "#706D74"
  })), _path1793 || (_path1793 = /*#__PURE__*/React.createElement("path", {
    d: "M1822.53 617.163H1838.83V631.779H1822.53V617.163Z",
    fill: "#FDFDE7"
  })), _path1794 || (_path1794 = /*#__PURE__*/React.createElement("path", {
    d: "M1839.33 616.669H1822.01V632.293H1839.33V616.669ZM1823.02 617.657H1838.32V631.285H1823.02V617.657Z",
    fill: "#706D74"
  })), _path1795 || (_path1795 = /*#__PURE__*/React.createElement("path", {
    d: "M1838.83 901.219H1855.05V915.834H1838.83V901.219Z",
    fill: "#FDFDE7"
  })), _path1796 || (_path1796 = /*#__PURE__*/React.createElement("path", {
    d: "M1855.55 900.725H1838.32V916.349H1855.55V900.725ZM1839.33 901.713H1854.56V915.34H1839.33V901.713Z",
    fill: "#706D74"
  })), _path1797 || (_path1797 = /*#__PURE__*/React.createElement("path", {
    d: "M1822.53 901.219H1838.83V915.834H1822.53V901.219Z",
    fill: "#FDFDE7"
  })), _path1798 || (_path1798 = /*#__PURE__*/React.createElement("path", {
    d: "M1839.33 900.725H1822.02V916.349H1839.33V900.725ZM1823.02 901.713H1838.32V915.34H1823.02V901.713Z",
    fill: "#706D74"
  })), _path1799 || (_path1799 = /*#__PURE__*/React.createElement("path", {
    d: "M1822.53 806.116H1838.83V821.967H1822.53V806.116Z",
    fill: "#FDFDE7"
  })), _path1800 || (_path1800 = /*#__PURE__*/React.createElement("path", {
    d: "M1839.33 805.621H1822.01V822.46H1839.33V805.621ZM1823.02 806.609H1838.32V821.472H1823.02V806.609Z",
    fill: "#706D74"
  })), _path1801 || (_path1801 = /*#__PURE__*/React.createElement("path", {
    d: "M1822.53 663.479H1838.83V679.33H1822.53V663.479Z",
    fill: "#FDFDE7"
  })), _path1802 || (_path1802 = /*#__PURE__*/React.createElement("path", {
    d: "M1839.33 662.985H1822.02V679.824H1839.33V662.985ZM1823.02 663.994H1838.32V678.836H1823.02V663.994Z",
    fill: "#706D74"
  })), _path1803 || (_path1803 = /*#__PURE__*/React.createElement("path", {
    d: "M1822.53 679.332H1838.83V695.162H1822.53V679.332Z",
    fill: "#FDFDE7"
  })), _path1804 || (_path1804 = /*#__PURE__*/React.createElement("path", {
    d: "M1839.33 678.838H1822.01V695.677H1839.33V678.838ZM1823.02 679.826H1838.32V694.689H1823.02V679.826Z",
    fill: "#706D74"
  })), _path1805 || (_path1805 = /*#__PURE__*/React.createElement("path", {
    d: "M1822.53 631.776H1838.83V647.627H1822.53V631.776Z",
    fill: "#FDFDE7"
  })), _path1806 || (_path1806 = /*#__PURE__*/React.createElement("path", {
    d: "M1839.33 631.282H1822.01V648.142H1839.33V631.282ZM1823.02 632.291H1838.32V647.133H1823.02V632.291Z",
    fill: "#706D74"
  })), _path1807 || (_path1807 = /*#__PURE__*/React.createElement("path", {
    d: "M1822.53 711.03H1838.83V726.881H1822.53V711.03Z",
    fill: "#FDFDE7"
  })), _path1808 || (_path1808 = /*#__PURE__*/React.createElement("path", {
    d: "M1839.33 710.517H1822.02V727.355H1839.33V710.517ZM1823.02 711.525H1838.32V726.367H1823.02V711.525Z",
    fill: "#706D74"
  })), _path1809 || (_path1809 = /*#__PURE__*/React.createElement("path", {
    d: "M1822.53 758.588H1838.83V774.439H1822.53V758.588Z",
    fill: "#FDFDE7"
  })), _path1810 || (_path1810 = /*#__PURE__*/React.createElement("path", {
    d: "M1839.33 758.073H1822.01V774.933H1839.33V758.073ZM1823.02 759.082H1838.32V773.945H1823.02V759.082Z",
    fill: "#706D74"
  })), _path1811 || (_path1811 = /*#__PURE__*/React.createElement("path", {
    d: "M1822.53 774.432H1838.83V790.282H1822.53V774.432Z",
    fill: "#FDFDE7"
  })), _path1812 || (_path1812 = /*#__PURE__*/React.createElement("path", {
    d: "M1839.33 773.918H1822.02V790.757H1839.33V773.918ZM1823.02 774.927H1838.32V789.769H1823.02V774.927Z",
    fill: "#706D74"
  })), _path1813 || (_path1813 = /*#__PURE__*/React.createElement("path", {
    d: "M1822.53 726.884H1838.83V742.735H1822.53V726.884Z",
    fill: "#FDFDE7"
  })), _path1814 || (_path1814 = /*#__PURE__*/React.createElement("path", {
    d: "M1839.33 726.37H1822.01V743.209H1839.33V726.37ZM1823.02 727.379H1838.32V742.221H1823.02V727.379Z",
    fill: "#706D74"
  })), _path1815 || (_path1815 = /*#__PURE__*/React.createElement("path", {
    d: "M1871.3 901.219H1887.52V915.834H1871.3V901.219Z",
    fill: "#FDFDE7"
  })), _path1816 || (_path1816 = /*#__PURE__*/React.createElement("path", {
    d: "M1888.01 900.725H1870.8V916.349H1888.01V900.725ZM1871.79 901.713H1887.02V915.34H1871.79V901.713Z",
    fill: "#706D74"
  })), _path1817 || (_path1817 = /*#__PURE__*/React.createElement("path", {
    d: "M1838.83 774.432H1855.05V790.282H1838.83V774.432Z",
    fill: "#FDFDE7"
  })), _path1818 || (_path1818 = /*#__PURE__*/React.createElement("path", {
    d: "M1855.55 773.918H1838.32V790.757H1855.55V773.918ZM1839.33 774.927H1854.56V789.769H1839.33V774.927Z",
    fill: "#706D74"
  })), _path1819 || (_path1819 = /*#__PURE__*/React.createElement("path", {
    d: "M1838.83 758.588H1855.05V774.439H1838.83V758.588Z",
    fill: "#FDFDE7"
  })), _path1820 || (_path1820 = /*#__PURE__*/React.createElement("path", {
    d: "M1855.55 758.073H1838.32V774.933H1855.55V758.073ZM1839.33 759.082H1854.56V773.945H1839.33V759.082Z",
    fill: "#706D74"
  })), _path1821 || (_path1821 = /*#__PURE__*/React.createElement("path", {
    d: "M1838.83 726.884H1855.05V742.735H1838.83V726.884Z",
    fill: "#FDFDE7"
  })), _path1822 || (_path1822 = /*#__PURE__*/React.createElement("path", {
    d: "M1855.55 726.37H1838.32V743.209H1855.55V726.37ZM1839.33 727.379H1854.56V742.221H1839.33V727.379Z",
    fill: "#706D74"
  })), _path1823 || (_path1823 = /*#__PURE__*/React.createElement("path", {
    d: "M1838.83 821.971H1855.05V837.821H1838.83V821.971Z",
    fill: "#FDFDE7"
  })), _path1824 || (_path1824 = /*#__PURE__*/React.createElement("path", {
    d: "M1855.55 821.475H1838.32V838.313H1855.55V821.475ZM1839.33 822.463H1854.56V837.305H1839.33V822.463Z",
    fill: "#706D74"
  })), _path1825 || (_path1825 = /*#__PURE__*/React.createElement("path", {
    d: "M1838.83 806.118H1855.05V821.969H1838.83V806.118Z",
    fill: "#FDFDE7"
  })), _path1826 || (_path1826 = /*#__PURE__*/React.createElement("path", {
    d: "M1855.55 805.624H1838.32V822.463H1855.55V805.624ZM1839.33 806.612H1854.56V821.475H1839.33V806.612Z",
    fill: "#706D74"
  })), _path1827 || (_path1827 = /*#__PURE__*/React.createElement("path", {
    d: "M1838.83 853.667H1855.05V869.497H1838.83V853.667Z",
    fill: "#FDFDE7"
  })), _path1828 || (_path1828 = /*#__PURE__*/React.createElement("path", {
    d: "M1855.55 853.173H1838.32V870.012H1855.55V853.173ZM1839.33 854.161H1854.56V869.024H1839.33V854.161Z",
    fill: "#706D74"
  })), _path1829 || (_path1829 = /*#__PURE__*/React.createElement("path", {
    d: "M1838.83 869.521H1855.05V885.371H1838.83V869.521Z",
    fill: "#FDFDE7"
  })), _path1830 || (_path1830 = /*#__PURE__*/React.createElement("path", {
    d: "M1855.55 869.026H1838.32V885.865H1855.55V869.026ZM1839.33 870.014H1854.56V884.877H1839.33V870.014Z",
    fill: "#706D74"
  })), _path1831 || (_path1831 = /*#__PURE__*/React.createElement("path", {
    d: "M1838.83 617.163H1855.05V631.779H1838.83V617.163Z",
    fill: "#FDFDE7"
  })), _path1832 || (_path1832 = /*#__PURE__*/React.createElement("path", {
    d: "M1855.55 616.669H1838.32V632.293H1855.55V616.669ZM1839.33 617.657H1854.56V631.285H1839.33V617.657Z",
    fill: "#706D74"
  })), _path1833 || (_path1833 = /*#__PURE__*/React.createElement("path", {
    d: "M1855.05 617.163H1871.28V631.779H1855.05V617.163Z",
    fill: "#FDFDE7"
  })), _path1834 || (_path1834 = /*#__PURE__*/React.createElement("path", {
    d: "M1871.79 616.669H1854.56V632.293H1871.79V616.669ZM1855.55 617.657H1870.78V631.285H1855.55V617.657Z",
    fill: "#706D74"
  })), _path1835 || (_path1835 = /*#__PURE__*/React.createElement("path", {
    d: "M1871.3 617.163H1887.52V631.779H1871.3V617.163Z",
    fill: "#FDFDE7"
  })), _path1836 || (_path1836 = /*#__PURE__*/React.createElement("path", {
    d: "M1888.01 616.669H1870.8V632.293H1888.01V616.669ZM1871.79 617.657H1887.02V631.285H1871.79V617.657Z",
    fill: "#706D74"
  })), _path1837 || (_path1837 = /*#__PURE__*/React.createElement("path", {
    d: "M1838.83 711.029H1855.05V726.88H1838.83V711.029Z",
    fill: "#FDFDE7"
  })), _path1838 || (_path1838 = /*#__PURE__*/React.createElement("path", {
    d: "M1855.55 710.516H1838.32V727.354H1855.55V710.516ZM1839.33 711.524H1854.56V726.366H1839.33V711.524Z",
    fill: "#706D74"
  })), _path1839 || (_path1839 = /*#__PURE__*/React.createElement("path", {
    d: "M1807.36 599.214H1983.92V605.698H1807.36V599.214Z",
    fill: "#C6C8CA"
  })), _path1840 || (_path1840 = /*#__PURE__*/React.createElement("path", {
    d: "M1984.41 605.698V599.214C1984.41 598.926 1984.18 598.72 1983.92 598.72H1807.36C1807.07 598.72 1806.86 598.946 1806.86 599.214V605.698C1806.86 605.986 1807.09 606.213 1807.36 606.213H1983.92C1984.21 606.213 1984.41 605.986 1984.41 605.698ZM1807.83 599.728H1983.42V605.225H1807.85V599.728H1807.83Z",
    fill: "#636562"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3
  }, _path1841 || (_path1841 = /*#__PURE__*/React.createElement("path", {
    d: "M1882.51 698.065L1825.51 746.112V759.883L1882.51 711.467V698.065Z",
    fill: "#C6C8CA"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3
  }, _path1842 || (_path1842 = /*#__PURE__*/React.createElement("path", {
    d: "M1882.51 848.955L1825.51 896.981V910.773L1882.51 862.336V848.955Z",
    fill: "#C6C8CA"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1843 || (_path1843 = /*#__PURE__*/React.createElement("path", {
    d: "M1908.6 650.413H1980.46V665.008H1908.6V650.413Z",
    fill: "#EAEAEC"
  }))), _path1844 || (_path1844 = /*#__PURE__*/React.createElement("path", {
    d: "M1908.61 646.068H1982.97V660.643H1908.61V646.068Z",
    fill: "#FDFDE7"
  })), _path1845 || (_path1845 = /*#__PURE__*/React.createElement("path", {
    d: "M1983.46 660.644V646.069C1983.46 645.781 1983.24 645.555 1982.97 645.555H1908.61C1908.33 645.555 1908.12 645.781 1908.12 646.069V660.644C1908.12 660.911 1908.35 661.138 1908.61 661.138H1982.97C1983.24 661.138 1983.46 660.911 1983.46 660.644ZM1909.11 646.563H1982.45V660.15H1909.11V646.563Z",
    fill: "#706D74"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1846 || (_path1846 = /*#__PURE__*/React.createElement("path", {
    d: "M1908.6 725.277H1980.46V739.872H1908.6V725.277Z",
    fill: "#EAEAEC"
  }))), _path1847 || (_path1847 = /*#__PURE__*/React.createElement("path", {
    d: "M1908.61 720.932H1982.97V735.506H1908.61V720.932Z",
    fill: "#FDFDE7"
  })), _path1848 || (_path1848 = /*#__PURE__*/React.createElement("path", {
    d: "M1983.46 735.486V720.912C1983.46 720.644 1983.24 720.418 1982.97 720.418H1908.61C1908.33 720.418 1908.12 720.644 1908.12 720.912V735.486C1908.12 735.775 1908.35 736.001 1908.61 736.001H1982.97C1983.24 736.001 1983.46 735.775 1983.46 735.486ZM1909.11 721.427H1982.45V734.992H1909.11V721.427Z",
    fill: "#706D74"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1849 || (_path1849 = /*#__PURE__*/React.createElement("path", {
    d: "M1908.6 800.149H1980.46V814.744H1908.6V800.149Z",
    fill: "#EAEAEC"
  }))), _path1850 || (_path1850 = /*#__PURE__*/React.createElement("path", {
    d: "M1908.61 795.805H1982.97V810.4H1908.61V795.805Z",
    fill: "#FDFDE7"
  })), _path1851 || (_path1851 = /*#__PURE__*/React.createElement("path", {
    d: "M1983.46 810.378V795.783C1983.46 795.495 1983.24 795.269 1982.97 795.269H1908.61C1908.33 795.269 1908.12 795.495 1908.12 795.783V810.378C1908.12 810.646 1908.35 810.872 1908.61 810.872H1982.97C1983.24 810.872 1983.46 810.646 1983.46 810.378ZM1909.11 796.298H1982.45V809.884H1909.11V796.298Z",
    fill: "#706D74"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1852 || (_path1852 = /*#__PURE__*/React.createElement("path", {
    d: "M1908.6 875.04H1980.46V889.614H1908.6V875.04Z",
    fill: "#EAEAEC"
  }))), _path1853 || (_path1853 = /*#__PURE__*/React.createElement("path", {
    d: "M1908.61 870.655H1982.97V885.25H1908.61V870.655Z",
    fill: "#FDFDE7"
  })), _path1854 || (_path1854 = /*#__PURE__*/React.createElement("path", {
    d: "M1983.46 885.25V870.655C1983.46 870.388 1983.24 870.161 1982.97 870.161H1908.61C1908.33 870.161 1908.12 870.388 1908.12 870.655V885.25C1908.12 885.518 1908.35 885.744 1908.61 885.744H1982.97C1983.24 885.744 1983.46 885.518 1983.46 885.25ZM1909.11 871.17H1982.45V884.736H1909.11V871.17Z",
    fill: "#706D74"
  })), _path1855 || (_path1855 = /*#__PURE__*/React.createElement("path", {
    d: "M1684.34 717.27H1828.76V955.947H1684.34V717.27Z",
    fill: "#DAC591"
  })), _path1856 || (_path1856 = /*#__PURE__*/React.createElement("path", {
    d: "M1828.2 717.82H1684.89V955.391H1828.2V717.82Z",
    fill: "#F6E1D8",
    stroke: "#706D74",
    strokeWidth: 1.10656
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1847-inside-1_6004_56885",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1829.29 955.943V717.266C1829.29 716.97 1829.05 716.728 1828.76 716.728H1684.34C1684.04 716.728 1683.8 716.97 1683.8 717.266V955.943C1683.8 956.266 1684.04 956.508 1684.34 956.508H1828.76C1829.05 956.508 1829.29 956.266 1829.29 955.943ZM1684.88 717.804H1828.22V955.432H1684.88V717.804Z"
  }))), _path1857 || (_path1857 = /*#__PURE__*/React.createElement("path", {
    d: "M1829.29 955.943V717.266C1829.29 716.97 1829.05 716.728 1828.76 716.728H1684.34C1684.04 716.728 1683.8 716.97 1683.8 717.266V955.943C1683.8 956.266 1684.04 956.508 1684.34 956.508H1828.76C1829.05 956.508 1829.29 956.266 1829.29 955.943ZM1684.88 717.804H1828.22V955.432H1684.88V717.804Z",
    fill: "#F9E3E1"
  })), _path1858 || (_path1858 = /*#__PURE__*/React.createElement("path", {
    d: "M1684.88 717.804H1683.77V716.697H1684.88V717.804ZM1828.22 717.804V716.697H1829.33V717.804H1828.22ZM1828.22 955.432H1829.33V956.538H1828.22V955.432ZM1684.88 955.432V956.538H1683.77V955.432H1684.88ZM1828.19 955.943V717.266H1830.4V955.943H1828.19ZM1828.19 717.266C1828.19 717.581 1828.44 717.834 1828.76 717.834V715.621C1829.66 715.621 1830.4 716.358 1830.4 717.266H1828.19ZM1828.76 717.834H1684.34V715.621H1828.76V717.834ZM1684.34 717.834C1684.65 717.834 1684.91 717.581 1684.91 717.266H1682.69C1682.69 716.359 1683.43 715.621 1684.34 715.621V717.834ZM1684.91 717.266V955.943H1682.69V717.266H1684.91ZM1684.91 955.943C1684.91 955.691 1684.69 955.402 1684.34 955.402V957.615C1683.4 957.615 1682.69 956.841 1682.69 955.943H1684.91ZM1684.34 955.402H1828.76V957.615H1684.34V955.402ZM1828.76 955.402C1828.41 955.402 1828.19 955.69 1828.19 955.943H1830.4C1830.4 956.842 1829.7 957.615 1828.76 957.615V955.402ZM1684.88 716.697H1828.22V718.91H1684.88V716.697ZM1829.33 717.804V955.432H1827.11V717.804H1829.33ZM1828.22 956.538H1684.88V954.325H1828.22V956.538ZM1683.77 955.432V717.804H1685.98V955.432H1683.77Z",
    fill: "#706D74",
    mask: "url(#path-1847-inside-1_6004_56885)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1859 || (_path1859 = /*#__PURE__*/React.createElement("path", {
    d: "M1684.34 717.27H1733.12V955.947H1684.34V717.27Z",
    fill: "#C6C8CA"
  }))), _path1860 || (_path1860 = /*#__PURE__*/React.createElement("path", {
    d: "M1742.71 745.251H1818.53V820.971H1742.71V745.251Z",
    fill: "#706D74"
  })), _path1861 || (_path1861 = /*#__PURE__*/React.createElement("path", {
    d: "M1744.67 747.889H1816.54V818.389H1744.67V747.889Z",
    fill: "#554B3F"
  })), _path1862 || (_path1862 = /*#__PURE__*/React.createElement("path", {
    d: "M1745.61 748.774H1815.57V817.391H1745.61V748.774Z",
    fill: "url(#paint10_linear_6004_56885)"
  })), _path1863 || (_path1863 = /*#__PURE__*/React.createElement("path", {
    d: "M1799.43 746.781H1801.31V819.488H1799.43V746.781Z",
    fill: "#706D74"
  })), _path1864 || (_path1864 = /*#__PURE__*/React.createElement("path", {
    d: "M1779.65 746.781H1781.53V819.488H1779.65V746.781Z",
    fill: "#706D74"
  })), _path1865 || (_path1865 = /*#__PURE__*/React.createElement("path", {
    d: "M1759.87 746.781H1761.75V819.488H1759.87V746.781Z",
    fill: "#706D74"
  })), _path1866 || (_path1866 = /*#__PURE__*/React.createElement("path", {
    d: "M1744.18 773.879H1817.08V775.736H1744.18V773.879Z",
    fill: "#706D74"
  })), _path1867 || (_path1867 = /*#__PURE__*/React.createElement("path", {
    d: "M1744.18 758.704H1817.08V760.534H1744.18V758.704Z",
    fill: "#706D74"
  })), _path1868 || (_path1868 = /*#__PURE__*/React.createElement("path", {
    d: "M1744.18 789.057H1817.08V790.886H1744.18V789.057Z",
    fill: "#706D74"
  })), _path1869 || (_path1869 = /*#__PURE__*/React.createElement("path", {
    d: "M1744.18 804.203H1817.08V806.06H1744.18V804.203Z",
    fill: "#706D74"
  })), _path1870 || (_path1870 = /*#__PURE__*/React.createElement("path", {
    d: "M1782.82 874.356H1821.27V929.438H1782.82V874.356Z",
    fill: "#706D74"
  })), _path1871 || (_path1871 = /*#__PURE__*/React.createElement("path", {
    d: "M1785.73 877.071H1818.4V926.744H1785.73V877.071Z",
    fill: "#554B3F"
  })), _path1872 || (_path1872 = /*#__PURE__*/React.createElement("path", {
    d: "M1786.7 877.826H1817.46V925.831H1786.7V877.826Z",
    fill: "url(#paint11_linear_6004_56885)"
  })), _path1873 || (_path1873 = /*#__PURE__*/React.createElement("path", {
    d: "M1801.21 877.071H1802.9V926.744H1801.21V877.071Z",
    fill: "#706D74"
  })), _path1874 || (_path1874 = /*#__PURE__*/React.createElement("path", {
    d: "M1785.81 888.133H1818.34V889.828H1785.81V888.133Z",
    fill: "#706D74"
  })), _path1875 || (_path1875 = /*#__PURE__*/React.createElement("path", {
    d: "M1785.81 901.396H1818.34V903.092H1785.81V901.396Z",
    fill: "#706D74"
  })), _path1876 || (_path1876 = /*#__PURE__*/React.createElement("path", {
    d: "M1785.81 914.716H1818.34V916.384H1785.81V914.716Z",
    fill: "#706D74"
  })), _path1877 || (_path1877 = /*#__PURE__*/React.createElement("path", {
    d: "M1739.9 874.356H1778.36V929.438H1739.9V874.356Z",
    fill: "#706D74"
  })), _path1878 || (_path1878 = /*#__PURE__*/React.createElement("path", {
    d: "M1742.83 877.071H1775.47V926.744H1742.83V877.071Z",
    fill: "#554B3F"
  })), _path1879 || (_path1879 = /*#__PURE__*/React.createElement("path", {
    d: "M1743.75 877.826H1774.53V925.831H1743.75V877.826Z",
    fill: "url(#paint12_linear_6004_56885)"
  })), _path1880 || (_path1880 = /*#__PURE__*/React.createElement("path", {
    d: "M1758.31 877.071H1759.98V926.744H1758.31V877.071Z",
    fill: "#706D74"
  })), _path1881 || (_path1881 = /*#__PURE__*/React.createElement("path", {
    d: "M1742.86 888.133H1775.39V889.828H1742.86V888.133Z",
    fill: "#706D74"
  })), _path1882 || (_path1882 = /*#__PURE__*/React.createElement("path", {
    d: "M1742.86 901.396H1775.39V903.092H1742.86V901.396Z",
    fill: "#706D74"
  })), _path1883 || (_path1883 = /*#__PURE__*/React.createElement("path", {
    d: "M1742.86 914.716H1775.39V916.384H1742.86V914.716Z",
    fill: "#706D74"
  })), _path1884 || (_path1884 = /*#__PURE__*/React.createElement("path", {
    d: "M1832.43 836.109H1718.42V852.52H1832.43V836.109Z",
    fill: "#F6E1D8",
    stroke: "#706D74",
    strokeWidth: 1.10656
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-1875-inside-2_6004_56885",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1833.52 853.045V835.527C1833.52 835.231 1833.28 834.989 1832.98 834.989H1717.87C1717.57 834.989 1717.33 835.231 1717.33 835.527V853.045C1717.33 853.341 1717.57 853.583 1717.87 853.583H1832.98C1833.28 853.583 1833.52 853.341 1833.52 853.045ZM1718.41 836.093H1832.44V852.534H1718.41V836.093Z"
  }))), _path1885 || (_path1885 = /*#__PURE__*/React.createElement("path", {
    d: "M1833.52 853.045V835.527C1833.52 835.231 1833.28 834.989 1832.98 834.989H1717.87C1717.57 834.989 1717.33 835.231 1717.33 835.527V853.045C1717.33 853.341 1717.57 853.583 1717.87 853.583H1832.98C1833.28 853.583 1833.52 853.341 1833.52 853.045ZM1718.41 836.093H1832.44V852.534H1718.41V836.093Z",
    fill: "#636562"
  })), _path1886 || (_path1886 = /*#__PURE__*/React.createElement("path", {
    d: "M1718.41 836.093H1717.3V834.986H1718.41V836.093ZM1832.44 836.093V834.986H1833.55V836.093H1832.44ZM1832.44 852.534H1833.55V853.64H1832.44V852.534ZM1718.41 852.534V853.64H1717.3V852.534H1718.41ZM1832.41 853.045V835.527H1834.63V853.045H1832.41ZM1832.41 835.527C1832.41 835.842 1832.67 836.096 1832.98 836.096V833.883C1833.89 833.883 1834.63 834.621 1834.63 835.527H1832.41ZM1832.98 836.096H1717.87V833.883H1832.98V836.096ZM1717.87 836.096C1718.18 836.096 1718.44 835.843 1718.44 835.527H1716.22C1716.22 834.62 1716.96 833.883 1717.87 833.883V836.096ZM1718.44 835.527V853.045H1716.22V835.527H1718.44ZM1718.44 853.045C1718.44 852.73 1718.18 852.476 1717.87 852.476V854.69C1716.96 854.69 1716.22 853.952 1716.22 853.045H1718.44ZM1717.87 852.476H1832.98V854.69H1717.87V852.476ZM1832.98 852.476C1832.67 852.476 1832.41 852.73 1832.41 853.045H1834.63C1834.63 853.952 1833.89 854.69 1832.98 854.69V852.476ZM1718.41 834.986H1832.44V837.199H1718.41V834.986ZM1833.55 836.093V852.534H1831.34V836.093H1833.55ZM1832.44 853.64H1718.41V851.427H1832.44V853.64ZM1717.3 852.534V836.093H1719.51V852.534H1717.3Z",
    fill: "#706D74",
    mask: "url(#path-1875-inside-2_6004_56885)"
  })), _path1887 || (_path1887 = /*#__PURE__*/React.createElement("path", {
    d: "M1684.34 717.265H1730.46V955.942H1684.34V717.265Z",
    fill: "#F7D2CF",
    stroke: "#706D74",
    strokeWidth: 1.10656
  })), _path1888 || (_path1888 = /*#__PURE__*/React.createElement("path", {
    d: "M1731 955.943V717.266C1731 716.97 1730.76 716.728 1730.46 716.728H1684.34C1684.05 716.728 1683.8 716.97 1683.8 717.266V955.943C1683.8 956.266 1684.05 956.508 1684.34 956.508H1730.46C1730.76 956.508 1731 956.266 1731 955.943ZM1684.88 717.804H1729.93V955.432H1684.88V717.804Z",
    fill: "#F9E3E1",
    stroke: "#706D74",
    strokeWidth: 1.10656
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1889 || (_path1889 = /*#__PURE__*/React.createElement("path", {
    d: "M1684.34 717.263H1828.75V732.762H1684.34V717.263Z",
    fill: "#EAEAEC"
  }))), _path1890 || (_path1890 = /*#__PURE__*/React.createElement("path", {
    d: "M1681.49 714.385H1830.75V728.243H1681.49V714.385Z",
    fill: "#FFBC9E"
  })), _path1891 || (_path1891 = /*#__PURE__*/React.createElement("path", {
    d: "M1831.29 728.242V714.384C1831.29 714.115 1831.04 713.873 1830.75 713.873H1681.49C1681.19 713.873 1680.95 714.115 1680.95 714.384V728.242C1680.95 728.538 1681.19 728.78 1681.49 728.78H1830.75C1831.04 728.78 1831.29 728.538 1831.29 728.242ZM1682.03 714.949H1830.21V727.731H1682.03V714.949Z",
    fill: "#706D74"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path1892 || (_path1892 = /*#__PURE__*/React.createElement("path", {
    d: "M1682.56 716.025H1829.13V718.878H1682.56V716.025Z",
    fill: "#EAEAEC"
  }))), _path1893 || (_path1893 = /*#__PURE__*/React.createElement("path", {
    d: "M1700.86 746.308H1713.94V782.984H1700.86V746.308Z",
    fill: "#FFF9DE"
  })), _path1894 || (_path1894 = /*#__PURE__*/React.createElement("path", {
    d: "M1700.3 783.521H1714.48V745.741H1700.3V783.521ZM1713.37 782.417H1701.43V746.871H1713.37V782.417Z",
    fill: "#706D74"
  })), _path1895 || (_path1895 = /*#__PURE__*/React.createElement("path", {
    d: "M1700.86 746.308H1713.94V764.013H1700.86V746.308Z",
    fill: "white"
  })), _path1896 || (_path1896 = /*#__PURE__*/React.createElement("path", {
    d: "M1700.3 764.577H1714.48V745.741H1700.3V764.577ZM1713.37 763.447H1701.43V746.844H1713.37V763.447Z",
    fill: "#706D74"
  })), _path1897 || (_path1897 = /*#__PURE__*/React.createElement("path", {
    d: "M1700.86 794.28H1713.94V830.956H1700.86V794.28Z",
    fill: "#FFF9DE"
  })), _path1898 || (_path1898 = /*#__PURE__*/React.createElement("path", {
    d: "M1700.3 831.52H1714.48V793.74H1700.3V831.52ZM1713.37 830.389H1701.43V794.843H1713.37V830.389Z",
    fill: "#706D74"
  })), _path1899 || (_path1899 = /*#__PURE__*/React.createElement("path", {
    d: "M1700.86 794.28H1713.94V812.013H1700.86V794.28Z",
    fill: "white"
  })), _path1900 || (_path1900 = /*#__PURE__*/React.createElement("path", {
    d: "M1700.3 812.576H1714.48V793.74H1700.3V812.576ZM1713.37 811.446H1701.43V794.87H1713.37V811.446Z",
    fill: "#706D74"
  })), _path1901 || (_path1901 = /*#__PURE__*/React.createElement("path", {
    d: "M1700.86 842.314H1713.94V878.964H1700.86V842.314Z",
    fill: "#FFF9DE"
  })), _path1902 || (_path1902 = /*#__PURE__*/React.createElement("path", {
    d: "M1700.3 879.527H1714.48V841.748H1700.3V879.527ZM1713.37 878.397H1701.43V842.851H1713.37V878.397Z",
    fill: "#706D74"
  })), _path1903 || (_path1903 = /*#__PURE__*/React.createElement("path", {
    d: "M1700.86 842.308H1713.94V860.013H1700.86V842.308Z",
    fill: "white"
  })), _path1904 || (_path1904 = /*#__PURE__*/React.createElement("path", {
    d: "M1700.3 860.554H1714.48V841.718H1700.3V860.554ZM1713.37 859.45H1701.43V842.875H1713.37V859.45Z",
    fill: "#706D74"
  })), _path1905 || (_path1905 = /*#__PURE__*/React.createElement("path", {
    d: "M1700.86 890.289H1713.94V926.938H1700.86V890.289Z",
    fill: "#FFF9DE"
  })), _path1906 || (_path1906 = /*#__PURE__*/React.createElement("path", {
    d: "M1700.3 927.529H1714.48V889.723H1700.3V927.529ZM1713.37 926.399H1701.43V890.853H1713.37V926.399Z",
    fill: "#706D74"
  })), _path1907 || (_path1907 = /*#__PURE__*/React.createElement("path", {
    d: "M1700.86 890.289H1713.94V907.995H1700.86V890.289Z",
    fill: "#FFF9DE"
  })), _path1908 || (_path1908 = /*#__PURE__*/React.createElement("path", {
    d: "M1700.3 908.559H1714.48V889.723H1700.3V908.559ZM1713.37 907.428H1701.43V890.853H1713.37V907.428Z",
    fill: "#706D74"
  })), _path1909 || (_path1909 = /*#__PURE__*/React.createElement("path", {
    d: "M1910.53 940.259C1910.55 940.239 1910.57 940.216 1910.6 940.189C1910.72 940.081 1910.89 939.921 1911.09 939.716C1911.49 939.306 1912.03 938.719 1912.57 938.012C1913.66 936.585 1914.73 934.721 1914.79 932.859C1914.8 932.404 1914.73 932.103 1914.62 931.907C1914.51 931.719 1914.36 931.603 1914.17 931.536C1913.74 931.392 1913.11 931.479 1912.38 931.723C1911.68 931.96 1910.96 932.319 1910.41 932.623C1910.14 932.774 1909.91 932.91 1909.75 933.008C1909.67 933.057 1909.61 933.097 1909.57 933.124L1909.52 933.155L1909.51 933.162L1909.51 933.164L1909.51 933.164L1909.5 933.164L1909.5 933.164L1909.5 933.164L1909 932.692C1909 932.692 1909 932.692 1909 932.692L1909 932.692L1909 932.69L1909.01 932.68C1909.02 932.67 1909.02 932.654 1909.04 932.634C1909.06 932.592 1909.09 932.532 1909.12 932.458C1909.18 932.307 1909.25 932.11 1909.29 931.909C1909.32 931.706 1909.31 931.53 1909.25 931.396C1909.19 931.277 1909.09 931.152 1908.83 931.07C1908.62 931.002 1908.28 931.051 1907.82 931.246C1907.39 931.434 1906.91 931.729 1906.46 932.046C1906.01 932.361 1905.61 932.692 1905.31 932.943C1905.16 933.069 1905.04 933.175 1904.96 933.249C1904.92 933.286 1904.89 933.315 1904.87 933.335L1904.84 933.357L1904.84 933.362L1904.84 933.363L1904.84 933.364L1904.83 933.364L1904.83 933.364L1904.25 933.916L1904.24 933.11L1904.24 933.11L1904.24 933.109L1904.24 933.106L1904.24 933.093C1904.24 933.08 1904.24 933.061 1904.24 933.035C1904.24 932.983 1904.23 932.906 1904.23 932.808C1904.21 932.61 1904.19 932.325 1904.14 931.98C1904.05 931.289 1903.87 930.366 1903.53 929.425C1902.84 927.538 1901.51 925.656 1898.92 925.337L1898.92 925.337C1896.25 925.006 1894.58 925.818 1893.56 926.684C1893.05 927.121 1892.71 927.579 1892.49 927.925C1892.38 928.098 1892.3 928.243 1892.25 928.342C1892.23 928.392 1892.21 928.431 1892.2 928.455C1892.19 928.468 1892.19 928.477 1892.19 928.482L1892.18 928.488L1892.18 928.488L1892.18 928.488L1892.18 928.488L1892.18 928.488L1891.84 929.372L1891.52 928.48L1891.52 928.479L1891.52 928.479L1891.52 928.479L1891.52 928.479L1891.52 928.479L1891.52 928.474L1891.51 928.452C1891.5 928.432 1891.49 928.403 1891.48 928.364C1891.45 928.287 1891.4 928.175 1891.33 928.041C1891.21 927.77 1891.02 927.412 1890.77 927.053C1890.26 926.318 1889.56 925.678 1888.7 925.654C1888.25 925.643 1887.97 925.757 1887.79 925.903C1887.6 926.052 1887.48 926.261 1887.4 926.496C1887.33 926.731 1887.31 926.975 1887.31 927.166C1887.3 927.26 1887.31 927.338 1887.31 927.391C1887.32 927.418 1887.32 927.438 1887.32 927.451L1887.32 927.464L1887.32 927.466L1887.32 927.466C1887.32 927.466 1887.32 927.466 1887.32 927.466L1886.68 927.722C1886.68 927.723 1886.68 927.723 1886.68 927.723L1886.68 927.723L1886.68 927.723L1886.68 927.718C1886.68 927.713 1886.67 927.704 1886.66 927.693C1886.64 927.67 1886.61 927.635 1886.58 927.589C1886.5 927.498 1886.38 927.365 1886.21 927.207C1885.88 926.89 1885.37 926.47 1884.67 926.072C1883.26 925.277 1881.06 924.556 1877.91 924.915C1874.8 925.27 1873.01 926.826 1871.98 928.286C1871.46 929.019 1871.14 929.732 1870.95 930.26C1870.85 930.524 1870.79 930.741 1870.75 930.89C1870.73 930.965 1870.71 931.022 1870.7 931.06C1870.7 931.079 1870.7 931.093 1870.7 931.102L1870.69 931.112L1870.69 931.113L1870.69 931.113L1870.69 931.113L1870.69 931.113L1870.58 931.735L1910.53 940.259ZM1910.53 940.259H1836.33C1836.29 940.224 1836.24 940.179 1836.18 940.125C1836.02 939.983 1835.8 939.778 1835.54 939.53C1835.03 939.032 1834.37 938.363 1833.81 937.671C1833.24 936.969 1832.79 936.284 1832.65 935.75C1832.58 935.488 1832.59 935.308 1832.65 935.187C1832.7 935.076 1832.82 934.95 1833.12 934.861C1834.44 934.457 1836.2 934.737 1837.68 935.15C1838.41 935.353 1839.05 935.584 1839.51 935.764C1839.74 935.854 1839.93 935.931 1840.05 935.985C1840.12 936.012 1840.17 936.034 1840.2 936.048L1840.23 936.065L1840.24 936.069L1840.25 936.07L1840.25 936.07L1840.25 936.07L1840.25 936.069L1840.66 935.519L1840.66 935.519L1840.66 935.519L1840.66 935.518L1840.66 935.516L1840.65 935.508L1840.63 935.475C1840.6 935.446 1840.57 935.403 1840.52 935.347C1840.43 935.236 1840.3 935.076 1840.15 934.882C1839.85 934.492 1839.48 933.972 1839.17 933.437C1838.84 932.893 1838.61 932.372 1838.55 931.975C1838.52 931.779 1838.54 931.649 1838.58 931.567C1838.61 931.498 1838.67 931.428 1838.83 931.379C1839.21 931.257 1839.69 931.267 1840.22 931.373C1840.74 931.479 1841.29 931.675 1841.79 931.893C1842.28 932.11 1842.72 932.346 1843.04 932.528C1843.2 932.619 1843.33 932.696 1843.42 932.75C1843.46 932.777 1843.49 932.798 1843.52 932.812L1843.54 932.828L1843.55 932.832L1843.55 932.833L1843.55 932.833L1910.53 940.259ZM1870.11 931.31L1870.11 931.31L1870.11 931.31L1870.11 931.309L1870.11 931.306L1870.09 931.293C1870.08 931.281 1870.06 931.263 1870.03 931.24C1869.97 931.193 1869.89 931.126 1869.78 931.046C1869.57 930.886 1869.27 930.676 1868.91 930.479C1868.18 930.077 1867.29 929.761 1866.45 929.932C1866.12 930 1865.92 930.211 1865.79 930.557C1865.66 930.919 1865.64 931.398 1865.67 931.903C1865.7 932.402 1865.79 932.894 1865.88 933.264C1865.92 933.448 1865.96 933.601 1865.99 933.706C1866 933.759 1866.01 933.8 1866.02 933.828L1866.03 933.858L1866.03 933.866L1866.03 933.867L1866.03 933.867L1866.03 933.867C1866.03 933.867 1866.03 933.867 1866.03 933.867L1865.4 934.17L1865.4 934.17L1865.4 934.17L1865.4 934.17L1865.4 934.169L1865.4 934.167L1865.39 934.157L1865.36 934.115C1865.34 934.079 1865.3 934.024 1865.25 933.955C1865.15 933.817 1865.01 933.619 1864.83 933.381C1864.47 932.904 1863.97 932.269 1863.4 931.634C1862.83 930.997 1862.19 930.37 1861.56 929.903C1860.92 929.427 1860.33 929.154 1859.86 929.146C1859.62 929.142 1859.46 929.195 1859.35 929.267C1859.24 929.34 1859.15 929.449 1859.08 929.604C1858.94 929.928 1858.91 930.402 1858.96 930.936C1859.01 931.459 1859.14 931.99 1859.25 932.394C1859.3 932.595 1859.36 932.762 1859.39 932.879C1859.41 932.937 1859.43 932.983 1859.44 933.013L1859.45 933.048L1859.45 933.056L1859.45 933.058L1859.45 933.058L1859.45 933.058C1859.45 933.058 1859.45 933.058 1859.45 933.058L1858.81 933.326C1858.8 933.328 1858.8 933.328 1858.8 933.328L1858.8 933.327L1858.8 933.326L1858.8 933.317C1858.79 933.309 1858.79 933.295 1858.78 933.277C1858.76 933.24 1858.73 933.185 1858.69 933.113C1858.61 932.969 1858.48 932.759 1858.31 932.503C1857.96 931.99 1857.42 931.292 1856.63 930.562C1855.07 929.104 1852.55 927.51 1848.72 927.007C1846.8 926.755 1845.61 926.998 1844.86 927.444C1844.14 927.882 1843.8 928.546 1843.67 929.272C1843.54 930.007 1843.64 930.787 1843.77 931.398C1843.84 931.7 1843.92 931.955 1843.97 932.133C1844 932.222 1844.03 932.292 1844.04 932.338C1844.05 932.362 1844.06 932.379 1844.06 932.39L1844.07 932.403L1844.07 932.405L1844.07 932.405L1844.07 932.406L1844.07 932.406L1844.5 933.458L1843.55 932.833L1870.11 931.31ZM1887.32 927.467C1887.32 927.467 1887.32 927.467 1887.32 927.467L1887.32 927.467Z",
    fill: "#62AE80",
    stroke: "#4C736A",
    strokeWidth: 0.707214
  })), _path1910 || (_path1910 = /*#__PURE__*/React.createElement("path", {
    d: "M1977.88 940.259C1977.9 940.244 1977.91 940.226 1977.93 940.207C1978.03 940.099 1978.18 939.939 1978.35 939.734C1978.7 939.324 1979.17 938.738 1979.64 938.031C1980.59 936.606 1981.52 934.737 1981.57 932.86C1981.58 932.399 1981.52 932.091 1981.42 931.889C1981.32 931.697 1981.2 931.59 1981.05 931.531C1980.71 931.399 1980.19 931.474 1979.56 931.717C1978.95 931.952 1978.33 932.308 1977.85 932.612C1977.62 932.763 1977.42 932.898 1977.28 932.996C1977.21 933.045 1977.16 933.084 1977.12 933.111L1977.08 933.141L1977.07 933.149L1977.07 933.15L1977.07 933.151L1977.07 933.151L1977.07 933.151L1977.07 933.15L1976.54 932.71C1976.54 932.71 1976.54 932.71 1976.54 932.71L1976.54 932.71L1976.54 932.708L1976.55 932.698C1976.55 932.688 1976.56 932.672 1976.57 932.651C1976.59 932.61 1976.61 932.548 1976.64 932.474C1976.7 932.322 1976.76 932.122 1976.79 931.917C1976.82 931.708 1976.81 931.522 1976.75 931.38C1976.7 931.253 1976.61 931.139 1976.41 931.065C1976.26 931.01 1975.99 931.043 1975.6 931.238C1975.22 931.423 1974.81 931.715 1974.42 932.031C1974.04 932.346 1973.68 932.675 1973.43 932.927C1973.3 933.052 1973.19 933.158 1973.12 933.232C1973.09 933.269 1973.06 933.298 1973.04 933.317L1973.02 933.339L1973.02 933.345L1973.01 933.346L1973.01 933.346L1973.01 933.346L1973.01 933.346L1972.41 934L1972.4 933.109V933.109L1972.4 933.109L1972.4 933.109L1972.4 933.106L1972.4 933.092C1972.4 933.079 1972.4 933.059 1972.4 933.033C1972.4 932.981 1972.4 932.904 1972.39 932.805C1972.38 932.606 1972.36 932.32 1972.32 931.974C1972.24 931.281 1972.08 930.354 1971.78 929.411C1971.17 927.502 1970.02 925.649 1967.81 925.336L1967.81 925.336C1965.53 925.01 1964.09 925.808 1963.22 926.667C1962.77 927.103 1962.47 927.559 1962.28 927.907C1962.19 928.08 1962.12 928.225 1962.08 928.325C1962.05 928.375 1962.04 928.414 1962.03 928.439C1962.03 928.452 1962.02 928.461 1962.02 928.467L1962.02 928.473L1962.02 928.473L1962.02 928.473L1962.02 928.473L1962.02 928.473L1961.67 929.506L1961.35 928.465L1961.35 928.465L1961.35 928.465L1961.35 928.465L1961.34 928.464L1961.34 928.459L1961.34 928.437C1961.33 928.417 1961.32 928.387 1961.31 928.349C1961.28 928.271 1961.24 928.159 1961.18 928.024C1961.07 927.753 1960.9 927.393 1960.69 927.034C1960.23 926.286 1959.64 925.676 1958.94 925.654C1958.57 925.644 1958.34 925.75 1958.19 925.887C1958.03 926.032 1957.93 926.241 1957.86 926.483C1957.79 926.723 1957.78 926.972 1957.77 927.165C1957.77 927.261 1957.78 927.34 1957.78 927.395C1957.78 927.422 1957.79 927.443 1957.79 927.456L1957.79 927.47L1957.79 927.472L1957.79 927.472C1957.79 927.472 1957.79 927.472 1957.79 927.473L1957.14 927.703C1957.14 927.704 1957.14 927.704 1957.14 927.704L1957.14 927.704L1957.14 927.704L1957.13 927.699C1957.13 927.694 1957.13 927.685 1957.12 927.674C1957.1 927.651 1957.08 927.616 1957.04 927.57C1956.98 927.479 1956.87 927.347 1956.73 927.189C1956.44 926.873 1956 926.456 1955.39 926.06C1954.18 925.272 1952.29 924.558 1949.57 924.915C1946.9 925.265 1945.35 926.802 1944.46 928.267C1944.01 929.001 1943.73 929.715 1943.56 930.246C1943.47 930.511 1943.42 930.728 1943.38 930.879C1943.36 930.954 1943.35 931.012 1943.35 931.051C1943.34 931.07 1943.34 931.084 1943.34 931.093L1943.34 931.103L1943.34 931.105L1943.34 931.105L1943.34 931.105L1943.22 931.804L1942.73 931.293L1942.73 931.293L1942.73 931.293L1942.73 931.292L1942.73 931.292L1942.73 931.289L1942.72 931.276C1942.7 931.265 1942.69 931.247 1942.66 931.223C1942.61 931.177 1942.54 931.11 1942.45 931.031C1942.27 930.871 1942.01 930.663 1941.7 930.468C1941.07 930.066 1940.31 929.767 1939.62 929.93C1939.37 929.989 1939.19 930.179 1939.08 930.542C1938.96 930.912 1938.94 931.398 1938.97 931.906C1939 932.408 1939.08 932.902 1939.15 933.274C1939.18 933.459 1939.22 933.612 1939.24 933.718C1939.26 933.771 1939.27 933.812 1939.27 933.84L1939.28 933.871L1939.28 933.878L1939.28 933.88L1939.28 933.88L1939.28 933.88L1977.88 940.259ZM1977.88 940.259H1913.45C1913.42 940.227 1913.38 940.188 1913.33 940.142C1913.2 940 1913 939.796 1912.78 939.547C1912.33 939.05 1911.76 938.382 1911.28 937.69C1910.78 936.99 1910.39 936.303 1910.26 935.762C1910.2 935.494 1910.21 935.302 1910.27 935.171C1910.32 935.054 1910.42 934.939 1910.65 934.857C1911.77 934.462 1913.28 934.733 1914.56 935.146C1915.2 935.348 1915.75 935.578 1916.15 935.757C1916.35 935.847 1916.51 935.923 1916.62 935.977C1916.67 936.004 1916.72 936.026 1916.74 936.04L1916.77 936.056L1916.78 936.06L1916.78 936.061L1916.78 936.061L1916.78 936.061L1916.78 936.061L1917.23 935.538L1917.23 935.538L1917.23 935.538L1917.23 935.537L1917.23 935.535L1917.23 935.527L1917.2 935.494C1917.18 935.465 1917.15 935.422 1917.11 935.366C1917.03 935.255 1916.92 935.095 1916.79 934.901C1916.53 934.512 1916.21 933.991 1915.93 933.456C1915.65 932.912 1915.44 932.387 1915.39 931.981C1915.37 931.78 1915.38 931.64 1915.42 931.55C1915.45 931.475 1915.5 931.415 1915.62 931.374C1915.93 931.26 1916.33 931.266 1916.78 931.371C1917.23 931.475 1917.69 931.668 1918.12 931.884C1918.55 932.101 1918.94 932.335 1919.21 932.517C1919.35 932.607 1919.46 932.684 1919.53 932.737C1919.57 932.764 1919.6 932.785 1919.62 932.799L1919.64 932.815L1919.65 932.819L1919.65 932.82L1919.65 932.82L1977.88 940.259ZM1939.28 933.88L1938.64 934.151L1938.64 934.151L1938.64 934.151L1938.64 934.151L1938.64 934.15L1938.64 934.148L1938.63 934.138L1938.61 934.096C1938.58 934.06 1938.55 934.005 1938.51 933.936C1938.42 933.798 1938.3 933.6 1938.14 933.361C1937.83 932.884 1937.4 932.25 1936.9 931.615C1936.4 930.979 1935.85 930.353 1935.3 929.888C1934.74 929.41 1934.25 929.154 1933.87 929.146C1933.68 929.143 1933.56 929.19 1933.47 929.254C1933.38 929.321 1933.3 929.427 1933.24 929.588C1933.11 929.92 1933.09 930.404 1933.14 930.941C1933.18 931.467 1933.29 932 1933.39 932.405C1933.43 932.607 1933.48 932.775 1933.51 932.892C1933.53 932.951 1933.54 932.996 1933.55 933.027L1933.56 933.062L1933.57 933.07L1933.57 933.072L1933.57 933.072L1933.57 933.072L1939.28 933.88ZM1933.56 933.073L1932.91 933.309C1932.9 933.311 1932.9 933.311 1932.9 933.311L1932.9 933.311L1932.9 933.309L1932.9 933.3C1932.89 933.292 1932.89 933.278 1932.88 933.26C1932.86 933.223 1932.84 933.167 1932.8 933.095C1932.73 932.951 1932.63 932.741 1932.47 932.484C1932.17 931.971 1931.7 931.274 1931.02 930.545C1929.66 929.089 1927.48 927.506 1924.17 927.006C1922.52 926.756 1921.5 926.999 1920.88 927.432C1920.26 927.861 1919.96 928.524 1919.84 929.264C1919.73 930.007 1919.82 930.794 1919.93 931.407C1919.99 931.711 1920.06 931.967 1920.11 932.146C1920.13 932.236 1920.16 932.306 1920.17 932.353C1920.18 932.376 1920.18 932.394 1920.19 932.405L1920.19 932.418L1920.19 932.42L1920.19 932.421L1920.19 932.421L1920.19 932.421L1920.58 933.53L1919.65 932.82L1933.56 933.073Z",
    fill: "#62AE80",
    stroke: "#4C736A",
    strokeWidth: 0.707214
  })), _path1911 || (_path1911 = /*#__PURE__*/React.createElement("path", {
    d: "M1981.28 937.438H1833.19V943.739H1981.28V937.438Z",
    fill: "white",
    stroke: "#382456",
    strokeWidth: 0.707214
  })), _path1912 || (_path1912 = /*#__PURE__*/React.createElement("path", {
    d: "M1845.38 955.402C1845.43 955.365 1845.49 955.317 1845.57 955.258C1845.78 955.1 1846.08 954.867 1846.44 954.57C1847.16 953.974 1848.12 953.121 1849.09 952.094C1851.05 950.016 1852.94 947.321 1853.04 944.642C1853.07 943.995 1852.94 943.567 1852.74 943.283C1852.55 943.002 1852.26 942.809 1851.86 942.698C1851.02 942.466 1849.82 942.613 1848.52 942.967C1847.24 943.315 1845.95 943.841 1844.97 944.283C1844.48 944.504 1844.07 944.702 1843.79 944.845C1843.64 944.917 1843.53 944.974 1843.46 945.014C1843.42 945.034 1843.39 945.049 1843.37 945.059L1843.35 945.07L1843.34 945.073L1843.34 945.074L1843.34 945.074L1843.34 945.074L1843.34 945.073L1842.74 944.386C1842.74 944.386 1842.74 944.386 1842.74 944.386L1842.74 944.386L1842.74 944.383L1842.75 944.368C1842.76 944.353 1842.77 944.331 1842.79 944.301C1842.83 944.241 1842.88 944.153 1842.94 944.045C1843.06 943.826 1843.18 943.544 1843.24 943.259C1843.29 942.973 1843.28 942.731 1843.17 942.543C1843.08 942.367 1842.86 942.157 1842.34 942.021C1841.87 941.9 1841.2 941.997 1840.38 942.282C1839.58 942.561 1838.71 942.995 1837.91 943.456C1837.11 943.917 1836.38 944.397 1835.85 944.763C1835.58 944.946 1835.37 945.1 1835.22 945.208C1835.15 945.262 1835.09 945.304 1835.05 945.333L1835.01 945.365L1835 945.373L1835 945.375L1834.99 945.375L1834.99 945.375L1834.99 945.376L1834.25 945.943L1834.24 945.008L1834.24 945.008L1834.24 945.008L1834.24 945.008L1834.24 945.004L1834.24 944.984C1834.24 944.966 1834.24 944.938 1834.24 944.901C1834.23 944.827 1834.23 944.716 1834.21 944.574C1834.19 944.289 1834.15 943.878 1834.07 943.38C1833.9 942.383 1833.59 941.049 1832.97 939.689C1831.75 936.983 1829.37 934.187 1824.63 933.712L1824.63 933.712C1819.8 933.225 1816.74 934.422 1814.9 935.7C1813.98 936.342 1813.35 937.011 1812.96 937.515C1812.76 937.767 1812.63 937.977 1812.54 938.122C1812.5 938.194 1812.47 938.25 1812.45 938.286C1812.44 938.304 1812.43 938.317 1812.43 938.325L1812.42 938.332L1812.42 938.332L1812.42 938.333L1812.42 938.333L1811.98 939.256L1845.38 955.402ZM1845.38 955.402H1712.91C1712.83 955.347 1712.72 955.268 1712.58 955.166C1712.3 954.96 1711.9 954.662 1711.44 954.302C1710.52 953.579 1709.35 952.608 1708.34 951.603C1707.32 950.58 1706.53 949.586 1706.27 948.816C1706.15 948.445 1706.17 948.201 1706.27 948.033C1706.38 947.86 1706.62 947.653 1707.2 947.51C1709.63 946.907 1712.82 947.327 1715.47 947.927C1716.78 948.224 1717.93 948.56 1718.76 948.822C1719.17 948.953 1719.51 949.065 1719.73 949.145C1719.85 949.184 1719.93 949.216 1719.99 949.237L1720.06 949.261L1720.07 949.267L1720.08 949.269L1720.08 949.269L1720.08 949.269L1720.08 949.269L1720.57 948.488L1720.57 948.487L1720.57 948.487L1720.57 948.487L1720.56 948.484L1720.55 948.472L1720.5 948.424C1720.46 948.381 1720.39 948.318 1720.31 948.238C1720.15 948.076 1719.92 947.844 1719.65 947.562C1719.12 946.997 1718.45 946.241 1717.89 945.465C1717.32 944.673 1716.9 943.921 1716.79 943.354C1716.74 943.08 1716.78 942.904 1716.84 942.791C1716.91 942.684 1717.04 942.555 1717.38 942.469C1718.12 942.278 1719.02 942.297 1719.98 942.455C1720.94 942.612 1721.92 942.9 1722.82 943.219C1723.72 943.537 1724.51 943.882 1725.08 944.147C1725.37 944.28 1725.6 944.392 1725.75 944.471C1725.83 944.511 1725.89 944.542 1725.93 944.563L1725.98 944.587L1725.99 944.592L1725.99 944.594L1725.99 944.594L1725.99 944.594L1727.29 945.29L1726.64 943.97L1726.63 943.97L1726.63 943.97L1726.63 943.97L1726.63 943.966L1726.62 943.948C1726.62 943.932 1726.6 943.907 1726.59 943.873C1726.56 943.806 1726.51 943.705 1726.46 943.577C1726.36 943.319 1726.23 942.952 1726.11 942.515C1725.87 941.634 1725.7 940.513 1725.92 939.461C1726.14 938.433 1726.74 937.447 1728.1 936.787C1729.48 936.113 1731.68 935.762 1735.12 936.13C1742 936.865 1746.54 939.193 1749.35 941.319C1750.75 942.382 1751.73 943.398 1752.35 944.143C1752.66 944.515 1752.88 944.82 1753.03 945.029C1753.1 945.133 1753.15 945.214 1753.18 945.267C1753.2 945.287 1753.21 945.303 1753.21 945.315L1753.22 945.325L1753.23 945.338L1753.23 945.34L1753.23 945.341C1753.23 945.341 1753.23 945.341 1753.23 945.337L1754.06 944.916C1754.07 944.915 1754.07 944.915 1754.07 944.915L1754.07 944.915L1754.06 944.915L1754.06 944.912L1754.06 944.9C1754.05 944.889 1754.05 944.873 1754.04 944.851C1754.02 944.807 1753.99 944.741 1753.96 944.657C1753.89 944.488 1753.8 944.246 1753.7 943.956C1753.5 943.371 1753.28 942.606 1753.19 941.854C1753.09 941.086 1753.14 940.411 1753.39 939.949C1753.61 939.539 1754.04 939.214 1754.95 939.226C1755.88 939.239 1756.97 939.665 1758.12 940.355C1759.25 941.039 1760.4 941.954 1761.42 942.877C1762.44 943.798 1763.34 944.72 1763.98 945.411C1764.3 945.757 1764.55 946.044 1764.73 946.245C1764.81 946.345 1764.88 946.424 1764.93 946.477L1764.98 946.537L1764.99 946.552L1764.99 946.556L1764.99 946.556L1764.99 946.556L1764.99 946.556L1765.79 946.089C1765.79 946.088 1765.79 946.088 1765.79 946.088L1765.79 946.088L1765.79 946.088L1765.79 946.086L1765.79 946.075L1765.77 946.031C1765.76 945.992 1765.74 945.932 1765.71 945.856C1765.66 945.703 1765.59 945.484 1765.52 945.217C1765.37 944.682 1765.21 943.973 1765.15 943.256C1765.09 942.529 1765.14 941.845 1765.37 941.327C1765.58 940.842 1765.96 940.483 1766.65 940.368C1768.23 940.106 1769.9 940.592 1771.2 941.178C1771.85 941.468 1772.4 941.776 1772.78 942.011C1772.97 942.129 1773.12 942.227 1773.22 942.296C1773.27 942.33 1773.31 942.357 1773.33 942.375L1773.36 942.395L1773.37 942.399L1773.37 942.4M1845.38 955.402L1773.37 942.4M1806.38 934.17C1808.03 934.206 1809.32 935.199 1810.22 936.251C1810.67 936.773 1811.01 937.294 1811.23 937.685C1811.35 937.88 1811.43 938.042 1811.49 938.153C1811.52 938.209 1811.54 938.252 1811.55 938.28L1811.56 938.312L1811.57 938.319L1811.57 938.319L1811.57 938.32L1811.57 938.32L1806.38 934.17ZM1806.38 934.17C1805.53 934.153 1804.97 934.33 1804.61 934.566C1804.24 934.8 1804.02 935.116 1803.9 935.446C1803.77 935.782 1803.73 936.13 1803.73 936.401C1803.72 936.535 1803.73 936.646 1803.74 936.721C1803.74 936.759 1803.75 936.788 1803.75 936.806L1803.75 936.824L1803.75 936.826L1803.75 936.826L1803.75 936.826L1803.75 936.827L1803.75 936.827L1804.05 938.473L1802.94 937.22L1802.94 937.22L1802.94 937.22L1802.94 937.219L1802.94 937.219L1802.93 937.211C1802.92 937.204 1802.91 937.191 1802.9 937.174C1802.86 937.14 1802.81 937.088 1802.74 937.021C1802.6 936.888 1802.38 936.693 1802.08 936.461C1801.49 935.997 1800.57 935.382 1799.29 934.798C1796.75 933.63 1792.78 932.575 1787.11 933.101C1781.48 933.623 1778.24 935.912 1776.4 938.035C1775.48 939.102 1774.9 940.135 1774.56 940.898C1774.38 941.279 1774.27 941.593 1774.2 941.808C1774.17 941.915 1774.14 941.998 1774.13 942.053C1774.12 942.08 1774.11 942.1 1774.11 942.113L1774.11 942.126L1774.11 942.127L1774.11 942.128L1774.11 942.128L1806.38 934.17ZM1773.37 942.4L1773.37 942.4L1773.37 942.4Z",
    fill: "#62AE80",
    stroke: "#4C736A",
    strokeWidth: 0.940403
  })), _path1913 || (_path1913 = /*#__PURE__*/React.createElement("path", {
    d: "M1848.76 952.307H1706.4V960.686H1848.76V952.307Z",
    fill: "white",
    stroke: "#382456",
    strokeWidth: 0.940403
  })), _path1914 || (_path1914 = /*#__PURE__*/React.createElement("path", {
    d: "M1602.81 872.251C1614.67 872.251 1624.28 881.864 1624.28 893.723C1624.28 905.582 1614.67 915.195 1602.81 915.195C1590.95 915.195 1581.34 905.582 1581.34 893.723C1581.34 881.864 1590.95 872.251 1602.81 872.251Z",
    fill: "#AACAC9",
    stroke: "#382456",
    strokeWidth: 1.3694
  })), _path1915 || (_path1915 = /*#__PURE__*/React.createElement("path", {
    d: "M1602.81 880.304H1604.61C1614 880.304 1621.6 887.918 1621.6 897.298C1621.6 906.692 1613.99 914.292 1604.61 914.292H1602.81C1593.42 914.292 1585.82 906.678 1585.82 897.298C1585.82 887.904 1593.43 880.304 1602.81 880.304Z",
    fill: "#62AE80"
  })), _path1916 || (_path1916 = /*#__PURE__*/React.createElement("path", {
    d: "M1601.91 896.4V962.597",
    stroke: "#382456",
    strokeWidth: 1.3694
  })), _path1917 || (_path1917 = /*#__PURE__*/React.createElement("path", {
    d: "M1614.44 898.204L1601.91 910.734",
    stroke: "#382456",
    strokeWidth: 1.3694
  })), _path1918 || (_path1918 = /*#__PURE__*/React.createElement("path", {
    d: "M1590.28 898.204L1602.81 910.734",
    stroke: "#382456",
    strokeWidth: 1.3694
  })), _path1919 || (_path1919 = /*#__PURE__*/React.createElement("path", {
    d: "M1631.43 872.251C1643.29 872.251 1652.91 881.864 1652.91 893.723C1652.91 905.582 1643.29 915.195 1631.43 915.195C1619.57 915.195 1609.96 905.582 1609.96 893.723C1609.96 881.864 1619.57 872.251 1631.43 872.251Z",
    fill: "#AACAC9",
    stroke: "#382456",
    strokeWidth: 1.3694
  })), _path1920 || (_path1920 = /*#__PURE__*/React.createElement("path", {
    d: "M1631.43 880.304H1633.23C1642.62 880.304 1650.22 887.918 1650.22 897.298C1650.22 906.692 1642.61 914.292 1633.23 914.292H1631.43C1622.04 914.292 1614.44 906.678 1614.44 897.298C1614.44 887.904 1622.05 880.304 1631.43 880.304Z",
    fill: "#62AE80"
  })), _path1921 || (_path1921 = /*#__PURE__*/React.createElement("path", {
    d: "M1630.54 896.4V962.597",
    stroke: "#382456",
    strokeWidth: 1.3694
  })), _path1922 || (_path1922 = /*#__PURE__*/React.createElement("path", {
    d: "M1643.07 898.204L1630.54 910.734",
    stroke: "#382456",
    strokeWidth: 1.3694
  })), _path1923 || (_path1923 = /*#__PURE__*/React.createElement("path", {
    d: "M1618.92 898.204L1631.45 910.734",
    stroke: "#382456",
    strokeWidth: 1.3694
  })), _path1924 || (_path1924 = /*#__PURE__*/React.createElement("path", {
    d: "M1660.07 872.251C1671.92 872.251 1681.54 881.864 1681.54 893.723C1681.54 905.582 1671.92 915.195 1660.07 915.195C1648.21 915.195 1638.59 905.582 1638.59 893.723C1638.59 881.864 1648.21 872.251 1660.07 872.251Z",
    fill: "#AACAC9",
    stroke: "#382456",
    strokeWidth: 1.3694
  })), _path1925 || (_path1925 = /*#__PURE__*/React.createElement("path", {
    d: "M1660.06 880.304H1661.86C1671.25 880.304 1678.85 887.918 1678.85 897.298C1678.85 906.692 1671.24 914.292 1661.86 914.292H1660.06C1650.67 914.292 1643.07 906.678 1643.07 897.298C1643.07 887.904 1650.68 880.304 1660.06 880.304Z",
    fill: "#62AE80"
  })), _path1926 || (_path1926 = /*#__PURE__*/React.createElement("path", {
    d: "M1671.69 898.204L1659.16 910.734",
    stroke: "#382456",
    strokeWidth: 1.3694
  })), _path1927 || (_path1927 = /*#__PURE__*/React.createElement("path", {
    d: "M1647.54 898.204L1660.06 910.734",
    stroke: "#382456",
    strokeWidth: 1.3694
  })), _path1928 || (_path1928 = /*#__PURE__*/React.createElement("path", {
    d: "M1659.16 896.4V962.597",
    stroke: "#382456",
    strokeWidth: 1.3694
  })), _path1929 || (_path1929 = /*#__PURE__*/React.createElement("path", {
    d: "M1591.24 801.967C1590.02 801.967 1589.01 802.958 1589.01 804.193V839.793C1589.01 841.015 1590 842.02 1591.24 842.02C1592.46 842.02 1593.46 841.028 1593.46 839.793V804.193C1593.46 802.972 1592.47 801.967 1591.24 801.967Z",
    fill: "#615E66"
  })), _path1930 || (_path1930 = /*#__PURE__*/React.createElement("path", {
    d: "M1513.37 804.922H1589.01V819.748H1513.37V804.922Z",
    fill: "#FFF9DE"
  })), _path1931 || (_path1931 = /*#__PURE__*/React.createElement("path", {
    d: "M1513.37 815.308H1589.01V816.788H1513.37V815.308Z",
    fill: "#615E66"
  })), _path1932 || (_path1932 = /*#__PURE__*/React.createElement("path", {
    d: "M1513.37 809.385H1589.01V810.865H1513.37V809.385Z",
    fill: "#615E66"
  })), _path1933 || (_path1933 = /*#__PURE__*/React.createElement("path", {
    d: "M1517.83 804.193C1517.83 802.958 1516.84 801.967 1515.61 801.967C1514.39 801.967 1513.37 802.958 1513.37 804.193V839.793C1513.37 841.015 1514.37 842.02 1515.61 842.02C1516.86 842.02 1517.83 841.028 1517.83 839.793V804.193Z",
    fill: "#615E66"
  })), _path1934 || (_path1934 = /*#__PURE__*/React.createElement("path", {
    d: "M1579.37 827.173C1578.15 827.173 1577.14 828.164 1577.14 829.4V842.746C1577.14 843.968 1578.13 844.973 1579.37 844.973C1580.59 844.973 1581.6 843.981 1581.6 842.746V829.4C1581.6 828.178 1580.61 827.173 1579.37 827.173Z",
    fill: "#615E66"
  })), _path1935 || (_path1935 = /*#__PURE__*/React.createElement("path", {
    d: "M1505.22 827.173C1504 827.173 1503 828.164 1503 829.4V842.746C1503 843.968 1503.99 844.973 1505.22 844.973C1506.45 844.973 1507.45 843.981 1507.45 842.746V829.4C1507.45 828.178 1506.46 827.173 1505.22 827.173Z",
    fill: "#615E66"
  })), _path1936 || (_path1936 = /*#__PURE__*/React.createElement("path", {
    d: "M1589.01 827.181L1593.46 823.475H1513.37L1503 827.181V831.635H1581.6L1589.01 827.181Z",
    fill: "#FFF9DE"
  })), _path1937 || (_path1937 = /*#__PURE__*/React.createElement("path", {
    d: "M1502.98 827.173H1581.6V831.626H1502.98V827.173Z",
    fill: "#615E66"
  })), _path1938 || (_path1938 = /*#__PURE__*/React.createElement("path", {
    d: "M1593.46 823.475L1581.6 827.181V833.114L1593.46 827.928V823.475Z",
    fill: "#615E66"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6004_56885",
    x1: 960.25,
    y1: -110.741,
    x2: 919.259,
    y2: 1031.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAEAFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.741703,
    stopColor: "#F7F0F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6004_56885",
    x1: 4199.59,
    y1: 828.346,
    x2: 4199.59,
    y2: 511.528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#928E7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E6F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6004_56885",
    x1: 4199.59,
    y1: 828.346,
    x2: 4199.59,
    y2: 511.528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#928E7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E6F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6004_56885",
    x1: 858.051,
    y1: 765.282,
    x2: 871.467,
    y2: 763.724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6004_56885",
    x1: 1367.05,
    y1: 757.225,
    x2: 1379.5,
    y2: 755.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6004_56885",
    x1: 1358.9,
    y1: 745.935,
    x2: 1358.9,
    y2: 752.586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9A8A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#767571"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_6004_56885",
    x1: 1192.51,
    y1: 776.647,
    x2: 1178.78,
    y2: 775.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6E3E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_6004_56885",
    x1: 1186.4,
    y1: 767.334,
    x2: 1221.93,
    y2: 767.334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#382456"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A4FBC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_6004_56885",
    x1: 1204.17,
    y1: 763.35,
    x2: 1204.17,
    y2: 771.319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9A8A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#767571"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_6004_56885",
    x1: 424.115,
    y1: 748.526,
    x2: 424.115,
    y2: 770.266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5B3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A7975"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_6004_56885",
    x1: 1780.59,
    y1: 817.391,
    x2: 1780.59,
    y2: 748.774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE7DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1EBCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_6004_56885",
    x1: 1802.08,
    y1: 925.831,
    x2: 1802.08,
    y2: 877.826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE7DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1EBCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_6004_56885",
    x1: 1759.14,
    y1: 925.831,
    x2: 1759.14,
    y2: 877.826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE7DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1EBCC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6004_56885"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetroLostBg);
export default __webpack_public_path__ + "static/media/MetroLostBg.199a391a5b82c3e33764.svg";
export { ForwardRef as ReactComponent };